import { jsx as w, jsxs as Vt, Fragment as XG } from "@emotion/react/jsx-runtime";
import * as v from "react";
import pt, { useEffect as Ee, forwardRef as Le, createElement as eI, useState as ee, useRef as Ke, useCallback as pn, memo as AA, useMemo as oe, createContext as cn, useContext as St, useId as xG, Component as WG, useLayoutEffect as fG, useInsertionEffect as BG, Fragment as ha } from "react";
import { css as Gt, keyframes as Zt } from "@emotion/react";
import { jsx as k, Fragment as nI, jsxs as Pn } from "react/jsx-runtime";
import * as YG from "react-dom";
import NG, { unstable_batchedUpdates as JG } from "react-dom";
import { makeObservable as RG, configure as SG, getDependencyTree as FG, Reaction as HG } from "mobx";
const Kn = {
  xs: 2,
  sm: 5,
  md: 10,
  lg: 15,
  xl: 25,
  xxl: 100
}, wG = {
  primary: "LuloClean",
  secondary: "GT Walsheim Pro",
  segoe: "Segoe UI",
  roboto: "Roboto",
  oxygen: "Oxygen",
  ubuntu: "Ubuntu",
  cantarell: "Cantarell",
  firaSans: "Fira Sans",
  droidSans: "Droid Sans",
  helvetica: "Helvetica Neue",
  nunitoSans: "Nunito Sans"
}, ke = {
  primary: "LuloClean",
  secondary: "GT Walsheim Pro",
  helvetica: "Helvetica Neue",
  nunitoSans: "Nunito Sans"
}, zG = {
  get: (t, e, n) => (console.warn(`Use of fontStyles.${String(e)} is deprecated. Please use fontFamilies instead.`), e in ke ? ke[e] : Reflect.get(t, e, n))
}, yf = new Proxy(wG, zG), pa = {
  xs: ".4em",
  sm: ".8em",
  smedium: "1.2em",
  md: "1.6em",
  lg: "2.5em",
  xl: "4.8em"
}, K = {
  primary: "#00A3FF",
  primaryBorder: "#008CDB",
  success: "#69DF0D",
  successBorder: "#5EC60D",
  warning: "#F2AC29",
  warningBorder: "#D79A27",
  danger: "#F25757",
  dangerBorder: "#B74848",
  secondary: "#F2AC29",
  secondaryBorder: "#D79A27",
  accent: "#FFEE00",
  background: "#2D5873",
  border: "#95A4BA",
  borderFocused: "#B9E3FF",
  text: "#FFF",
  textSecondary: "#000",
  gray: "#C7C7C7",
  darkGray: "#4D4D4D",
  component: "rgba(217,217,217,0.10)",
  componentSolid: "#3E657D",
  componentInset: "rgba(0,0,0,.1)",
  componentInsetSolid: "#385B71",
  componentSecondary: "#4B8DFF",
  componentHeaderBackground: "#1C3443",
  transparent: "rgba(0,0,0,0.20)",
  lessTransparent: "rgba(0,0,0,0.25)",
  transparentLight: "rgba(255,255,255,0.50)",
  textDark: "#000"
}, vf = {
  default: "linear-gradient(#4B8DFF, #4DACFF)",
  QRCode: "linear-gradient(#FCD7FF, #CFFAFF, #F2FCD1)"
}, sA = {
  0: "0 0 0 rgba(0,0,0,0.10), 0 0 0 rgba(0,0,0,0.24)",
  1: "0 1px 0px rgba(0,0,0,0.10), 0 1px 2px rgba(0,0,0,0.24)",
  2: "0 4px 0px rgba(0,0,0,0.10), 0 4px 2px rgba(0,0,0,0.23)",
  3: "0 6px 0px rgba(0,0,0,0.10), 0 6px 2px rgba(0,0,0,0.23)",
  4: "0 14px 0px rgba(0,0,0,0.25), 0 10px 2px rgba(0,0,0,0.22)",
  5: "0 19px 0px rgba(0,0,0,0.30), 0 15px 2px rgba(0,0,0,0.22)"
}, qG = {
  fast: "0.2s",
  medium: "0.4s",
  slow: "0.6s",
  debug: "5s"
};
var UA = /* @__PURE__ */ ((t) => (t.Primary = "primary", t.Success = "success", t.Warning = "warning", t.Danger = "danger", t))(UA || {});
const $g = {
  primary: {
    backgroundColor: K.primary,
    borderColor: K.primaryBorder
  },
  success: {
    backgroundColor: K.success,
    borderColor: K.successBorder
  },
  danger: {
    backgroundColor: K.danger,
    borderColor: K.dangerBorder
  },
  warning: {
    backgroundColor: K.warning,
    borderColor: K.warningBorder
  }
}, _e = (t) => typeof t == "number" ? t : Kn[t], TA = (t) => (e) => ({
  [t]: typeof e == "number" ? e : Kn[e]
}), Ft = (t, e, n, g) => ({
  position: "absolute",
  top: t,
  right: e,
  bottom: n,
  left: g
}), DG = (t, e) => ({
  textShadow: `-${e}px -${e}px 0 ${t},  
   ${e}px -${e}px 0 ${t},
  -${e}px  ${e}px 0 ${t},
   ${e}px  ${e}px 0 ${t};`
}), _n = (t, e, n, g) => ({
  position: "relative",
  top: t,
  right: e,
  bottom: n,
  left: g
}), Xf = (t) => ({
  position: "absolute",
  ...t
}), xf = (t) => ({
  position: "relative",
  ...t
}), ti = TA("borderRadius"), QA = (t, e = "2px") => ({
  border: `${e} solid ${t}`
}), Wf = (t, e = "2px") => ({
  borderBottom: `${e} solid ${t}`
}), WI = TA("padding"), OA = (t) => ({
  paddingLeft: _e(t),
  paddingRight: _e(t)
}), Va = (t) => ({
  paddingTop: _e(t),
  paddingBottom: _e(t)
}), ff = TA("margin"), Bf = {
  marginLeft: "auto",
  marginRight: "auto"
}, LG = (t) => ({
  marginLeft: _e(t),
  marginRight: _e(t)
}), Yf = (t) => ({
  marginTop: _e(t),
  marginBottom: _e(t)
}), Za = (t = "row") => ({
  display: "flex",
  flexDirection: t
}), ei = (t = 1) => ({
  flex: t
}), kG = ["LuloClean", "GT Walsheim Pro", "Nunito Sans", "Segoe UI Symbol", "Courier New", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Nunito Sans", "Segoe UI Symbol"], fn = (t, e, n, g) => ({
  fontFamily: `${t}, ${kG.join(", ")}`,
  fontSize: e,
  fontWeight: n,
  color: g
}), ni = ei(1), Nf = ei(2), Jf = ei(3), Rf = ei(4), Sf = ei(5), $n = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}, Ff = {
  display: "flex",
  alignItems: "center"
}, Hf = {
  display: "flex",
  justifyContent: "center"
}, wf = {
  display: "flex",
  justifyContent: "space-between"
}, zf = {
  display: "flex",
  justifyContent: "space-around"
}, qf = {
  display: "flex",
  justifyContent: "space-evenly"
}, Df = Za("column"), ne = {
  width: "100%",
  height: "100%"
}, ya = {
  width: "100%"
}, Lf = {
  height: "100%"
}, kf = {
  objectFit: "cover",
  ...ne
}, Ef = {
  objectFit: "contain",
  ...ne
}, va = {
  WebkitUserSelect: "none",
  WebkitTouchCallout: "none",
  KhtmlUserSelect: "none",
  MozUserSelect: "none",
  msUserSelect: "none",
  userSelect: "none"
}, me = (t, e) => ({
  boxShadow: e ? "inset " + sA[t].replace("),", "), inset ") : sA[t]
}), jf = (t) => ({
  textShadow: sA[t]
}), Mf = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
}, Uf = {
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)"
}, Tf = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)"
}, Qf = (t) => ({
  transition: `all ${qG[t]}`
}), Of = {
  textDecoration: "none",
  color: "inherit"
}, Pf = (t) => (e) => ({
  [t]: e
});
function gI() {
  return gI = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var g in n) ({}).hasOwnProperty.call(n, g) && (t[g] = n[g]);
    }
    return t;
  }, gI.apply(null, arguments);
}
function EG(t, e) {
  if (t == null) return {};
  var n = {};
  for (var g in t) if ({}.hasOwnProperty.call(t, g)) {
    if (e.indexOf(g) >= 0) continue;
    n[g] = t[g];
  }
  return n;
}
function jG(t) {
  Ee(t, []);
}
var MG = ["id", "volume", "playbackRate", "soundEnabled", "interrupt", "onload"];
function iI(t, e) {
  var n = e === void 0 ? {} : e, g = n.volume, i = g === void 0 ? 1 : g, c = n.playbackRate, A = c === void 0 ? 1 : c, l = n.soundEnabled, a = l === void 0 ? !0 : l, C = n.interrupt, b = C === void 0 ? !1 : C, m = n.onload, p = EG(n, MG), y = pt.useRef(null), f = pt.useRef(!1), x = pt.useState(null), Y = x[0], B = x[1], J = pt.useState(null), N = J[0], R = J[1], H = function() {
    typeof m == "function" && m.call(this), f.current && B(this.duration() * 1e3), R(this);
  };
  jG(function() {
    return import("./howler-DJIW9wc6.mjs").then((D) => D.h).then(function(D) {
      if (!f.current) {
        var gt;
        y.current = (gt = D.Howl) !== null && gt !== void 0 ? gt : D.default.Howl, f.current = !0, new y.current(gI({
          src: Array.isArray(t) ? t : [t],
          volume: i,
          rate: A,
          onload: H
        }, p));
      }
    }), function() {
      f.current = !1;
    };
  }), pt.useEffect(function() {
    y.current && N && R(new y.current(gI({
      src: Array.isArray(t) ? t : [t],
      volume: i,
      onload: H
    }, p)));
  }, [JSON.stringify(t)]), pt.useEffect(function() {
    N && (N.volume(i), N.rate(A));
  }, [i, A]);
  var E = pt.useCallback(function(D) {
    typeof D > "u" && (D = {}), !(!N || !a && !D.forceSoundEnabled) && (b && N.stop(), D.playbackRate && N.rate(D.playbackRate), N.play(D.id));
  }, [N, a, b]), O = pt.useCallback(function(D) {
    N && N.stop(D);
  }, [N]), j = pt.useCallback(function(D) {
    N && N.pause(D);
  }, [N]), U = [E, {
    sound: N,
    stop: O,
    pause: j,
    duration: Y
  }];
  return U;
}
const $o = "data:audio/mpeg;base64,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", Je = {
  RGB: "rgb",
  RGBA: "rgba",
  HEX: "hex",
  HSL: "hsl",
  HSLA: "hsla",
  PREDEFINED: "predefined"
}, Kf = (t, e, n, g = 90) => ({
  background: `linear-gradient(${g}deg, ${t} 0% ${n},   ${e} ${n} 100%)`
});
function UG(t, e = [0, 0, 0], n = [256, 256, 256]) {
  const g = [n[0] - e[0], n[1] - e[1], n[2] - e[2]], i = [Math.round(e[0] + t * g[0]), Math.round(e[1] + t * g[1]), Math.round(e[2] + t * g[2])];
  return `rgb(${i[0]}, ${i[1]}, ${i[2]})`;
}
function TG(t, [e, n, g, i] = [0, 0, 0, 0], [c, A, l, a] = [256, 256, 256, 1]) {
  const [C, b, m, p] = [c - e, A - n, l - g, a - i], [y, f, x, Y] = [Math.round(e + t * C), Math.round(n + t * b), Math.round(g + t * m), i + t * p];
  return `rgba(${y}, ${f}, ${x}, ${Y})`;
}
function Xa(t) {
  const e = t.length - 1;
  if (t[0] !== "#" || e !== 3 && e !== 6)
    return console.error("Invalid hex string"), [255, 0, 0];
  e === 3 && (t = t[0] + t[1] + t[1] + t[2] + t[2] + t[3] + t[3]);
  const n = parseInt(t.replace("#", ""), 16);
  return [n >> 16 & 255, n >> 8 & 255, n & 255];
}
function QG(t, e) {
  const n = PG(t);
  let [g, i, c, A] = [255, 0, 0, 1];
  switch (n) {
    case Je.RGB:
      [g, i, c] = xa(t);
      break;
    case Je.RGBA:
      [g, i, c, A] = OG(t);
      break;
    case Je.HEX:
      [g, i, c] = Xa(t);
      break;
  }
  return TG(e, [g, i, c, A], [0, 0, 0, A]);
}
function _f(t, e) {
  const n = t.startsWith("rgb(") && t.endsWith(")"), [g, i, c] = n ? xa(t) : Xa(t);
  return UG(e, [g, i, c], [255, 255, 255]);
}
const xa = (t) => {
  const e = t.replace("rgb(", "").replace(")", "").split(",");
  return [parseInt(e[0]), parseInt(e[1]), parseInt(e[2])];
}, OG = (t) => {
  const e = t.replace("rgba(", "").replace(")", "").split(",");
  return [parseInt(e[0]), parseInt(e[1]), parseInt(e[2]), parseFloat(e[3])];
}, PG = (t) => t.startsWith("rgba(") && t.endsWith(")") ? Je.RGBA : t.startsWith("rgb(") && t.endsWith(")") ? Je.RGB : t.startsWith("#") ? Je.HEX : t.startsWith("hsla(") && t.endsWith(")") ? Je.HSLA : t.startsWith("hsl(") && t.endsWith(")") ? Je.HSL : Je.PREDEFINED, KG = (t, e, n, g, i, c, A) => {
  const l = g, a = g, C = i;
  return [{
    top: 0,
    backgroundColor: "transparent",
    position: "relative",
    color: K.text,
    border: "none",
    cursor: "pointer",
    letterSpacing: "-0.15em",
    transition: ".2s ease",
    "& > div": {
      position: "relative",
      zIndex: 2,
      top: 0,
      transition: ".2s ease"
    },
    "&::before, &::after": {
      content: '""',
      display: "block",
      borderRadius: "inherit",
      transition: ".2s ease"
    },
    "&::before": [{
      zIndex: 1,
      background: e
    }, Ft(0, 0, 0, 0)],
    "&::after": [{
      zIndex: 0,
      background: n
    }, Ft(0, 0, -l, 0), t && me(2)],
    "&:active:not([disabled])": [{
      "&::before,&>div": [{
        top: C,
        bottom: -C
      }]
    }, {
      "&::after": [{
        top: C
      }, t && me(1)]
    }],
    "&:disabled": {
      filter: "brightness(0.7)",
      cursor: "default",
      color: n
    },
    "&:hover": !c && [{
      "&::before,&>div": [{
        top: -a,
        bottom: a
      }]
    }, {
      "&::after": [{
        top: -a
      }, t && me(3)]
    }]
  }, fn(ke.primary, "14px", "bold"), ti("lg"), OA("md"), $n, A || va];
};
function oA(t) {
  const {
    children: e,
    secondary: n,
    className: g,
    color: i,
    intent: c,
    shadow: A,
    buttonHeight: l,
    pressedButtonHeight: a,
    onPointerUp: C,
    onPointerDown: b,
    disabled: m,
    selectable: p = !1,
    hasSound: y = !1,
    ...f
  } = t, x = c ?? (n ? "success" : "primary");
  let {
    borderColor: Y,
    backgroundColor: B
  } = $g[x];
  i && (B = i, Y = QG(B, 0.2));
  const [J, N] = [l ?? 3, a ?? 2], [R] = iI($o, {
    volume: 0.2
  }), [H] = iI($o, {
    volume: 0.2,
    playbackRate: 1.5
  });
  return /* @__PURE__ */ w("button", { css: [KG(!!A, B, Y, J, N, !!m, p), process.env.NODE_ENV === "production" ? "" : ";label:Button;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], disabled: m, className: g, onPointerDown: (E) => {
    y && R(), b == null || b(E);
  }, onPointerUp: (E) => {
    y && H(), C == null || C(E);
  }, ...f, children: /* @__PURE__ */ w("div", { children: e }) });
}
function _G() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function gi(t) {
  const {
    children: e,
    className: n,
    shadow: g,
    inset: i,
    solid: c = !0,
    noPadding: A,
    ...l
  } = t, a = !A, C = c ? i ? K.componentInsetSolid : K.componentSolid : i ? K.componentInset : K.component;
  return /* @__PURE__ */ w("div", { className: n, css: [{
    backgroundColor: C,
    color: K.text
  }, ti("lg"), a && WI("lg"), g && me(2, !!i), process.env.NODE_ENV === "production" ? "" : ";label:Card;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ...l, children: e });
}
var $G = process.env.NODE_ENV === "production" ? {
  name: "14mdnr2",
  styles: "font-size:1.5rem;font-weight:bold"
} : {
  name: "2xpfyg-CardHeader",
  styles: "font-size:1.5rem;font-weight:bold;label:CardHeader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL0NhcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNFUSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay91aS91aS9zcmMvY29tbW9uL2NvbXBvbmVudHMvYmFzZS9DYXJkLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ0AvY29tbW9uL3N0eWxlcy90aGVtZSc7XG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGRyb3BTaGFkb3csIHBhZGRpbmcgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdXRpbHMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGludGVyZmFjZSBDYXJkUHJvcHMge1xuICBjaGlsZHJlbj86IFJlYWN0LlJlYWN0Tm9kZTtcbiAgY2xhc3NOYW1lPzogc3RyaW5nO1xuICBzaGFkb3c/OiBib29sZWFuO1xuICBpbnNldD86IGJvb2xlYW47XG4gIHNvbGlkPzogYm9vbGVhbjtcbiAgbm9QYWRkaW5nPzogYm9vbGVhbjtcbn1cblxuLyoqXG4gKiBSZW5kZXJzIGEgY2FyZCBjb21wb25lbnQuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBDYXJkKFxuICBwcm9wczogQ2FyZFByb3BzICZcbiAgICBSZWFjdC5DbGFzc0F0dHJpYnV0ZXM8SFRNTERpdkVsZW1lbnQ+ICZcbiAgICBSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4sXG4pIHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBzaGFkb3csIGluc2V0LCBzb2xpZCA9IHRydWUsIG5vUGFkZGluZywgLi4ucmVzdCB9ID0gcHJvcHM7XG5cbiAgY29uc3QgaGFzUGFkZGluZyA9ICFub1BhZGRpbmc7XG5cbiAgY29uc3QgYmdDb2xvciA9IHNvbGlkXG4gICAgPyBpbnNldFxuICAgICAgPyBjb2xvcnMuY29tcG9uZW50SW5zZXRTb2xpZFxuICAgICAgOiBjb2xvcnMuY29tcG9uZW50U29saWRcbiAgICA6IGluc2V0XG4gICAgICA/IGNvbG9ycy5jb21wb25lbnRJbnNldFxuICAgICAgOiBjb2xvcnMuY29tcG9uZW50O1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICBjc3M9e1tcbiAgICAgICAge1xuICAgICAgICAgIGJhY2tncm91bmRDb2xvcjogYmdDb2xvcixcbiAgICAgICAgICBjb2xvcjogY29sb3JzLnRleHQsXG4gICAgICAgIH0sXG4gICAgICAgIGJvcmRlclJhZGl1cygnbGcnKSxcbiAgICAgICAgaGFzUGFkZGluZyAmJiBwYWRkaW5nKCdsZycpLFxuICAgICAgICBzaGFkb3cgJiYgZHJvcFNoYWRvdygyLCAhIWluc2V0KSxcbiAgICAgIF19XG4gICAgICB7Li4ucmVzdH1cbiAgICA+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9kaXY+XG4gICk7XG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ2FyZEhlYWRlclByb3BzIGV4dGVuZHMgUmVhY3QuSFRNTEF0dHJpYnV0ZXM8SFRNTERpdkVsZW1lbnQ+IHt9XG5cbmV4cG9ydCBjb25zdCBDYXJkSGVhZGVyID0gKHByb3BzOiBDYXJkSGVhZGVyUHJvcHMpID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgLi4ucmVzdCB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e1tcbiAgICAgICAge1xuICAgICAgICAgIGJvcmRlclRvcExlZnRSYWRpdXM6ICdpbmhlcml0JyxcbiAgICAgICAgICBib3JkZXJUb3BSaWdodFJhZGl1czogJ2luaGVyaXQnLFxuICAgICAgICAgIGJhY2tncm91bmQ6IGNvbG9ycy5jb21wb25lbnRIZWFkZXJCYWNrZ3JvdW5kLFxuICAgICAgICB9LFxuICAgICAgICBwYWRkaW5nKCdsZycpLFxuICAgICAgXX1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIDxoMVxuICAgICAgICBjc3M9e3tcbiAgICAgICAgICBmb250U2l6ZTogJzEuNXJlbScsXG4gICAgICAgICAgZm9udFdlaWdodDogJ2JvbGQnLFxuICAgICAgICB9fVxuICAgICAgPlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L2gxPlxuICAgIDwvZGl2PlxuICApO1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBDYXJkQm9keVByb3BzIGV4dGVuZHMgUmVhY3QuSFRNTEF0dHJpYnV0ZXM8SFRNTERpdkVsZW1lbnQ+IHt9XG5cbmV4cG9ydCBjb25zdCBDYXJkQm9keSA9IChwcm9wczogQ2FyZEJvZHlQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCAuLi5yZXN0IH0gPSBwcm9wcztcblxuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIGNzcz17W1xuICAgICAgICB7XG4gICAgICAgICAgYm9yZGVyUmFkaXVzOiAnaW5oZXJpdCcsXG4gICAgICAgIH0sXG4gICAgICAgIHBhZGRpbmcoJ2xnJyksXG4gICAgICBdfVxuICAgICAgey4uLnJlc3R9XG4gICAgPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvZGl2PlxuICApO1xufTtcbiJdfQ== */",
  toString: _G
};
const $f = (t) => {
  const {
    children: e,
    ...n
  } = t;
  return /* @__PURE__ */ w("div", { css: [{
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit",
    background: K.componentHeaderBackground
  }, WI("lg"), process.env.NODE_ENV === "production" ? "" : ";label:CardHeader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ...n, children: /* @__PURE__ */ w("h1", { css: $G, children: e }) });
}, t2 = (t) => {
  const {
    children: e,
    ...n
  } = t;
  return /* @__PURE__ */ w("div", { css: ["border-radius:inherit;", WI("lg"), process.env.NODE_ENV === "production" ? "" : ";label:CardBody;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ...n, children: e });
};
function tm(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Wa(...t) {
  return (e) => t.forEach((n) => tm(n, e));
}
function dt(...t) {
  return v.useCallback(Wa(...t), t);
}
function em(t, e) {
  const n = v.createContext(e), g = (c) => {
    const { children: A, ...l } = c, a = v.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ k(n.Provider, { value: a, children: A });
  };
  g.displayName = t + "Provider";
  function i(c) {
    const A = v.useContext(n);
    if (A) return A;
    if (e !== void 0) return e;
    throw new Error(`\`${c}\` must be used within \`${t}\``);
  }
  return [g, i];
}
function ii(t, e = []) {
  let n = [];
  function g(c, A) {
    const l = v.createContext(A), a = n.length;
    n = [...n, A];
    const C = (m) => {
      var B;
      const { scope: p, children: y, ...f } = m, x = ((B = p == null ? void 0 : p[t]) == null ? void 0 : B[a]) || l, Y = v.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ k(x.Provider, { value: Y, children: y });
    };
    C.displayName = c + "Provider";
    function b(m, p) {
      var x;
      const y = ((x = p == null ? void 0 : p[t]) == null ? void 0 : x[a]) || l, f = v.useContext(y);
      if (f) return f;
      if (A !== void 0) return A;
      throw new Error(`\`${m}\` must be used within \`${c}\``);
    }
    return [C, b];
  }
  const i = () => {
    const c = n.map((A) => v.createContext(A));
    return function(l) {
      const a = (l == null ? void 0 : l[t]) || c;
      return v.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: a } }),
        [l, a]
      );
    };
  };
  return i.scopeName = t, [g, nm(i, ...e)];
}
function nm(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const g = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const A = g.reduce((l, { useScope: a, scopeName: C }) => {
        const m = a(c)[`__scope${C}`];
        return { ...l, ...m };
      }, {});
      return v.useMemo(() => ({ [`__scope${e.scopeName}`]: A }), [A]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function Ct(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (t == null || t(i), n === !1 || !i.defaultPrevented)
      return e == null ? void 0 : e(i);
  };
}
function wt(t) {
  const e = v.useRef(t);
  return v.useEffect(() => {
    e.current = t;
  }), v.useMemo(() => (...n) => {
    var g;
    return (g = e.current) == null ? void 0 : g.call(e, ...n);
  }, []);
}
function fI({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [g, i] = gm({ defaultProp: e, onChange: n }), c = t !== void 0, A = c ? t : g, l = wt(n), a = v.useCallback(
    (C) => {
      if (c) {
        const m = typeof C == "function" ? C(t) : C;
        m !== t && l(m);
      } else
        i(C);
    },
    [c, t, i, l]
  );
  return [A, a];
}
function gm({
  defaultProp: t,
  onChange: e
}) {
  const n = v.useState(t), [g] = n, i = v.useRef(g), c = wt(e);
  return v.useEffect(() => {
    i.current !== g && (c(g), i.current = g);
  }, [g, i, c]), n;
}
function PA(t) {
  const e = v.useRef({ value: t, previous: t });
  return v.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var tg = globalThis != null && globalThis.document ? v.useLayoutEffect : () => {
};
function BI(t) {
  const [e, n] = v.useState(void 0);
  return tg(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const g = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const c = i[0];
        let A, l;
        if ("borderBoxSize" in c) {
          const a = c.borderBoxSize, C = Array.isArray(a) ? a[0] : a;
          A = C.inlineSize, l = C.blockSize;
        } else
          A = t.offsetWidth, l = t.offsetHeight;
        n({ width: A, height: l });
      });
      return g.observe(t, { box: "border-box" }), () => g.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
function im(t, e) {
  return v.useReducer((n, g) => e[n][g] ?? n, t);
}
var je = (t) => {
  const { present: e, children: n } = t, g = Im(e), i = typeof n == "function" ? n({ present: g.isPresent }) : v.Children.only(n), c = dt(g.ref, cm(i));
  return typeof n == "function" || g.isPresent ? v.cloneElement(i, { ref: c }) : null;
};
je.displayName = "Presence";
function Im(t) {
  const [e, n] = v.useState(), g = v.useRef({}), i = v.useRef(t), c = v.useRef("none"), A = t ? "mounted" : "unmounted", [l, a] = im(A, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return v.useEffect(() => {
    const C = Ni(g.current);
    c.current = l === "mounted" ? C : "none";
  }, [l]), tg(() => {
    const C = g.current, b = i.current;
    if (b !== t) {
      const p = c.current, y = Ni(C);
      t ? a("MOUNT") : y === "none" || (C == null ? void 0 : C.display) === "none" ? a("UNMOUNT") : a(b && p !== y ? "ANIMATION_OUT" : "UNMOUNT"), i.current = t;
    }
  }, [t, a]), tg(() => {
    if (e) {
      let C;
      const b = e.ownerDocument.defaultView ?? window, m = (y) => {
        const x = Ni(g.current).includes(y.animationName);
        if (y.target === e && x && (a("ANIMATION_END"), !i.current)) {
          const Y = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", C = b.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = Y);
          });
        }
      }, p = (y) => {
        y.target === e && (c.current = Ni(g.current));
      };
      return e.addEventListener("animationstart", p), e.addEventListener("animationcancel", m), e.addEventListener("animationend", m), () => {
        b.clearTimeout(C), e.removeEventListener("animationstart", p), e.removeEventListener("animationcancel", m), e.removeEventListener("animationend", m);
      };
    } else
      a("ANIMATION_END");
  }, [e, a]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: v.useCallback((C) => {
      C && (g.current = getComputedStyle(C)), n(C);
    }, [])
  };
}
function Ni(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function cm(t) {
  var g, i;
  let e = (g = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : g.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Lg = v.forwardRef((t, e) => {
  const { children: n, ...g } = t, i = v.Children.toArray(n), c = i.find(sm);
  if (c) {
    const A = c.props.children, l = i.map((a) => a === c ? v.Children.count(A) > 1 ? v.Children.only(null) : v.isValidElement(A) ? A.props.children : null : a);
    return /* @__PURE__ */ k(lA, { ...g, ref: e, children: v.isValidElement(A) ? v.cloneElement(A, void 0, l) : null });
  }
  return /* @__PURE__ */ k(lA, { ...g, ref: e, children: n });
});
Lg.displayName = "Slot";
var lA = v.forwardRef((t, e) => {
  const { children: n, ...g } = t;
  if (v.isValidElement(n)) {
    const i = lm(n);
    return v.cloneElement(n, {
      ...om(g, n.props),
      // @ts-ignore
      ref: e ? Wa(e, i) : i
    });
  }
  return v.Children.count(n) > 1 ? v.Children.only(null) : null;
});
lA.displayName = "SlotClone";
var Am = ({ children: t }) => /* @__PURE__ */ k(nI, { children: t });
function sm(t) {
  return v.isValidElement(t) && t.type === Am;
}
function om(t, e) {
  const n = { ...e };
  for (const g in e) {
    const i = t[g], c = e[g];
    /^on[A-Z]/.test(g) ? i && c ? n[g] = (...l) => {
      c(...l), i(...l);
    } : i && (n[g] = i) : g === "style" ? n[g] = { ...i, ...c } : g === "className" && (n[g] = [i, c].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function lm(t) {
  var g, i;
  let e = (g = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : g.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (i = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var rm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], at = rm.reduce((t, e) => {
  const n = v.forwardRef((g, i) => {
    const { asChild: c, ...A } = g, l = c ? Lg : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ k(l, { ...A, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function am(t, e) {
  t && YG.flushSync(() => t.dispatchEvent(e));
}
var KA = "Checkbox", [Cm, e2] = ii(KA), [um, bm] = Cm(KA), fa = v.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: g,
      checked: i,
      defaultChecked: c,
      required: A,
      disabled: l,
      value: a = "on",
      onCheckedChange: C,
      form: b,
      ...m
    } = t, [p, y] = v.useState(null), f = dt(e, (R) => y(R)), x = v.useRef(!1), Y = p ? b || !!p.closest("form") : !0, [B = !1, J] = fI({
      prop: i,
      defaultProp: c,
      onChange: C
    }), N = v.useRef(B);
    return v.useEffect(() => {
      const R = p == null ? void 0 : p.form;
      if (R) {
        const H = () => J(N.current);
        return R.addEventListener("reset", H), () => R.removeEventListener("reset", H);
      }
    }, [p, J]), /* @__PURE__ */ Pn(um, { scope: n, state: B, disabled: l, children: [
      /* @__PURE__ */ k(
        at.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Pe(B) ? "mixed" : B,
          "aria-required": A,
          "data-state": Na(B),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: a,
          ...m,
          ref: f,
          onKeyDown: Ct(t.onKeyDown, (R) => {
            R.key === "Enter" && R.preventDefault();
          }),
          onClick: Ct(t.onClick, (R) => {
            J((H) => Pe(H) ? !0 : !H), Y && (x.current = R.isPropagationStopped(), x.current || R.stopPropagation());
          })
        }
      ),
      Y && /* @__PURE__ */ k(
        dm,
        {
          control: p,
          bubbles: !x.current,
          name: g,
          value: a,
          checked: B,
          required: A,
          disabled: l,
          form: b,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Pe(c) ? !1 : c
        }
      )
    ] });
  }
);
fa.displayName = KA;
var Ba = "CheckboxIndicator", Ya = v.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: g, ...i } = t, c = bm(Ba, n);
    return /* @__PURE__ */ k(je, { present: g || Pe(c.state) || c.state === !0, children: /* @__PURE__ */ k(
      at.span,
      {
        "data-state": Na(c.state),
        "data-disabled": c.disabled ? "" : void 0,
        ...i,
        ref: e,
        style: { pointerEvents: "none", ...t.style }
      }
    ) });
  }
);
Ya.displayName = Ba;
var dm = (t) => {
  const { control: e, checked: n, bubbles: g = !0, defaultChecked: i, ...c } = t, A = v.useRef(null), l = PA(n), a = BI(e);
  v.useEffect(() => {
    const b = A.current, m = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(m, "checked").set;
    if (l !== n && y) {
      const f = new Event("click", { bubbles: g });
      b.indeterminate = Pe(n), y.call(b, Pe(n) ? !1 : n), b.dispatchEvent(f);
    }
  }, [l, n, g]);
  const C = v.useRef(Pe(n) ? !1 : n);
  return /* @__PURE__ */ k(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: i ?? C.current,
      ...c,
      tabIndex: -1,
      ref: A,
      style: {
        ...t.style,
        ...a,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Pe(t) {
  return t === "indeterminate";
}
function Na(t) {
  return Pe(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
var Gm = fa, mm = Ya;
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hm = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Ja = (...t) => t.filter((e, n, g) => !!e && g.indexOf(e) === n).join(" ");
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var pm = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vm = Le(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: g,
    className: i = "",
    children: c,
    iconNode: A,
    ...l
  }, a) => eI(
    "svg",
    {
      ref: a,
      ...pm,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: g ? Number(n) * 24 / Number(e) : n,
      className: Ja("lucide", i),
      ...l
    },
    [
      ...A.map(([C, b]) => eI(C, b)),
      ...Array.isArray(c) ? c : [c]
    ]
  )
);
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ra = (t, e) => {
  const n = Le(
    ({ className: g, ...i }, c) => eI(Vm, {
      ref: c,
      iconNode: e,
      className: Ja(`lucide-${hm(t)}`, g),
      ...i
    })
  );
  return n.displayName = `${t}`, n;
};
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zm = Ra("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.428.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ym = Ra("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]), vm = "data:audio/mpeg;base64,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";
function n2(t) {
  const {
    hasSound: e,
    shadow: n = !1,
    intent: g = UA.Primary,
    ...i
  } = t, [c] = iI(vm, {
    volume: 0.25
  }), A = "checked" in t, [l, a] = ee("defaultChecked" in t && t.defaultChecked || !1), C = A ? t.checked : l, b = (y) => {
    A || a(y), t.onCheckedChange && t.onCheckedChange(y === !0);
  }, m = Ke(t.checked);
  return Ee(() => {
    A && e && m.current !== i.checked && (m.current = i.checked, c());
  }, [i.checked]), /* @__PURE__ */ w(Gm, { css: Xm({
    checked: C,
    intent: g,
    shadow: n
  }), checked: C, onCheckedChange: (y) => {
    !A && e && c(), b == null || b(y);
  }, ...i, children: /* @__PURE__ */ Vt(mm, { css: xm(), children: [
    C === "indeterminate" && /* @__PURE__ */ w(ym, {}),
    C === !0 && /* @__PURE__ */ w(Zm, { strokeWidth: 2.5 })
  ] }) });
}
const Xm = (t) => /* @__PURE__ */ Gt([{
  all: "unset",
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  backgroundColor: t.checked ? $g[t.intent].backgroundColor : "#ddd",
  width: 26,
  height: 26,
  borderRadius: 4,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "2px solid white",
  transition: "0.2s ease-in-out",
  "&:active": {
    scale: 0.9
  },
  "&:focus": {
    boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)"
  }
}], t.shadow && me(2), process.env.NODE_ENV === "production" ? "" : ";label:RootStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), xm = (t) => /* @__PURE__ */ Gt([{
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "white"
}], process.env.NODE_ENV === "production" ? "" : ";label:IndicatorStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function Wm(t) {
  const {
    children: e,
    defaultValue: n = !1,
    value: g,
    hideBackgroundOnActive: i,
    hideBackgroundOnHover: c,
    selectable: A = !1,
    ...l
  } = t, [a, C] = ee(n), b = g !== void 0, m = b ? g : a, p = pn(() => {
    if (b) {
      const {
        onClick: y
      } = t;
      y == null || y();
    } else {
      const {
        onToggle: y
      } = t;
      C((f) => !f), y == null || y(a);
    }
  }, [b, a, g]);
  return /* @__PURE__ */ w("button", { css: [{
    background: "#0000",
    color: m ? K.warning : K.transparentLight,
    border: "none",
    cursor: "pointer",
    letterSpacing: "-0.1em",
    transition: ".2s",
    "&:enabled:active": [{
      filter: "brightness(110%)"
    }],
    "&:disabled": {
      opacity: 0.5,
      cursor: "default"
    }
  }, fn(ke.primary, pa.xs, "bold"), ti("xxl"), OA("md"), Va("sm"), $n, !i && m && {
    background: K.transparent
  }, !c && {
    "&:hover": {
      background: K.transparent
    }
  }, A || va, process.env.NODE_ENV === "production" ? "" : ";label:Chip;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], onClick: p, ...l, children: /* @__PURE__ */ w("div", { children: e }) });
}
const g2 = (t) => {
  const {
    size: e,
    matrix: n,
    cssProp: g,
    faceCss: i
  } = t, c = /* @__PURE__ */ Gt([{
    width: e,
    height: e,
    background: "skyblue",
    border: "2px solid black",
    opacity: 0.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Arial, sans-serif",
    fontSize: "2rem",
    position: "absolute"
  }, i], process.env.NODE_ENV === "production" ? "" : ";label:faceStyling;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  return /* @__PURE__ */ w("div", { css: [{
    width: e,
    height: e,
    perspective: 500
  }, g, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ Vt("div", { css: [{
    position: "relative",
    width: e,
    height: e,
    transformStyle: "preserve-3d"
  }, n && {
    transform: `matrix3d(${n})`
  }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateY(-${e / 2}px) rotateX(90deg)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: "Top" }),
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateY(${e / 2}px) rotateX(-90deg)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: "Bottom" }),
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateX(-${e / 2}px) rotateY(-90deg)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: "Left" }),
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateX(${e / 2}px) rotateY(90deg)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: "Right" }),
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateZ(${e / 2}px)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL0N1YmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFGVSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay91aS91aS9zcmMvY29tbW9uL2NvbXBvbmVudHMvYmFzZS9DdWJlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgSW50ZXJwb2xhdGlvbiwgVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBDU1NJbnRlcnBvbGF0aW9uIH0gZnJvbSAnQGVtb3Rpb24vc2VyaWFsaXplL3R5cGVzJztcblxuZXhwb3J0IGludGVyZmFjZSBDdWJlUHJvcHMge1xuICBzaXplOiBudW1iZXI7XG4gIG1hdHJpeD86IG51bWJlcltdIHwgbnVsbDtcbiAgY3NzUHJvcD86IEludGVycG9sYXRpb248VGhlbWU+O1xuICBmYWNlQ3NzPzogQ1NTSW50ZXJwb2xhdGlvbjtcbn1cblxuZXhwb3J0IGNvbnN0IEN1YmUgPSAocHJvcHM6IEN1YmVQcm9wcykgPT4ge1xuICBjb25zdCB7IHNpemUsIG1hdHJpeCwgY3NzUHJvcCwgZmFjZUNzcyB9ID0gcHJvcHM7XG5cbiAgY29uc3QgZmFjZVN0eWxpbmcgPSBjc3MoW1xuICAgIHtcbiAgICAgIHdpZHRoOiBzaXplLFxuICAgICAgaGVpZ2h0OiBzaXplLFxuICAgICAgYmFja2dyb3VuZDogJ3NreWJsdWUnLFxuICAgICAgYm9yZGVyOiAnMnB4IHNvbGlkIGJsYWNrJyxcbiAgICAgIG9wYWNpdHk6IDAuNSxcbiAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIGFsaWduSXRlbXM6ICdjZW50ZXInLFxuICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuICAgICAgZm9udEZhbWlseTogJ0FyaWFsLCBzYW5zLXNlcmlmJyxcbiAgICAgIGZvbnRTaXplOiAnMnJlbScsXG4gICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICB9LFxuICAgIGZhY2VDc3MsXG4gIF0pO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtbXG4gICAgICAgIHtcbiAgICAgICAgICB3aWR0aDogc2l6ZSxcbiAgICAgICAgICBoZWlnaHQ6IHNpemUsXG4gICAgICAgICAgcGVyc3BlY3RpdmU6IDUwMCxcbiAgICAgICAgfSxcbiAgICAgICAgY3NzUHJvcCxcbiAgICAgIF19XG4gICAgPlxuICAgICAgPGRpdlxuICAgICAgICBjc3M9e1tcbiAgICAgICAgICB7XG4gICAgICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgICAgIHdpZHRoOiBzaXplLFxuICAgICAgICAgICAgaGVpZ2h0OiBzaXplLFxuICAgICAgICAgICAgdHJhbnNmb3JtU3R5bGU6ICdwcmVzZXJ2ZS0zZCcsXG4gICAgICAgICAgfSxcbiAgICAgICAgICBtYXRyaXggJiYge1xuICAgICAgICAgICAgdHJhbnNmb3JtOiBgbWF0cml4M2QoJHttYXRyaXh9KWAsXG4gICAgICAgICAgfSxcbiAgICAgICAgXX1cbiAgICAgID5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17W1xuICAgICAgICAgICAgZmFjZVN0eWxpbmcsXG4gICAgICAgICAgICB7XG4gICAgICAgICAgICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZVkoLSR7c2l6ZSAvIDJ9cHgpIHJvdGF0ZVgoOTBkZWcpYCxcbiAgICAgICAgICAgIH0sXG4gICAgICAgICAgXX1cbiAgICAgICAgPlxuICAgICAgICAgIFRvcFxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17W2ZhY2VTdHlsaW5nLCB7IHRyYW5zZm9ybTogYHRyYW5zbGF0ZVkoJHtzaXplIC8gMn1weCkgcm90YXRlWCgtOTBkZWcpYCB9XX1cbiAgICAgICAgPlxuICAgICAgICAgIEJvdHRvbVxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17W2ZhY2VTdHlsaW5nLCB7IHRyYW5zZm9ybTogYHRyYW5zbGF0ZVgoLSR7c2l6ZSAvIDJ9cHgpIHJvdGF0ZVkoLTkwZGVnKWAgfV19XG4gICAgICAgID5cbiAgICAgICAgICBMZWZ0XG4gICAgICAgIDwvZGl2PlxuICAgICAgICA8ZGl2XG4gICAgICAgICAgY3NzPXtbXG4gICAgICAgICAgICBmYWNlU3R5bGluZyxcbiAgICAgICAgICAgIHtcbiAgICAgICAgICAgICAgdHJhbnNmb3JtOiBgdHJhbnNsYXRlWCgke3NpemUgLyAyfXB4KSByb3RhdGVZKDkwZGVnKWAsXG4gICAgICAgICAgICB9LFxuICAgICAgICAgIF19XG4gICAgICAgID5cbiAgICAgICAgICBSaWdodFxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdlxuICAgICAgICAgIGNzcz17W1xuICAgICAgICAgICAgZmFjZVN0eWxpbmcsXG4gICAgICAgICAgICB7XG4gICAgICAgICAgICAgIHRyYW5zZm9ybTogYHRyYW5zbGF0ZVooJHtzaXplIC8gMn1weClgLFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdfVxuICAgICAgICA+XG4gICAgICAgICAgRnJvbnRcbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxkaXZcbiAgICAgICAgICBjc3M9e1tmYWNlU3R5bGluZywgeyB0cmFuc2Zvcm06IGB0cmFuc2xhdGVaKC0ke3NpemUgLyAyfXB4KSByb3RhdGVZKDE4MGRlZylgIH1dfVxuICAgICAgICA+XG4gICAgICAgICAgQmFja1xuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICApO1xufTtcbiJdfQ== */"], children: "Front" }),
    /* @__PURE__ */ w("div", { css: [c, {
      transform: `translateZ(-${e / 2}px) rotateY(180deg)`
    }, process.env.NODE_ENV === "production" ? "" : ";label:Cube;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: "Back" })
  ] }) });
};
var fm = v.useId || (() => {
}), Bm = 0;
function Xc(t) {
  const [e, n] = v.useState(fm());
  return tg(() => {
    t || n((g) => g ?? String(Bm++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
function Ym(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t);
  v.useEffect(() => {
    const g = (i) => {
      i.key === "Escape" && n(i);
    };
    return e.addEventListener("keydown", g, { capture: !0 }), () => e.removeEventListener("keydown", g, { capture: !0 });
  }, [n, e]);
}
var Nm = "DismissableLayer", rA = "dismissableLayer.update", Jm = "dismissableLayer.pointerDownOutside", Rm = "dismissableLayer.focusOutside", tl, Sa = v.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Fa = v.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: g,
      onPointerDownOutside: i,
      onFocusOutside: c,
      onInteractOutside: A,
      onDismiss: l,
      ...a
    } = t, C = v.useContext(Sa), [b, m] = v.useState(null), p = (b == null ? void 0 : b.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = v.useState({}), f = dt(e, (O) => m(O)), x = Array.from(C.layers), [Y] = [...C.layersWithOutsidePointerEventsDisabled].slice(-1), B = x.indexOf(Y), J = b ? x.indexOf(b) : -1, N = C.layersWithOutsidePointerEventsDisabled.size > 0, R = J >= B, H = Hm((O) => {
      const j = O.target, U = [...C.branches].some((D) => D.contains(j));
      !R || U || (i == null || i(O), A == null || A(O), O.defaultPrevented || l == null || l());
    }, p), E = wm((O) => {
      const j = O.target;
      [...C.branches].some((D) => D.contains(j)) || (c == null || c(O), A == null || A(O), O.defaultPrevented || l == null || l());
    }, p);
    return Ym((O) => {
      J === C.layers.size - 1 && (g == null || g(O), !O.defaultPrevented && l && (O.preventDefault(), l()));
    }, p), v.useEffect(() => {
      if (b)
        return n && (C.layersWithOutsidePointerEventsDisabled.size === 0 && (tl = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), C.layersWithOutsidePointerEventsDisabled.add(b)), C.layers.add(b), el(), () => {
          n && C.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = tl);
        };
    }, [b, p, n, C]), v.useEffect(() => () => {
      b && (C.layers.delete(b), C.layersWithOutsidePointerEventsDisabled.delete(b), el());
    }, [b, C]), v.useEffect(() => {
      const O = () => y({});
      return document.addEventListener(rA, O), () => document.removeEventListener(rA, O);
    }, []), /* @__PURE__ */ k(
      at.div,
      {
        ...a,
        ref: f,
        style: {
          pointerEvents: N ? R ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Ct(t.onFocusCapture, E.onFocusCapture),
        onBlurCapture: Ct(t.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: Ct(
          t.onPointerDownCapture,
          H.onPointerDownCapture
        )
      }
    );
  }
);
Fa.displayName = Nm;
var Sm = "DismissableLayerBranch", Fm = v.forwardRef((t, e) => {
  const n = v.useContext(Sa), g = v.useRef(null), i = dt(e, g);
  return v.useEffect(() => {
    const c = g.current;
    if (c)
      return n.branches.add(c), () => {
        n.branches.delete(c);
      };
  }, [n.branches]), /* @__PURE__ */ k(at.div, { ...t, ref: i });
});
Fm.displayName = Sm;
function Hm(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t), g = v.useRef(!1), i = v.useRef(() => {
  });
  return v.useEffect(() => {
    const c = (l) => {
      if (l.target && !g.current) {
        let a = function() {
          Ha(
            Jm,
            n,
            C,
            { discrete: !0 }
          );
        };
        const C = { originalEvent: l };
        l.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = a, e.addEventListener("click", i.current, { once: !0 })) : a();
      } else
        e.removeEventListener("click", i.current);
      g.current = !1;
    }, A = window.setTimeout(() => {
      e.addEventListener("pointerdown", c);
    }, 0);
    return () => {
      window.clearTimeout(A), e.removeEventListener("pointerdown", c), e.removeEventListener("click", i.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => g.current = !0
  };
}
function wm(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(t), g = v.useRef(!1);
  return v.useEffect(() => {
    const i = (c) => {
      c.target && !g.current && Ha(Rm, n, { originalEvent: c }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, n]), {
    onFocusCapture: () => g.current = !0,
    onBlurCapture: () => g.current = !1
  };
}
function el() {
  const t = new CustomEvent(rA);
  document.dispatchEvent(t);
}
function Ha(t, e, n, { discrete: g }) {
  const i = n.originalEvent.target, c = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && i.addEventListener(t, e, { once: !0 }), g ? am(i, c) : i.dispatchEvent(c);
}
var xc = "focusScope.autoFocusOnMount", Wc = "focusScope.autoFocusOnUnmount", nl = { bubbles: !1, cancelable: !0 }, zm = "FocusScope", wa = v.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: g = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: c,
    ...A
  } = t, [l, a] = v.useState(null), C = wt(i), b = wt(c), m = v.useRef(null), p = dt(e, (x) => a(x)), y = v.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  v.useEffect(() => {
    if (g) {
      let x = function(N) {
        if (y.paused || !l) return;
        const R = N.target;
        l.contains(R) ? m.current = R : Te(m.current, { select: !0 });
      }, Y = function(N) {
        if (y.paused || !l) return;
        const R = N.relatedTarget;
        R !== null && (l.contains(R) || Te(m.current, { select: !0 }));
      }, B = function(N) {
        if (document.activeElement === document.body)
          for (const H of N)
            H.removedNodes.length > 0 && Te(l);
      };
      document.addEventListener("focusin", x), document.addEventListener("focusout", Y);
      const J = new MutationObserver(B);
      return l && J.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", x), document.removeEventListener("focusout", Y), J.disconnect();
      };
    }
  }, [g, l, y.paused]), v.useEffect(() => {
    if (l) {
      il.add(y);
      const x = document.activeElement;
      if (!l.contains(x)) {
        const B = new CustomEvent(xc, nl);
        l.addEventListener(xc, C), l.dispatchEvent(B), B.defaultPrevented || (qm(jm(za(l)), { select: !0 }), document.activeElement === x && Te(l));
      }
      return () => {
        l.removeEventListener(xc, C), setTimeout(() => {
          const B = new CustomEvent(Wc, nl);
          l.addEventListener(Wc, b), l.dispatchEvent(B), B.defaultPrevented || Te(x ?? document.body, { select: !0 }), l.removeEventListener(Wc, b), il.remove(y);
        }, 0);
      };
    }
  }, [l, C, b, y]);
  const f = v.useCallback(
    (x) => {
      if (!n && !g || y.paused) return;
      const Y = x.key === "Tab" && !x.altKey && !x.ctrlKey && !x.metaKey, B = document.activeElement;
      if (Y && B) {
        const J = x.currentTarget, [N, R] = Dm(J);
        N && R ? !x.shiftKey && B === R ? (x.preventDefault(), n && Te(N, { select: !0 })) : x.shiftKey && B === N && (x.preventDefault(), n && Te(R, { select: !0 })) : B === J && x.preventDefault();
      }
    },
    [n, g, y.paused]
  );
  return /* @__PURE__ */ k(at.div, { tabIndex: -1, ...A, ref: p, onKeyDown: f });
});
wa.displayName = zm;
function qm(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const g of t)
    if (Te(g, { select: e }), document.activeElement !== n) return;
}
function Dm(t) {
  const e = za(t), n = gl(e, t), g = gl(e.reverse(), t);
  return [n, g];
}
function za(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (g) => {
      const i = g.tagName === "INPUT" && g.type === "hidden";
      return g.disabled || g.hidden || i ? NodeFilter.FILTER_SKIP : g.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function gl(t, e) {
  for (const n of t)
    if (!Lm(n, { upTo: e })) return n;
}
function Lm(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function km(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Te(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && km(t) && e && t.select();
  }
}
var il = Em();
function Em() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = Il(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = Il(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function Il(t, e) {
  const n = [...t], g = n.indexOf(e);
  return g !== -1 && n.splice(g, 1), n;
}
function jm(t) {
  return t.filter((e) => e.tagName !== "A");
}
var Mm = "Portal", qa = v.forwardRef((t, e) => {
  var l;
  const { container: n, ...g } = t, [i, c] = v.useState(!1);
  tg(() => c(!0), []);
  const A = n || i && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return A ? NG.createPortal(/* @__PURE__ */ k(at.div, { ...g, ref: e }), A) : null;
});
qa.displayName = Mm;
var fc = 0;
function Um() {
  v.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? cl()), document.body.insertAdjacentElement("beforeend", t[1] ?? cl()), fc++, () => {
      fc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), fc--;
    };
  }, []);
}
function cl() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var be = function() {
  return be = Object.assign || function(e) {
    for (var n, g = 1, i = arguments.length; g < i; g++) {
      n = arguments[g];
      for (var c in n) Object.prototype.hasOwnProperty.call(n, c) && (e[c] = n[c]);
    }
    return e;
  }, be.apply(this, arguments);
};
function Da(t, e) {
  var n = {};
  for (var g in t) Object.prototype.hasOwnProperty.call(t, g) && e.indexOf(g) < 0 && (n[g] = t[g]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, g = Object.getOwnPropertySymbols(t); i < g.length; i++)
      e.indexOf(g[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, g[i]) && (n[g[i]] = t[g[i]]);
  return n;
}
function Tm(t, e, n) {
  if (n || arguments.length === 2) for (var g = 0, i = e.length, c; g < i; g++)
    (c || !(g in e)) && (c || (c = Array.prototype.slice.call(e, 0, g)), c[g] = e[g]);
  return t.concat(c || Array.prototype.slice.call(e));
}
var Ui = "right-scroll-bar-position", Ti = "width-before-scroll-bar", Qm = "with-scroll-bars-hidden", Om = "--removed-body-scroll-bar-size";
function Bc(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Pm(t, e) {
  var n = ee(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(g) {
          var i = n.value;
          i !== g && (n.value = g, n.callback(g, i));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var Km = typeof window < "u" ? v.useLayoutEffect : v.useEffect, Al = /* @__PURE__ */ new WeakMap();
function _m(t, e) {
  var n = Pm(null, function(g) {
    return t.forEach(function(i) {
      return Bc(i, g);
    });
  });
  return Km(function() {
    var g = Al.get(n);
    if (g) {
      var i = new Set(g), c = new Set(t), A = n.current;
      i.forEach(function(l) {
        c.has(l) || Bc(l, null);
      }), c.forEach(function(l) {
        i.has(l) || Bc(l, A);
      });
    }
    Al.set(n, t);
  }, [t]), n;
}
function $m(t) {
  return t;
}
function th(t, e) {
  e === void 0 && (e = $m);
  var n = [], g = !1, i = {
    read: function() {
      if (g)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(c) {
      var A = e(c, g);
      return n.push(A), function() {
        n = n.filter(function(l) {
          return l !== A;
        });
      };
    },
    assignSyncMedium: function(c) {
      for (g = !0; n.length; ) {
        var A = n;
        n = [], A.forEach(c);
      }
      n = {
        push: function(l) {
          return c(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(c) {
      g = !0;
      var A = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(c), A = n;
      }
      var a = function() {
        var b = A;
        A = [], b.forEach(c);
      }, C = function() {
        return Promise.resolve().then(a);
      };
      C(), n = {
        push: function(b) {
          A.push(b), C();
        },
        filter: function(b) {
          return A = A.filter(b), n;
        }
      };
    }
  };
  return i;
}
function eh(t) {
  t === void 0 && (t = {});
  var e = th(null);
  return e.options = be({ async: !0, ssr: !1 }, t), e;
}
var La = function(t) {
  var e = t.sideCar, n = Da(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var g = e.read();
  if (!g)
    throw new Error("Sidecar medium not found");
  return v.createElement(g, be({}, n));
};
La.isSideCarExport = !0;
function nh(t, e) {
  return t.useMedium(e), La;
}
var ka = eh(), Yc = function() {
}, YI = v.forwardRef(function(t, e) {
  var n = v.useRef(null), g = v.useState({
    onScrollCapture: Yc,
    onWheelCapture: Yc,
    onTouchMoveCapture: Yc
  }), i = g[0], c = g[1], A = t.forwardProps, l = t.children, a = t.className, C = t.removeScrollBar, b = t.enabled, m = t.shards, p = t.sideCar, y = t.noIsolation, f = t.inert, x = t.allowPinchZoom, Y = t.as, B = Y === void 0 ? "div" : Y, J = t.gapMode, N = Da(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = p, H = _m([n, e]), E = be(be({}, N), i);
  return v.createElement(
    v.Fragment,
    null,
    b && v.createElement(R, { sideCar: ka, removeScrollBar: C, shards: m, noIsolation: y, inert: f, setCallbacks: c, allowPinchZoom: !!x, lockRef: n, gapMode: J }),
    A ? v.cloneElement(v.Children.only(l), be(be({}, E), { ref: H })) : v.createElement(B, be({}, E, { className: a, ref: H }), l)
  );
});
YI.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
YI.classNames = {
  fullWidth: Ti,
  zeroRight: Ui
};
var gh = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ih() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = gh();
  return e && t.setAttribute("nonce", e), t;
}
function Ih(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function ch(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var Ah = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = ih()) && (Ih(e, n), ch(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, sh = function() {
  var t = Ah();
  return function(e, n) {
    v.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, Ea = function() {
  var t = sh(), e = function(n) {
    var g = n.styles, i = n.dynamic;
    return t(g, i), null;
  };
  return e;
}, oh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Nc = function(t) {
  return parseInt(t || "", 10) || 0;
}, lh = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], g = e[t === "padding" ? "paddingTop" : "marginTop"], i = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Nc(n), Nc(g), Nc(i)];
}, rh = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return oh;
  var e = lh(t), n = document.documentElement.clientWidth, g = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, g - n + e[2] - e[0])
  };
}, ah = Ea(), Qn = "data-scroll-locked", Ch = function(t, e, n, g) {
  var i = t.left, c = t.top, A = t.right, l = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Qm, ` {
   overflow: hidden `).concat(g, `;
   padding-right: `).concat(l, "px ").concat(g, `;
  }
  body[`).concat(Qn, `] {
    overflow: hidden `).concat(g, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(g, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(c, `px;
    padding-right: `).concat(A, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(g, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(g, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ui, ` {
    right: `).concat(l, "px ").concat(g, `;
  }
  
  .`).concat(Ti, ` {
    margin-right: `).concat(l, "px ").concat(g, `;
  }
  
  .`).concat(Ui, " .").concat(Ui, ` {
    right: 0 `).concat(g, `;
  }
  
  .`).concat(Ti, " .").concat(Ti, ` {
    margin-right: 0 `).concat(g, `;
  }
  
  body[`).concat(Qn, `] {
    `).concat(Om, ": ").concat(l, `px;
  }
`);
}, sl = function() {
  var t = parseInt(document.body.getAttribute(Qn) || "0", 10);
  return isFinite(t) ? t : 0;
}, uh = function() {
  v.useEffect(function() {
    return document.body.setAttribute(Qn, (sl() + 1).toString()), function() {
      var t = sl() - 1;
      t <= 0 ? document.body.removeAttribute(Qn) : document.body.setAttribute(Qn, t.toString());
    };
  }, []);
}, bh = function(t) {
  var e = t.noRelative, n = t.noImportant, g = t.gapMode, i = g === void 0 ? "margin" : g;
  uh();
  var c = v.useMemo(function() {
    return rh(i);
  }, [i]);
  return v.createElement(ah, { styles: Ch(c, !e, i, n ? "" : "!important") });
}, aA = !1;
if (typeof window < "u")
  try {
    var Ji = Object.defineProperty({}, "passive", {
      get: function() {
        return aA = !0, !0;
      }
    });
    window.addEventListener("test", Ji, Ji), window.removeEventListener("test", Ji, Ji);
  } catch {
    aA = !1;
  }
var Hn = aA ? { passive: !1 } : !1, dh = function(t) {
  return t.tagName === "TEXTAREA";
}, ja = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !dh(t) && n[e] === "visible")
  );
}, Gh = function(t) {
  return ja(t, "overflowY");
}, mh = function(t) {
  return ja(t, "overflowX");
}, ol = function(t, e) {
  var n = e.ownerDocument, g = e;
  do {
    typeof ShadowRoot < "u" && g instanceof ShadowRoot && (g = g.host);
    var i = Ma(t, g);
    if (i) {
      var c = Ua(t, g), A = c[1], l = c[2];
      if (A > l)
        return !0;
    }
    g = g.parentNode;
  } while (g && g !== n.body);
  return !1;
}, hh = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, g = t.clientHeight;
  return [
    e,
    n,
    g
  ];
}, ph = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, g = t.clientWidth;
  return [
    e,
    n,
    g
  ];
}, Ma = function(t, e) {
  return t === "v" ? Gh(e) : mh(e);
}, Ua = function(t, e) {
  return t === "v" ? hh(e) : ph(e);
}, Vh = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, Zh = function(t, e, n, g, i) {
  var c = Vh(t, window.getComputedStyle(e).direction), A = c * g, l = n.target, a = e.contains(l), C = !1, b = A > 0, m = 0, p = 0;
  do {
    var y = Ua(t, l), f = y[0], x = y[1], Y = y[2], B = x - Y - c * f;
    (f || B) && Ma(t, l) && (m += B, p += f), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !a && l !== document.body || // self content
    a && (e.contains(l) || e === l)
  );
  return (b && (Math.abs(m) < 1 || !i) || !b && (Math.abs(p) < 1 || !i)) && (C = !0), C;
}, Ri = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, ll = function(t) {
  return [t.deltaX, t.deltaY];
}, rl = function(t) {
  return t && "current" in t ? t.current : t;
}, yh = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, vh = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, Xh = 0, wn = [];
function xh(t) {
  var e = v.useRef([]), n = v.useRef([0, 0]), g = v.useRef(), i = v.useState(Xh++)[0], c = v.useState(Ea)[0], A = v.useRef(t);
  v.useEffect(function() {
    A.current = t;
  }, [t]), v.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var x = Tm([t.lockRef.current], (t.shards || []).map(rl), !0).filter(Boolean);
      return x.forEach(function(Y) {
        return Y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), x.forEach(function(Y) {
          return Y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var l = v.useCallback(function(x, Y) {
    if ("touches" in x && x.touches.length === 2 || x.type === "wheel" && x.ctrlKey)
      return !A.current.allowPinchZoom;
    var B = Ri(x), J = n.current, N = "deltaX" in x ? x.deltaX : J[0] - B[0], R = "deltaY" in x ? x.deltaY : J[1] - B[1], H, E = x.target, O = Math.abs(N) > Math.abs(R) ? "h" : "v";
    if ("touches" in x && O === "h" && E.type === "range")
      return !1;
    var j = ol(O, E);
    if (!j)
      return !0;
    if (j ? H = O : (H = O === "v" ? "h" : "v", j = ol(O, E)), !j)
      return !1;
    if (!g.current && "changedTouches" in x && (N || R) && (g.current = H), !H)
      return !0;
    var U = g.current || H;
    return Zh(U, Y, x, U === "h" ? N : R, !0);
  }, []), a = v.useCallback(function(x) {
    var Y = x;
    if (!(!wn.length || wn[wn.length - 1] !== c)) {
      var B = "deltaY" in Y ? ll(Y) : Ri(Y), J = e.current.filter(function(H) {
        return H.name === Y.type && (H.target === Y.target || Y.target === H.shadowParent) && yh(H.delta, B);
      })[0];
      if (J && J.should) {
        Y.cancelable && Y.preventDefault();
        return;
      }
      if (!J) {
        var N = (A.current.shards || []).map(rl).filter(Boolean).filter(function(H) {
          return H.contains(Y.target);
        }), R = N.length > 0 ? l(Y, N[0]) : !A.current.noIsolation;
        R && Y.cancelable && Y.preventDefault();
      }
    }
  }, []), C = v.useCallback(function(x, Y, B, J) {
    var N = { name: x, delta: Y, target: B, should: J, shadowParent: Wh(B) };
    e.current.push(N), setTimeout(function() {
      e.current = e.current.filter(function(R) {
        return R !== N;
      });
    }, 1);
  }, []), b = v.useCallback(function(x) {
    n.current = Ri(x), g.current = void 0;
  }, []), m = v.useCallback(function(x) {
    C(x.type, ll(x), x.target, l(x, t.lockRef.current));
  }, []), p = v.useCallback(function(x) {
    C(x.type, Ri(x), x.target, l(x, t.lockRef.current));
  }, []);
  v.useEffect(function() {
    return wn.push(c), t.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", a, Hn), document.addEventListener("touchmove", a, Hn), document.addEventListener("touchstart", b, Hn), function() {
      wn = wn.filter(function(x) {
        return x !== c;
      }), document.removeEventListener("wheel", a, Hn), document.removeEventListener("touchmove", a, Hn), document.removeEventListener("touchstart", b, Hn);
    };
  }, []);
  var y = t.removeScrollBar, f = t.inert;
  return v.createElement(
    v.Fragment,
    null,
    f ? v.createElement(c, { styles: vh(i) }) : null,
    y ? v.createElement(bh, { gapMode: t.gapMode }) : null
  );
}
function Wh(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const fh = nh(ka, xh);
var Ta = v.forwardRef(function(t, e) {
  return v.createElement(YI, be({}, t, { ref: e, sideCar: fh }));
});
Ta.classNames = YI.classNames;
var Bh = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, zn = /* @__PURE__ */ new WeakMap(), Si = /* @__PURE__ */ new WeakMap(), Fi = {}, Jc = 0, Qa = function(t) {
  return t && (t.host || Qa(t.parentNode));
}, Yh = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var g = Qa(n);
    return g && t.contains(g) ? g : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Nh = function(t, e, n, g) {
  var i = Yh(e, Array.isArray(t) ? t : [t]);
  Fi[n] || (Fi[n] = /* @__PURE__ */ new WeakMap());
  var c = Fi[n], A = [], l = /* @__PURE__ */ new Set(), a = new Set(i), C = function(m) {
    !m || l.has(m) || (l.add(m), C(m.parentNode));
  };
  i.forEach(C);
  var b = function(m) {
    !m || a.has(m) || Array.prototype.forEach.call(m.children, function(p) {
      if (l.has(p))
        b(p);
      else
        try {
          var y = p.getAttribute(g), f = y !== null && y !== "false", x = (zn.get(p) || 0) + 1, Y = (c.get(p) || 0) + 1;
          zn.set(p, x), c.set(p, Y), A.push(p), x === 1 && f && Si.set(p, !0), Y === 1 && p.setAttribute(n, "true"), f || p.setAttribute(g, "true");
        } catch (B) {
          console.error("aria-hidden: cannot operate on ", p, B);
        }
    });
  };
  return b(e), l.clear(), Jc++, function() {
    A.forEach(function(m) {
      var p = zn.get(m) - 1, y = c.get(m) - 1;
      zn.set(m, p), c.set(m, y), p || (Si.has(m) || m.removeAttribute(g), Si.delete(m)), y || m.removeAttribute(n);
    }), Jc--, Jc || (zn = /* @__PURE__ */ new WeakMap(), zn = /* @__PURE__ */ new WeakMap(), Si = /* @__PURE__ */ new WeakMap(), Fi = {});
  };
}, Jh = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var g = Array.from(Array.isArray(t) ? t : [t]), i = Bh(t);
  return i ? (g.push.apply(g, Array.from(i.querySelectorAll("[aria-live]"))), Nh(g, i, n, "aria-hidden")) : function() {
    return null;
  };
}, _A = "Dialog", [Oa, i2] = ii(_A), [Rh, le] = Oa(_A), Pa = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: g,
    defaultOpen: i,
    onOpenChange: c,
    modal: A = !0
  } = t, l = v.useRef(null), a = v.useRef(null), [C = !1, b] = fI({
    prop: g,
    defaultProp: i,
    onChange: c
  });
  return /* @__PURE__ */ k(
    Rh,
    {
      scope: e,
      triggerRef: l,
      contentRef: a,
      contentId: Xc(),
      titleId: Xc(),
      descriptionId: Xc(),
      open: C,
      onOpenChange: b,
      onOpenToggle: v.useCallback(() => b((m) => !m), [b]),
      modal: A,
      children: n
    }
  );
};
Pa.displayName = _A;
var Ka = "DialogTrigger", _a = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...g } = t, i = le(Ka, n), c = dt(e, i.triggerRef);
    return /* @__PURE__ */ k(
      at.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": es(i.open),
        ...g,
        ref: c,
        onClick: Ct(t.onClick, i.onOpenToggle)
      }
    );
  }
);
_a.displayName = Ka;
var $A = "DialogPortal", [Sh, $a] = Oa($A, {
  forceMount: void 0
}), tC = (t) => {
  const { __scopeDialog: e, forceMount: n, children: g, container: i } = t, c = le($A, e);
  return /* @__PURE__ */ k(Sh, { scope: e, forceMount: n, children: v.Children.map(g, (A) => /* @__PURE__ */ k(je, { present: n || c.open, children: /* @__PURE__ */ k(qa, { asChild: !0, container: i, children: A }) })) });
};
tC.displayName = $A;
var II = "DialogOverlay", eC = v.forwardRef(
  (t, e) => {
    const n = $a(II, t.__scopeDialog), { forceMount: g = n.forceMount, ...i } = t, c = le(II, t.__scopeDialog);
    return c.modal ? /* @__PURE__ */ k(je, { present: g || c.open, children: /* @__PURE__ */ k(Fh, { ...i, ref: e }) }) : null;
  }
);
eC.displayName = II;
var Fh = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...g } = t, i = le(II, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ k(Ta, { as: Lg, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ k(
        at.div,
        {
          "data-state": es(i.open),
          ...g,
          ref: e,
          style: { pointerEvents: "auto", ...g.style }
        }
      ) })
    );
  }
), Xn = "DialogContent", nC = v.forwardRef(
  (t, e) => {
    const n = $a(Xn, t.__scopeDialog), { forceMount: g = n.forceMount, ...i } = t, c = le(Xn, t.__scopeDialog);
    return /* @__PURE__ */ k(je, { present: g || c.open, children: c.modal ? /* @__PURE__ */ k(Hh, { ...i, ref: e }) : /* @__PURE__ */ k(wh, { ...i, ref: e }) });
  }
);
nC.displayName = Xn;
var Hh = v.forwardRef(
  (t, e) => {
    const n = le(Xn, t.__scopeDialog), g = v.useRef(null), i = dt(e, n.contentRef, g);
    return v.useEffect(() => {
      const c = g.current;
      if (c) return Jh(c);
    }, []), /* @__PURE__ */ k(
      gC,
      {
        ...t,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ct(t.onCloseAutoFocus, (c) => {
          var A;
          c.preventDefault(), (A = n.triggerRef.current) == null || A.focus();
        }),
        onPointerDownOutside: Ct(t.onPointerDownOutside, (c) => {
          const A = c.detail.originalEvent, l = A.button === 0 && A.ctrlKey === !0;
          (A.button === 2 || l) && c.preventDefault();
        }),
        onFocusOutside: Ct(
          t.onFocusOutside,
          (c) => c.preventDefault()
        )
      }
    );
  }
), wh = v.forwardRef(
  (t, e) => {
    const n = le(Xn, t.__scopeDialog), g = v.useRef(!1), i = v.useRef(!1);
    return /* @__PURE__ */ k(
      gC,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (c) => {
          var A, l;
          (A = t.onCloseAutoFocus) == null || A.call(t, c), c.defaultPrevented || (g.current || (l = n.triggerRef.current) == null || l.focus(), c.preventDefault()), g.current = !1, i.current = !1;
        },
        onInteractOutside: (c) => {
          var a, C;
          (a = t.onInteractOutside) == null || a.call(t, c), c.defaultPrevented || (g.current = !0, c.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const A = c.target;
          ((C = n.triggerRef.current) == null ? void 0 : C.contains(A)) && c.preventDefault(), c.detail.originalEvent.type === "focusin" && i.current && c.preventDefault();
        }
      }
    );
  }
), gC = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: g, onOpenAutoFocus: i, onCloseAutoFocus: c, ...A } = t, l = le(Xn, n), a = v.useRef(null), C = dt(e, a);
    return Um(), /* @__PURE__ */ Pn(nI, { children: [
      /* @__PURE__ */ k(
        wa,
        {
          asChild: !0,
          loop: !0,
          trapped: g,
          onMountAutoFocus: i,
          onUnmountAutoFocus: c,
          children: /* @__PURE__ */ k(
            Fa,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": es(l.open),
              ...A,
              ref: C,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Pn(nI, { children: [
        /* @__PURE__ */ k(Dh, { titleId: l.titleId }),
        /* @__PURE__ */ k(kh, { contentRef: a, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), ts = "DialogTitle", iC = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...g } = t, i = le(ts, n);
    return /* @__PURE__ */ k(at.h2, { id: i.titleId, ...g, ref: e });
  }
);
iC.displayName = ts;
var IC = "DialogDescription", zh = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...g } = t, i = le(IC, n);
    return /* @__PURE__ */ k(at.p, { id: i.descriptionId, ...g, ref: e });
  }
);
zh.displayName = IC;
var cC = "DialogClose", qh = v.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...g } = t, i = le(cC, n);
    return /* @__PURE__ */ k(
      at.button,
      {
        type: "button",
        ...g,
        ref: e,
        onClick: Ct(t.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
qh.displayName = cC;
function es(t) {
  return t ? "open" : "closed";
}
var AC = "DialogTitleWarning", [I2, sC] = em(AC, {
  contentName: Xn,
  titleName: ts,
  docsSlug: "dialog"
}), Dh = ({ titleId: t }) => {
  const e = sC(AC), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return v.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, Lh = "DialogDescriptionWarning", kh = ({ contentRef: t, descriptionId: e }) => {
  const g = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${sC(Lh).contentName}}.`;
  return v.useEffect(() => {
    var c;
    const i = (c = t.current) == null ? void 0 : c.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(g));
  }, [g, t, e]), null;
}, Eh = Pa, jh = _a, Mh = tC, Uh = nC;
function c2(t) {
  const {
    className: e,
    onInput: n,
    onChange: g,
    ...i
  } = t;
  return /* @__PURE__ */ w("input", { className: e, css: [{
    background: K.componentInset,
    color: K.text,
    "&:focus": {
      outline: "none",
      borderColor: K.borderFocused,
      filter: "brightness(110%)"
    }
  }, QA(K.border), ti("md"), OA("md"), Va("sm"), me(2, !0), fn(ke.secondary, pa.md), process.env.NODE_ENV === "production" ? "" : ";label:Input;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], onChange: (c) => {
    g == null || g(c), n && n(c.target.value);
  }, ...i });
}
Oh(Array.from({ length: 256 }, (t, e) => e));
function Th(t, e) {
  return t + Math.random() * (e - t);
}
function Qh(t, e) {
  return Math.floor(Th(t, e));
}
function Oh(t) {
  const e = t.slice();
  for (let n = e.length - 1; n > 0; n--) {
    const g = Qh(0, n + 1);
    [e[n], e[g]] = [e[g], e[n]];
  }
  return e;
}
var Ph = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, e) {
    return "Cannot apply '" + t + "' to '" + e.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, e) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + e;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, e) {
    return "the entry '" + t + "' does not exist in the observable map '" + e + "'";
  },
  26: "please specify a property",
  27: function(t, e) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + e + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, e) {
    return "Cycle detected in computation " + t + ": " + e;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, Kh = process.env.NODE_ENV !== "production" ? Ph : {};
function T(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), g = 1; g < e; g++)
    n[g - 1] = arguments[g];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof t == "string" ? t : Kh[t];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof t == "number" ? "[MobX] minified error nr: " + t + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + t);
}
var _h = {};
function ns() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : _h;
}
var oC = Object.assign, cI = Object.getOwnPropertyDescriptor, he = Object.defineProperty, NI = Object.prototype, AI = [];
Object.freeze(AI);
var lC = {};
Object.freeze(lC);
var $h = typeof Proxy < "u", tp = /* @__PURE__ */ Object.toString();
function rC() {
  $h || T(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Jg(t) {
  process.env.NODE_ENV !== "production" && L.verifyProxies && T("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + t);
}
function re() {
  return ++L.mobxGuid;
}
function gs(t) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, t.apply(this, arguments);
  };
}
var Dn = function() {
};
function yt(t) {
  return typeof t == "function";
}
function xn(t) {
  var e = typeof t;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function JI(t) {
  return t !== null && typeof t == "object";
}
function ve(t) {
  if (!JI(t))
    return !1;
  var e = Object.getPrototypeOf(t);
  if (e == null)
    return !0;
  var n = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n.toString() === tp;
}
function aC(t) {
  var e = t == null ? void 0 : t.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function is(t, e, n) {
  he(t, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function CC(t, e, n) {
  he(t, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function Bn(t, e) {
  var n = "isMobX" + t;
  return e.prototype[n] = !0, function(g) {
    return JI(g) && g[n] === !0;
  };
}
function og(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Map]";
}
function ep(t) {
  var e = Object.getPrototypeOf(t), n = Object.getPrototypeOf(e), g = Object.getPrototypeOf(n);
  return g === null;
}
function Re(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Set]";
}
var uC = typeof Object.getOwnPropertySymbols < "u";
function np(t) {
  var e = Object.keys(t);
  if (!uC)
    return e;
  var n = Object.getOwnPropertySymbols(t);
  return n.length ? [].concat(e, n.filter(function(g) {
    return NI.propertyIsEnumerable.call(t, g);
  })) : e;
}
var Is = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : uC ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function CA(t) {
  return typeof t == "string" ? t : typeof t == "symbol" ? t.toString() : new String(t).toString();
}
function bC(t) {
  return t === null ? null : typeof t == "object" ? "" + t : t;
}
function ce(t, e) {
  return NI.hasOwnProperty.call(t, e);
}
var gp = Object.getOwnPropertyDescriptors || function(t) {
  var e = {};
  return Is(t).forEach(function(n) {
    e[n] = cI(t, n);
  }), e;
};
function qt(t, e) {
  return !!(t & e);
}
function Dt(t, e, n) {
  return n ? t |= e : t &= ~e, t;
}
function al(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, g = Array(e); n < e; n++) g[n] = t[n];
  return g;
}
function ip(t, e) {
  for (var n = 0; n < e.length; n++) {
    var g = e[n];
    g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(t, cp(g.key), g);
  }
}
function lg(t, e, n) {
  return e && ip(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Ln(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = Ap(t)) || e) {
    n && (t = n);
    var g = 0;
    return function() {
      return g >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[g++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $e() {
  return $e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var g in n) ({}).hasOwnProperty.call(n, g) && (t[g] = n[g]);
    }
    return t;
  }, $e.apply(null, arguments);
}
function dC(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, uA(t, e);
}
function uA(t, e) {
  return uA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, g) {
    return n.__proto__ = g, n;
  }, uA(t, e);
}
function Ip(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var g = n.call(t, e);
    if (typeof g != "object") return g;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function cp(t) {
  var e = Ip(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Ap(t, e) {
  if (t) {
    if (typeof t == "string") return al(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? al(t, e) : void 0;
  }
}
var Se = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function pe(t) {
  function e(n, g) {
    if (ci(g))
      return t.decorate_20223_(n, g);
    Ii(n, g, t);
  }
  return Object.assign(e, t);
}
function Ii(t, e, n) {
  if (ce(t, Se) || is(t, Se, $e({}, t[Se])), process.env.NODE_ENV !== "production" && oI(n) && !ce(t[Se], e)) {
    var g = t.constructor.name + ".prototype." + e.toString();
    T("'" + g + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  sp(t, n, e), oI(n) || (t[Se][e] = n);
}
function sp(t, e, n) {
  if (process.env.NODE_ENV !== "production" && !oI(e) && ce(t[Se], n)) {
    var g = t.constructor.name + ".prototype." + n.toString(), i = t[Se][n].annotationType_, c = e.annotationType_;
    T("Cannot apply '@" + c + "' to '" + g + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function ci(t) {
  return typeof t == "object" && typeof t.kind == "string";
}
function RI(t, e) {
  process.env.NODE_ENV !== "production" && !e.includes(t.kind) && T("The decorator applied to '" + String(t.name) + "' cannot be used on a " + t.kind + " element");
}
var tt = /* @__PURE__ */ Symbol("mobx administration"), An = /* @__PURE__ */ function() {
  function t(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + re() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = It.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var e = t.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, e.reportObserved = function() {
    return NC(this);
  }, e.reportChanged = function() {
    _t(), JC(this), $t();
  }, e.toString = function() {
    return this.name_;
  }, lg(t, [{
    key: "isBeingObserved",
    get: function() {
      return qt(this.flags_, t.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return qt(this.flags_, t.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return qt(this.flags_, t.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.diffValueMask_, n === 1);
    }
  }]);
}();
An.isBeingObservedMask_ = 1;
An.isPendingUnobservationMask_ = 2;
An.diffValueMask_ = 4;
var cs = /* @__PURE__ */ Bn("Atom", An);
function GC(t, e, n) {
  e === void 0 && (e = Dn), n === void 0 && (n = Dn);
  var g = new An(t);
  return e !== Dn && VV(g, e), n !== Dn && zC(g, n), g;
}
function op(t, e) {
  return t === e;
}
function lp(t, e) {
  return us(t, e);
}
function rp(t, e) {
  return us(t, e, 1);
}
function ap(t, e) {
  return Object.is ? Object.is(t, e) : t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
var sI = {
  identity: op,
  structural: lp,
  default: ap,
  shallow: rp
};
function rg(t, e, n) {
  return jg(t) ? t : Array.isArray(t) ? Yt.array(t, {
    name: n
  }) : ve(t) ? Yt.object(t, void 0, {
    name: n
  }) : og(t) ? Yt.map(t, {
    name: n
  }) : Re(t) ? Yt.set(t, {
    name: n
  }) : typeof t == "function" && !ng(t) && !Eg(t) ? aC(t) ? gg(t) : kg(n, t) : t;
}
function Cp(t, e, n) {
  if (t == null || ri(t) || zI(t) || sn(t) || de(t))
    return t;
  if (Array.isArray(t))
    return Yt.array(t, {
      name: n,
      deep: !1
    });
  if (ve(t))
    return Yt.object(t, void 0, {
      name: n,
      deep: !1
    });
  if (og(t))
    return Yt.map(t, {
      name: n,
      deep: !1
    });
  if (Re(t))
    return Yt.set(t, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && T("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function SI(t) {
  return t;
}
function up(t, e) {
  return process.env.NODE_ENV !== "production" && jg(t) && T("observable.struct should not be used with observable values"), us(t, e) ? e : t;
}
var bp = "override";
function oI(t) {
  return t.annotationType_ === bp;
}
function Ai(t, e) {
  return {
    annotationType_: t,
    options_: e,
    make_: dp,
    extend_: Gp,
    decorate_20223_: mp
  };
}
function dp(t, e, n, g) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(t, e, n, !1) === null ? 0 : 1;
  if (g === t.target_)
    return this.extend_(t, e, n, !1) === null ? 0 : 2;
  if (ng(n.value))
    return 1;
  var c = mC(t, this, e, n, !1);
  return he(g, e, c), 2;
}
function Gp(t, e, n, g) {
  var i = mC(t, this, e, n);
  return t.defineProperty_(e, i, g);
}
function mp(t, e) {
  process.env.NODE_ENV !== "production" && RI(e, ["method", "field"]);
  var n = e.kind, g = e.name, i = e.addInitializer, c = this, A = function(a) {
    var C, b, m, p;
    return Wn((C = (b = c.options_) == null ? void 0 : b.name) != null ? C : g.toString(), a, (m = (p = c.options_) == null ? void 0 : p.autoAction) != null ? m : !1);
  };
  if (n == "field")
    return function(a) {
      var C, b = a;
      return ng(b) || (b = A(b)), (C = c.options_) != null && C.bound && (b = b.bind(this), b.isMobxAction = !0), b;
    };
  if (n == "method") {
    var l;
    return ng(t) || (t = A(t)), (l = this.options_) != null && l.bound && i(function() {
      var a = this, C = a[g].bind(a);
      C.isMobxAction = !0, a[g] = C;
    }), t;
  }
  T("Cannot apply '" + c.annotationType_ + "' to '" + String(g) + "' (kind: " + n + "):" + (`
'` + c.annotationType_ + "' can only be used on properties with a function value."));
}
function hp(t, e, n, g) {
  var i = e.annotationType_, c = g.value;
  process.env.NODE_ENV !== "production" && !yt(c) && T("Cannot apply '" + i + "' to '" + t.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function mC(t, e, n, g, i) {
  var c, A, l, a, C, b, m;
  i === void 0 && (i = L.safeDescriptors), hp(t, e, n, g);
  var p = g.value;
  if ((c = e.options_) != null && c.bound) {
    var y;
    p = p.bind((y = t.proxy_) != null ? y : t.target_);
  }
  return {
    value: Wn(
      (A = (l = e.options_) == null ? void 0 : l.name) != null ? A : n.toString(),
      p,
      (a = (C = e.options_) == null ? void 0 : C.autoAction) != null ? a : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (b = e.options_) != null && b.bound ? (m = t.proxy_) != null ? m : t.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? t.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function hC(t, e) {
  return {
    annotationType_: t,
    options_: e,
    make_: pp,
    extend_: Vp,
    decorate_20223_: Zp
  };
}
function pp(t, e, n, g) {
  var i;
  if (g === t.target_)
    return this.extend_(t, e, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!ce(t.target_, e) || !Eg(t.target_[e])) && this.extend_(t, e, n, !1) === null)
    return 0;
  if (Eg(n.value))
    return 1;
  var c = pC(t, this, e, n, !1, !1);
  return he(g, e, c), 2;
}
function Vp(t, e, n, g) {
  var i, c = pC(t, this, e, n, (i = this.options_) == null ? void 0 : i.bound);
  return t.defineProperty_(e, c, g);
}
function Zp(t, e) {
  var n;
  process.env.NODE_ENV !== "production" && RI(e, ["method"]);
  var g = e.name, i = e.addInitializer;
  return Eg(t) || (t = gg(t)), (n = this.options_) != null && n.bound && i(function() {
    var c = this, A = c[g].bind(c);
    A.isMobXFlow = !0, c[g] = A;
  }), t;
}
function yp(t, e, n, g) {
  var i = e.annotationType_, c = g.value;
  process.env.NODE_ENV !== "production" && !yt(c) && T("Cannot apply '" + i + "' to '" + t.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function pC(t, e, n, g, i, c) {
  c === void 0 && (c = L.safeDescriptors), yp(t, e, n, g);
  var A = g.value;
  if (Eg(A) || (A = gg(A)), i) {
    var l;
    A = A.bind((l = t.proxy_) != null ? l : t.target_), A.isMobXFlow = !0;
  }
  return {
    value: A,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: c ? t.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !c
  };
}
function As(t, e) {
  return {
    annotationType_: t,
    options_: e,
    make_: vp,
    extend_: Xp,
    decorate_20223_: xp
  };
}
function vp(t, e, n) {
  return this.extend_(t, e, n, !1) === null ? 0 : 1;
}
function Xp(t, e, n, g) {
  return Wp(t, this, e, n), t.defineComputedProperty_(e, $e({}, this.options_, {
    get: n.get,
    set: n.set
  }), g);
}
function xp(t, e) {
  process.env.NODE_ENV !== "production" && RI(e, ["getter"]);
  var n = this, g = e.name, i = e.addInitializer;
  return i(function() {
    var c = li(this)[tt], A = $e({}, n.options_, {
      get: t,
      context: this
    });
    A.name || (A.name = process.env.NODE_ENV !== "production" ? c.name_ + "." + g.toString() : "ObservableObject." + g.toString()), c.values_.set(g, new ge(A));
  }), function() {
    return this[tt].getObservablePropValue_(g);
  };
}
function Wp(t, e, n, g) {
  var i = e.annotationType_, c = g.get;
  process.env.NODE_ENV !== "production" && !c && T("Cannot apply '" + i + "' to '" + t.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function FI(t, e) {
  return {
    annotationType_: t,
    options_: e,
    make_: fp,
    extend_: Bp,
    decorate_20223_: Yp
  };
}
function fp(t, e, n) {
  return this.extend_(t, e, n, !1) === null ? 0 : 1;
}
function Bp(t, e, n, g) {
  var i, c;
  return Np(t, this, e, n), t.defineObservableProperty_(e, n.value, (i = (c = this.options_) == null ? void 0 : c.enhancer) != null ? i : rg, g);
}
function Yp(t, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw T("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    RI(e, ["accessor"]);
  }
  var n = this, g = e.kind, i = e.name, c = /* @__PURE__ */ new WeakSet();
  function A(l, a) {
    var C, b, m = li(l)[tt], p = new Vn(a, (C = (b = n.options_) == null ? void 0 : b.enhancer) != null ? C : rg, process.env.NODE_ENV !== "production" ? m.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    m.values_.set(i, p), c.add(l);
  }
  if (g == "accessor")
    return {
      get: function() {
        return c.has(this) || A(this, t.get.call(this)), this[tt].getObservablePropValue_(i);
      },
      set: function(l) {
        return c.has(this) || A(this, l), this[tt].setObservablePropValue_(i, l);
      },
      init: function(l) {
        return c.has(this) || A(this, l), l;
      }
    };
}
function Np(t, e, n, g) {
  var i = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in g) && T("Cannot apply '" + i + "' to '" + t.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var Jp = "true", Rp = /* @__PURE__ */ VC();
function VC(t) {
  return {
    annotationType_: Jp,
    options_: t,
    make_: Sp,
    extend_: Fp,
    decorate_20223_: Hp
  };
}
function Sp(t, e, n, g) {
  var i, c;
  if (n.get)
    return HI.make_(t, e, n, g);
  if (n.set) {
    var A = Wn(e.toString(), n.set);
    return g === t.target_ ? t.defineProperty_(e, {
      configurable: L.safeDescriptors ? t.isPlainObject_ : !0,
      set: A
    }) === null ? 0 : 2 : (he(g, e, {
      configurable: !0,
      set: A
    }), 2);
  }
  if (g !== t.target_ && typeof n.value == "function") {
    var l;
    if (aC(n.value)) {
      var a, C = (a = this.options_) != null && a.autoBind ? gg.bound : gg;
      return C.make_(t, e, n, g);
    }
    var b = (l = this.options_) != null && l.autoBind ? kg.bound : kg;
    return b.make_(t, e, n, g);
  }
  var m = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? Yt.ref : Yt;
  if (typeof n.value == "function" && (c = this.options_) != null && c.autoBind) {
    var p;
    n.value = n.value.bind((p = t.proxy_) != null ? p : t.target_);
  }
  return m.make_(t, e, n, g);
}
function Fp(t, e, n, g) {
  var i, c;
  if (n.get)
    return HI.extend_(t, e, n, g);
  if (n.set)
    return t.defineProperty_(e, {
      configurable: L.safeDescriptors ? t.isPlainObject_ : !0,
      set: Wn(e.toString(), n.set)
    }, g);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var A;
    n.value = n.value.bind((A = t.proxy_) != null ? A : t.target_);
  }
  var l = ((c = this.options_) == null ? void 0 : c.deep) === !1 ? Yt.ref : Yt;
  return l.extend_(t, e, n, g);
}
function Hp(t, e) {
  T("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var wp = "observable", zp = "observable.ref", qp = "observable.shallow", Dp = "observable.struct", ZC = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(ZC);
function Hi(t) {
  return t || ZC;
}
var bA = /* @__PURE__ */ FI(wp), Lp = /* @__PURE__ */ FI(zp, {
  enhancer: SI
}), kp = /* @__PURE__ */ FI(qp, {
  enhancer: Cp
}), Ep = /* @__PURE__ */ FI(Dp, {
  enhancer: up
}), yC = /* @__PURE__ */ pe(bA);
function wi(t) {
  return t.deep === !0 ? rg : t.deep === !1 ? SI : Mp(t.defaultDecorator);
}
function jp(t) {
  var e;
  return t ? (e = t.defaultDecorator) != null ? e : VC(t) : void 0;
}
function Mp(t) {
  var e, n;
  return t && (e = (n = t.options_) == null ? void 0 : n.enhancer) != null ? e : rg;
}
function vC(t, e, n) {
  if (ci(e))
    return bA.decorate_20223_(t, e);
  if (xn(e)) {
    Ii(t, e, bA);
    return;
  }
  return jg(t) ? t : ve(t) ? Yt.object(t, e, n) : Array.isArray(t) ? Yt.array(t, e) : og(t) ? Yt.map(t, e) : Re(t) ? Yt.set(t, e) : typeof t == "object" && t !== null ? t : Yt.box(t, e);
}
oC(vC, yC);
var Up = {
  box: function(t, e) {
    var n = Hi(e);
    return new Vn(t, wi(n), n.name, !0, n.equals);
  },
  array: function(t, e) {
    var n = Hi(e);
    return (L.useProxies === !1 || n.proxy === !1 ? jV : SV)(t, wi(n), n.name);
  },
  map: function(t, e) {
    var n = Hi(e);
    return new EC(t, wi(n), n.name);
  },
  set: function(t, e) {
    var n = Hi(e);
    return new jC(t, wi(n), n.name);
  },
  object: function(t, e, n) {
    return ag(function() {
      return ZV(L.useProxies === !1 || (n == null ? void 0 : n.proxy) === !1 ? li({}, n) : NV({}, n), t, e);
    });
  },
  ref: /* @__PURE__ */ pe(Lp),
  shallow: /* @__PURE__ */ pe(kp),
  deep: yC,
  struct: /* @__PURE__ */ pe(Ep)
}, Yt = /* @__PURE__ */ oC(vC, Up), XC = "computed", Tp = "computed.struct", dA = /* @__PURE__ */ As(XC), Qp = /* @__PURE__ */ As(Tp, {
  equals: sI.structural
}), HI = function(t, e) {
  if (ci(e))
    return dA.decorate_20223_(t, e);
  if (xn(e))
    return Ii(t, e, dA);
  if (ve(t))
    return pe(As(XC, t));
  process.env.NODE_ENV !== "production" && (yt(t) || T("First argument to `computed` should be an expression."), yt(e) && T("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var n = ve(e) ? e : {};
  return n.get = t, n.name || (n.name = t.name || ""), new ge(n);
};
Object.assign(HI, dA);
HI.struct = /* @__PURE__ */ pe(Qp);
var Cl, ul, lI = 0, Op = 1, Pp = (Cl = (ul = /* @__PURE__ */ cI(function() {
}, "name")) == null ? void 0 : ul.configurable) != null ? Cl : !1, bl = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Wn(t, e, n, g) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (yt(e) || T("`action` can only be invoked on functions"), (typeof t != "string" || !t) && T("actions should have valid names, got: '" + t + "'"));
  function i() {
    return Kp(t, n, e, g || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return e.toString();
  }, Pp && (bl.value = t, he(i, "name", bl)), i;
}
function Kp(t, e, n, g, i) {
  var c = _p(t, e, g, i);
  try {
    return n.apply(g, i);
  } catch (A) {
    throw c.error_ = A, A;
  } finally {
    $p(c);
  }
}
function _p(t, e, n, g) {
  var i = process.env.NODE_ENV !== "production" && Nt() && !!t, c = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    c = Date.now();
    var A = g ? Array.from(g) : AI;
    Lt({
      type: rs,
      name: t,
      object: n,
      arguments: A
    });
  }
  var l = L.trackingDerivation, a = !e || !l;
  _t();
  var C = L.allowStateChanges;
  a && (Yn(), C = ss(!0));
  var b = ls(!0), m = {
    runAsAction_: a,
    prevDerivation_: l,
    prevAllowStateChanges_: C,
    prevAllowStateReads_: b,
    notifySpy_: i,
    startTime_: c,
    actionId_: Op++,
    parentActionId_: lI
  };
  return lI = m.actionId_, m;
}
function $p(t) {
  lI !== t.actionId_ && T(30), lI = t.parentActionId_, t.error_ !== void 0 && (L.suppressReactionErrors = !0), os(t.prevAllowStateChanges_), Hg(t.prevAllowStateReads_), $t(), t.runAsAction_ && we(t.prevDerivation_), process.env.NODE_ENV !== "production" && t.notifySpy_ && kt({
    time: Date.now() - t.startTime_
  }), L.suppressReactionErrors = !1;
}
function ss(t) {
  var e = L.allowStateChanges;
  return L.allowStateChanges = t, e;
}
function os(t) {
  L.allowStateChanges = t;
}
var tV = "create", Vn = /* @__PURE__ */ function(t) {
  function e(g, i, c, A, l) {
    var a;
    return c === void 0 && (c = process.env.NODE_ENV !== "production" ? "ObservableValue@" + re() : "ObservableValue"), A === void 0 && (A = !0), l === void 0 && (l = sI.default), a = t.call(this, c) || this, a.enhancer = void 0, a.name_ = void 0, a.equals = void 0, a.hasUnreportedChange_ = !1, a.interceptors_ = void 0, a.changeListeners_ = void 0, a.value_ = void 0, a.dehancer = void 0, a.enhancer = i, a.name_ = c, a.equals = l, a.value_ = i(g, void 0, c), process.env.NODE_ENV !== "production" && A && Nt() && eg({
      type: tV,
      object: a,
      observableKind: "value",
      debugObjectName: a.name_,
      newValue: "" + a.value_
    }), a;
  }
  dC(e, t);
  var n = e.prototype;
  return n.dehanceValue = function(g) {
    return this.dehancer !== void 0 ? this.dehancer(g) : g;
  }, n.set = function(g) {
    var i = this.value_;
    if (g = this.prepareNewValue_(g), g !== L.UNCHANGED) {
      var c = Nt();
      process.env.NODE_ENV !== "production" && c && Lt({
        type: Ie,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: g,
        oldValue: i
      }), this.setNewValue_(g), process.env.NODE_ENV !== "production" && c && kt();
    }
  }, n.prepareNewValue_ = function(g) {
    if (Ge(this), Pt(this)) {
      var i = Kt(this, {
        object: this,
        type: Ie,
        newValue: g
      });
      if (!i)
        return L.UNCHANGED;
      g = i.newValue;
    }
    return g = this.enhancer(g, this.value_, this.name_), this.equals(this.value_, g) ? L.UNCHANGED : g;
  }, n.setNewValue_ = function(g) {
    var i = this.value_;
    this.value_ = g, this.reportChanged(), Ae(this) && se(this, {
      type: Ie,
      object: this,
      newValue: g,
      oldValue: i
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(g) {
    return si(this, g);
  }, n.observe_ = function(g, i) {
    return i && g({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Ie,
      newValue: this.value_,
      oldValue: void 0
    }), oi(this, g);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return bC(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(An), ge = /* @__PURE__ */ function() {
  function t(n) {
    this.dependenciesState_ = It.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = It.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new rI(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = te.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || T(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + re() : "ComputedValue"), n.set && (this.setter_ = Wn(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? sI.structural : sI.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var e = t.prototype;
  return e.onBecomeStale_ = function() {
    cV(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, e.get = function() {
    if (this.isComputing && T(32, this.name_, this.derivation), L.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      GA(this) && (this.warnAboutUntrackedRead_(), _t(), this.value_ = this.computeValue_(!1), $t());
    else if (NC(this), GA(this)) {
      var n = L.trackingContext;
      this.keepAlive_ && !n && (L.trackingContext = this), this.trackAndCompute() && IV(this), L.trackingContext = n;
    }
    var g = this.value_;
    if (Qi(g))
      throw g.cause;
    return g;
  }, e.set = function(n) {
    if (this.setter_) {
      this.isRunningSetter && T(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, n);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      T(34, this.name_);
  }, e.trackAndCompute = function() {
    var n = this.value_, g = (
      /* see #1208 */
      this.dependenciesState_ === It.NOT_TRACKING_
    ), i = this.computeValue_(!0), c = g || Qi(n) || Qi(i) || !this.equals_(n, i);
    return c && (this.value_ = i, process.env.NODE_ENV !== "production" && Nt() && eg({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: n,
      newValue: i
    })), c;
  }, e.computeValue_ = function(n) {
    this.isComputing = !0;
    var g = ss(!1), i;
    if (n)
      i = xC(this, this.derivation, this.scope_);
    else if (L.disableErrorBoundaries === !0)
      i = this.derivation.call(this.scope_);
    else
      try {
        i = this.derivation.call(this.scope_);
      } catch (c) {
        i = new rI(c);
      }
    return os(g), this.isComputing = !1, i;
  }, e.suspend_ = function() {
    this.keepAlive_ || (mA(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== te.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(n, g) {
    var i = this, c = !0, A = void 0;
    return dV(function() {
      var l = i.get();
      if (!c || g) {
        var a = Yn();
        n({
          observableKind: "computed",
          debugObjectName: i.name_,
          type: Ie,
          object: i,
          newValue: l,
          oldValue: A
        }), we(a);
      }
      c = !1, A = l;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== te.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : L.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return bC(this.get());
  }, e[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, lg(t, [{
    key: "isComputing",
    get: function() {
      return qt(this.flags_, t.isComputingMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isComputingMask_, n);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return qt(this.flags_, t.isRunningSetterMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isRunningSetterMask_, n);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return qt(this.flags_, t.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return qt(this.flags_, t.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return qt(this.flags_, t.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.diffValueMask_, n === 1);
    }
  }]);
}();
ge.isComputingMask_ = 1;
ge.isRunningSetterMask_ = 2;
ge.isBeingObservedMask_ = 4;
ge.isPendingUnobservationMask_ = 8;
ge.diffValueMask_ = 16;
var wI = /* @__PURE__ */ Bn("ComputedValue", ge), It;
(function(t) {
  t[t.NOT_TRACKING_ = -1] = "NOT_TRACKING_", t[t.UP_TO_DATE_ = 0] = "UP_TO_DATE_", t[t.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", t[t.STALE_ = 2] = "STALE_";
})(It || (It = {}));
var te;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.LOG = 1] = "LOG", t[t.BREAK = 2] = "BREAK";
})(te || (te = {}));
var rI = function(t) {
  this.cause = void 0, this.cause = t;
};
function Qi(t) {
  return t instanceof rI;
}
function GA(t) {
  switch (t.dependenciesState_) {
    case It.UP_TO_DATE_:
      return !1;
    case It.NOT_TRACKING_:
    case It.STALE_:
      return !0;
    case It.POSSIBLY_STALE_: {
      for (var e = ls(!0), n = Yn(), g = t.observing_, i = g.length, c = 0; c < i; c++) {
        var A = g[c];
        if (wI(A)) {
          if (L.disableErrorBoundaries)
            A.get();
          else
            try {
              A.get();
            } catch {
              return we(n), Hg(e), !0;
            }
          if (t.dependenciesState_ === It.STALE_)
            return we(n), Hg(e), !0;
        }
      }
      return fC(t), we(n), Hg(e), !1;
    }
  }
}
function Ge(t) {
  if (process.env.NODE_ENV !== "production") {
    var e = t.observers_.size > 0;
    !L.allowStateChanges && (e || L.enforceActions === "always") && console.warn("[MobX] " + (L.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + t.name_);
  }
}
function eV(t) {
  process.env.NODE_ENV !== "production" && !L.allowStateReads && L.observableRequiresReaction && console.warn("[mobx] Observable '" + t.name_ + "' being read outside a reactive context.");
}
function xC(t, e, n) {
  var g = ls(!0);
  fC(t), t.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    t.runId_ === 0 ? 100 : t.observing_.length
  ), t.unboundDepsCount_ = 0, t.runId_ = ++L.runId;
  var i = L.trackingDerivation;
  L.trackingDerivation = t, L.inBatch++;
  var c;
  if (L.disableErrorBoundaries === !0)
    c = e.call(n);
  else
    try {
      c = e.call(n);
    } catch (A) {
      c = new rI(A);
    }
  return L.inBatch--, L.trackingDerivation = i, gV(t), nV(t), Hg(g), c;
}
function nV(t) {
  process.env.NODE_ENV !== "production" && t.observing_.length === 0 && (typeof t.requiresObservable_ == "boolean" ? t.requiresObservable_ : L.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + t.name_ + "' is created/updated without reading any observable value.");
}
function gV(t) {
  for (var e = t.observing_, n = t.observing_ = t.newObserving_, g = It.UP_TO_DATE_, i = 0, c = t.unboundDepsCount_, A = 0; A < c; A++) {
    var l = n[A];
    l.diffValue === 0 && (l.diffValue = 1, i !== A && (n[i] = l), i++), l.dependenciesState_ > g && (g = l.dependenciesState_);
  }
  for (n.length = i, t.newObserving_ = null, c = e.length; c--; ) {
    var a = e[c];
    a.diffValue === 0 && BC(a, t), a.diffValue = 0;
  }
  for (; i--; ) {
    var C = n[i];
    C.diffValue === 1 && (C.diffValue = 0, iV(C, t));
  }
  g !== It.UP_TO_DATE_ && (t.dependenciesState_ = g, t.onBecomeStale_());
}
function mA(t) {
  var e = t.observing_;
  t.observing_ = [];
  for (var n = e.length; n--; )
    BC(e[n], t);
  t.dependenciesState_ = It.NOT_TRACKING_;
}
function WC(t) {
  var e = Yn();
  try {
    return t();
  } finally {
    we(e);
  }
}
function Yn() {
  var t = L.trackingDerivation;
  return L.trackingDerivation = null, t;
}
function we(t) {
  L.trackingDerivation = t;
}
function ls(t) {
  var e = L.allowStateReads;
  return L.allowStateReads = t, e;
}
function Hg(t) {
  L.allowStateReads = t;
}
function fC(t) {
  if (t.dependenciesState_ !== It.UP_TO_DATE_) {
    t.dependenciesState_ = It.UP_TO_DATE_;
    for (var e = t.observing_, n = e.length; n--; )
      e[n].lowestObserverState_ = It.UP_TO_DATE_;
  }
}
var Rc = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Sc = !0, L = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ ns();
  return t.__mobxInstanceCount > 0 && !t.__mobxGlobals && (Sc = !1), t.__mobxGlobals && t.__mobxGlobals.version !== new Rc().version && (Sc = !1), Sc ? t.__mobxGlobals ? (t.__mobxInstanceCount += 1, t.__mobxGlobals.UNCHANGED || (t.__mobxGlobals.UNCHANGED = {}), t.__mobxGlobals) : (t.__mobxInstanceCount = 1, t.__mobxGlobals = /* @__PURE__ */ new Rc()) : (setTimeout(function() {
    T(35);
  }, 1), new Rc());
}();
function iV(t, e) {
  t.observers_.add(e), t.lowestObserverState_ > e.dependenciesState_ && (t.lowestObserverState_ = e.dependenciesState_);
}
function BC(t, e) {
  t.observers_.delete(e), t.observers_.size === 0 && YC(t);
}
function YC(t) {
  t.isPendingUnobservation === !1 && (t.isPendingUnobservation = !0, L.pendingUnobservations.push(t));
}
function _t() {
  L.inBatch++;
}
function $t() {
  if (--L.inBatch === 0) {
    FC();
    for (var t = L.pendingUnobservations, e = 0; e < t.length; e++) {
      var n = t[e];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof ge && n.suspend_());
    }
    L.pendingUnobservations = [];
  }
}
function NC(t) {
  eV(t);
  var e = L.trackingDerivation;
  return e !== null ? (e.runId_ !== t.lastAccessedBy_ && (t.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = t, !t.isBeingObserved && L.trackingContext && (t.isBeingObserved = !0, t.onBO())), t.isBeingObserved) : (t.observers_.size === 0 && L.inBatch > 0 && YC(t), !1);
}
function JC(t) {
  t.lowestObserverState_ !== It.STALE_ && (t.lowestObserverState_ = It.STALE_, t.observers_.forEach(function(e) {
    e.dependenciesState_ === It.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== te.NONE && RC(e, t), e.onBecomeStale_()), e.dependenciesState_ = It.STALE_;
  }));
}
function IV(t) {
  t.lowestObserverState_ !== It.STALE_ && (t.lowestObserverState_ = It.STALE_, t.observers_.forEach(function(e) {
    e.dependenciesState_ === It.POSSIBLY_STALE_ ? (e.dependenciesState_ = It.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== te.NONE && RC(e, t)) : e.dependenciesState_ === It.UP_TO_DATE_ && (t.lowestObserverState_ = It.UP_TO_DATE_);
  }));
}
function cV(t) {
  t.lowestObserverState_ === It.UP_TO_DATE_ && (t.lowestObserverState_ = It.POSSIBLY_STALE_, t.observers_.forEach(function(e) {
    e.dependenciesState_ === It.UP_TO_DATE_ && (e.dependenciesState_ = It.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function RC(t, e) {
  if (console.log("[mobx.trace] '" + t.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), t.isTracing_ === te.BREAK) {
    var n = [];
    SC(yV(t), n, 1), new Function(`debugger;
/*
Tracing '` + t.name_ + `'

You are entering this break point because derivation '` + t.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (t instanceof ge ? t.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function SC(t, e, n) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(n - 1) + t.name), t.dependencies && t.dependencies.forEach(function(g) {
    return SC(g, e, n + 1);
  });
}
var tn = /* @__PURE__ */ function() {
  function t(n, g, i, c) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + re() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = It.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = te.NONE, this.name_ = n, this.onInvalidate_ = g, this.errorHandler_ = i, this.requiresObservable_ = c;
  }
  var e = t.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, L.pendingReactions.push(this), FC());
  }, e.runReaction_ = function() {
    if (!this.isDisposed) {
      _t(), this.isScheduled = !1;
      var n = L.trackingContext;
      if (L.trackingContext = this, GA(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && Nt() && eg({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (g) {
          this.reportExceptionInDerivation_(g);
        }
      }
      L.trackingContext = n, $t();
    }
  }, e.track = function(n) {
    if (!this.isDisposed) {
      _t();
      var g = Nt(), i;
      process.env.NODE_ENV !== "production" && g && (i = Date.now(), Lt({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var c = L.trackingContext;
      L.trackingContext = this;
      var A = xC(this, n, void 0);
      L.trackingContext = c, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && mA(this), Qi(A) && this.reportExceptionInDerivation_(A.cause), process.env.NODE_ENV !== "production" && g && kt({
        time: Date.now() - i
      }), $t();
    }
  }, e.reportExceptionInDerivation_ = function(n) {
    var g = this;
    if (this.errorHandler_) {
      this.errorHandler_(n, this);
      return;
    }
    if (L.disableErrorBoundaries)
      throw n;
    var i = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    L.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(i, n), process.env.NODE_ENV !== "production" && Nt() && eg({
      type: "error",
      name: this.name_,
      message: i,
      error: "" + n
    }), L.globalReactionErrorHandlers.forEach(function(c) {
      return c(n, g);
    });
  }, e.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (_t(), mA(this), $t()));
  }, e.getDisposer_ = function(n) {
    var g = this, i = function c() {
      g.dispose(), n == null || n.removeEventListener == null || n.removeEventListener("abort", c);
    };
    return n == null || n.addEventListener == null || n.addEventListener("abort", i), i[tt] = this, i;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(n) {
    n === void 0 && (n = !1), fV(this, n);
  }, lg(t, [{
    key: "isDisposed",
    get: function() {
      return qt(this.flags_, t.isDisposedMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isDisposedMask_, n);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return qt(this.flags_, t.isScheduledMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isScheduledMask_, n);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return qt(this.flags_, t.isTrackPendingMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isTrackPendingMask_, n);
    }
  }, {
    key: "isRunning",
    get: function() {
      return qt(this.flags_, t.isRunningMask_);
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.isRunningMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return qt(this.flags_, t.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = Dt(this.flags_, t.diffValueMask_, n === 1);
    }
  }]);
}();
tn.isDisposedMask_ = 1;
tn.isScheduledMask_ = 2;
tn.isTrackPendingMask_ = 4;
tn.isRunningMask_ = 8;
tn.diffValueMask_ = 16;
var dl = 100, AV = function(t) {
  return t();
};
function FC() {
  L.inBatch > 0 || L.isRunningReactions || AV(sV);
}
function sV() {
  L.isRunningReactions = !0;
  for (var t = L.pendingReactions, e = 0; t.length > 0; ) {
    ++e === dl && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + dl + " iterations." + (" Probably there is a cycle in the reactive function: " + t[0]) : "[mobx] cycle in reaction: " + t[0]), t.splice(0));
    for (var n = t.splice(0), g = 0, i = n.length; g < i; g++)
      n[g].runReaction_();
  }
  L.isRunningReactions = !1;
}
var aI = /* @__PURE__ */ Bn("Reaction", tn);
function Nt() {
  return process.env.NODE_ENV !== "production" && !!L.spyListeners.length;
}
function eg(t) {
  if (process.env.NODE_ENV !== "production" && L.spyListeners.length)
    for (var e = L.spyListeners, n = 0, g = e.length; n < g; n++)
      e[n](t);
}
function Lt(t) {
  if (process.env.NODE_ENV !== "production") {
    var e = $e({}, t, {
      spyReportStart: !0
    });
    eg(e);
  }
}
var oV = {
  type: "report-end",
  spyReportEnd: !0
};
function kt(t) {
  process.env.NODE_ENV !== "production" && eg(t ? $e({}, t, {
    type: "report-end",
    spyReportEnd: !0
  }) : oV);
}
function lV(t) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (L.spyListeners.push(t), gs(function() {
    L.spyListeners = L.spyListeners.filter(function(e) {
      return e !== t;
    });
  }));
}
var rs = "action", rV = "action.bound", HC = "autoAction", aV = "autoAction.bound", CV = "<unnamed action>", hA = /* @__PURE__ */ Ai(rs), uV = /* @__PURE__ */ Ai(rV, {
  bound: !0
}), pA = /* @__PURE__ */ Ai(HC, {
  autoAction: !0
}), bV = /* @__PURE__ */ Ai(aV, {
  autoAction: !0,
  bound: !0
});
function wC(t) {
  var e = function(n, g) {
    if (yt(n))
      return Wn(n.name || CV, n, t);
    if (yt(g))
      return Wn(n, g, t);
    if (ci(g))
      return (t ? pA : hA).decorate_20223_(n, g);
    if (xn(g))
      return Ii(n, g, t ? pA : hA);
    if (xn(n))
      return pe(Ai(t ? HC : rs, {
        name: n,
        autoAction: t
      }));
    process.env.NODE_ENV !== "production" && T("Invalid arguments for `action`");
  };
  return e;
}
var kn = /* @__PURE__ */ wC(!1);
Object.assign(kn, hA);
var kg = /* @__PURE__ */ wC(!0);
Object.assign(kg, pA);
kn.bound = /* @__PURE__ */ pe(uV);
kg.bound = /* @__PURE__ */ pe(bV);
function ng(t) {
  return yt(t) && t.isMobxAction === !0;
}
function dV(t, e) {
  var n, g, i, c;
  e === void 0 && (e = lC), process.env.NODE_ENV !== "production" && (yt(t) || T("Autorun expects a function as first argument"), ng(t) && T("Autorun does not accept actions since actions are untrackable"));
  var A = (n = (g = e) == null ? void 0 : g.name) != null ? n : process.env.NODE_ENV !== "production" ? t.name || "Autorun@" + re() : "Autorun", l = !e.scheduler && !e.delay, a;
  if (l)
    a = new tn(A, function() {
      this.track(m);
    }, e.onError, e.requiresObservable);
  else {
    var C = mV(e), b = !1;
    a = new tn(A, function() {
      b || (b = !0, C(function() {
        b = !1, a.isDisposed || a.track(m);
      }));
    }, e.onError, e.requiresObservable);
  }
  function m() {
    t(a);
  }
  return (i = e) != null && (i = i.signal) != null && i.aborted || a.schedule_(), a.getDisposer_((c = e) == null ? void 0 : c.signal);
}
var GV = function(t) {
  return t();
};
function mV(t) {
  return t.scheduler ? t.scheduler : t.delay ? function(e) {
    return setTimeout(e, t.delay);
  } : GV;
}
var hV = "onBO", pV = "onBUO";
function VV(t, e, n) {
  return qC(hV, t, e, n);
}
function zC(t, e, n) {
  return qC(pV, t, e, n);
}
function qC(t, e, n, g) {
  var i = ig(e), c = yt(g) ? g : n, A = t + "L";
  return i[A] ? i[A].add(c) : i[A] = /* @__PURE__ */ new Set([c]), function() {
    var l = i[A];
    l && (l.delete(c), l.size === 0 && delete i[A]);
  };
}
function ZV(t, e, n, g) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && T("'extendObservable' expected 2-4 arguments"), typeof t != "object" && T("'extendObservable' expects an object as first argument"), sn(t) && T("'extendObservable' should not be used on maps, use map.merge instead"), ve(e) || T("'extendObservable' only accepts plain objects as second argument"), (jg(e) || jg(n)) && T("Extending an object with another observable (object) is not supported"));
  var i = gp(e);
  return ag(function() {
    var c = li(t, g)[tt];
    Is(i).forEach(function(A) {
      c.extend_(
        A,
        i[A],
        // must pass "undefined" for { key: undefined }
        n && A in n ? n[A] : !0
      );
    });
  }), t;
}
function yV(t, e) {
  return DC(ig(t, e));
}
function DC(t) {
  var e = {
    name: t.name_
  };
  return t.observing_ && t.observing_.length > 0 && (e.dependencies = vV(t.observing_).map(DC)), e;
}
function vV(t) {
  return Array.from(new Set(t));
}
var XV = 0;
function LC() {
  this.message = "FLOW_CANCELLED";
}
LC.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var Fc = /* @__PURE__ */ hC("flow"), xV = /* @__PURE__ */ hC("flow.bound", {
  bound: !0
}), gg = /* @__PURE__ */ Object.assign(function(t, e) {
  if (ci(e))
    return Fc.decorate_20223_(t, e);
  if (xn(e))
    return Ii(t, e, Fc);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && T("Flow expects single argument with generator function");
  var n = t, g = n.name || "<unnamed flow>", i = function() {
    var c = this, A = arguments, l = ++XV, a = kn(g + " - runid: " + l + " - init", n).apply(c, A), C, b = void 0, m = new Promise(function(p, y) {
      var f = 0;
      C = y;
      function x(J) {
        b = void 0;
        var N;
        try {
          N = kn(g + " - runid: " + l + " - yield " + f++, a.next).call(a, J);
        } catch (R) {
          return y(R);
        }
        B(N);
      }
      function Y(J) {
        b = void 0;
        var N;
        try {
          N = kn(g + " - runid: " + l + " - yield " + f++, a.throw).call(a, J);
        } catch (R) {
          return y(R);
        }
        B(N);
      }
      function B(J) {
        if (yt(J == null ? void 0 : J.then)) {
          J.then(B, y);
          return;
        }
        return J.done ? p(J.value) : (b = Promise.resolve(J.value), b.then(x, Y));
      }
      x(void 0);
    });
    return m.cancel = kn(g + " - runid: " + l + " - cancel", function() {
      try {
        b && Gl(b);
        var p = a.return(void 0), y = Promise.resolve(p.value);
        y.then(Dn, Dn), Gl(y), C(new LC());
      } catch (f) {
        C(f);
      }
    }), m;
  };
  return i.isMobXFlow = !0, i;
}, Fc);
gg.bound = /* @__PURE__ */ pe(xV);
function Gl(t) {
  yt(t.cancel) && t.cancel();
}
function Eg(t) {
  return (t == null ? void 0 : t.isMobXFlow) === !0;
}
function WV(t, e) {
  return t ? ri(t) || !!t[tt] || cs(t) || aI(t) || wI(t) : !1;
}
function jg(t) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && T("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), WV(t);
}
function fV() {
  if (process.env.NODE_ENV !== "production") {
    for (var t = !1, e = arguments.length, n = new Array(e), g = 0; g < e; g++)
      n[g] = arguments[g];
    typeof n[n.length - 1] == "boolean" && (t = n.pop());
    var i = BV(n);
    if (!i)
      return T("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === te.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = t ? te.BREAK : te.LOG;
  }
}
function BV(t) {
  switch (t.length) {
    case 0:
      return L.trackingDerivation;
    case 1:
      return ig(t[0]);
    case 2:
      return ig(t[0], t[1]);
  }
}
function Fe(t, e) {
  e === void 0 && (e = void 0), _t();
  try {
    return t.apply(e);
  } finally {
    $t();
  }
}
function bn(t) {
  return t[tt];
}
var YV = {
  has: function(t, e) {
    return process.env.NODE_ENV !== "production" && L.trackingDerivation && Jg("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), bn(t).has_(e);
  },
  get: function(t, e) {
    return bn(t).get_(e);
  },
  set: function(t, e, n) {
    var g;
    return xn(e) ? (process.env.NODE_ENV !== "production" && !bn(t).values_.has(e) && Jg("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (g = bn(t).set_(e, n, !0)) != null ? g : !0) : !1;
  },
  deleteProperty: function(t, e) {
    var n;
    return process.env.NODE_ENV !== "production" && Jg("delete properties from an observable object. Use 'remove' from 'mobx' instead."), xn(e) ? (n = bn(t).delete_(e, !0)) != null ? n : !0 : !1;
  },
  defineProperty: function(t, e, n) {
    var g;
    return process.env.NODE_ENV !== "production" && Jg("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (g = bn(t).defineProperty_(e, n)) != null ? g : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && L.trackingDerivation && Jg("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), bn(t).ownKeys_();
  },
  preventExtensions: function(t) {
    T(13);
  }
};
function NV(t, e) {
  var n, g;
  return rC(), t = li(t, e), (g = (n = t[tt]).proxy_) != null ? g : n.proxy_ = new Proxy(t, YV);
}
function Pt(t) {
  return t.interceptors_ !== void 0 && t.interceptors_.length > 0;
}
function si(t, e) {
  var n = t.interceptors_ || (t.interceptors_ = []);
  return n.push(e), gs(function() {
    var g = n.indexOf(e);
    g !== -1 && n.splice(g, 1);
  });
}
function Kt(t, e) {
  var n = Yn();
  try {
    for (var g = [].concat(t.interceptors_ || []), i = 0, c = g.length; i < c && (e = g[i](e), e && !e.type && T(14), !!e); i++)
      ;
    return e;
  } finally {
    we(n);
  }
}
function Ae(t) {
  return t.changeListeners_ !== void 0 && t.changeListeners_.length > 0;
}
function oi(t, e) {
  var n = t.changeListeners_ || (t.changeListeners_ = []);
  return n.push(e), gs(function() {
    var g = n.indexOf(e);
    g !== -1 && n.splice(g, 1);
  });
}
function se(t, e) {
  var n = Yn(), g = t.changeListeners_;
  if (g) {
    g = g.slice();
    for (var i = 0, c = g.length; i < c; i++)
      g[i](e);
    we(n);
  }
}
var ml = "splice", Ie = "update", JV = 1e4, RV = {
  get: function(t, e) {
    var n = t[tt];
    return e === tt ? n : e === "length" ? n.getArrayLength_() : typeof e == "string" && !isNaN(e) ? n.get_(parseInt(e)) : ce(CI, e) ? CI[e] : t[e];
  },
  set: function(t, e, n) {
    var g = t[tt];
    return e === "length" && g.setArrayLength_(n), typeof e == "symbol" || isNaN(e) ? t[e] = n : g.set_(parseInt(e), n), !0;
  },
  preventExtensions: function() {
    T(15);
  }
}, as = /* @__PURE__ */ function() {
  function t(n, g, i, c) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + re() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = c, this.atom_ = new An(n), this.enhancer_ = function(A, l) {
      return g(A, l, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var e = t.prototype;
  return e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.dehanceValues_ = function(n) {
    return this.dehancer !== void 0 && n.length > 0 ? n.map(this.dehancer) : n;
  }, e.intercept_ = function(n) {
    return si(this, n);
  }, e.observe_ = function(n, g) {
    return g === void 0 && (g = !1), g && n({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), oi(this, n);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(n) {
    (typeof n != "number" || isNaN(n) || n < 0) && T("Out of range: " + n);
    var g = this.values_.length;
    if (n !== g)
      if (n > g) {
        for (var i = new Array(n - g), c = 0; c < n - g; c++)
          i[c] = void 0;
        this.spliceWithArray_(g, 0, i);
      } else
        this.spliceWithArray_(n, g - n);
  }, e.updateArrayLength_ = function(n, g) {
    n !== this.lastKnownLength_ && T(16), this.lastKnownLength_ += g, this.legacyMode_ && g > 0 && TC(n + g + 1);
  }, e.spliceWithArray_ = function(n, g, i) {
    var c = this;
    Ge(this.atom_);
    var A = this.values_.length;
    if (n === void 0 ? n = 0 : n > A ? n = A : n < 0 && (n = Math.max(0, A + n)), arguments.length === 1 ? g = A - n : g == null ? g = 0 : g = Math.max(0, Math.min(g, A - n)), i === void 0 && (i = AI), Pt(this)) {
      var l = Kt(this, {
        object: this.proxy_,
        type: ml,
        index: n,
        removedCount: g,
        added: i
      });
      if (!l)
        return AI;
      g = l.removedCount, i = l.added;
    }
    if (i = i.length === 0 ? i : i.map(function(b) {
      return c.enhancer_(b, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var a = i.length - g;
      this.updateArrayLength_(A, a);
    }
    var C = this.spliceItemsIntoValues_(n, g, i);
    return (g !== 0 || i.length !== 0) && this.notifyArraySplice_(n, i, C), this.dehanceValues_(C);
  }, e.spliceItemsIntoValues_ = function(n, g, i) {
    if (i.length < JV) {
      var c;
      return (c = this.values_).splice.apply(c, [n, g].concat(i));
    } else {
      var A = this.values_.slice(n, n + g), l = this.values_.slice(n + g);
      this.values_.length += i.length - g;
      for (var a = 0; a < i.length; a++)
        this.values_[n + a] = i[a];
      for (var C = 0; C < l.length; C++)
        this.values_[n + i.length + C] = l[C];
      return A;
    }
  }, e.notifyArrayChildUpdate_ = function(n, g, i) {
    var c = !this.owned_ && Nt(), A = Ae(this), l = A || c ? {
      observableKind: "array",
      object: this.proxy_,
      type: Ie,
      debugObjectName: this.atom_.name_,
      index: n,
      newValue: g,
      oldValue: i
    } : null;
    process.env.NODE_ENV !== "production" && c && Lt(l), this.atom_.reportChanged(), A && se(this, l), process.env.NODE_ENV !== "production" && c && kt();
  }, e.notifyArraySplice_ = function(n, g, i) {
    var c = !this.owned_ && Nt(), A = Ae(this), l = A || c ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: ml,
      index: n,
      removed: i,
      added: g,
      removedCount: i.length,
      addedCount: g.length
    } : null;
    process.env.NODE_ENV !== "production" && c && Lt(l), this.atom_.reportChanged(), A && se(this, l), process.env.NODE_ENV !== "production" && c && kt();
  }, e.get_ = function(n) {
    if (this.legacyMode_ && n >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + n + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + n);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[n]);
  }, e.set_ = function(n, g) {
    var i = this.values_;
    if (this.legacyMode_ && n > i.length && T(17, n, i.length), n < i.length) {
      Ge(this.atom_);
      var c = i[n];
      if (Pt(this)) {
        var A = Kt(this, {
          type: Ie,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: n,
          newValue: g
        });
        if (!A)
          return;
        g = A.newValue;
      }
      g = this.enhancer_(g, c);
      var l = g !== c;
      l && (i[n] = g, this.notifyArrayChildUpdate_(n, g, c));
    } else {
      for (var a = new Array(n + 1 - i.length), C = 0; C < a.length - 1; C++)
        a[C] = void 0;
      a[a.length - 1] = g, this.spliceWithArray_(i.length, 0, a);
    }
  }, t;
}();
function SV(t, e, n, g) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + re() : "ObservableArray"), g === void 0 && (g = !1), rC(), ag(function() {
    var i = new as(n, e, g, !1);
    CC(i.values_, tt, i);
    var c = new Proxy(i.values_, RV);
    return i.proxy_ = c, t && t.length && i.spliceWithArray_(0, 0, t), c;
  });
}
var CI = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var e = this[tt];
    return e.spliceWithArray_(0, e.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, e) {
    for (var n = arguments.length, g = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
      g[i - 2] = arguments[i];
    var c = this[tt];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return c.spliceWithArray_(t);
      case 2:
        return c.spliceWithArray_(t, e);
    }
    return c.spliceWithArray_(t, e, g);
  },
  spliceWithArray: function(t, e, n) {
    return this[tt].spliceWithArray_(t, e, n);
  },
  push: function() {
    for (var t = this[tt], e = arguments.length, n = new Array(e), g = 0; g < e; g++)
      n[g] = arguments[g];
    return t.spliceWithArray_(t.values_.length, 0, n), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[tt].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[tt], e = arguments.length, n = new Array(e), g = 0; g < e; g++)
      n[g] = arguments[g];
    return t.spliceWithArray_(0, 0, n), t.values_.length;
  },
  reverse: function() {
    return L.trackingDerivation && T(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    L.trackingDerivation && T(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var e = this[tt], n = e.dehanceValues_(e.values_).indexOf(t);
    return n > -1 ? (this.splice(n, 1), !0) : !1;
  }
};
rt("at", jt);
rt("concat", jt);
rt("flat", jt);
rt("includes", jt);
rt("indexOf", jt);
rt("join", jt);
rt("lastIndexOf", jt);
rt("slice", jt);
rt("toString", jt);
rt("toLocaleString", jt);
rt("toSorted", jt);
rt("toSpliced", jt);
rt("with", jt);
rt("every", ae);
rt("filter", ae);
rt("find", ae);
rt("findIndex", ae);
rt("findLast", ae);
rt("findLastIndex", ae);
rt("flatMap", ae);
rt("forEach", ae);
rt("map", ae);
rt("some", ae);
rt("toReversed", ae);
rt("reduce", kC);
rt("reduceRight", kC);
function rt(t, e) {
  typeof Array.prototype[t] == "function" && (CI[t] = e(t));
}
function jt(t) {
  return function() {
    var e = this[tt];
    e.atom_.reportObserved();
    var n = e.dehanceValues_(e.values_);
    return n[t].apply(n, arguments);
  };
}
function ae(t) {
  return function(e, n) {
    var g = this, i = this[tt];
    i.atom_.reportObserved();
    var c = i.dehanceValues_(i.values_);
    return c[t](function(A, l) {
      return e.call(n, A, l, g);
    });
  };
}
function kC(t) {
  return function() {
    var e = this, n = this[tt];
    n.atom_.reportObserved();
    var g = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(c, A, l) {
      return i(c, A, l, e);
    }, g[t].apply(g, arguments);
  };
}
var FV = /* @__PURE__ */ Bn("ObservableArrayAdministration", as);
function zI(t) {
  return JI(t) && FV(t[tt]);
}
var HV = {}, Oe = "add", uI = "delete", EC = /* @__PURE__ */ function() {
  function t(n, g, i) {
    var c = this;
    g === void 0 && (g = rg), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + re() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[tt] = HV, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = g, this.name_ = i, yt(Map) || T(18), ag(function() {
      c.keysAtom_ = GC(process.env.NODE_ENV !== "production" ? c.name_ + ".keys()" : "ObservableMap.keys()"), c.data_ = /* @__PURE__ */ new Map(), c.hasMap_ = /* @__PURE__ */ new Map(), n && c.merge(n);
    });
  }
  var e = t.prototype;
  return e.has_ = function(n) {
    return this.data_.has(n);
  }, e.has = function(n) {
    var g = this;
    if (!L.trackingDerivation)
      return this.has_(n);
    var i = this.hasMap_.get(n);
    if (!i) {
      var c = i = new Vn(this.has_(n), SI, process.env.NODE_ENV !== "production" ? this.name_ + "." + CA(n) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(n, c), zC(c, function() {
        return g.hasMap_.delete(n);
      });
    }
    return i.get();
  }, e.set = function(n, g) {
    var i = this.has_(n);
    if (Pt(this)) {
      var c = Kt(this, {
        type: i ? Ie : Oe,
        object: this,
        newValue: g,
        name: n
      });
      if (!c)
        return this;
      g = c.newValue;
    }
    return i ? this.updateValue_(n, g) : this.addValue_(n, g), this;
  }, e.delete = function(n) {
    var g = this;
    if (Ge(this.keysAtom_), Pt(this)) {
      var i = Kt(this, {
        type: uI,
        object: this,
        name: n
      });
      if (!i)
        return !1;
    }
    if (this.has_(n)) {
      var c = Nt(), A = Ae(this), l = A || c ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: uI,
        object: this,
        oldValue: this.data_.get(n).value_,
        name: n
      } : null;
      return process.env.NODE_ENV !== "production" && c && Lt(l), Fe(function() {
        var a;
        g.keysAtom_.reportChanged(), (a = g.hasMap_.get(n)) == null || a.setNewValue_(!1);
        var C = g.data_.get(n);
        C.setNewValue_(void 0), g.data_.delete(n);
      }), A && se(this, l), process.env.NODE_ENV !== "production" && c && kt(), !0;
    }
    return !1;
  }, e.updateValue_ = function(n, g) {
    var i = this.data_.get(n);
    if (g = i.prepareNewValue_(g), g !== L.UNCHANGED) {
      var c = Nt(), A = Ae(this), l = A || c ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Ie,
        object: this,
        oldValue: i.value_,
        name: n,
        newValue: g
      } : null;
      process.env.NODE_ENV !== "production" && c && Lt(l), i.setNewValue_(g), A && se(this, l), process.env.NODE_ENV !== "production" && c && kt();
    }
  }, e.addValue_ = function(n, g) {
    var i = this;
    Ge(this.keysAtom_), Fe(function() {
      var a, C = new Vn(g, i.enhancer_, process.env.NODE_ENV !== "production" ? i.name_ + "." + CA(n) : "ObservableMap.key", !1);
      i.data_.set(n, C), g = C.value_, (a = i.hasMap_.get(n)) == null || a.setNewValue_(!0), i.keysAtom_.reportChanged();
    });
    var c = Nt(), A = Ae(this), l = A || c ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: Oe,
      object: this,
      name: n,
      newValue: g
    } : null;
    process.env.NODE_ENV !== "production" && c && Lt(l), A && se(this, l), process.env.NODE_ENV !== "production" && c && kt();
  }, e.get = function(n) {
    return this.has(n) ? this.dehanceValue_(this.data_.get(n).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var n = this, g = this.keys();
    return hl({
      next: function() {
        var i = g.next(), c = i.done, A = i.value;
        return {
          done: c,
          value: c ? void 0 : n.get(A)
        };
      }
    });
  }, e.entries = function() {
    var n = this, g = this.keys();
    return hl({
      next: function() {
        var i = g.next(), c = i.done, A = i.value;
        return {
          done: c,
          value: c ? void 0 : [A, n.get(A)]
        };
      }
    });
  }, e[Symbol.iterator] = function() {
    return this.entries();
  }, e.forEach = function(n, g) {
    for (var i = Ln(this), c; !(c = i()).done; ) {
      var A = c.value, l = A[0], a = A[1];
      n.call(g, a, l, this);
    }
  }, e.merge = function(n) {
    var g = this;
    return sn(n) && (n = new Map(n)), Fe(function() {
      ve(n) ? np(n).forEach(function(i) {
        return g.set(i, n[i]);
      }) : Array.isArray(n) ? n.forEach(function(i) {
        var c = i[0], A = i[1];
        return g.set(c, A);
      }) : og(n) ? (ep(n) || T(19, n), n.forEach(function(i, c) {
        return g.set(c, i);
      })) : n != null && T(20, n);
    }), this;
  }, e.clear = function() {
    var n = this;
    Fe(function() {
      WC(function() {
        for (var g = Ln(n.keys()), i; !(i = g()).done; ) {
          var c = i.value;
          n.delete(c);
        }
      });
    });
  }, e.replace = function(n) {
    var g = this;
    return Fe(function() {
      for (var i = wV(n), c = /* @__PURE__ */ new Map(), A = !1, l = Ln(g.data_.keys()), a; !(a = l()).done; ) {
        var C = a.value;
        if (!i.has(C)) {
          var b = g.delete(C);
          if (b)
            A = !0;
          else {
            var m = g.data_.get(C);
            c.set(C, m);
          }
        }
      }
      for (var p = Ln(i.entries()), y; !(y = p()).done; ) {
        var f = y.value, x = f[0], Y = f[1], B = g.data_.has(x);
        if (g.set(x, Y), g.data_.has(x)) {
          var J = g.data_.get(x);
          c.set(x, J), B || (A = !0);
        }
      }
      if (!A)
        if (g.data_.size !== c.size)
          g.keysAtom_.reportChanged();
        else
          for (var N = g.data_.keys(), R = c.keys(), H = N.next(), E = R.next(); !H.done; ) {
            if (H.value !== E.value) {
              g.keysAtom_.reportChanged();
              break;
            }
            H = N.next(), E = R.next();
          }
      g.data_ = c;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(n, g) {
    return process.env.NODE_ENV !== "production" && g === !0 && T("`observe` doesn't support fireImmediately=true in combination with maps."), oi(this, n);
  }, e.intercept_ = function(n) {
    return si(this, n);
  }, lg(t, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), sn = /* @__PURE__ */ Bn("ObservableMap", EC);
function hl(t) {
  return t[Symbol.toStringTag] = "MapIterator", bs(t);
}
function wV(t) {
  if (og(t) || sn(t))
    return t;
  if (Array.isArray(t))
    return new Map(t);
  if (ve(t)) {
    var e = /* @__PURE__ */ new Map();
    for (var n in t)
      e.set(n, t[n]);
    return e;
  } else
    return T(21, t);
}
var zV = {}, jC = /* @__PURE__ */ function() {
  function t(n, g, i) {
    var c = this;
    g === void 0 && (g = rg), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + re() : "ObservableSet"), this.name_ = void 0, this[tt] = zV, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, yt(Set) || T(22), this.enhancer_ = function(A, l) {
      return g(A, l, i);
    }, ag(function() {
      c.atom_ = GC(c.name_), n && c.replace(n);
    });
  }
  var e = t.prototype;
  return e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.clear = function() {
    var n = this;
    Fe(function() {
      WC(function() {
        for (var g = Ln(n.data_.values()), i; !(i = g()).done; ) {
          var c = i.value;
          n.delete(c);
        }
      });
    });
  }, e.forEach = function(n, g) {
    for (var i = Ln(this), c; !(c = i()).done; ) {
      var A = c.value;
      n.call(g, A, A, this);
    }
  }, e.add = function(n) {
    var g = this;
    if (Ge(this.atom_), Pt(this)) {
      var i = Kt(this, {
        type: Oe,
        object: this,
        newValue: n
      });
      if (!i)
        return this;
    }
    if (!this.has(n)) {
      Fe(function() {
        g.data_.add(g.enhancer_(n, void 0)), g.atom_.reportChanged();
      });
      var c = process.env.NODE_ENV !== "production" && Nt(), A = Ae(this), l = A || c ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Oe,
        object: this,
        newValue: n
      } : null;
      c && process.env.NODE_ENV !== "production" && Lt(l), A && se(this, l), c && process.env.NODE_ENV !== "production" && kt();
    }
    return this;
  }, e.delete = function(n) {
    var g = this;
    if (Pt(this)) {
      var i = Kt(this, {
        type: uI,
        object: this,
        oldValue: n
      });
      if (!i)
        return !1;
    }
    if (this.has(n)) {
      var c = process.env.NODE_ENV !== "production" && Nt(), A = Ae(this), l = A || c ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: uI,
        object: this,
        oldValue: n
      } : null;
      return c && process.env.NODE_ENV !== "production" && Lt(l), Fe(function() {
        g.atom_.reportChanged(), g.data_.delete(n);
      }), A && se(this, l), c && process.env.NODE_ENV !== "production" && kt(), !0;
    }
    return !1;
  }, e.has = function(n) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(n));
  }, e.entries = function() {
    var n = 0, g = Array.from(this.keys()), i = Array.from(this.values());
    return pl({
      next: function() {
        var c = n;
        return n += 1, c < i.length ? {
          value: [g[c], i[c]],
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var n = this, g = 0, i = Array.from(this.data_.values());
    return pl({
      next: function() {
        return g < i.length ? {
          value: n.dehanceValue_(i[g++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, e.intersection = function(n) {
    if (Re(n) && !de(n))
      return n.intersection(this);
    var g = new Set(this);
    return g.intersection(n);
  }, e.union = function(n) {
    if (Re(n) && !de(n))
      return n.union(this);
    var g = new Set(this);
    return g.union(n);
  }, e.difference = function(n) {
    return new Set(this).difference(n);
  }, e.symmetricDifference = function(n) {
    if (Re(n) && !de(n))
      return n.symmetricDifference(this);
    var g = new Set(this);
    return g.symmetricDifference(n);
  }, e.isSubsetOf = function(n) {
    return new Set(this).isSubsetOf(n);
  }, e.isSupersetOf = function(n) {
    return new Set(this).isSupersetOf(n);
  }, e.isDisjointFrom = function(n) {
    if (Re(n) && !de(n))
      return n.isDisjointFrom(this);
    var g = new Set(this);
    return g.isDisjointFrom(n);
  }, e.replace = function(n) {
    var g = this;
    return de(n) && (n = new Set(n)), Fe(function() {
      Array.isArray(n) ? (g.clear(), n.forEach(function(i) {
        return g.add(i);
      })) : Re(n) ? (g.clear(), n.forEach(function(i) {
        return g.add(i);
      })) : n != null && T("Cannot initialize set from " + n);
    }), this;
  }, e.observe_ = function(n, g) {
    return process.env.NODE_ENV !== "production" && g === !0 && T("`observe` doesn't support fireImmediately=true in combination with sets."), oi(this, n);
  }, e.intercept_ = function(n) {
    return si(this, n);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[Symbol.iterator] = function() {
    return this.values();
  }, lg(t, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), de = /* @__PURE__ */ Bn("ObservableSet", jC);
function pl(t) {
  return t[Symbol.toStringTag] = "SetIterator", bs(t);
}
var Vl = /* @__PURE__ */ Object.create(null), Zl = "remove", VA = /* @__PURE__ */ function() {
  function t(n, g, i, c) {
    g === void 0 && (g = /* @__PURE__ */ new Map()), c === void 0 && (c = Rp), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = g, this.name_ = i, this.defaultAnnotation_ = c, this.keysAtom_ = new An(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = ve(this.target_), process.env.NODE_ENV !== "production" && !OC(this.defaultAnnotation_) && T("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = t.prototype;
  return e.getObservablePropValue_ = function(n) {
    return this.values_.get(n).get();
  }, e.setObservablePropValue_ = function(n, g) {
    var i = this.values_.get(n);
    if (i instanceof ge)
      return i.set(g), !0;
    if (Pt(this)) {
      var c = Kt(this, {
        type: Ie,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: g
      });
      if (!c)
        return null;
      g = c.newValue;
    }
    if (g = i.prepareNewValue_(g), g !== L.UNCHANGED) {
      var A = Ae(this), l = process.env.NODE_ENV !== "production" && Nt(), a = A || l ? {
        type: Ie,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: i.value_,
        name: n,
        newValue: g
      } : null;
      process.env.NODE_ENV !== "production" && l && Lt(a), i.setNewValue_(g), A && se(this, a), process.env.NODE_ENV !== "production" && l && kt();
    }
    return !0;
  }, e.get_ = function(n) {
    return L.trackingDerivation && !ce(this.target_, n) && this.has_(n), this.target_[n];
  }, e.set_ = function(n, g, i) {
    return i === void 0 && (i = !1), ce(this.target_, n) ? this.values_.has(n) ? this.setObservablePropValue_(n, g) : i ? Reflect.set(this.target_, n, g) : (this.target_[n] = g, !0) : this.extend_(n, {
      value: g,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, i);
  }, e.has_ = function(n) {
    if (!L.trackingDerivation)
      return n in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var g = this.pendingKeys_.get(n);
    return g || (g = new Vn(n in this.target_, SI, process.env.NODE_ENV !== "production" ? this.name_ + "." + CA(n) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(n, g)), g.get();
  }, e.make_ = function(n, g) {
    if (g === !0 && (g = this.defaultAnnotation_), g !== !1) {
      if (Xl(this, g, n), !(n in this.target_)) {
        var i;
        if ((i = this.target_[Se]) != null && i[n])
          return;
        T(1, g.annotationType_, this.name_ + "." + n.toString());
      }
      for (var c = this.target_; c && c !== NI; ) {
        var A = cI(c, n);
        if (A) {
          var l = g.make_(this, n, A, c);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        c = Object.getPrototypeOf(c);
      }
      vl(this, g, n);
    }
  }, e.extend_ = function(n, g, i, c) {
    if (c === void 0 && (c = !1), i === !0 && (i = this.defaultAnnotation_), i === !1)
      return this.defineProperty_(n, g, c);
    Xl(this, i, n);
    var A = i.extend_(this, n, g, c);
    return A && vl(this, i, n), A;
  }, e.defineProperty_ = function(n, g, i) {
    i === void 0 && (i = !1), Ge(this.keysAtom_);
    try {
      _t();
      var c = this.delete_(n);
      if (!c)
        return c;
      if (Pt(this)) {
        var A = Kt(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Oe,
          newValue: g.value
        });
        if (!A)
          return null;
        var l = A.newValue;
        g.value !== l && (g = $e({}, g, {
          value: l
        }));
      }
      if (i) {
        if (!Reflect.defineProperty(this.target_, n, g))
          return !1;
      } else
        he(this.target_, n, g);
      this.notifyPropertyAddition_(n, g.value);
    } finally {
      $t();
    }
    return !0;
  }, e.defineObservableProperty_ = function(n, g, i, c) {
    c === void 0 && (c = !1), Ge(this.keysAtom_);
    try {
      _t();
      var A = this.delete_(n);
      if (!A)
        return A;
      if (Pt(this)) {
        var l = Kt(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Oe,
          newValue: g
        });
        if (!l)
          return null;
        g = l.newValue;
      }
      var a = yl(n), C = {
        configurable: L.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: a.get,
        set: a.set
      };
      if (c) {
        if (!Reflect.defineProperty(this.target_, n, C))
          return !1;
      } else
        he(this.target_, n, C);
      var b = new Vn(g, i, process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key", !1);
      this.values_.set(n, b), this.notifyPropertyAddition_(n, b.value_);
    } finally {
      $t();
    }
    return !0;
  }, e.defineComputedProperty_ = function(n, g, i) {
    i === void 0 && (i = !1), Ge(this.keysAtom_);
    try {
      _t();
      var c = this.delete_(n);
      if (!c)
        return c;
      if (Pt(this)) {
        var A = Kt(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Oe,
          newValue: void 0
        });
        if (!A)
          return null;
      }
      g.name || (g.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key"), g.context = this.proxy_ || this.target_;
      var l = yl(n), a = {
        configurable: L.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (i) {
        if (!Reflect.defineProperty(this.target_, n, a))
          return !1;
      } else
        he(this.target_, n, a);
      this.values_.set(n, new ge(g)), this.notifyPropertyAddition_(n, void 0);
    } finally {
      $t();
    }
    return !0;
  }, e.delete_ = function(n, g) {
    if (g === void 0 && (g = !1), Ge(this.keysAtom_), !ce(this.target_, n))
      return !0;
    if (Pt(this)) {
      var i = Kt(this, {
        object: this.proxy_ || this.target_,
        name: n,
        type: Zl
      });
      if (!i)
        return null;
    }
    try {
      var c;
      _t();
      var A = Ae(this), l = process.env.NODE_ENV !== "production" && Nt(), a = this.values_.get(n), C = void 0;
      if (!a && (A || l)) {
        var b;
        C = (b = cI(this.target_, n)) == null ? void 0 : b.value;
      }
      if (g) {
        if (!Reflect.deleteProperty(this.target_, n))
          return !1;
      } else
        delete this.target_[n];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[n], a && (this.values_.delete(n), a instanceof Vn && (C = a.value_), JC(a)), this.keysAtom_.reportChanged(), (c = this.pendingKeys_) == null || (c = c.get(n)) == null || c.set(n in this.target_), A || l) {
        var m = {
          type: Zl,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: C,
          name: n
        };
        process.env.NODE_ENV !== "production" && l && Lt(m), A && se(this, m), process.env.NODE_ENV !== "production" && l && kt();
      }
    } finally {
      $t();
    }
    return !0;
  }, e.observe_ = function(n, g) {
    return process.env.NODE_ENV !== "production" && g === !0 && T("`observe` doesn't support the fire immediately property for observable objects."), oi(this, n);
  }, e.intercept_ = function(n) {
    return si(this, n);
  }, e.notifyPropertyAddition_ = function(n, g) {
    var i, c = Ae(this), A = process.env.NODE_ENV !== "production" && Nt();
    if (c || A) {
      var l = c || A ? {
        type: Oe,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: g
      } : null;
      process.env.NODE_ENV !== "production" && A && Lt(l), c && se(this, l), process.env.NODE_ENV !== "production" && A && kt();
    }
    (i = this.pendingKeys_) == null || (i = i.get(n)) == null || i.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Is(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, t;
}();
function li(t, e) {
  var n;
  if (process.env.NODE_ENV !== "production" && e && ri(t) && T("Options can't be provided for already observable objects."), ce(t, tt))
    return process.env.NODE_ENV !== "production" && !(QC(t) instanceof VA) && T("Cannot convert '" + bI(t) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), t;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(t) && T("Cannot make the designated object observable; it is not extensible");
  var g = (n = e == null ? void 0 : e.name) != null ? n : process.env.NODE_ENV !== "production" ? (ve(t) ? "ObservableObject" : t.constructor.name) + "@" + re() : "ObservableObject", i = new VA(t, /* @__PURE__ */ new Map(), String(g), jp(e));
  return is(t, tt, i), t;
}
var qV = /* @__PURE__ */ Bn("ObservableObjectAdministration", VA);
function yl(t) {
  return Vl[t] || (Vl[t] = {
    get: function() {
      return this[tt].getObservablePropValue_(t);
    },
    set: function(e) {
      return this[tt].setObservablePropValue_(t, e);
    }
  });
}
function ri(t) {
  return JI(t) ? qV(t[tt]) : !1;
}
function vl(t, e, n) {
  var g;
  process.env.NODE_ENV !== "production" && (t.appliedAnnotations_[n] = e), (g = t.target_[Se]) == null || delete g[n];
}
function Xl(t, e, n) {
  if (process.env.NODE_ENV !== "production" && !OC(e) && T("Cannot annotate '" + t.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !oI(e) && ce(t.appliedAnnotations_, n)) {
    var g = t.name_ + "." + n.toString(), i = t.appliedAnnotations_[n].annotationType_, c = e.annotationType_;
    T("Cannot apply '" + c + "' to '" + g + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var DV = /* @__PURE__ */ UC(0), LV = /* @__PURE__ */ function() {
  var t = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      t = !0;
    }
  }), Object.create(e)[0] = 1, t === !1;
}(), Hc = 0, MC = function() {
};
function kV(t, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(t.prototype, e) : t.prototype.__proto__ !== void 0 ? t.prototype.__proto__ = e : t.prototype = e;
}
kV(MC, Array.prototype);
var Cs = /* @__PURE__ */ function(t) {
  function e(g, i, c, A) {
    var l;
    return c === void 0 && (c = process.env.NODE_ENV !== "production" ? "ObservableArray@" + re() : "ObservableArray"), A === void 0 && (A = !1), l = t.call(this) || this, ag(function() {
      var a = new as(c, i, A, !0);
      a.proxy_ = l, CC(l, tt, a), g && g.length && l.spliceWithArray(0, 0, g), LV && Object.defineProperty(l, "0", DV);
    }), l;
  }
  dC(e, t);
  var n = e.prototype;
  return n.concat = function() {
    this[tt].atom_.reportObserved();
    for (var g = arguments.length, i = new Array(g), c = 0; c < g; c++)
      i[c] = arguments[c];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      i.map(function(A) {
        return zI(A) ? A.slice() : A;
      })
    );
  }, n[Symbol.iterator] = function() {
    var g = this, i = 0;
    return bs({
      next: function() {
        return i < g.length ? {
          value: g[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, lg(e, [{
    key: "length",
    get: function() {
      return this[tt].getArrayLength_();
    },
    set: function(g) {
      this[tt].setArrayLength_(g);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(MC);
Object.entries(CI).forEach(function(t) {
  var e = t[0], n = t[1];
  e !== "concat" && is(Cs.prototype, e, n);
});
function UC(t) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[tt].get_(t);
    },
    set: function(e) {
      this[tt].set_(t, e);
    }
  };
}
function EV(t) {
  he(Cs.prototype, "" + t, UC(t));
}
function TC(t) {
  if (t > Hc) {
    for (var e = Hc; e < t + 100; e++)
      EV(e);
    Hc = t;
  }
}
TC(1e3);
function jV(t, e, n) {
  return new Cs(t, e, n);
}
function ig(t, e) {
  if (typeof t == "object" && t !== null) {
    if (zI(t))
      return e !== void 0 && T(23), t[tt].atom_;
    if (de(t))
      return t.atom_;
    if (sn(t)) {
      if (e === void 0)
        return t.keysAtom_;
      var n = t.data_.get(e) || t.hasMap_.get(e);
      return n || T(25, e, bI(t)), n;
    }
    if (ri(t)) {
      if (!e)
        return T(26);
      var g = t[tt].values_.get(e);
      return g || T(27, e, bI(t)), g;
    }
    if (cs(t) || wI(t) || aI(t))
      return t;
  } else if (yt(t) && aI(t[tt]))
    return t[tt];
  T(28);
}
function QC(t, e) {
  if (t || T(29), cs(t) || wI(t) || aI(t) || sn(t) || de(t))
    return t;
  if (t[tt])
    return t[tt];
  T(24, t);
}
function bI(t, e) {
  var n;
  if (e !== void 0)
    n = ig(t, e);
  else {
    if (ng(t))
      return t.name;
    ri(t) || sn(t) || de(t) ? n = QC(t) : n = ig(t);
  }
  return n.name_;
}
function ag(t) {
  var e = Yn(), n = ss(!0);
  _t();
  try {
    return t();
  } finally {
    $t(), os(n), we(e);
  }
}
var xl = NI.toString;
function us(t, e, n) {
  return n === void 0 && (n = -1), ZA(t, e, n);
}
function ZA(t, e, n, g, i) {
  if (t === e)
    return t !== 0 || 1 / t === 1 / e;
  if (t == null || e == null)
    return !1;
  if (t !== t)
    return e !== e;
  var c = typeof t;
  if (c !== "function" && c !== "object" && typeof e != "object")
    return !1;
  var A = xl.call(t);
  if (A !== xl.call(e))
    return !1;
  switch (A) {
    case "[object RegExp]":
    case "[object String]":
      return "" + t == "" + e;
    case "[object Number]":
      return +t != +t ? +e != +e : +t == 0 ? 1 / +t === 1 / e : +t == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +t == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(t) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  t = Wl(t), e = Wl(e);
  var l = A === "[object Array]";
  if (!l) {
    if (typeof t != "object" || typeof e != "object")
      return !1;
    var a = t.constructor, C = e.constructor;
    if (a !== C && !(yt(a) && a instanceof a && yt(C) && C instanceof C) && "constructor" in t && "constructor" in e)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), g = g || [], i = i || [];
  for (var b = g.length; b--; )
    if (g[b] === t)
      return i[b] === e;
  if (g.push(t), i.push(e), l) {
    if (b = t.length, b !== e.length)
      return !1;
    for (; b--; )
      if (!ZA(t[b], e[b], n - 1, g, i))
        return !1;
  } else {
    var m = Object.keys(t), p;
    if (b = m.length, Object.keys(e).length !== b)
      return !1;
    for (; b--; )
      if (p = m[b], !(ce(e, p) && ZA(t[p], e[p], n - 1, g, i)))
        return !1;
  }
  return g.pop(), i.pop(), !0;
}
function Wl(t) {
  return zI(t) ? t.slice() : og(t) || sn(t) || Re(t) || de(t) ? Array.from(t.entries()) : t;
}
var fl, MV = ((fl = ns().Iterator) == null ? void 0 : fl.prototype) || {};
function bs(t) {
  return t[Symbol.iterator] = UV, Object.assign(Object.create(MV), t);
}
function UV() {
  return this;
}
function OC(t) {
  return (
    // Can be function
    t instanceof Object && typeof t.annotationType_ == "string" && yt(t.make_) && yt(t.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(t) {
  var e = ns();
  typeof e[t] > "u" && T("MobX requires global '" + t + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: lV,
  extras: {
    getDebugName: bI
  },
  $mobx: tt
});
var Mg = /* @__PURE__ */ ((t) => (t.Free = "Free", t.Day_Pass = "Day_Pass", t))(Mg || {});
if (!ee)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!RG)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function TV(t) {
  t();
}
function QV(t) {
  t || (t = TV, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), SG({ reactionScheduler: t });
}
function OV(t) {
  return FG(t);
}
var PV = 1e4, KV = 1e4, _V = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(g) {
          g === void 0 && (g = PV), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var i = Date.now();
          n.registrations.forEach(function(c, A) {
            i - c.registeredAt >= g && (n.finalize(c.value), n.registrations.delete(A));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(t.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, n, g) {
        this.registrations.set(g, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(t.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(t.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, KV));
      }
    }), t;
  }()
), $V = typeof FinalizationRegistry < "u" ? FinalizationRegistry : _V, yA = new $V(function(t) {
  var e;
  (e = t.reaction) === null || e === void 0 || e.dispose(), t.reaction = null;
}), vA = { exports: {} }, wc = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bl;
function tZ() {
  if (Bl) return wc;
  Bl = 1;
  var t = pt;
  function e(m, p) {
    return m === p && (m !== 0 || 1 / m === 1 / p) || m !== m && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : e, g = t.useState, i = t.useEffect, c = t.useLayoutEffect, A = t.useDebugValue;
  function l(m, p) {
    var y = p(), f = g({ inst: { value: y, getSnapshot: p } }), x = f[0].inst, Y = f[1];
    return c(function() {
      x.value = y, x.getSnapshot = p, a(x) && Y({ inst: x });
    }, [m, y, p]), i(function() {
      return a(x) && Y({ inst: x }), m(function() {
        a(x) && Y({ inst: x });
      });
    }, [m]), A(y), y;
  }
  function a(m) {
    var p = m.getSnapshot;
    m = m.value;
    try {
      var y = p();
      return !n(m, y);
    } catch {
      return !0;
    }
  }
  function C(m, p) {
    return p();
  }
  var b = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? C : l;
  return wc.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : b, wc;
}
var zc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yl;
function eZ() {
  return Yl || (Yl = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = pt, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(N) {
      {
        for (var R = arguments.length, H = new Array(R > 1 ? R - 1 : 0), E = 1; E < R; E++)
          H[E - 1] = arguments[E];
        g("error", N, H);
      }
    }
    function g(N, R, H) {
      {
        var E = e.ReactDebugCurrentFrame, O = E.getStackAddendum();
        O !== "" && (R += "%s", H = H.concat([O]));
        var j = H.map(function(U) {
          return String(U);
        });
        j.unshift("Warning: " + R), Function.prototype.apply.call(console[N], console, j);
      }
    }
    function i(N, R) {
      return N === R && (N !== 0 || 1 / N === 1 / R) || N !== N && R !== R;
    }
    var c = typeof Object.is == "function" ? Object.is : i, A = t.useState, l = t.useEffect, a = t.useLayoutEffect, C = t.useDebugValue, b = !1, m = !1;
    function p(N, R, H) {
      b || t.startTransition !== void 0 && (b = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var E = R();
      if (!m) {
        var O = R();
        c(E, O) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), m = !0);
      }
      var j = A({
        inst: {
          value: E,
          getSnapshot: R
        }
      }), U = j[0].inst, D = j[1];
      return a(function() {
        U.value = E, U.getSnapshot = R, y(U) && D({
          inst: U
        });
      }, [N, E, R]), l(function() {
        y(U) && D({
          inst: U
        });
        var gt = function() {
          y(U) && D({
            inst: U
          });
        };
        return N(gt);
      }, [N]), C(E), E;
    }
    function y(N) {
      var R = N.getSnapshot, H = N.value;
      try {
        var E = R();
        return !c(H, E);
      } catch {
        return !0;
      }
    }
    function f(N, R, H) {
      return R();
    }
    var x = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Y = !x, B = Y ? f : p, J = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : B;
    zc.useSyncExternalStore = J, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), zc;
}
process.env.NODE_ENV === "production" ? vA.exports = tZ() : vA.exports = eZ();
var nZ = vA.exports;
function Nl(t) {
  t.reaction = new HG("observer".concat(t.name), function() {
    var e;
    t.stateVersion = Symbol(), (e = t.onStoreChange) === null || e === void 0 || e.call(t);
  });
}
function gZ(t, e) {
  e === void 0 && (e = "observed");
  var n = pt.useRef(null);
  if (!n.current) {
    var g = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(l) {
        return yA.unregister(g), g.onStoreChange = l, g.reaction || (Nl(g), g.stateVersion = Symbol()), function() {
          var a;
          g.onStoreChange = null, (a = g.reaction) === null || a === void 0 || a.dispose(), g.reaction = null;
        };
      },
      getSnapshot: function() {
        return g.stateVersion;
      }
    };
    n.current = g;
  }
  var i = n.current;
  i.reaction || (Nl(i), yA.register(n, i, i)), pt.useDebugValue(i.reaction, OV), nZ.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var c, A;
  if (i.reaction.track(function() {
    try {
      c = t();
    } catch (l) {
      A = l;
    }
  }), A)
    throw A;
  return c;
}
var qc, Dc, Jl = !0, PC = typeof Symbol == "function" && Symbol.for, iZ = (Dc = (qc = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || qc === void 0 ? void 0 : qc.configurable) !== null && Dc !== void 0 ? Dc : !1, Rl = PC ? Symbol.for("react.forward_ref") : typeof Le == "function" && Le(function(t) {
  return null;
}).$$typeof, Sl = PC ? Symbol.for("react.memo") : typeof AA == "function" && AA(function(t) {
  return null;
}).$$typeof;
function KC(t, e) {
  var n;
  if (process.env.NODE_ENV !== "production" && Jl && e && (Jl = !1, console.warn("[mobx-react-lite] `observer(fn, { forwardRef: true })` is deprecated, use `observer(React.forwardRef(fn))`")), Sl && t.$$typeof === Sl)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var g = (n = void 0) !== null && n !== void 0 ? n : !1, i = t, c = t.displayName || t.name;
  if (Rl && t.$$typeof === Rl && (g = !0, i = t.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var A = function(l, a) {
    return gZ(function() {
      return i(l, a);
    }, c);
  };
  return A.displayName = t.displayName, iZ && Object.defineProperty(A, "name", {
    value: t.name,
    writable: !0,
    configurable: !0
  }), t.contextTypes && (A.contextTypes = t.contextTypes), g && (A = Le(A)), A = AA(A), cZ(t, A), process.env.NODE_ENV !== "production" && Object.defineProperty(A, "contextTypes", {
    set: function() {
      var l, a;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((l = this.type) === null || l === void 0 ? void 0 : l.displayName) || ((a = this.type) === null || a === void 0 ? void 0 : a.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), A;
}
var IZ = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function cZ(t, e) {
  Object.keys(t).forEach(function(n) {
    IZ[n] || Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
  });
}
process.env.NODE_ENV;
var Lc;
QV(JG);
Lc = yA.finalizeAllImmediately;
const AZ = (t = !0, e = 1.1) => Zt({
  "from, to": [{
    transform: "scale(1)"
  }, t && me(2)],
  "50%": [{
    transform: `scale(${e})`
  }, t && me(3)]
}), sZ = (t = 1.2) => Zt({
  "0, 100%": [{
    transform: "scale(1)"
  }],
  "50%": [{
    transform: `scale(${t})`
  }]
}), oZ = (t, e) => Zt({
  "0, 100%": [{
    color: t
  }],
  "50%": [{
    color: e
  }]
}), lZ = (t = "0.5s", e = 1.2) => ({
  animation: `${sZ(e)} ${t} infinite`
}), rZ = (t = "0.5s", e = K.secondaryBorder, n = K.transparentLight) => ({
  color: e,
  animation: `${oZ(e, n)} ${t} infinite`
}), aZ = (t = "0.5s", e = "cubic-bezier(0.0, 1.01, 0.0, 1.65)", n = !0, g = 1.1) => ({
  animation: `${AZ(n, g)} ${t} ${e}`
}), CZ = Zt({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), dI = (t = "0.6s", e = "ease", n = "0s") => ({
  animation: `${CZ} ${t} ${e}`,
  animationDelay: n,
  opacity: 1
}), uZ = Zt({
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
}), XA = (t = "0.6s", e = "ease") => ({
  animation: `${uZ} ${t} ${e}`,
  opacity: 0
}), bZ = (t, e) => Zt({
  from: {
    transform: `scale(${t})`
  },
  to: {
    transform: `scale(${e})`
  }
}), xA = (t = "0.5s", e = 1, n = 0, g = "ease") => ({
  animation: `${bZ(e, n)} ${t} 1 ${g}`,
  transform: `scale(${n})`
}), Fl = (t = "x") => Zt({
  from: {
    [t === "x" ? "left" : "bottom"]: 0
  },
  to: {
    [t === "x" ? "left" : "bottom"]: "100vh"
  }
  // from: {
  //   bottom: 0,
  //   left: '50%',
  // },
  // '50%': {
  //   bottom: '50%',
  //   left: '60%',
  // },
  // to: {
  //   bottom: '100%',
  //   left: '40%',
  // },
}), dZ = (t = "2s", e = "ease-in-out") => ({
  animation: `${Fl()} ${t} alternate infinite ${e}, ${Fl("y")} 3s alternate infinite ${e}`
  // bottom: '100%',
  // left: '25%',
}), GZ = (t = "0") => Zt({
  from: {
    transform: `translateX(calc(100% + ${t}))`
  },
  to: {
    transform: "translateX(0)"
  }
}), mZ = (t = "0") => Zt({
  from: {
    transform: `translateX(calc(-100% - ${t}))`
  },
  to: {
    transform: "translateX(0)"
  }
}), hZ = (t = "0") => Zt({
  from: {
    transform: `translateY(calc(100% + ${t}))`
  },
  to: {
    transform: "translateY(0)"
  }
}), pZ = (t = "0") => Zt({
  from: {
    transform: `translateY(calc(-100% - ${t}))`
  },
  to: {
    transform: "translateY(0)"
  }
}), Hl = (t, e = "0.6s", n = "ease", g = "0") => ({
  animation: `${{
    left: GZ,
    right: mZ,
    up: hZ,
    down: pZ
  }[t](g)} ${e} 1 ${n}`
}), VZ = (t = "0") => Zt({
  from: {
    transform: "translateX(0)"
  },
  to: {
    transform: `translateX(calc(-100% - ${t}))`
  }
}), ZZ = (t = "0") => Zt({
  from: {
    transform: "translateX(0)"
  },
  to: {
    transform: `translateX(calc(100% + ${t}))`
  }
}), yZ = (t = "0") => Zt({
  from: {
    transform: "translateY(0)"
  },
  to: {
    transform: `translateY(calc(-100% - ${t}))`
  }
}), vZ = (t = "0") => Zt({
  from: {
    transform: "translateY(0)"
  },
  to: {
    transform: `translateY(calc(100% + ${t}))`
  }
}), wl = (t, e = "0.6s", n = "ease", g = "0") => ({
  animation: `${{
    left: VZ,
    right: ZZ,
    up: yZ,
    down: vZ
  }[t](g)} ${e} 1 ${n} forwards`
}), XZ = (t) => Zt({
  from: {
    display: t
  },
  to: {
    display: t
  }
}), _C = (t = "block", e = "block", n = "0.6s") => ({
  animation: `${XZ(t)} ${n} alternate infinite linear`,
  display: e
}), A2 = (t = "block", e = "block", n = "0.6s", g = "ease") => Ug(_C(t, e, n), dI(n, g)), s2 = (t = "block", e = "block", n = "0.6s", g = "ease") => Ug(_C(t, e, n), XA(n, g)), Ug = (...t) => [...t, {
  animation: t.map((e) => e.animation).join(", ")
}], xZ = Zt({
  "from, to": {
    transform: "translateX(0)",
    scale: "1"
  },
  "20%": {
    transform: "translateX(-5px)"
  },
  "40%": {
    transform: "translateX(5px)"
  },
  "50%": {
    scale: "1.1"
  },
  "60%": {
    transform: "translateX(-5px)"
  },
  "80%": {
    transform: "translateX(5px)"
  }
}), o2 = (t = "0.5s") => ({
  animation: `${xZ} ${t} 1`
}), WZ = Zt({
  "from, to": {
    borderColor: "transparent"
  },
  "20%, 80%": {
    borderColor: "#cf5050"
  }
}), l2 = (t = "1s", e = "ease") => ({
  animation: `${WZ} ${t} ${e}`
}), fZ = "data:image/png;base64,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", BZ = KC((t) => {
  const {
    image: e
  } = t;
  return /* @__PURE__ */ w("img", { css: ["height:100%;", ti("xxl"), process.env.NODE_ENV === "production" ? "" : ";label:PlayerIcon;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1BsYXllckljb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFNIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1BsYXllckljb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYm9yZGVyUmFkaXVzIH0gZnJvbSAnQC9jb21tb24vc3R5bGVzL3V0aWxzJztcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdC1saXRlJztcbmltcG9ydCBkZWZhdWx0UGxheWVySW1hZ2UgZnJvbSAnQC9jb21tb24vYXNzZXRzL3BsYWNlaG9sZGVyLnBuZyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgUGxheWVySWNvblByb3BzIHtcbiAgaW1hZ2U/OiBzdHJpbmcgfCBudWxsO1xufVxuXG5leHBvcnQgY29uc3QgUGxheWVySWNvbiA9IG9ic2VydmVyKChwcm9wczogUGxheWVySWNvblByb3BzKSA9PiB7XG4gIGNvbnN0IHsgaW1hZ2UgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPGltZ1xuICAgICAgY3NzPXtbeyBoZWlnaHQ6ICcxMDAlJyB9LCBib3JkZXJSYWRpdXMoJ3h4bCcpXX1cbiAgICAgIHNyYz17aW1hZ2UgPz8gZGVmYXVsdFBsYXllckltYWdlfVxuICAgIC8+XG4gICk7XG59KTtcbiJdfQ== */"], src: e ?? fZ });
}), YZ = (t, e) => [{
  height: 50,
  alignItems: "center",
  minWidth: 100
}, ya, t && aZ(), _n(), Za(), WI("sm"), QA(K.warning, e ? "4px" : "0px")], zl = [fn(ke.primary, "1em"), ni, {
  letterSpacing: "-0.15em",
  lineHeight: "1em",
  color: K.text,
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "clip",
  textOverflow: "ellipsis",
  width: "fit-content"
}], NZ = (t, e, n) => [{
  letterSpacing: "-0.15em",
  color: SZ[t],
  visibility: e && n && t !== void 0 ? "visible" : "hidden"
}, fn(ke.primary, "8px", "bold"), ni], JZ = (t, e, n) => [{
  letterSpacing: "-0.15em",
  color: t ? K.success : K.component,
  visibility: e && n && t !== void 0 ? "visible" : "hidden"
}, fn(ke.primary, "8px", "bold"), ni], RZ = [{
  rotate: "-30deg",
  width: "fit-content",
  height: "fit-content",
  color: K.warning,
  letterSpacing: "-0.15em"
}, lZ("1s"), Ft(-16, 0, 0, -24), DG(K.transparent, 1.5)], SZ = {
  [Mg.Free]: K.component,
  [Mg.Day_Pass]: K.primary
}, FZ = {
  [Mg.Free]: "Guest",
  [Mg.Day_Pass]: "Day Pass"
}, r2 = KC((t) => {
  const {
    player: e,
    host: n,
    ...g
  } = t, i = (e == null ? void 0 : e.screenName) !== null, c = Ke(!!e), [A, l] = ee(!1);
  return Ee(() => {
    !c.current && e && l(!0), e || l(!1), c.current = !!e;
  }, [e]), /* @__PURE__ */ Vt(gi, { inset: !0, css: YZ(A, !!n), ...g, children: [
    n && /* @__PURE__ */ w("span", { css: RZ, children: "Host" }),
    e && /* @__PURE__ */ w(BZ, { image: e.image }),
    e ? /* @__PURE__ */ Vt("div", { css: ["height:fit-content;", LG("sm"), ya, process.env.NODE_ENV === "production" ? "" : ";label:PlayerSlot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
      t.superComponent ?? /* @__PURE__ */ w("div", { css: NZ(e.subscription, t.showSubscription, i), children: FZ[e.subscription] }),
      /* @__PURE__ */ w("div", { css: [zl, e.screenName === null && rZ("2s"), process.env.NODE_ENV === "production" ? "" : ";label:PlayerSlot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: e.screenName ?? "Connecting..." }),
      t.subComponent ?? /* @__PURE__ */ w("div", { css: JZ(e.ready, t.showReady, i), children: e.ready ? "Ready" : "Not Ready" })
    ] }) : /* @__PURE__ */ w("div", { css: [zl, process.env.NODE_ENV === "production" ? "" : ";label:PlayerSlot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"] })
  ] });
});
function a2(t) {
  return /* @__PURE__ */ w("div", { css: [
    "width:50px;height:50px;background:red;",
    Ft(),
    Ug(
      //   fadeOut('4s'),
      xA("1.7s", 1, 0.5, "ease-out"),
      dZ()
    ),
    process.env.NODE_ENV === "production" ? "" : ";label:Reaction;",
    process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1JlYWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQk0iLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvdWkvdWkvc3JjL2NvbW1vbi9jb21wb25lbnRzL2Jhc2UvUmVhY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgY29tYmluZUFuaW1hdGlvbnMsXG4gIHNjYWxlVHJhbnNpdGlvbixcbiAgd2F2ZU1vdmVtZW50LFxufSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvYW5pbWF0aW9uJztcbmltcG9ydCB7IGFic29sdXRlIH0gZnJvbSAnQC9jb21tb24vc3R5bGVzL3V0aWxzJztcblxuZXhwb3J0IGludGVyZmFjZSBSZWFjdGlvblByb3BzIHtcbiAgaDogbnVtYmVyO1xufVxuXG4vKipcbiAqIFJlbmRlcnMgYSByZWFjdGlvbiBjb21wb25lbnQuXG4qXG4qIEBwYXJhbSB7UmVhY3Rpb25Qcm9wc30gcHJvcHMgLSBUaGUgcHJvcHMgZm9yIHRoZSByZWFjdGlvbiBjb21wb25lbnQuXG4qIEByZXR1cm5zIHtKU1guRWxlbWVudH0gVGhlIHJlbmRlcmVkIHJlYWN0aW9uIGNvbXBvbmVudC5cbiovXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzXG5leHBvcnQgZnVuY3Rpb24gUmVhY3Rpb24ocHJvcHM6IFJlYWN0aW9uUHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e1tcbiAgICAgICAge1xuICAgICAgICAgIHdpZHRoOiA1MCxcbiAgICAgICAgICBoZWlnaHQ6IDUwLFxuICAgICAgICAgIGJhY2tncm91bmQ6ICdyZWQnLFxuICAgICAgICB9LFxuICAgICAgICBhYnNvbHV0ZSgpLFxuICAgICAgICBjb21iaW5lQW5pbWF0aW9ucyhcbiAgICAgICAgICAvLyAgIGZhZGVPdXQoJzRzJyksXG4gICAgICAgICAgc2NhbGVUcmFuc2l0aW9uKCcxLjdzJywgMSwgMC41LCAnZWFzZS1vdXQnKSxcbiAgICAgICAgICB3YXZlTW92ZW1lbnQoKSxcbiAgICAgICAgKSxcbiAgICAgICAgLy8gd2F2ZU1vdmVtZW50KCksXG4gICAgICBdfVxuICAgIC8+XG4gICk7XG59XG4iXX0= */"
  ] });
}
function C2(t) {
  const {
    mainAxis: e = 15,
    crossAxis: n = 0,
    direction: g = "column"
  } = t;
  return /* @__PURE__ */ w("div", { css: /* @__PURE__ */ Gt({
    width: g === "column" ? n : e,
    height: g === "column" ? e : n
  }, process.env.NODE_ENV === "production" ? "" : ";label:Spacing;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1NwYWNpbmcudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCTSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay91aS91aS9zcmMvY29tbW9uL2NvbXBvbmVudHMvYmFzZS9TcGFjaW5nLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBpbnRlcmZhY2UgU3BhY2luZ1Byb3BzIHtcbiAgbWFpbkF4aXM/OiBudW1iZXIgfCBzdHJpbmc7XG4gIGNyb3NzQXhpcz86IG51bWJlciB8IHN0cmluZztcbiAgZGlyZWN0aW9uPzogJ3JvdycgfCAnY29sdW1uJztcbn1cblxuLyoqXG4gKiBSZW5kZXJzIGEgc3BhY2luZyBjb21wb25lbnQgd2l0aCBjdXN0b21pemFibGUgZGltZW5zaW9ucy5cbiAqIEBwYXJhbSB7U3BhY2luZ1Byb3BzfSBwcm9wcyAtIFRoZSBwcm9wcyBmb3IgdGhlIHNwYWNpbmcgY29tcG9uZW50LlxuICogQHJldHVybnMge0pTWC5FbGVtZW50fSBUaGUgcmVuZGVyZWQgc3BhY2luZyBjb21wb25lbnQuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBTcGFjaW5nKHByb3BzOiBTcGFjaW5nUHJvcHMpIHtcbiAgY29uc3QgeyBtYWluQXhpcyA9IDE1LCBjcm9zc0F4aXMgPSAwLCBkaXJlY3Rpb24gPSAnY29sdW1uJyB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e3tcbiAgICAgICAgd2lkdGg6IGRpcmVjdGlvbiA9PT0gJ2NvbHVtbicgPyBjcm9zc0F4aXMgOiBtYWluQXhpcyxcbiAgICAgICAgaGVpZ2h0OiBkaXJlY3Rpb24gPT09ICdjb2x1bW4nID8gbWFpbkF4aXMgOiBjcm9zc0F4aXMsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */") });
}
function u2(t) {
  const {
    children: e,
    className: n,
    ...g
  } = t;
  return /* @__PURE__ */ w("div", { className: n, css: [{
    background: K.background
  }, Ft(), ne, $n, process.env.NODE_ENV === "production" ? "" : ";label:Splash;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1NwbGFzaC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0JNIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1NwbGFzaC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdGhlbWUnO1xuaW1wb3J0IHsgYWJzb2x1dGUsIGZsZXhDZW50ZXIsIGZ1bGxTaXplIH0gZnJvbSAnQC9jb21tb24vc3R5bGVzL3V0aWxzJztcblxuZXhwb3J0IGludGVyZmFjZSBTcGxhc2hQcm9wcyB7XG4gIGNoaWxkcmVuPzogUmVhY3QuUmVhY3ROb2RlO1xuICBjbGFzc05hbWU/OiBzdHJpbmc7XG59XG5cbi8qKlxuICogUmVuZGVycyBhIHNwbGFzaCBjb21wb25lbnQgd2l0aCB0aGUgcHJvdmlkZWQgcHJvcHMuXG4gKlxuICogQHBhcmFtIHByb3BzIC0gVGhlIHByb3BzIGZvciB0aGUgU3BsYXNoIGNvbXBvbmVudC5cbiAqIEByZXR1cm5zIFRoZSByZW5kZXJlZCBTcGxhc2ggY29tcG9uZW50LlxuICovXG5leHBvcnQgZnVuY3Rpb24gU3BsYXNoKFxuICBwcm9wczogU3BsYXNoUHJvcHMgJlxuICAgIFJlYWN0LkNsYXNzQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4gJlxuICAgIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50Pixcbikge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIC4uLnJlc3QgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gICAgICBjc3M9e1t7IGJhY2tncm91bmQ6IGNvbG9ycy5iYWNrZ3JvdW5kIH0sIGFic29sdXRlKCksIGZ1bGxTaXplLCBmbGV4Q2VudGVyXX1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn1cbiJdfQ== */"], ...g, children: e });
}
var HZ = "VisuallyHidden", $C = v.forwardRef(
  (t, e) => /* @__PURE__ */ k(
    at.span,
    {
      ...t,
      ref: e,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
$C.displayName = HZ;
const tu = 200, qn = `${tu}ms`, b2 = (t) => {
  const {
    open: e,
    children: n,
    title: g,
    noAnimation: i = !1,
    cardProps: c,
    ...A
  } = t, l = !i, [a, C] = ee(e);
  Ee(() => {
    if (l)
      if (e)
        C(!0);
      else {
        const m = setTimeout(() => {
          C(!1);
        }, tu);
        return () => {
          clearTimeout(m);
        };
      }
  }, [e, l, C]);
  const b = (l ? a : e) || void 0;
  return /* @__PURE__ */ w(Eh, { open: e, ...A, children: /* @__PURE__ */ Vt(Mh, { forceMount: b, children: [
    /* @__PURE__ */ w(eC, { css: [Ft(0, 0, 0, 0), {
      background: K.transparent
    }, ne, "z-index:10000;", l && (e ? dI(qn) : XA(qn)), !e && {
      pointerEvents: "none"
    }, process.env.NODE_ENV === "production" ? "" : ";label:Dialog;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"] }),
    /* @__PURE__ */ Vt(Uh, { forceMount: b, children: [
      /* @__PURE__ */ w($C, { asChild: !0, children: /* @__PURE__ */ w(iC, { children: g }) }),
      /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), $n, process.env.NODE_ENV === "production" ? "" : ";label:Dialog;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w(gi, { shadow: !0, solid: !0, css: [Ft(), $n, "z-index:10000;", l && (e ? Ug(dI(qn), xA(qn, 0, 1)) : Ug(XA(qn), xA(qn, 1, 0))), !e && {
        pointerEvents: "none"
      }, process.env.NODE_ENV === "production" ? "" : ";label:Dialog;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ...c, children: n }) })
    ] })
  ] }) });
}, d2 = jh, eu = Le((t, e) => {
  const {
    children: n,
    justifyContent: g,
    alignItems: i,
    flexDirection: c = "row",
    // default to row
    flexWrap: A,
    gap: l,
    className: a,
    divProps: C,
    center: b = !1,
    flex: m,
    horizontalAxis: p,
    verticalAxis: y
  } = t, x = ["column", "column-reverse"].includes(c);
  return /* @__PURE__ */ w("div", { ref: e, className: a, style: {
    display: "flex",
    flexDirection: c,
    flexWrap: A,
    justifyContent: b ? "center" : x ? y || g : p || g,
    alignItems: b ? "center" : x ? p || i : y || i,
    gap: l,
    flex: m
  }, ...C, children: n });
}), Cg = Le((t, e) => /* @__PURE__ */ w(eu, { ref: e, flexDirection: "row", ...t })), ds = Le((t, e) => /* @__PURE__ */ w(eu, { ref: e, flexDirection: "column", ...t })), G2 = () => /* @__PURE__ */ w(Cg, { center: !0 }), m2 = (t) => {
  const {
    icon: e,
    circular: n = !1,
    noIconAnimation: g = !1,
    children: i,
    ...c
  } = t, l = {
    circular: n,
    hasIconAnimation: !g
  };
  return /* @__PURE__ */ w(oA, { css: wZ(l), ...c, children: /* @__PURE__ */ Vt(Cg, { gap: Kn.md, alignItems: "center", justifyContent: "space-between", children: [
    /* @__PURE__ */ w("div", { css: [zZ(l), $n, process.env.NODE_ENV === "production" ? "" : ";label:IconButton;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: e }),
    i && /* @__PURE__ */ w("div", { children: i })
  ] }) });
}, wZ = (t) => /* @__PURE__ */ Gt("padding:10px;", t.hasIconAnimation && {
  "&:hover > div > div > div:first-of-type": {
    transform: "scale(1.5)"
  },
  "&:active > div > div > div:first-of-type": {
    transform: "scale(1.5) rotate(-30deg)"
  }
}, t.circular && {
  borderRadius: 9999
}, process.env.NODE_ENV === "production" ? "" : ";label:IconButtonStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), zZ = (t) => /* @__PURE__ */ Gt(t.hasIconAnimation && {
  transform: "scale(1)",
  transition: "transform 0.2s ease"
}, process.env.NODE_ENV === "production" ? "" : ";label:IconStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function qZ(t, e = []) {
  let n = [];
  function g(c, A) {
    const l = v.createContext(A), a = n.length;
    n = [...n, A];
    function C(m) {
      const { scope: p, children: y, ...f } = m, x = (p == null ? void 0 : p[t][a]) || l, Y = v.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ k(x.Provider, { value: Y, children: y });
    }
    function b(m, p) {
      const y = (p == null ? void 0 : p[t][a]) || l, f = v.useContext(y);
      if (f) return f;
      if (A !== void 0) return A;
      throw new Error(`\`${m}\` must be used within \`${c}\``);
    }
    return C.displayName = c + "Provider", [C, b];
  }
  const i = () => {
    const c = n.map((A) => v.createContext(A));
    return function(l) {
      const a = (l == null ? void 0 : l[t]) || c;
      return v.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: a } }),
        [l, a]
      );
    };
  };
  return i.scopeName = t, [g, DZ(i, ...e)];
}
function DZ(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const g = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const A = g.reduce((l, { useScope: a, scopeName: C }) => {
        const m = a(c)[`__scope${C}`];
        return { ...l, ...m };
      }, {});
      return v.useMemo(() => ({ [`__scope${e.scopeName}`]: A }), [A]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
var Gs = "Progress", ms = 100, [LZ, h2] = qZ(Gs), [kZ, EZ] = LZ(Gs), nu = v.forwardRef(
  (t, e) => {
    const {
      __scopeProgress: n,
      value: g = null,
      max: i,
      getValueLabel: c = jZ,
      ...A
    } = t;
    (i || i === 0) && !ql(i) && console.error(MZ(`${i}`, "Progress"));
    const l = ql(i) ? i : ms;
    g !== null && !Dl(g, l) && console.error(UZ(`${g}`, "Progress"));
    const a = Dl(g, l) ? g : null, C = GI(a) ? c(a, l) : void 0;
    return /* @__PURE__ */ k(kZ, { scope: n, value: a, max: l, children: /* @__PURE__ */ k(
      at.div,
      {
        "aria-valuemax": l,
        "aria-valuemin": 0,
        "aria-valuenow": GI(a) ? a : void 0,
        "aria-valuetext": C,
        role: "progressbar",
        "data-state": Iu(a, l),
        "data-value": a ?? void 0,
        "data-max": l,
        ...A,
        ref: e
      }
    ) });
  }
);
nu.displayName = Gs;
var gu = "ProgressIndicator", iu = v.forwardRef(
  (t, e) => {
    const { __scopeProgress: n, ...g } = t, i = EZ(gu, n);
    return /* @__PURE__ */ k(
      at.div,
      {
        "data-state": Iu(i.value, i.max),
        "data-value": i.value ?? void 0,
        "data-max": i.max,
        ...g,
        ref: e
      }
    );
  }
);
iu.displayName = gu;
function jZ(t, e) {
  return `${Math.round(t / e * 100)}%`;
}
function Iu(t, e) {
  return t == null ? "indeterminate" : t === e ? "complete" : "loading";
}
function GI(t) {
  return typeof t == "number";
}
function ql(t) {
  return GI(t) && !isNaN(t) && t > 0;
}
function Dl(t, e) {
  return GI(t) && !isNaN(t) && t <= e && t >= 0;
}
function MZ(t, e) {
  return `Invalid prop \`max\` of value \`${t}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${ms}\`.`;
}
function UZ(t, e) {
  return `Invalid prop \`value\` of value \`${t}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${ms} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var TZ = nu, QZ = iu;
const OZ = /* @__PURE__ */ Gt([_n(), {
  overflow: "hidden",
  background: K.componentSolid,
  borderRadius: 25,
  width: 300,
  height: 25,
  transform: "translateZ(0)"
}, QA(K.border)], process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), PZ = (t) => /* @__PURE__ */ Gt("width:100%;height:100%;", t && {
  transition: "transform 0.2s cubic-bezier(0.65, 0, 0.35, 1)"
}, process.env.NODE_ENV === "production" ? "" : ";label:indicatorStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), p2 = (t) => {
  const {
    progress: e,
    intent: n = "primary",
    noTransition: g = !1,
    className: i
  } = t, c = !g;
  return /* @__PURE__ */ w(TZ, { className: i, css: OZ, value: e * 100, children: /* @__PURE__ */ w(QZ, { css: [PZ(c), {
    background: $g[n].backgroundColor
  }, process.env.NODE_ENV === "production" ? "" : ";label:ProgressBar;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], style: {
    transform: `translateX(-${100 - e * 100}%)`
  } }) });
};
var KZ = v.createContext(void 0);
function cu(t) {
  const e = v.useContext(KZ);
  return t || e || "ltr";
}
function hs(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
function _Z(t, e) {
  return v.useReducer((n, g) => e[n][g] ?? n, t);
}
var ps = "ScrollArea", [Au, V2] = ii(ps), [$Z, ie] = Au(ps), su = v.forwardRef(
  (t, e) => {
    const {
      __scopeScrollArea: n,
      type: g = "hover",
      dir: i,
      scrollHideDelay: c = 600,
      ...A
    } = t, [l, a] = v.useState(null), [C, b] = v.useState(null), [m, p] = v.useState(null), [y, f] = v.useState(null), [x, Y] = v.useState(null), [B, J] = v.useState(0), [N, R] = v.useState(0), [H, E] = v.useState(!1), [O, j] = v.useState(!1), U = dt(e, (gt) => a(gt)), D = cu(i);
    return /* @__PURE__ */ k(
      $Z,
      {
        scope: n,
        type: g,
        dir: D,
        scrollHideDelay: c,
        scrollArea: l,
        viewport: C,
        onViewportChange: b,
        content: m,
        onContentChange: p,
        scrollbarX: y,
        onScrollbarXChange: f,
        scrollbarXEnabled: H,
        onScrollbarXEnabledChange: E,
        scrollbarY: x,
        onScrollbarYChange: Y,
        scrollbarYEnabled: O,
        onScrollbarYEnabledChange: j,
        onCornerWidthChange: J,
        onCornerHeightChange: R,
        children: /* @__PURE__ */ k(
          at.div,
          {
            dir: D,
            ...A,
            ref: U,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": B + "px",
              "--radix-scroll-area-corner-height": N + "px",
              ...t.style
            }
          }
        )
      }
    );
  }
);
su.displayName = ps;
var ou = "ScrollAreaViewport", lu = v.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: n, children: g, asChild: i, nonce: c, ...A } = t, l = ie(ou, n), a = v.useRef(null), C = dt(e, a, l.onViewportChange);
    return /* @__PURE__ */ Pn(nI, { children: [
      /* @__PURE__ */ k(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: `
[data-radix-scroll-area-viewport] {
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}
[data-radix-scroll-area-viewport]::-webkit-scrollbar {
  display: none;
}
:where([data-radix-scroll-area-viewport]) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:where([data-radix-scroll-area-content]) {
  flex-grow: 1;
}
`
          },
          nonce: c
        }
      ),
      /* @__PURE__ */ k(
        at.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...A,
          asChild: i,
          ref: C,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: l.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: l.scrollbarYEnabled ? "scroll" : "hidden",
            ...t.style
          },
          children: o0({ asChild: i, children: g }, (b) => /* @__PURE__ */ k(
            "div",
            {
              "data-radix-scroll-area-content": "",
              ref: l.onContentChange,
              style: { minWidth: l.scrollbarXEnabled ? "fit-content" : void 0 },
              children: b
            }
          ))
        }
      )
    ] });
  }
);
lu.displayName = ou;
var Xe = "ScrollAreaScrollbar", ru = v.forwardRef(
  (t, e) => {
    const { forceMount: n, ...g } = t, i = ie(Xe, t.__scopeScrollArea), { onScrollbarXEnabledChange: c, onScrollbarYEnabledChange: A } = i, l = t.orientation === "horizontal";
    return v.useEffect(() => (l ? c(!0) : A(!0), () => {
      l ? c(!1) : A(!1);
    }), [l, c, A]), i.type === "hover" ? /* @__PURE__ */ k(t0, { ...g, ref: e, forceMount: n }) : i.type === "scroll" ? /* @__PURE__ */ k(e0, { ...g, ref: e, forceMount: n }) : i.type === "auto" ? /* @__PURE__ */ k(au, { ...g, ref: e, forceMount: n }) : i.type === "always" ? /* @__PURE__ */ k(Vs, { ...g, ref: e }) : null;
  }
);
ru.displayName = Xe;
var t0 = v.forwardRef((t, e) => {
  const { forceMount: n, ...g } = t, i = ie(Xe, t.__scopeScrollArea), [c, A] = v.useState(!1);
  return v.useEffect(() => {
    const l = i.scrollArea;
    let a = 0;
    if (l) {
      const C = () => {
        window.clearTimeout(a), A(!0);
      }, b = () => {
        a = window.setTimeout(() => A(!1), i.scrollHideDelay);
      };
      return l.addEventListener("pointerenter", C), l.addEventListener("pointerleave", b), () => {
        window.clearTimeout(a), l.removeEventListener("pointerenter", C), l.removeEventListener("pointerleave", b);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ k(je, { present: n || c, children: /* @__PURE__ */ k(
    au,
    {
      "data-state": c ? "visible" : "hidden",
      ...g,
      ref: e
    }
  ) });
}), e0 = v.forwardRef((t, e) => {
  const { forceMount: n, ...g } = t, i = ie(Xe, t.__scopeScrollArea), c = t.orientation === "horizontal", A = DI(() => a("SCROLL_END"), 100), [l, a] = _Z("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return v.useEffect(() => {
    if (l === "idle") {
      const C = window.setTimeout(() => a("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(C);
    }
  }, [l, i.scrollHideDelay, a]), v.useEffect(() => {
    const C = i.viewport, b = c ? "scrollLeft" : "scrollTop";
    if (C) {
      let m = C[b];
      const p = () => {
        const y = C[b];
        m !== y && (a("SCROLL"), A()), m = y;
      };
      return C.addEventListener("scroll", p), () => C.removeEventListener("scroll", p);
    }
  }, [i.viewport, c, a, A]), /* @__PURE__ */ k(je, { present: n || l !== "hidden", children: /* @__PURE__ */ k(
    Vs,
    {
      "data-state": l === "hidden" ? "hidden" : "visible",
      ...g,
      ref: e,
      onPointerEnter: Ct(t.onPointerEnter, () => a("POINTER_ENTER")),
      onPointerLeave: Ct(t.onPointerLeave, () => a("POINTER_LEAVE"))
    }
  ) });
}), au = v.forwardRef((t, e) => {
  const n = ie(Xe, t.__scopeScrollArea), { forceMount: g, ...i } = t, [c, A] = v.useState(!1), l = t.orientation === "horizontal", a = DI(() => {
    if (n.viewport) {
      const C = n.viewport.offsetWidth < n.viewport.scrollWidth, b = n.viewport.offsetHeight < n.viewport.scrollHeight;
      A(l ? C : b);
    }
  }, 10);
  return Ig(n.viewport, a), Ig(n.content, a), /* @__PURE__ */ k(je, { present: g || c, children: /* @__PURE__ */ k(
    Vs,
    {
      "data-state": c ? "visible" : "hidden",
      ...i,
      ref: e
    }
  ) });
}), Vs = v.forwardRef((t, e) => {
  const { orientation: n = "vertical", ...g } = t, i = ie(Xe, t.__scopeScrollArea), c = v.useRef(null), A = v.useRef(0), [l, a] = v.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), C = Gu(l.viewport, l.content), b = {
    ...g,
    sizes: l,
    onSizesChange: a,
    hasThumb: C > 0 && C < 1,
    onThumbChange: (p) => c.current = p,
    onThumbPointerUp: () => A.current = 0,
    onThumbPointerDown: (p) => A.current = p
  };
  function m(p, y) {
    return A0(p, A.current, l, y);
  }
  return n === "horizontal" ? /* @__PURE__ */ k(
    n0,
    {
      ...b,
      ref: e,
      onThumbPositionChange: () => {
        if (i.viewport && c.current) {
          const p = i.viewport.scrollLeft, y = Ll(p, l, i.dir);
          c.current.style.transform = `translate3d(${y}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        i.viewport && (i.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        i.viewport && (i.viewport.scrollLeft = m(p, i.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ k(
    g0,
    {
      ...b,
      ref: e,
      onThumbPositionChange: () => {
        if (i.viewport && c.current) {
          const p = i.viewport.scrollTop, y = Ll(p, l);
          c.current.style.transform = `translate3d(0, ${y}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        i.viewport && (i.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        i.viewport && (i.viewport.scrollTop = m(p));
      }
    }
  ) : null;
}), n0 = v.forwardRef((t, e) => {
  const { sizes: n, onSizesChange: g, ...i } = t, c = ie(Xe, t.__scopeScrollArea), [A, l] = v.useState(), a = v.useRef(null), C = dt(e, a, c.onScrollbarXChange);
  return v.useEffect(() => {
    a.current && l(getComputedStyle(a.current));
  }, [a]), /* @__PURE__ */ k(
    uu,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: C,
      sizes: n,
      style: {
        bottom: 0,
        left: c.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: c.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": qI(n) + "px",
        ...t.style
      },
      onThumbPointerDown: (b) => t.onThumbPointerDown(b.x),
      onDragScroll: (b) => t.onDragScroll(b.x),
      onWheelScroll: (b, m) => {
        if (c.viewport) {
          const p = c.viewport.scrollLeft + b.deltaX;
          t.onWheelScroll(p), hu(p, m) && b.preventDefault();
        }
      },
      onResize: () => {
        a.current && c.viewport && A && g({
          content: c.viewport.scrollWidth,
          viewport: c.viewport.offsetWidth,
          scrollbar: {
            size: a.current.clientWidth,
            paddingStart: hI(A.paddingLeft),
            paddingEnd: hI(A.paddingRight)
          }
        });
      }
    }
  );
}), g0 = v.forwardRef((t, e) => {
  const { sizes: n, onSizesChange: g, ...i } = t, c = ie(Xe, t.__scopeScrollArea), [A, l] = v.useState(), a = v.useRef(null), C = dt(e, a, c.onScrollbarYChange);
  return v.useEffect(() => {
    a.current && l(getComputedStyle(a.current));
  }, [a]), /* @__PURE__ */ k(
    uu,
    {
      "data-orientation": "vertical",
      ...i,
      ref: C,
      sizes: n,
      style: {
        top: 0,
        right: c.dir === "ltr" ? 0 : void 0,
        left: c.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": qI(n) + "px",
        ...t.style
      },
      onThumbPointerDown: (b) => t.onThumbPointerDown(b.y),
      onDragScroll: (b) => t.onDragScroll(b.y),
      onWheelScroll: (b, m) => {
        if (c.viewport) {
          const p = c.viewport.scrollTop + b.deltaY;
          t.onWheelScroll(p), hu(p, m) && b.preventDefault();
        }
      },
      onResize: () => {
        a.current && c.viewport && A && g({
          content: c.viewport.scrollHeight,
          viewport: c.viewport.offsetHeight,
          scrollbar: {
            size: a.current.clientHeight,
            paddingStart: hI(A.paddingTop),
            paddingEnd: hI(A.paddingBottom)
          }
        });
      }
    }
  );
}), [i0, Cu] = Au(Xe), uu = v.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    sizes: g,
    hasThumb: i,
    onThumbChange: c,
    onThumbPointerUp: A,
    onThumbPointerDown: l,
    onThumbPositionChange: a,
    onDragScroll: C,
    onWheelScroll: b,
    onResize: m,
    ...p
  } = t, y = ie(Xe, n), [f, x] = v.useState(null), Y = dt(e, (U) => x(U)), B = v.useRef(null), J = v.useRef(""), N = y.viewport, R = g.content - g.viewport, H = wt(b), E = wt(a), O = DI(m, 10);
  function j(U) {
    if (B.current) {
      const D = U.clientX - B.current.left, gt = U.clientY - B.current.top;
      C({ x: D, y: gt });
    }
  }
  return v.useEffect(() => {
    const U = (D) => {
      const gt = D.target;
      (f == null ? void 0 : f.contains(gt)) && H(D, R);
    };
    return document.addEventListener("wheel", U, { passive: !1 }), () => document.removeEventListener("wheel", U, { passive: !1 });
  }, [N, f, R, H]), v.useEffect(E, [g, E]), Ig(f, O), Ig(y.content, O), /* @__PURE__ */ k(
    i0,
    {
      scope: n,
      scrollbar: f,
      hasThumb: i,
      onThumbChange: wt(c),
      onThumbPointerUp: wt(A),
      onThumbPositionChange: E,
      onThumbPointerDown: wt(l),
      children: /* @__PURE__ */ k(
        at.div,
        {
          ...p,
          ref: Y,
          style: { position: "absolute", ...p.style },
          onPointerDown: Ct(t.onPointerDown, (U) => {
            U.button === 0 && (U.target.setPointerCapture(U.pointerId), B.current = f.getBoundingClientRect(), J.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", y.viewport && (y.viewport.style.scrollBehavior = "auto"), j(U));
          }),
          onPointerMove: Ct(t.onPointerMove, j),
          onPointerUp: Ct(t.onPointerUp, (U) => {
            const D = U.target;
            D.hasPointerCapture(U.pointerId) && D.releasePointerCapture(U.pointerId), document.body.style.webkitUserSelect = J.current, y.viewport && (y.viewport.style.scrollBehavior = ""), B.current = null;
          })
        }
      )
    }
  );
}), mI = "ScrollAreaThumb", bu = v.forwardRef(
  (t, e) => {
    const { forceMount: n, ...g } = t, i = Cu(mI, t.__scopeScrollArea);
    return /* @__PURE__ */ k(je, { present: n || i.hasThumb, children: /* @__PURE__ */ k(I0, { ref: e, ...g }) });
  }
), I0 = v.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: n, style: g, ...i } = t, c = ie(mI, n), A = Cu(mI, n), { onThumbPositionChange: l } = A, a = dt(
      e,
      (m) => A.onThumbChange(m)
    ), C = v.useRef(), b = DI(() => {
      C.current && (C.current(), C.current = void 0);
    }, 100);
    return v.useEffect(() => {
      const m = c.viewport;
      if (m) {
        const p = () => {
          if (b(), !C.current) {
            const y = s0(m, l);
            C.current = y, l();
          }
        };
        return l(), m.addEventListener("scroll", p), () => m.removeEventListener("scroll", p);
      }
    }, [c.viewport, b, l]), /* @__PURE__ */ k(
      at.div,
      {
        "data-state": A.hasThumb ? "visible" : "hidden",
        ...i,
        ref: a,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...g
        },
        onPointerDownCapture: Ct(t.onPointerDownCapture, (m) => {
          const y = m.target.getBoundingClientRect(), f = m.clientX - y.left, x = m.clientY - y.top;
          A.onThumbPointerDown({ x: f, y: x });
        }),
        onPointerUp: Ct(t.onPointerUp, A.onThumbPointerUp)
      }
    );
  }
);
bu.displayName = mI;
var Zs = "ScrollAreaCorner", du = v.forwardRef(
  (t, e) => {
    const n = ie(Zs, t.__scopeScrollArea), g = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && g ? /* @__PURE__ */ k(c0, { ...t, ref: e }) : null;
  }
);
du.displayName = Zs;
var c0 = v.forwardRef((t, e) => {
  const { __scopeScrollArea: n, ...g } = t, i = ie(Zs, n), [c, A] = v.useState(0), [l, a] = v.useState(0), C = !!(c && l);
  return Ig(i.scrollbarX, () => {
    var m;
    const b = ((m = i.scrollbarX) == null ? void 0 : m.offsetHeight) || 0;
    i.onCornerHeightChange(b), a(b);
  }), Ig(i.scrollbarY, () => {
    var m;
    const b = ((m = i.scrollbarY) == null ? void 0 : m.offsetWidth) || 0;
    i.onCornerWidthChange(b), A(b);
  }), C ? /* @__PURE__ */ k(
    at.div,
    {
      ...g,
      ref: e,
      style: {
        width: c,
        height: l,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...t.style
      }
    }
  ) : null;
});
function hI(t) {
  return t ? parseInt(t, 10) : 0;
}
function Gu(t, e) {
  const n = t / e;
  return isNaN(n) ? 0 : n;
}
function qI(t) {
  const e = Gu(t.viewport, t.content), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, g = (t.scrollbar.size - n) * e;
  return Math.max(g, 18);
}
function A0(t, e, n, g = "ltr") {
  const i = qI(n), c = i / 2, A = e || c, l = i - A, a = n.scrollbar.paddingStart + A, C = n.scrollbar.size - n.scrollbar.paddingEnd - l, b = n.content - n.viewport, m = g === "ltr" ? [0, b] : [b * -1, 0];
  return mu([a, C], m)(t);
}
function Ll(t, e, n = "ltr") {
  const g = qI(e), i = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, c = e.scrollbar.size - i, A = e.content - e.viewport, l = c - g, a = n === "ltr" ? [0, A] : [A * -1, 0], C = hs(t, a);
  return mu([0, A], [0, l])(C);
}
function mu(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const g = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + g * (n - t[0]);
  };
}
function hu(t, e) {
  return t > 0 && t < e;
}
var s0 = (t, e = () => {
}) => {
  let n = { left: t.scrollLeft, top: t.scrollTop }, g = 0;
  return function i() {
    const c = { left: t.scrollLeft, top: t.scrollTop }, A = n.left !== c.left, l = n.top !== c.top;
    (A || l) && e(), n = c, g = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(g);
};
function DI(t, e) {
  const n = wt(t), g = v.useRef(0);
  return v.useEffect(() => () => window.clearTimeout(g.current), []), v.useCallback(() => {
    window.clearTimeout(g.current), g.current = window.setTimeout(n, e);
  }, [n, e]);
}
function Ig(t, e) {
  const n = wt(e);
  tg(() => {
    let g = 0;
    if (t) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(g), g = window.requestAnimationFrame(n);
      });
      return i.observe(t), () => {
        window.cancelAnimationFrame(g), i.unobserve(t);
      };
    }
  }, [t, n]);
}
function o0(t, e) {
  const { asChild: n, children: g } = t;
  if (!n) return typeof e == "function" ? e(g) : e;
  const i = v.Children.only(g);
  return v.cloneElement(i, {
    children: typeof e == "function" ? e(i.props.children) : e
  });
}
var l0 = su, r0 = lu, kl = ru, El = bu, a0 = du;
function C0() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const u0 = ["auto", "always"], Z2 = (t) => {
  const {
    type: e = "auto",
    hideScrollBackground: n = !1,
    children: g,
    ...i
  } = t, c = oe(() => u0.includes(e), [e]);
  return /* @__PURE__ */ Vt(l0, { type: e, css: b0(c), ...i, children: [
    /* @__PURE__ */ w(r0, { css: d0, children: g }),
    /* @__PURE__ */ w(kl, { css: jl(n), orientation: "vertical", children: /* @__PURE__ */ w(El, { css: Ml }) }),
    /* @__PURE__ */ w(kl, { css: jl(n), orientation: "horizontal", children: /* @__PURE__ */ w(El, { css: Ml }) }),
    /* @__PURE__ */ w(a0, { css: G0 })
  ] });
}, kc = 15, b0 = (t) => /* @__PURE__ */ Gt({
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  borderRadius: "inherit",
  "--scrollbar-size": `${kc}px`
}, t && {
  ":has(div[data-orientation='vertical'][data-state='visible'])": {
    paddingRight: kc
  },
  ":has(div[data-orientation='horizontal'][data-state='visible'])": {
    paddingBottom: kc
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:ScrollAreaRoot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), d0 = process.env.NODE_ENV === "production" ? {
  name: "1nxlove",
  styles: "width:100%;height:100%;border-radius:inherit"
} : {
  name: "1q8tg0p-ScrollAreaViewport",
  styles: "width:100%;height:100%;border-radius:inherit;label:ScrollAreaViewport;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: C0
}, jl = (t) => /* @__PURE__ */ Gt({
  display: "flex",
  userSelect: "none",
  touchAction: "none",
  padding: 2,
  background: t ? "none" : K.transparent,
  transition: "background 160ms ease-out",
  "&:hover": {
    background: t ? "none" : K.lessTransparent
  },
  "&[data-orientation='vertical']": {
    width: "var(--scrollbar-size)"
  },
  "&[data-orientation='horizontal']": {
    flexDirection: "column",
    height: "var(--scrollbar-size)"
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:ScrollAreaScrollbar;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Ml = /* @__PURE__ */ Gt({
  flex: 1,
  background: K.transparent,
  // borderRadius: 'var(--scrollbar-size)',
  borderRadius: 4,
  position: "relative",
  "&:before": {
    content: "''",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    minWidth: 44,
    minHeight: 44
  }
}, process.env.NODE_ENV === "production" ? "" : ";label:ScrollAreaThumb;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1Njcm9sbEFyZWEudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdGd0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvdWkvdWkvc3JjL2NvbW1vbi9jb21wb25lbnRzL2Jhc2UvU2Nyb2xsQXJlYS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgKiBhcyBTY3JvbGxBcmVhUHJpbWl0aXZlIGZyb20gJ0ByYWRpeC11aS9yZWFjdC1zY3JvbGwtYXJlYSc7XG5pbXBvcnQgeyBDb21wb25lbnRQcm9wcywgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ0AvY29tbW9uL3N0eWxlcy90aGVtZSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU2Nyb2xsQXJlYVByb3BzIGV4dGVuZHMgQ29tcG9uZW50UHJvcHM8dHlwZW9mIFNjcm9sbEFyZWFQcmltaXRpdmUuUm9vdD4ge1xuICBoaWRlU2Nyb2xsQmFja2dyb3VuZD86IGJvb2xlYW47XG59XG5cbmNvbnN0IHBhZFNjcm9sbGJhclR5cGVzOiBTY3JvbGxBcmVhUHJvcHNbJ3R5cGUnXVtdID0gWydhdXRvJywgJ2Fsd2F5cyddO1xuXG5leHBvcnQgY29uc3QgU2Nyb2xsQXJlYSA9IChwcm9wczogU2Nyb2xsQXJlYVByb3BzKSA9PiB7XG4gIGNvbnN0IHsgdHlwZSA9ICdhdXRvJywgaGlkZVNjcm9sbEJhY2tncm91bmQgPSBmYWxzZSwgY2hpbGRyZW4sIC4uLnJlc3QgfSA9IHByb3BzO1xuXG4gIGNvbnN0IHNob3VsZFBhZFNjcm9sbGJhciA9IHVzZU1lbW8oKCkgPT4gcGFkU2Nyb2xsYmFyVHlwZXMuaW5jbHVkZXModHlwZSksIFt0eXBlXSk7XG5cbiAgcmV0dXJuIChcbiAgICA8U2Nyb2xsQXJlYVByaW1pdGl2ZS5Sb290XG4gICAgICB0eXBlPXt0eXBlfVxuICAgICAgY3NzPXtTY3JvbGxBcmVhUm9vdChzaG91bGRQYWRTY3JvbGxiYXIpfVxuICAgICAgey4uLnJlc3R9XG4gICAgPlxuICAgICAgPFNjcm9sbEFyZWFQcmltaXRpdmUuVmlld3BvcnQgY3NzPXtTY3JvbGxBcmVhVmlld3BvcnR9PlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L1Njcm9sbEFyZWFQcmltaXRpdmUuVmlld3BvcnQ+XG4gICAgICA8U2Nyb2xsQXJlYVByaW1pdGl2ZS5TY3JvbGxiYXJcbiAgICAgICAgY3NzPXtTY3JvbGxBcmVhU2Nyb2xsYmFyKGhpZGVTY3JvbGxCYWNrZ3JvdW5kKX1cbiAgICAgICAgb3JpZW50YXRpb249XCJ2ZXJ0aWNhbFwiXG4gICAgICA+XG4gICAgICAgIDxTY3JvbGxBcmVhUHJpbWl0aXZlLlRodW1iIGNzcz17U2Nyb2xsQXJlYVRodW1ifSAvPlxuICAgICAgPC9TY3JvbGxBcmVhUHJpbWl0aXZlLlNjcm9sbGJhcj5cbiAgICAgIDxTY3JvbGxBcmVhUHJpbWl0aXZlLlNjcm9sbGJhclxuICAgICAgICBjc3M9e1Njcm9sbEFyZWFTY3JvbGxiYXIoaGlkZVNjcm9sbEJhY2tncm91bmQpfVxuICAgICAgICBvcmllbnRhdGlvbj1cImhvcml6b250YWxcIlxuICAgICAgPlxuICAgICAgICA8U2Nyb2xsQXJlYVByaW1pdGl2ZS5UaHVtYiBjc3M9e1Njcm9sbEFyZWFUaHVtYn0gLz5cbiAgICAgIDwvU2Nyb2xsQXJlYVByaW1pdGl2ZS5TY3JvbGxiYXI+XG4gICAgICA8U2Nyb2xsQXJlYVByaW1pdGl2ZS5Db3JuZXIgY3NzPXtTY3JvbGxBcmVhQ29ybmVyfSAvPlxuICAgIDwvU2Nyb2xsQXJlYVByaW1pdGl2ZS5Sb290PlxuICApO1xufTtcblxuY29uc3Qgc2Nyb2xsYmFyU2l6ZSA9IDE1O1xuXG5jb25zdCBTY3JvbGxBcmVhUm9vdCA9IChwYWQ6IGJvb2xlYW4pID0+XG4gIGNzcyhcbiAgICB7XG4gICAgICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcbiAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICBoZWlnaHQ6ICcxMDAlJyxcbiAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgIGJvcmRlclJhZGl1czogJ2luaGVyaXQnLFxuICAgICAgJy0tc2Nyb2xsYmFyLXNpemUnOiBgJHtzY3JvbGxiYXJTaXplfXB4YCxcbiAgICB9LFxuICAgIHBhZCAmJiB7XG4gICAgICBcIjpoYXMoZGl2W2RhdGEtb3JpZW50YXRpb249J3ZlcnRpY2FsJ11bZGF0YS1zdGF0ZT0ndmlzaWJsZSddKVwiOiB7XG4gICAgICAgIHBhZGRpbmdSaWdodDogc2Nyb2xsYmFyU2l6ZSxcbiAgICAgIH0sXG4gICAgICBcIjpoYXMoZGl2W2RhdGEtb3JpZW50YXRpb249J2hvcml6b250YWwnXVtkYXRhLXN0YXRlPSd2aXNpYmxlJ10pXCI6IHtcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogc2Nyb2xsYmFyU2l6ZSxcbiAgICAgIH0sXG4gICAgfSxcbiAgKTtcblxuY29uc3QgU2Nyb2xsQXJlYVZpZXdwb3J0ID0gY3NzKHtcbiAgd2lkdGg6ICcxMDAlJyxcbiAgaGVpZ2h0OiAnMTAwJScsXG4gIGJvcmRlclJhZGl1czogJ2luaGVyaXQnLFxufSk7XG5cbmNvbnN0IFNjcm9sbEFyZWFTY3JvbGxiYXIgPSAoaGlkZVNjcm9sbEJhY2tncm91bmQ6IGJvb2xlYW4pID0+XG4gIGNzcyh7XG4gICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgIHVzZXJTZWxlY3Q6ICdub25lJyxcbiAgICB0b3VjaEFjdGlvbjogJ25vbmUnLFxuICAgIHBhZGRpbmc6IDIsXG4gICAgYmFja2dyb3VuZDogaGlkZVNjcm9sbEJhY2tncm91bmQgPyAnbm9uZScgOiBjb2xvcnMudHJhbnNwYXJlbnQsXG4gICAgdHJhbnNpdGlvbjogJ2JhY2tncm91bmQgMTYwbXMgZWFzZS1vdXQnLFxuICAgICcmOmhvdmVyJzogeyBiYWNrZ3JvdW5kOiBoaWRlU2Nyb2xsQmFja2dyb3VuZCA/ICdub25lJyA6IGNvbG9ycy5sZXNzVHJhbnNwYXJlbnQgfSxcbiAgICBcIiZbZGF0YS1vcmllbnRhdGlvbj0ndmVydGljYWwnXVwiOiB7XG4gICAgICB3aWR0aDogJ3ZhcigtLXNjcm9sbGJhci1zaXplKScsXG4gICAgfSxcbiAgICBcIiZbZGF0YS1vcmllbnRhdGlvbj0naG9yaXpvbnRhbCddXCI6IHtcbiAgICAgIGZsZXhEaXJlY3Rpb246ICdjb2x1bW4nLFxuICAgICAgaGVpZ2h0OiAndmFyKC0tc2Nyb2xsYmFyLXNpemUpJyxcbiAgICB9LFxuICB9KTtcblxuY29uc3QgU2Nyb2xsQXJlYVRodW1iID0gY3NzKHtcbiAgZmxleDogMSxcbiAgYmFja2dyb3VuZDogY29sb3JzLnRyYW5zcGFyZW50LFxuICAvLyBib3JkZXJSYWRpdXM6ICd2YXIoLS1zY3JvbGxiYXItc2l6ZSknLFxuICBib3JkZXJSYWRpdXM6IDQsXG4gIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAnJjpiZWZvcmUnOiB7XG4gICAgY29udGVudDogXCInJ1wiLFxuICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgIHRvcDogJzUwJScsXG4gICAgbGVmdDogJzUwJScsXG4gICAgdHJhbnNmb3JtOiAndHJhbnNsYXRlKC01MCUsIC01MCUpJyxcbiAgICB3aWR0aDogJzEwMCUnLFxuICAgIGhlaWdodDogJzEwMCUnLFxuICAgIG1pbldpZHRoOiA0NCxcbiAgICBtaW5IZWlnaHQ6IDQ0LFxuICB9LFxufSk7XG5cbmNvbnN0IFNjcm9sbEFyZWFDb3JuZXIgPSBjc3MoeyBiYWNrZ3JvdW5kOiBjb2xvcnMubGVzc1RyYW5zcGFyZW50IH0pO1xuIl19 */"), G0 = /* @__PURE__ */ Gt({
  background: K.lessTransparent
}, process.env.NODE_ENV === "production" ? "" : ";label:ScrollAreaCorner;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function m0(t, e = []) {
  let n = [];
  function g(c, A) {
    const l = v.createContext(A), a = n.length;
    n = [...n, A];
    function C(m) {
      const { scope: p, children: y, ...f } = m, x = (p == null ? void 0 : p[t][a]) || l, Y = v.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ k(x.Provider, { value: Y, children: y });
    }
    function b(m, p) {
      const y = (p == null ? void 0 : p[t][a]) || l, f = v.useContext(y);
      if (f) return f;
      if (A !== void 0) return A;
      throw new Error(`\`${m}\` must be used within \`${c}\``);
    }
    return C.displayName = c + "Provider", [C, b];
  }
  const i = () => {
    const c = n.map((A) => v.createContext(A));
    return function(l) {
      const a = (l == null ? void 0 : l[t]) || c;
      return v.useMemo(
        () => ({ [`__scope${t}`]: { ...l, [t]: a } }),
        [l, a]
      );
    };
  };
  return i.scopeName = t, [g, h0(i, ...e)];
}
function h0(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const g = t.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(c) {
      const A = g.reduce((l, { useScope: a, scopeName: C }) => {
        const m = a(c)[`__scope${C}`];
        return { ...l, ...m };
      }, {});
      return v.useMemo(() => ({ [`__scope${e.scopeName}`]: A }), [A]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function p0(t) {
  const e = t + "CollectionProvider", [n, g] = m0(e), [i, c] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), A = (y) => {
    const { scope: f, children: x } = y, Y = pt.useRef(null), B = pt.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ k(i, { scope: f, itemMap: B, collectionRef: Y, children: x });
  };
  A.displayName = e;
  const l = t + "CollectionSlot", a = pt.forwardRef(
    (y, f) => {
      const { scope: x, children: Y } = y, B = c(l, x), J = dt(f, B.collectionRef);
      return /* @__PURE__ */ k(Lg, { ref: J, children: Y });
    }
  );
  a.displayName = l;
  const C = t + "CollectionItemSlot", b = "data-radix-collection-item", m = pt.forwardRef(
    (y, f) => {
      const { scope: x, children: Y, ...B } = y, J = pt.useRef(null), N = dt(f, J), R = c(C, x);
      return pt.useEffect(() => (R.itemMap.set(J, { ref: J, ...B }), () => void R.itemMap.delete(J))), /* @__PURE__ */ k(Lg, { [b]: "", ref: N, children: Y });
    }
  );
  m.displayName = C;
  function p(y) {
    const f = c(t + "CollectionConsumer", y);
    return pt.useCallback(() => {
      const Y = f.collectionRef.current;
      if (!Y) return [];
      const B = Array.from(Y.querySelectorAll(`[${b}]`));
      return Array.from(f.itemMap.values()).sort(
        (R, H) => B.indexOf(R.ref.current) - B.indexOf(H.ref.current)
      );
    }, [f.collectionRef, f.itemMap]);
  }
  return [
    { Provider: A, Slot: a, ItemSlot: m },
    p,
    g
  ];
}
const pu = ["PageUp", "PageDown"], Vu = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Zu = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, ug = "Slider", [WA, V0, Z0] = p0(ug), [yu, y2] = ii(ug, [Z0]), [y0, LI] = yu(ug), vu = v.forwardRef((t, e) => {
  const {
    name: n,
    min: g = 0,
    max: i = 100,
    step: c = 1,
    orientation: A = "horizontal",
    disabled: l = !1,
    minStepsBetweenThumbs: a = 0,
    defaultValue: C = [g],
    value: b,
    onValueChange: m = () => {
    },
    onValueCommit: p = () => {
    },
    inverted: y = !1,
    ...f
  } = t, x = v.useRef(/* @__PURE__ */ new Set()), Y = v.useRef(0), J = A === "horizontal" ? v0 : X0, [N = [], R] = fI({
    prop: b,
    defaultProp: C,
    onChange: (D) => {
      var xt;
      (xt = [...x.current][Y.current]) == null || xt.focus(), m(D);
    }
  }), H = v.useRef(N);
  function E(D) {
    const gt = Y0(N, D);
    U(D, gt);
  }
  function O(D) {
    U(D, Y.current);
  }
  function j() {
    const D = H.current[Y.current];
    N[Y.current] !== D && p(N);
  }
  function U(D, gt, {
    commit: xt
  } = {
    commit: !1
  }) {
    const rn = R0(c), xe = S0(Math.round((D - g) / c) * c + g, rn), We = hs(xe, [g, i]);
    R((Mt = []) => {
      const At = f0(Mt, We, gt);
      if (J0(At, a * c)) {
        Y.current = At.indexOf(We);
        const Wt = String(At) !== String(Mt);
        return Wt && xt && p(At), Wt ? At : Mt;
      } else
        return Mt;
    });
  }
  return /* @__PURE__ */ w(y0, { scope: t.__scopeSlider, name: n, disabled: l, min: g, max: i, valueIndexToChangeRef: Y, thumbs: x.current, values: N, orientation: A, children: /* @__PURE__ */ w(WA.Provider, { scope: t.__scopeSlider, children: /* @__PURE__ */ w(WA.Slot, { scope: t.__scopeSlider, children: /* @__PURE__ */ w(J, { "aria-disabled": l, "data-disabled": l ? "" : void 0, ...f, ref: e, onPointerDown: Ct(f.onPointerDown, () => {
    l || (H.current = N);
  }), min: g, max: i, inverted: y, onSlideStart: l ? void 0 : E, onSlideMove: l ? void 0 : O, onSlideEnd: l ? void 0 : j, onHomeKeyDown: () => !l && U(g, 0, {
    commit: !0
  }), onEndKeyDown: () => !l && U(i, N.length - 1, {
    commit: !0
  }), onStepKeyDown: ({
    event: D,
    direction: gt
  }) => {
    if (!l) {
      const xe = pu.includes(D.key) || D.shiftKey && Vu.includes(D.key) ? 10 : 1, We = Y.current, Mt = N[We], At = c * xe * gt;
      U(Mt + At, We, {
        commit: !0
      });
    }
  } }) }) }) });
});
vu.displayName = ug;
const [Xu, xu] = yu(ug, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), v0 = v.forwardRef((t, e) => {
  const {
    min: n,
    max: g,
    dir: i,
    inverted: c,
    onSlideStart: A,
    onSlideMove: l,
    onSlideEnd: a,
    onStepKeyDown: C,
    ...b
  } = t, [m, p] = v.useState(null), y = dt(e, (N) => p(N)), f = v.useRef(), x = cu(i), Y = x === "ltr", B = Y && !c || !Y && c;
  function J(N) {
    const R = f.current || m.getBoundingClientRect(), H = [0, R.width], O = ys(H, B ? [n, g] : [g, n]);
    return f.current = R, O(N - R.left);
  }
  return /* @__PURE__ */ w(Xu, { scope: t.__scopeSlider, startEdge: B ? "left" : "right", endEdge: B ? "right" : "left", direction: B ? 1 : -1, size: "width", children: /* @__PURE__ */ w(Wu, { dir: x, "data-orientation": "horizontal", ...b, ref: y, style: {
    ...b.style,
    "--radix-slider-thumb-transform": "translateX(-50%)"
  }, onSlideStart: (N) => {
    const R = J(N.clientX);
    A == null || A(R);
  }, onSlideMove: (N) => {
    const R = J(N.clientX);
    l == null || l(R);
  }, onSlideEnd: () => {
    f.current = void 0, a == null || a();
  }, onStepKeyDown: (N) => {
    const H = Zu[B ? "from-left" : "from-right"].includes(N.key);
    C == null || C({
      event: N,
      direction: H ? -1 : 1
    });
  } }) });
}), X0 = v.forwardRef((t, e) => {
  const {
    min: n,
    max: g,
    inverted: i,
    onSlideStart: c,
    onSlideMove: A,
    onSlideEnd: l,
    onStepKeyDown: a,
    ...C
  } = t, b = v.useRef(null), m = dt(e, b), p = v.useRef(), y = !i;
  function f(x) {
    const Y = p.current || b.current.getBoundingClientRect(), B = [0, Y.height], N = ys(B, y ? [g, n] : [n, g]);
    return p.current = Y, N(x - Y.top);
  }
  return /* @__PURE__ */ w(Xu, { scope: t.__scopeSlider, startEdge: y ? "bottom" : "top", endEdge: y ? "top" : "bottom", size: "height", direction: y ? 1 : -1, children: /* @__PURE__ */ w(Wu, { "data-orientation": "vertical", ...C, ref: m, style: {
    ...C.style,
    "--radix-slider-thumb-transform": "translateY(50%)"
  }, onSlideStart: (x) => {
    const Y = f(x.clientY);
    c == null || c(Y);
  }, onSlideMove: (x) => {
    const Y = f(x.clientY);
    A == null || A(Y);
  }, onSlideEnd: () => {
    p.current = void 0, l == null || l();
  }, onStepKeyDown: (x) => {
    const B = Zu[y ? "from-bottom" : "from-top"].includes(x.key);
    a == null || a({
      event: x,
      direction: B ? -1 : 1
    });
  } }) });
}), Wu = v.forwardRef((t, e) => {
  const {
    __scopeSlider: n,
    onSlideStart: g,
    onSlideMove: i,
    onSlideEnd: c,
    onHomeKeyDown: A,
    onEndKeyDown: l,
    onStepKeyDown: a,
    ...C
  } = t, b = LI(ug, n);
  return /* @__PURE__ */ w(at.span, { ...C, ref: e, onKeyDown: Ct(t.onKeyDown, (m) => {
    m.key === "Home" ? (A(m), m.preventDefault()) : m.key === "End" ? (l(m), m.preventDefault()) : pu.concat(Vu).includes(m.key) && (a(m), m.preventDefault());
  }), onPointerDown: Ct(t.onPointerDown, (m) => {
    const p = m.target;
    p.setPointerCapture(m.pointerId), m.preventDefault(), b.thumbs.has(p) ? p.focus() : g(m);
  }), onPointerMove: Ct(t.onPointerMove, (m) => {
    m.target.hasPointerCapture(m.pointerId) && i(m);
  }), onPointerUp: Ct(t.onPointerUp, (m) => {
    const p = m.target;
    p.hasPointerCapture(m.pointerId) && (p.releasePointerCapture(m.pointerId), c(m));
  }) });
}), fu = "SliderTrack", Bu = v.forwardRef((t, e) => {
  const {
    __scopeSlider: n,
    ...g
  } = t, i = LI(fu, n);
  return /* @__PURE__ */ w(at.span, { "data-disabled": i.disabled ? "" : void 0, "data-orientation": i.orientation, ...g, ref: e });
});
Bu.displayName = fu;
const fA = "SliderRange", Yu = v.forwardRef((t, e) => {
  const {
    __scopeSlider: n,
    ...g
  } = t, i = LI(fA, n), c = xu(fA, n), A = v.useRef(null), l = dt(e, A), a = i.values.length, C = i.values.map((Y) => Ju(Y, i.min, i.max)), b = a > 1 ? Math.min(...C) : 0, m = 100 - Math.max(...C), p = i.thumbs.values().next().value, y = BI(p), f = y == null ? void 0 : y[c.size], x = f ? Ru(f, Math.max(...C), c.direction) : 0;
  return /* @__PURE__ */ w(at.span, { "data-orientation": i.orientation, "data-disabled": i.disabled ? "" : void 0, ...g, ref: l, style: {
    ...t.style,
    [c.startEdge]: `calc(${b}%)`,
    // NOTE: Added this change from Radix's implementation to fix the range not matching location of the thumb
    [c.endEdge]: `calc(${m}% - ${x}px)`
  } });
});
Yu.displayName = fA;
const BA = "SliderThumb", Nu = v.forwardRef((t, e) => {
  const n = V0(t.__scopeSlider), [g, i] = v.useState(null), c = dt(e, (l) => i(l)), A = v.useMemo(() => g ? n().findIndex((l) => l.ref.current === g) : -1, [n, g]);
  return /* @__PURE__ */ w(x0, { ...t, ref: c, index: A });
}), x0 = v.forwardRef((t, e) => {
  const {
    __scopeSlider: n,
    index: g,
    name: i,
    ...c
  } = t, A = LI(BA, n), l = xu(BA, n), [a, C] = v.useState(null), b = dt(e, (J) => C(J)), m = a ? !!a.closest("form") : !0, p = BI(a), y = A.values[g], f = y === void 0 ? 0 : Ju(y, A.min, A.max), x = B0(g, A.values.length), Y = p == null ? void 0 : p[l.size], B = Y ? Ru(Y, f, l.direction) : 0;
  return v.useEffect(() => {
    if (a)
      return A.thumbs.add(a), () => {
        A.thumbs.delete(a);
      };
  }, [a, A.thumbs]), /* @__PURE__ */ Vt("span", { style: {
    transform: "var(--radix-slider-thumb-transform)",
    position: "absolute",
    [l.startEdge]: `calc(${f}% + ${B}px)`
  }, children: [
    /* @__PURE__ */ w(WA.ItemSlot, { scope: t.__scopeSlider, children: /* @__PURE__ */ w(
      at.span,
      {
        role: "slider",
        "aria-label": t["aria-label"] || x,
        "aria-valuemin": A.min,
        "aria-valuenow": y,
        "aria-valuemax": A.max,
        "aria-orientation": A.orientation,
        "data-orientation": A.orientation,
        "data-disabled": A.disabled ? "" : void 0,
        tabIndex: A.disabled ? void 0 : 0,
        ...c,
        ref: b,
        style: y === void 0 ? {
          display: "none"
        } : t.style,
        onFocus: Ct(t.onFocus, () => {
          A.valueIndexToChangeRef.current = g;
        })
      }
    ) }),
    m && /* @__PURE__ */ w(W0, { name: i ?? (A.name ? A.name + (A.values.length > 1 ? "[]" : "") : void 0), value: y }, g)
  ] });
});
Nu.displayName = BA;
const W0 = (t) => {
  const {
    value: e,
    ...n
  } = t, g = v.useRef(null), i = PA(e);
  return v.useEffect(() => {
    const c = g.current, A = window.HTMLInputElement.prototype, a = Object.getOwnPropertyDescriptor(A, "value").set;
    if (i !== e && a) {
      const C = new Event("input", {
        bubbles: !0
      });
      a.call(c, e), c.dispatchEvent(C);
    }
  }, [i, e]), /* @__PURE__ */ w("input", { style: {
    display: "none"
  }, ...n, ref: g, defaultValue: e });
};
function f0(t = [], e, n) {
  const g = [...t];
  return g[n] = e, g.sort((i, c) => i - c);
}
function Ju(t, e, n) {
  const c = 100 / (n - e) * (t - e);
  return hs(c, [0, 100]);
}
function B0(t, e) {
  return e > 2 ? `Value ${t + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][t] : void 0;
}
function Y0(t, e) {
  if (t.length === 1) return 0;
  const n = t.map((i) => Math.abs(i - e)), g = Math.min(...n);
  return n.indexOf(g);
}
function Ru(t, e, n) {
  const g = t / 2, c = ys([0, 50], [0, g]);
  return (g - c(e) * n) * n;
}
function N0(t) {
  return t.slice(0, -1).map((e, n) => t[n + 1] - e);
}
function J0(t, e) {
  if (e > 0) {
    const n = N0(t);
    return Math.min(...n) >= e;
  }
  return !0;
}
function ys(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const g = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + g * (n - t[0]);
  };
}
function R0(t) {
  return (String(t).split(".")[1] || "").length;
}
function S0(t, e) {
  const n = Math.pow(10, e);
  return Math.round(t * n) / n;
}
const F0 = vu, H0 = Bu, w0 = Yu, z0 = Nu;
function q0() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const v2 = (t) => {
  const {
    bordered: e = !1,
    value: n,
    ...g
  } = t, i = n !== void 0, c = {
    bordered: e
  }, A = oe(() => i ? [n] : void 0, [i, n]);
  return /* @__PURE__ */ Vt(F0, { value: A, css: E0(), ...g, children: [
    /* @__PURE__ */ w(H0, { css: j0(c), children: /* @__PURE__ */ w(w0, { css: M0() }) }),
    /* @__PURE__ */ w(z0, { css: U0(c) })
  ] });
}, D0 = K.componentSolid, L0 = "#C7C7C7";
var k0 = process.env.NODE_ENV === "production" ? {
  name: "1cir6af",
  styles: "position:relative;display:flex;align-items:center;user-select:none;touch-action:none;width:200px;height:18px"
} : {
  name: "mv7zsg-RootStyle",
  styles: "position:relative;display:flex;align-items:center;user-select:none;touch-action:none;width:200px;height:18px;label:RootStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: q0
};
const E0 = (t) => k0, j0 = (t) => /* @__PURE__ */ Gt([{
  backgroundColor: L0,
  position: "relative",
  flexGrow: 1,
  borderRadius: 9999,
  height: 18,
  overflow: "hidden"
}, t.bordered && {
  border: "2px solid black"
}], process.env.NODE_ENV === "production" ? "" : ";label:TrackStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), M0 = (t) => /* @__PURE__ */ Gt({
  position: "absolute",
  backgroundColor: D0,
  height: "100%"
}, process.env.NODE_ENV === "production" ? "" : ";label:RangeStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), Ec = 38, U0 = (t) => /* @__PURE__ */ Gt([{
  display: "block",
  width: Ec,
  height: Ec,
  backgroundColor: $g[UA.Danger].backgroundColor,
  borderRadius: Ec,
  "&:hover": {
    filter: "brightness(1.1)"
  },
  "&:focus": {
    outline: "1px white"
  }
}, t.bordered && {
  border: "2px solid black"
}], process.env.NODE_ENV === "production" ? "" : ";label:ThumbStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function T0(t) {
  const {
    children: e,
    className: n,
    strokeColor: g = K.transparent,
    strokeWidth: i = Kn.sm,
    color: c = K.text
  } = t;
  return /* @__PURE__ */ w("span", { className: n, css: /* @__PURE__ */ Gt({
    color: c,
    WebkitTextStrokeColor: g,
    WebkitTextStrokeWidth: i,
    paintOrder: "stroke fill"
  }, process.env.NODE_ENV === "production" ? "" : ";label:StrokeText;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL1N0cm9rZVRleHQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCTSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay91aS91aS9zcmMvY29tbW9uL2NvbXBvbmVudHMvYmFzZS9TdHJva2VUZXh0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNvbG9ycywgc3RhbmRhcmRTaXplcyB9IGZyb20gJ0AvY29tbW9uL3N0eWxlcy90aGVtZSc7XG5pbXBvcnQgeyBQcm9wZXJ0eSB9IGZyb20gJ2Nzc3R5cGUnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFN0cm9rZVRleHRQcm9wcyB7XG4gIGNoaWxkcmVuPzogc3RyaW5nO1xuICBjbGFzc05hbWU/OiBzdHJpbmc7XG4gIHN0cm9rZUNvbG9yPzpcbiAgICB8IHN0cmluZ1tdXG4gICAgfCBQcm9wZXJ0eS5XZWJraXRUZXh0U3Ryb2tlQ29sb3JcbiAgICB8IHJlYWRvbmx5IFByb3BlcnR5LldlYmtpdFRleHRTdHJva2VDb2xvcltdXG4gICAgfCB1bmRlZmluZWQ7XG4gIHN0cm9rZVdpZHRoPzpcbiAgICB8IFByb3BlcnR5LldlYmtpdFRleHRTdHJva2VXaWR0aDxzdHJpbmcgfCBudW1iZXI+XG4gICAgfCBOb25OdWxsYWJsZTxQcm9wZXJ0eS5XZWJraXRUZXh0U3Ryb2tlV2lkdGg8c3RyaW5nIHwgbnVtYmVyPiB8IHVuZGVmaW5lZD5bXVxuICAgIHwgcmVhZG9ubHkgc3RyaW5nW11cbiAgICB8IHVuZGVmaW5lZDtcbiAgY29sb3I/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBTdHJva2VUZXh0KHByb3BzOiBTdHJva2VUZXh0UHJvcHMpIHtcbiAgY29uc3Qge1xuICAgIGNoaWxkcmVuOiB0ZXh0LFxuICAgIGNsYXNzTmFtZSxcbiAgICBzdHJva2VDb2xvciA9IGNvbG9ycy50cmFuc3BhcmVudCxcbiAgICBzdHJva2VXaWR0aCA9IHN0YW5kYXJkU2l6ZXMuc20sXG4gICAgY29sb3IgPSBjb2xvcnMudGV4dCxcbiAgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxzcGFuXG4gICAgICBjbGFzc05hbWU9e2NsYXNzTmFtZX1cbiAgICAgIGNzcz17e1xuICAgICAgICBjb2xvcixcbiAgICAgICAgV2Via2l0VGV4dFN0cm9rZUNvbG9yOiBzdHJva2VDb2xvcixcbiAgICAgICAgV2Via2l0VGV4dFN0cm9rZVdpZHRoOiBzdHJva2VXaWR0aCxcbiAgICAgICAgcGFpbnRPcmRlcjogYHN0cm9rZSBmaWxsYCxcbiAgICAgIH19XG4gICAgPlxuICAgICAge3RleHR9XG4gICAgPC9zcGFuPlxuICApO1xufVxuIl19 */"), children: e });
}
var vs = "Switch", [Q0, X2] = ii(vs), [O0, P0] = Q0(vs), Su = v.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: g,
      checked: i,
      defaultChecked: c,
      required: A,
      disabled: l,
      value: a = "on",
      onCheckedChange: C,
      form: b,
      ...m
    } = t, [p, y] = v.useState(null), f = dt(e, (N) => y(N)), x = v.useRef(!1), Y = p ? b || !!p.closest("form") : !0, [B = !1, J] = fI({
      prop: i,
      defaultProp: c,
      onChange: C
    });
    return /* @__PURE__ */ Pn(O0, { scope: n, checked: B, disabled: l, children: [
      /* @__PURE__ */ k(
        at.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": B,
          "aria-required": A,
          "data-state": wu(B),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: a,
          ...m,
          ref: f,
          onClick: Ct(t.onClick, (N) => {
            J((R) => !R), Y && (x.current = N.isPropagationStopped(), x.current || N.stopPropagation());
          })
        }
      ),
      Y && /* @__PURE__ */ k(
        K0,
        {
          control: p,
          bubbles: !x.current,
          name: g,
          value: a,
          checked: B,
          required: A,
          disabled: l,
          form: b,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Su.displayName = vs;
var Fu = "SwitchThumb", Hu = v.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...g } = t, i = P0(Fu, n);
    return /* @__PURE__ */ k(
      at.span,
      {
        "data-state": wu(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...g,
        ref: e
      }
    );
  }
);
Hu.displayName = Fu;
var K0 = (t) => {
  const { control: e, checked: n, bubbles: g = !0, ...i } = t, c = v.useRef(null), A = PA(n), l = BI(e);
  return v.useEffect(() => {
    const a = c.current, C = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(C, "checked").set;
    if (A !== n && m) {
      const p = new Event("click", { bubbles: g });
      m.call(a, n), a.dispatchEvent(p);
    }
  }, [A, n, g]), /* @__PURE__ */ k(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: c,
      style: {
        ...t.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function wu(t) {
  return t ? "checked" : "unchecked";
}
var _0 = Su, $0 = Hu;
const ty = "data:audio/mpeg;base64,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", x2 = (t) => {
  const {
    intent: e = "success",
    shadow: n = !1,
    hasSound: g = !1,
    solid: i,
    ...c
  } = t, [A] = iI(ty, {
    volume: 0.25
  }), l = c.checked !== void 0, {
    backgroundColor: a
  } = $g[e], C = {
    thumbColor: "white",
    onColor: a,
    solid: i,
    shadow: n
  }, b = Ke(c.checked);
  return Ee(() => {
    l && g && b.current !== c.checked && (b.current = c.checked, A());
  }, [c.checked]), /* @__PURE__ */ w(_0, { onCheckedChange: (m) => {
    var p;
    !l && g && A(), (p = t.onCheckedChange) == null || p.call(t, m);
  }, css: ey(C), ...c, children: /* @__PURE__ */ w($0, { css: ny(C) }) });
}, zu = 58, ey = (t) => /* @__PURE__ */ Gt([{
  cursor: "pointer",
  width: zu,
  height: 25,
  backgroundColor: t.solid ? K.gray : K.component,
  borderRadius: "9999px",
  position: "relative",
  border: "none",
  transition: "background-color 200ms",
  "&:focus": {
    // here for future changes
  },
  '&[data-state="checked"]': {
    backgroundColor: t.onColor
  }
}, t.shadow && me(2, !0)], process.env.NODE_ENV === "production" ? "" : ";label:RootStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), jc = 16, ny = (t) => /* @__PURE__ */ Gt({
  display: "block",
  width: jc,
  height: jc,
  backgroundColor: t.solid ? K.darkGray : t.thumbColor,
  borderRadius: "9999px",
  transition: "transform 200ms ease",
  transform: "translateX(6px)",
  willChange: "transform",
  '&[data-state="checked"]': {
    transform: `translateX(${zu - jc - 6}px)`,
    backgroundColor: t.thumbColor
  }
}, t.shadow && me(2), process.env.NODE_ENV === "production" ? "" : ";label:ThumbStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), gy = [{
  letterSpacing: "-0.10em"
}, Ft(), {
  top: 0,
  left: Kn.lg,
  right: Kn.lg,
  zIndex: 10,
  transform: "translateY(-50%)"
}, fn(ke.primary, "1.5em", "bold")];
function W2(t) {
  const {
    children: e,
    className: n,
    title: g,
    titleClassName: i,
    alignment: c,
    ...A
  } = t;
  return /* @__PURE__ */ Vt(gi, { css: _n(), className: n, ...A, children: [
    /* @__PURE__ */ w(T0, { css: [gy, {
      textAlign: c
    }, process.env.NODE_ENV === "production" ? "" : ";label:TitledCard;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], className: i, ...t.titleProps, children: g }),
    /* @__PURE__ */ w("div", { css: [ne, "z-index:5;" + (process.env.NODE_ENV === "production" ? "" : ";label:TitledCard;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: e })
  ] });
}
function iy() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function Ul(t, e, n) {
  return t + (e - t) * n;
}
function Tl() {
  return {
    size: Math.floor(Ul(50, 150, Math.sqrt(Math.random()))),
    left: `${Math.floor(Math.random() * 100)}%`,
    transform: "translateX(-50%)",
    animationDelayS: Math.floor(Math.random() * 10),
    animationDurationS: Math.floor(Ul(5, 15, Math.random()))
  };
}
const Iy = (t) => {
  const {
    color: e = "#fff",
    squareCount: n = 10
  } = t;
  return /* @__PURE__ */ w("div", { css: [Ay, process.env.NODE_ENV === "production" ? "" : ";label:FloatingSquares;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w("ul", { css: [sy, process.env.NODE_ENV === "production" ? "" : ";label:FloatingSquares;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: Array.from({
    length: n
  }, (g, i) => /* @__PURE__ */ w(cy, {}, i)) }) });
}, cy = () => {
  const t = Ke(null), [e, n] = ee(Tl), [g, i] = ee(0);
  return Ee(() => {
    const c = t.current;
    if (!c)
      return;
    const A = () => {
      i((l) => l + 1), n(Tl());
    };
    return c.addEventListener("animationend", A), () => {
      c.removeEventListener("animationend", A);
    };
  }, [g]), /* @__PURE__ */ w("li", { ref: t, css: oy(e) }, g);
}, Ay = /* @__PURE__ */ Gt({
  background: ["#4e54c8", "-webkit-linear-gradient(to left, #8f94fb, #4e54c8)"],
  width: "100%",
  height: "100vh"
}, process.env.NODE_ENV === "production" ? "" : ";label:rootStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL2JhY2tkcm9wcy9GbG9hdGluZ1NxdWFyZXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdFa0IiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvdWkvdWkvc3JjL2NvbW1vbi9jb21wb25lbnRzL2Jhc2UvYmFja2Ryb3BzL0Zsb2F0aW5nU3F1YXJlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGtleWZyYW1lcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IHVzZUVmZmVjdCwgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGkgfSBmcm9tICd2aXRlc3QvZGlzdC9yZXBvcnRlcnMteXg1WlR0RVYnO1xuaW1wb3J0IHsgYSB9IGZyb20gJ3ZpdGVzdC9kaXN0L3N1aXRlLUliTlNzVVdOJztcblxuZXhwb3J0IGludGVyZmFjZSBGbG9hdGluZ1NxdWFyZXNQcm9wcyB7XG4gIGNvbG9yPzogc3RyaW5nO1xuICBzcXVhcmVDb3VudD86IG51bWJlcjtcbn1cblxuZnVuY3Rpb24gbGVycChhOiBudW1iZXIsIGI6IG51bWJlciwgdDogbnVtYmVyKSB7XG4gIHJldHVybiBhICsgKGIgLSBhKSAqIHQ7XG59XG5cbmZ1bmN0aW9uIGdlbmVyYXRlUmFuZG9tU3F1YXJlKCkge1xuICByZXR1cm4ge1xuICAgIHNpemU6IE1hdGguZmxvb3IobGVycCg1MCwgMTUwLCBNYXRoLnNxcnQoTWF0aC5yYW5kb20oKSkpKSxcbiAgICBsZWZ0OiBgJHtNYXRoLmZsb29yKE1hdGgucmFuZG9tKCkgKiAxMDApfSVgLFxuICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVgoLTUwJSknLFxuICAgIGFuaW1hdGlvbkRlbGF5UzogTWF0aC5mbG9vcihNYXRoLnJhbmRvbSgpICogMTApLFxuICAgIGFuaW1hdGlvbkR1cmF0aW9uUzogTWF0aC5mbG9vcihsZXJwKDUsIDE1LCBNYXRoLnJhbmRvbSgpKSksXG4gIH07XG59XG5cbmV4cG9ydCBjb25zdCBGbG9hdGluZ1NxdWFyZXMgPSAocHJvcHM6IEZsb2F0aW5nU3F1YXJlc1Byb3BzKSA9PiB7XG4gIGNvbnN0IHsgY29sb3IgPSAnI2ZmZicsIHNxdWFyZUNvdW50ID0gMTAgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdiBjc3M9e1tyb290U3R5bGVdfT5cbiAgICAgIDx1bCBjc3M9e1tjaXJjbGVDb250YWluZXJTdHlsZV19PlxuICAgICAgICB7QXJyYXkuZnJvbSh7IGxlbmd0aDogc3F1YXJlQ291bnQgfSwgKF8sIGkpID0+IChcbiAgICAgICAgICA8RmxvYXRpbmdTcXVhcmUga2V5PXtpfSAvPlxuICAgICAgICApKX1cbiAgICAgIDwvdWw+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgY29uc3QgRmxvYXRpbmdTcXVhcmUgPSAoKSA9PiB7XG4gIGNvbnN0IGVsUmVmID0gdXNlUmVmPEhUTUxMSUVsZW1lbnQ+KG51bGwpO1xuICBjb25zdCBbc3F1YXJlLCBzZXRTcXVhcmVdID0gdXNlU3RhdGU8Q2lyY2xlU3R5bGVQcm9wcz4oZ2VuZXJhdGVSYW5kb21TcXVhcmUpO1xuICBjb25zdCBbaXRlcmF0aW9uLCBzZXRJdGVyYXRpb25dID0gdXNlU3RhdGUoMCk7XG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBjb25zdCBlbCA9IGVsUmVmLmN1cnJlbnQ7XG4gICAgaWYgKCFlbCkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGNvbnN0IGl0ZXJhdGlvbkxpc3RlbmVyID0gKCkgPT4ge1xuICAgICAgc2V0SXRlcmF0aW9uKChpKSA9PiBpICsgMSk7XG4gICAgICBzZXRTcXVhcmUoZ2VuZXJhdGVSYW5kb21TcXVhcmUoKSk7XG4gICAgfTtcblxuICAgIGVsLmFkZEV2ZW50TGlzdGVuZXIoJ2FuaW1hdGlvbmVuZCcsIGl0ZXJhdGlvbkxpc3RlbmVyKTtcblxuICAgIHJldHVybiAoKSA9PiB7XG4gICAgICBlbC5yZW1vdmVFdmVudExpc3RlbmVyKCdhbmltYXRpb25lbmQnLCBpdGVyYXRpb25MaXN0ZW5lcik7XG4gICAgfTtcbiAgfSwgW2l0ZXJhdGlvbl0pO1xuXG4gIHJldHVybiA8bGkga2V5PXtpdGVyYXRpb259IHJlZj17ZWxSZWZ9IGNzcz17Y2lyY2xlU3R5bGUoc3F1YXJlKX0gLz47XG59O1xuXG5jb25zdCByb290U3R5bGUgPSBjc3Moe1xuICBiYWNrZ3JvdW5kOiBbJyM0ZTU0YzgnLCAnLXdlYmtpdC1saW5lYXItZ3JhZGllbnQodG8gbGVmdCwgIzhmOTRmYiwgIzRlNTRjOCknXSxcbiAgd2lkdGg6ICcxMDAlJyxcbiAgaGVpZ2h0OiAnMTAwdmgnLFxufSk7XG5cbmNvbnN0IGNpcmNsZUNvbnRhaW5lclN0eWxlID0gY3NzKHtcbiAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gIHRvcDogJzAnLFxuICBsZWZ0OiAnMCcsXG4gIHdpZHRoOiAnMTAwJScsXG4gIGhlaWdodDogJzEwMCUnLFxuICBvdmVyZmxvdzogJ2hpZGRlbicsXG59KTtcblxuaW50ZXJmYWNlIENpcmNsZVN0eWxlUHJvcHMge1xuICBsZWZ0OiBzdHJpbmc7XG4gIHNpemU6IG51bWJlcjtcbiAgYW5pbWF0aW9uRGVsYXlTPzogbnVtYmVyO1xuICBhbmltYXRpb25EdXJhdGlvblM/OiBudW1iZXI7XG59XG5cbmNvbnN0IGNpcmNsZVN0eWxlID0gKHA6IENpcmNsZVN0eWxlUHJvcHMpID0+XG4gIGNzcyhcbiAgICB7XG4gICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgIGRpc3BsYXk6ICdibG9jaycsXG4gICAgICBsaXN0U3R5bGU6ICdub25lJyxcbiAgICAgIHdpZHRoOiBwLnNpemUsXG4gICAgICBoZWlnaHQ6IHAuc2l6ZSxcbiAgICAgIGJhY2tncm91bmQ6ICdyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMiknLFxuICAgICAgYW5pbWF0aW9uOiBgJHtmbG9hdFVwS2V5ZnJhbWVzfSBsaW5lYXJgLFxuICAgICAgYm90dG9tOiAtcC5zaXplLFxuICAgICAgbGVmdDogcC5sZWZ0LFxuICAgIH0sXG4gICAgcC5hbmltYXRpb25EZWxheVMgJiYgeyBhbmltYXRpb25EZWxheTogYCR7cC5hbmltYXRpb25EZWxheVN9c2AgfSxcbiAgICBwLmFuaW1hdGlvbkR1cmF0aW9uUyAmJiB7IGFuaW1hdGlvbkR1cmF0aW9uOiBgJHtwLmFuaW1hdGlvbkR1cmF0aW9uU31zYCB9LFxuICApO1xuXG5jb25zdCBmbG9hdFVwS2V5ZnJhbWVzID0ga2V5ZnJhbWVzKHtcbiAgJzAlJzoge1xuICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVgoLTUwJSkgdHJhbnNsYXRlWSgwKSByb3RhdGUoMGRlZyknLFxuICAgIG9wYWNpdHk6IDEsXG4gICAgYm9yZGVyUmFkaXVzOiAnMCcsXG4gIH0sXG4gICcxMDAlJzoge1xuICAgIHRyYW5zZm9ybTogJ3RyYW5zbGF0ZVgoLTUwJSkgdHJhbnNsYXRlWSgtMTAwMHB4KSByb3RhdGUoNzIwZGVnKScsXG4gICAgb3BhY2l0eTogMCxcbiAgICBib3JkZXJSYWRpdXM6ICc1MCUnLFxuICB9LFxufSk7XG4iXX0= */"), sy = process.env.NODE_ENV === "production" ? {
  name: "1g85vkz",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden"
} : {
  name: "oohxew-circleContainerStyle",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;label:circleContainerStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: iy
}, oy = (t) => /* @__PURE__ */ Gt({
  position: "absolute",
  display: "block",
  listStyle: "none",
  width: t.size,
  height: t.size,
  background: "rgba(255, 255, 255, 0.2)",
  animation: `${ly} linear`,
  bottom: -t.size,
  left: t.left
}, t.animationDelayS && {
  animationDelay: `${t.animationDelayS}s`
}, t.animationDurationS && {
  animationDuration: `${t.animationDurationS}s`
}, process.env.NODE_ENV === "production" ? "" : ";label:circleStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), ly = Zt({
  "0%": {
    transform: "translateX(-50%) translateY(0) rotate(0deg)",
    opacity: 1,
    borderRadius: "0"
  },
  "100%": {
    transform: "translateX(-50%) translateY(-1000px) rotate(720deg)",
    opacity: 0,
    borderRadius: "50%"
  }
});
/*! css-doodle v0.40.7 MIT licensed */
(() => {
  var t = [":", ";", ",", "(", ")", "[", "]", "{", "}", "π", "±", "+", "-", "*", "/", "%", '"', "'", "`", "@", "=", "^"], e = { escape: (I) => I == "\\", space: (I) => /[\r\n\t\s]/.test(I), digit: (I) => /^[0-9]$/.test(I), sign: (I) => /^[+-]$/.test(I), dot: (I) => I == ".", quote: (I) => /^["'`]$/.test(I), symbol: (I) => t.includes(I), hexNum: (I) => /^[0-9a-f]$/i.test(I), hex: (I, s, o) => I == "0" && e.letter(s, "x") && e.hexNum(o), expWithSign: (I, s, o) => e.letter(I, "e") && e.sign(s) && e.digit(o), exp: (I, s) => e.letter(I, "e") && e.digit(s), dots: (I, s) => e.dot(I) && e.dot(s), letter: (I, s) => String(I).toLowerCase() == String(s).toLowerCase(), comment: (I, s) => I == "/" && s == "*", inlineComment: (I, s) => I == "/" && s === "/", selfClosedTag: (I, s) => I == "/" && s == ">", closedTag: (I, s) => I == "<" && s == "/" }, n = class {
    constructor({ type: I, value: s, pos: o, status: r }) {
      this.type = I, this.value = s, this.pos = o, r && (this.status = r);
    }
    isSymbol(...I) {
      let s = this.type == "Symbol";
      return I.length ? I.some((o) => o === this.value) : s;
    }
    isSpace() {
      return this.type == "Space";
    }
    isNumber() {
      return this.type == "Number";
    }
    isWord() {
      return this.type == "Word";
    }
  };
  function g(I) {
    let s = -1, o = I.length, r = -1, u = 0;
    return { curr: (d = 0) => I[s + d], next(d = 1) {
      let h = I[s += d];
      return h === `
` ? (u++, r = 0) : r += d, h;
    }, end: () => s >= o, get: () => ({ prev: I[s - 1], curr: I[s + 0], next: I[s + 1], next2: I[s + 2], next3: I[s + 3], pos: [r, u] }) };
  }
  function i(I) {
    for (; I.next(); ) {
      let { curr: s, prev: o } = I.get();
      if (e.comment(s, o)) break;
    }
  }
  function c(I) {
    for (; I.next() && I.curr() !== `
`; ) ;
  }
  function A(I) {
    return [":", ";", ",", "{", "}", "(", ")", "[", "]"].includes(I);
  }
  function l(I) {
    let s = "";
    for (; !I.end(); ) {
      let { curr: o, next: r } = I.get();
      s += o;
      let u = e.symbol(r) || e.space(r) || e.digit(r);
      if (s.length && u && !e.closedTag(o, r)) break;
      I.next();
    }
    return s.trim();
  }
  function a(I) {
    let s = "";
    for (; !I.end(); ) {
      let { curr: o, next: r } = I.get();
      if (s += o, !e.space(r)) break;
      I.next();
    }
    return s;
  }
  function C(I) {
    let s = "", o = !1;
    for (; !I.end(); ) {
      let { curr: r, next: u, next2: d, next3: h } = I.get();
      if (s += r, o && e.dot(u) || (e.dot(r) && (o = !0), e.dots(u, d))) break;
      if (e.expWithSign(u, d, h)) s += I.next() + I.next();
      else if (e.exp(u, d)) s += I.next();
      else if (!e.digit(u) && !e.dot(u)) break;
      I.next();
    }
    return s;
  }
  function b(I) {
    let s = "0x";
    for (I.next(2); !I.end(); ) {
      let { curr: o, next: r } = I.get();
      if (s += o, !e.hexNum(r)) break;
      I.next();
    }
    return s;
  }
  function m(I) {
    return I[I.length - 1];
  }
  function p(I, s = {}) {
    let o = g(String(I).trim()), r = [], u = [];
    for (; o.next(); ) {
      let { prev: h, curr: G, next: V, next2: Z, pos: X } = o.get();
      if (e.comment(G, V)) i(o);
      else if (s.ignoreInlineComment && e.inlineComment(G, V)) c(o);
      else if (e.hex(G, V, Z)) {
        let W = b(o);
        r.push(new n({ type: "Number", value: W, pos: X }));
      } else if (e.digit(G) || e.digit(V) && e.dot(G) && !e.dots(h, G)) {
        let W = C(o);
        r.push(new n({ type: "Number", value: W, pos: X }));
      } else if (e.symbol(G) && !e.selfClosedTag(G, V)) {
        let W = m(r), S = e.digit(V) || e.dot(V) && e.digit(Z);
        if (G === "-" && S && (!W || !W.isNumber())) {
          let z = C(o);
          r.push(new n({ type: "Number", value: z, pos: X }));
          continue;
        }
        let F = { type: "Symbol", value: G, pos: X };
        if (u.length && e.escape(W.value)) {
          r.pop();
          let z = l(o);
          z.length && r.push(new n({ type: "Word", value: z, pos: X }));
        } else
          e.quote(G) && (m(u) == G ? (u.pop(), F.status = "close") : (u.push(G), F.status = "open")), r.push(new n(F));
      } else if (e.space(G)) {
        let W = a(o), S = m(r), { next: F } = o.get();
        if (!u.length && S) {
          let z = S.value, q = A(z) && z !== ")", M = A(F) && F !== "(";
          if (q || M) continue;
          W = s.preserveLineBreak ? G : " ";
        }
        r.length && F && F.trim() && r.push(new n({ type: "Space", value: W, pos: X }));
      } else {
        let W = l(o);
        W.length && r.push(new n({ type: "Word", value: W, pos: X }));
      }
    }
    let d = m(r);
    return d && d.isSpace() && (r.length = r.length - 1), r;
  }
  function y(I) {
    let s = [];
    for (; I.next(); ) {
      let { curr: o, next: r } = I.get();
      if (o.value === "var") {
        if (r && r.isSymbol("(")) {
          I.next();
          let u = f(I);
          Y(u.name) && s.push(u);
        }
      } else if (s.length && !o.isSymbol(",")) break;
    }
    return s;
  }
  function f(I) {
    let s = {}, o = [];
    for (; I.next(); ) {
      let { curr: r, next: u } = I.get();
      if (r.isSymbol(")", ";") && !s.name) {
        s.name = x(o);
        break;
      }
      r.isSymbol(",") ? (s.name === void 0 && (s.name = x(o), o = []), s.name && (s.fallback = y(I))) : o.push(r);
    }
    return s;
  }
  function x(I) {
    return I.map((s) => s.value).join("");
  }
  function Y(I) {
    return I !== void 0 && !(I.length <= 2) && !I.substr(2).startsWith("-") && !!I.startsWith("--");
  }
  var B = function(I) {
    return y(g(p(I)));
  };
  function J(I, s, o) {
    return I = Number(I) || 0, Math.max(s, Math.min(o, I));
  }
  function N(I, s) {
    for (let [o, r] of Object.entries(s)) I[o] = I[r];
    return I;
  }
  function R(I) {
    return /^[a-zA-Z]$/.test(I);
  }
  function H(I) {
    return I == null;
  }
  function E(I) {
    return H(I) || Number.isNaN(I);
  }
  function O(I) {
    return H(I) || I === "";
  }
  function j(I) {
    let s = (o) => (...r) => I(o, ...r);
    return s.lazy = !0, s;
  }
  function U(I, s, o) {
    return "c-" + I + "-" + s + "-" + o;
  }
  function D(I) {
    let s = I;
    for (; s && !H(s.value); ) s = s.value;
    return s ?? "";
  }
  function gt(I, s, o = 0) {
    let r = new Image();
    r.crossOrigin = "anonymous", r.src = I, r.onload = function() {
      setTimeout(s, o);
    };
  }
  function xt() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  function rn(I) {
    let s = document.createElement("textarea");
    return s.innerHTML = I, s.value;
  }
  function xe(I, s = 0) {
    I = String(I);
    let o = 3735928559 ^ s, r = 1103547991 ^ s;
    for (let u, d = 0; d < I.length; d++) u = I.charCodeAt(d), o = Math.imul(o ^ u, 2654435761), r = Math.imul(r ^ u, 1597334677);
    return o = Math.imul(o ^ o >>> 16, 2246822507) ^ Math.imul(r ^ r >>> 13, 3266489909), r = Math.imul(r ^ r >>> 16, 2246822507) ^ Math.imul(o ^ o >>> 13, 3266489909), 4294967296 * (2097151 & r) + (o >>> 0);
  }
  function We(I, s, o) {
    return s + I * (o - s);
  }
  function Mt(I = "") {
    return I + Math.random().toString(32).substr(2);
  }
  function At(I) {
    return H(I) ? [] : Array.isArray(I) ? I : [I];
  }
  function Wt(I, s = `
`) {
    return (I || []).join(s);
  }
  function nt(I, s = 1) {
    return H(I) ? "" : I[I.length - s];
  }
  function Nn(I) {
    return I[0];
  }
  var vt = function(I, s = { symbol: ",", noSpace: !1, verbose: !1 }) {
    let o = [], r = [], u = [], d = [], h = "";
    if (O(I)) return o;
    let G = g(p(I));
    function V(X) {
      let W = s.symbol || [","];
      return Array.isArray(W) || (W = [W]), s.noSpace ? X.isSymbol(...W) : X.isSymbol(...W) || X.isSpace();
    }
    function Z(X) {
      let W = function(S) {
        return S.map((F) => F.value).join("");
      }(X);
      s.verbose ? (h.length || W.length) && o.push({ group: h, value: W }) : o.push(W);
    }
    for (; G.next(); ) {
      let { prev: X, curr: W, next: S } = G.get();
      W.isSymbol("(") && u.push(W.value), W.isSymbol(")") && u.pop(), W.status === "open" && d.push(W.value), W.status === "close" && d.pop();
      let F = !u.length && !d.length;
      if (F) {
        let z = s.noSpace && W.isSpace() && V(S), q = s.noSpace && W.isSpace() && V(X);
        if (z || q) continue;
      }
      F && V(W) ? (Z(r), h = W.value, r = []) : r.push(W);
    }
    return r.length && Z(r), o;
  };
  function Vd(I, s) {
    let o, r = [], u = [], d = [], h = !1;
    for (; I.next(); ) {
      let { curr: G, next: V } = I.get();
      G.isSymbol("(") && !u.length ? d.push(G) : G.isSymbol(")") && !u.length && d.pop(), G.isSymbol("'", '"') && (G.status === "open" ? u.push(G) : u.pop());
      let Z = !u.length && !d.length && (!V || G.isSymbol(";") || V.isSymbol("}"));
      if (G.isSymbol("'", '"') && V && V.isSymbol("}") && !u.length && (Z = !0), !d.length && !u.length && G.isSymbol("{")) {
        let X = no(r);
        if (!X.length) continue;
        let W = X.pop(), S = PI(...X, W);
        for (o = bi(OI(I, di(W, { type: "block", name: W, value: [] })), S); W = X.pop(); ) o = bi(di(W, { type: "block", name: W, value: [o] }), S);
        h = !0;
        break;
      }
      if (r.push(G), Z) break;
    }
    return r.length && !o ? (s._valueTokens = r, s.value = Gg(r)) : o && (s.value = o), h && (s.value.inline = !0), s.origin && (s.origin.value = s.value), s;
  }
  function Zd(I) {
    let s = [], o = [];
    for (; I.next(); ) {
      let { curr: r } = I.get();
      if (r.isSymbol("{")) s.push(r.value);
      else if (r.isSymbol("}")) {
        if (!s.length) break;
        s.pop();
      }
      o.push(r.value);
    }
    return o.join("");
  }
  function OI(I, s) {
    let o = [], r = [], u = s && s.type || "", d = [];
    for (; I.next(); ) {
      let { prev: h, curr: G, next: V } = I.get();
      G.isSymbol("(") && d.push(G.value), G.isSymbol(")") && d.pop();
      let Z = !V || G.isSymbol("}");
      if (KI(u) && Z) {
        !V && o.length && !G.isSymbol("}") && typeof o[o.length - 1].value == "string" && (o[o.length - 1].value += ";" + G.value), s.value = o;
        break;
      }
      if (G.isSymbol("{")) {
        let X = no(r);
        if (!X.length) continue;
        PI(s.name) && (X = [Gg(r)]);
        let W = X.pop(), S = PI(...X, s.name, W);
        if (W === "style") o.push({ type: "block", name: W, value: Zd(I) });
        else {
          let F = bi(OI(I, di(W, { type: "block", name: W, value: [] })), S);
          for (; W = X.pop(); ) F = bi(di(W, { type: "block", name: W, value: [F] }), S);
          o.push(F);
        }
        r = [];
      } else if (G.isSymbol(":") && !d.length && !yd(h, V) && r.length) {
        let X = vd(r, (q) => q.isSymbol(",")), W = { type: "statement", name: "unkown", value: "" };
        X.length > 1 && (W.origin = { name: X });
        let S = Vd(I, W), F = vt(S.value), z = X.length > 1 && F.length === X.length;
        X.forEach((q, M) => {
          let Q = Object.assign({}, S, { name: q });
          /^\-\-/.test(q) && (Q.variable = !0), z && (Q.value = F[M]), /viewBox/i.test(q) && (Q.detail = Xd(Q.value, Q._valueTokens)), delete Q._valueTokens, o.push(Q);
        }), KI(u) && (s.value = o), r = [];
      } else G.isSymbol(";") ? o.length && r.length && (o[o.length - 1].value += ";" + Gg(r), r = []) : r.push(G);
    }
    return o.length && KI(u) && (s.value = o), u ? s : o;
  }
  function yd(I, s) {
    let o = I && I.value, r = s && s.value;
    return ["xlink:actuate", "xlink:arcrole", "xlink:href", "xlink:role", "xlink:show", "xlink:title", "xlink:type", "xml:base", "xml:lang", "xml:space"].includes(o + ":" + r);
  }
  function Gg(I) {
    return I.filter((s, o) => !s.isSymbol(";", "}") || o !== I.length - 1).map((s) => s.value).join("");
  }
  function bi(I, s) {
    let o = I.name || "", [r, ...u] = o.split(/#/), d = u[u.length - 1];
    return r && d && !s && (I.name = r, I.value.push({ type: "statement", name: "id", value: d })), I;
  }
  function vd(I, s) {
    let o = [], r = [];
    return I.forEach((u) => {
      s(u) ? (o.push(Gg(r)), r = []) : r.push(u);
    }), r.length && o.push(Gg(r)), o;
  }
  function no(I) {
    let s, o = [], r = g(I);
    for (; r.next(); ) {
      let { prev: u, curr: d, next: h } = r.get(), G = u && h && d.value === "x" && u.isNumber() && h.isNumber();
      !d.isWord() || s || G ? o[o.length - 1] = (o[o.length - 1] + d.value).trim() : o.push(d.value.trim()), d.isSymbol() ? s = !0 : d.isSpace() || (s = !1);
    }
    return o;
  }
  function Xd(I, s) {
    const o = { value: [] };
    let r;
    if (!Array.isArray(s)) return o;
    for (let u of s) u.isSpace() || u.isSymbol(",", ";") || (o.value.length < 4 && u.isNumber() ? o.value.push(Number(u.value)) : u.isNumber() && r ? (o[r] = Number(u.value), r = null) : u.isWord() && (r = u.value));
    return o;
  }
  function di(I, s) {
    let o = Object.assign({}, s);
    if (/\*\s*[0-9]/.test(I)) {
      let [r, u] = I.split("*");
      u && (o.times = u.trim(), o.pureName = r.trim());
    }
    return o;
  }
  function PI(...I) {
    return I.some((s) => s === "style");
  }
  function KI(I) {
    return I === "block";
  }
  var mg = function(I, s) {
    return function(o) {
      let r, u = [];
      for (let d of o.value) d.name === "svg" && (r = d), d.variable && u.push(d);
      if (r && Array.isArray(r.value)) {
        for (let d of u) r.value.find((h) => h.name == d.name) || r.value.unshift(d);
        return r;
      }
      return o;
    }(OI(g(p(I)), s || { type: "block", name: "svg", value: [] }));
  };
  function _I(I, s) {
    let o = "";
    if (I.type === "block") {
      let r = Array.isArray(I.value) && I.value[0] && I.value[0].inline;
      if (I.times ? o += "@M" + I.times + "(" + I.pureName + "{" : o += I.name + "{", I.name === "style") o += I.value;
      else if (Array.isArray(I.value) && I.value.length) {
        let u = "";
        for (let d of I.value) o += _I(d, u), d.origin && (u = d.origin.name.join(","));
      }
      I.times ? o += "})" : r || (o += "}");
    } else if (I.type === "statement") {
      let r = I.origin && s === I.origin.name.join(","), u = I.origin ? I.origin.name.join(",") : I.name, d = I.origin ? I.origin.value : I.value;
      r || (o += d && d.type ? u + ":" + _I(d) : u + ":" + d + ";");
    }
    return o;
  }
  function xd(I) {
    return _I(I).trim();
  }
  var zt = { func: (I = "") => ({ type: "func", name: I, arguments: [] }), argument: () => ({ type: "argument", value: [] }), text: (I = "") => ({ type: "text", value: I }), pseudo: (I = "") => ({ type: "pseudo", selector: I, styles: [] }), cond: (I = "") => ({ type: "cond", name: I, styles: [], arguments: [] }), rule: (I = "") => ({ type: "rule", property: I, value: [] }), keyframes: (I = "") => ({ type: "keyframes", name: I, steps: [] }), step: (I = "") => ({ type: "step", name: I, styles: [] }) }, Xt = { white_space: (I) => /[\s\n\t]/.test(I), line_break: (I) => /\n/.test(I), number: (I) => !isNaN(I), pair: (I) => ['"', "(", ")", "'"].includes(I), pair_of: (I, s) => ({ '"': '"', "'": "'", "(": ")" })[I] == s, selector(I) {
    let s, o = I.index(), r = [], u = [], d = !1;
    for (; !I.end(); )
      if (s = I.next(), (s === '"' || s === "'" || s === "`") && (s === nt(u) ? u.pop() : u.length || u.push(s)), s == "(" && r.push(s), s == ")" && r.pop(), !r.length && !u.length) {
        if (s === "{") {
          d = !0;
          break;
        }
        if (s === ";" || s === "}") {
          d = !1;
          break;
        }
      }
    return I.index(o), d;
  } }, Gi = { π: Math.PI, "∏": Math.PI };
  function go(I) {
    return /^@(canvas|shaders|doodle)/.test(I);
  }
  function io(I = "") {
    let s = 0, o = 1, r = 1;
    return { curr: (u = 0) => I[s + u], end: () => I.length <= s, info: () => ({ index: s, col: o, line: r }), index: (u) => u === void 0 ? s : s = u, range: (u, d) => I.substring(u, d), next() {
      let u = I[s++];
      return u == `
` ? (r++, o = 0) : o++, u;
    } };
  }
  function Wd(I, { col: s, line: o }) {
    console.warn(`(at line ${o}, column ${s}) ${I}`);
  }
  function $I(I, s) {
    return function(o, r) {
      let u = o.index(), d = "";
      for (; !o.end(); ) {
        let h = o.next();
        if (I(h)) {
          s && (d += h);
          break;
        }
        d += h;
      }
      return r && o.index(u), d;
    };
  }
  function Io(I, s) {
    return $I((o) => /[^\w@]/.test(o))(I, s);
  }
  function fd(I) {
    return $I((s) => /[\s\{]/.test(s))(I);
  }
  function Bd(I, s) {
    return $I((o) => Xt.line_break(o) || o == "{", !0)(I, s);
  }
  function Yd(I, s) {
    let o, r = zt.step();
    for (; !I.end() && (o = I.curr()) != "}"; ) if (Xt.white_space(o)) I.next();
    else {
      if (r.name.length) {
        if (r.styles.push(hi(I, s)), I.curr() == "}") break;
      } else r.name = nc(I, (u) => u === "{");
      I.next();
    }
    return r;
  }
  function Nd(I, s) {
    const o = [];
    let r;
    for (; !I.end() && (r = I.curr()) != "}"; ) Xt.white_space(r) || o.push(Yd(I, s)), I.next();
    return o;
  }
  function Jd(I, s) {
    let o, r = zt.keyframes();
    for (; !I.end() && (o = I.curr()) != "}"; ) if (r.name.length) {
      if (o == "{" || I.curr(-1) == "{") {
        I.next(), r.steps = Nd(I, s);
        break;
      }
      I.next();
    } else if (Io(I), r.name = fd(I), !r.name.length) {
      Wd("missing keyframes name", I.info());
      break;
    }
    return r;
  }
  function mi(I, s = {}) {
    for (I.next(); !I.end(); ) {
      let o = I.curr();
      if (s.inline) {
        if (o == `
`) break;
      } else if ((o = I.curr()) == "*" && I.curr(1) == "/") break;
      I.next();
    }
    s.inline || (I.next(), I.next());
  }
  function Rd(I) {
    for (I.next(); !I.end() && I.curr() != ">"; )
      I.next();
  }
  function Sd(I) {
    let s, o = "";
    for (; !I.end() && (s = I.curr()) != ":"; ) Xt.white_space(s) || (o += s), I.next();
    return o;
  }
  function tc(I, s, o, r = {}) {
    let u, d = [], h = [], G = [], V = "", Z = "";
    for (; !I.end(); ) {
      u = I.curr();
      let W = I.curr(-1), S = I.index();
      if (/[\('"`]/.test(u) && W !== "\\") G.length && u !== "(" && u === nt(G) ? G.pop() : G.push(u), V += u;
      else if (!o && (u == "@" || u === "$" || W === "." && s)) h.length || (V = V.trimLeft()), V.length && (h.push(zt.text(V)), V = ""), h.push(co(I, r));
      else if (o && /[)]/.test(u) || !o && /[,)]/.test(u)) if (G.length) u == ")" && nt(G) === "(" && G.pop(), V += u;
      else {
        if (V.length && (h.length ? /\S/.test(V) && h.push(zt.text(V)) : h.push(zt.text((X = V).trim().length ? Xt.number(+X) ? +X : X.trim() : X)), V.trim().startsWith("±") && !o)) {
          let F = V.trim().substr(1), z = structuredClone(h);
          nt(z).value = "-" + F, d.push(ec(z)), nt(h).value = F;
        }
        if (d.push(ec(h)), [h, V] = [[], ""], u == ")") break;
      }
      else Gi[u] && !/[0-9]/.test(I.curr(-1)) && (u = Gi[u]), V += u;
      if (!(!s || I.curr(1) != ")" && I.curr(1) != ";" && /[0-9a-zA-Z_\-.]/.test(I.curr()) || G.length)) {
        h.length && d.push(ec(h));
        break;
      }
      Z += I.range(S, I.index() + 1), I.next();
    }
    var X;
    return [Fd(d), Z];
  }
  function Fd(I) {
    let s = nt(I[0]);
    return s && s.type === "text" && !String(s.value).trim().length && (I[0] = I[0].slice(0, -1)), I;
  }
  function ec(I) {
    let s = I.map((u) => {
      if (u.type == "text" && typeof u.value == "string") {
        let d = String(u.value);
        d.includes("`") && (u.value = d = d.replace(/`/g, '"')), u.value = d;
      }
      return u;
    }), o = Nn(s) || {}, r = nt(s) || {};
    if (o.type == "text" && r.type == "text") {
      let u = Nn(o.value), d = nt(r.value);
      typeof o.value == "string" && typeof r.value == "string" && Xt.pair_of(u, d) && (o.value = o.value.slice(1), r.value = r.value.slice(0, r.value.length - 1), s.cluster = !0);
    }
    return s;
  }
  function Hd(I) {
    let s = JSON.stringify(I);
    return s.includes("pureName") && s.includes("times");
  }
  function wd(I) {
    return /^@svg$/i.test(I);
  }
  function co(I, s = {}) {
    let o, r = zt.func(), u = I.curr(), d = !1, h = u === "$";
    for (u === "@" ? I.next() : u = "@"; !I.end(); ) {
      o = I.curr();
      let Z = I.curr(1), X = o == "." && /[a-zA-Z@$]/.test(Z);
      if (o == "(" || X) {
        d = !0, I.next();
        let [W, S] = tc(I, X, go(u), s);
        if (wd(u)) {
          let F = mg(S), z = 0;
          for (let q of F.value) q.variable && (s[q.name] = Jn(`${`
`.repeat(z++)} ${q.name}:${q.value}`)[0].value);
          if (/\d\s*{/.test(S) && Hd(F)) {
            let q = xd(F);
            q += ")", W = tc(io(q), X, go(u), s)[0];
          }
        }
        r.arguments = W, r.variables = s;
        break;
      }
      if (/[0-9a-zA-Z_\-.%]/.test(o) && (u += o), !d && Z !== "(" && !/[0-9a-zA-Z_\-.%]/.test(Z)) break;
      I.next();
    }
    let { fname: G, extra: V } = function(Z) {
      let X = "", W = "";
      if (/\D$/.test(Z) && !/\d+[x-]\d+/.test(Z) || Math[Z.substr(1)]) return { fname: Z, extra: W };
      for (let S = Z.length - 1; S >= 0; S--) {
        let F = Z[S], z = Z[S - 1], q = Z[S + 1];
        if (!(/[\d.]/.test(F) || (F == "x" || F == "-") && /\d/.test(z) && /\d/.test(q))) {
          X = Z.substring(0, S + 1);
          break;
        }
        W = F + W;
      }
      return { fname: X, extra: W };
    }(u);
    if (r.name = h ? "@$" + u.substr(1) : G, V.length && r.arguments.unshift([{ type: "text", value: V }]), h && r.name.length > 2) {
      if (!r.arguments.length) {
        let Z = r.name.substring(0, 2), X = r.name.substring(2);
        r.name = Z, r.arguments.push([{ type: "text", value: X }]);
      }
      if (/\d$/.test(r.name)) {
        let Z = r.name.substring(0, 2), X = r.name.substring(2);
        r.name = Z, r.arguments[0][0].value = X;
      }
    }
    return r.position = I.info().index, r;
  }
  function nc(I, s = () => {
  }) {
    let o, r = zt.text(), u = 0, d = !0;
    const h = [];
    h[u] = [];
    let G = [], V = [];
    for (; !I.end(); ) {
      if (o = I.curr(), d && Xt.white_space(o)) {
        I.next();
        continue;
      }
      if (d = !1, o != `
` || Xt.white_space(I.curr(-1))) if (o != "," || G.length) {
        if ((/[;}<]/.test(o) || s(o)) && !V.length) {
          r.value.length && (h[u].push(r), r = zt.text());
          break;
        }
        o !== "@" && o !== "$" || !/[\w-\(%]/.test(I.curr(1)) ? o === '"' || o === "'" ? (o === nt(V) ? V.pop() : V.length || V.push(o), r.value += o) : Xt.white_space(o) && Xt.white_space(I.curr(-1)) || (o == "(" && G.push(o), o == ")" && G.pop(), Gi[o] && !/[0-9]/.test(I.curr(-1)) && (o = Gi[o]), r.value += o) : (r.value.length && (h[u].push(r), r = zt.text()), h[u].push(co(I)));
      } else r.value.length && (h[u].push(r), r = zt.text()), h[++u] = [], d = !0;
      else r.value += " ";
      let Z = I.curr();
      if ((Z === ";" || Z == "}" || s(Z)) && !V.length) break;
      I.next();
    }
    return r.value.length && h[u].push(r), h;
  }
  function zd(I) {
    let s, o = "";
    for (; !I.end() && (s = I.curr()) != "{"; ) o += s, I.next();
    return o = o.trim(), o;
  }
  function qd(I) {
    let s, o = "", r = [], u = {};
    for (; !I.end() && !/[){]/.test(s); ) {
      if ((s = I.curr()) == "(") {
        o && (u.name ? r.push({ keyword: o }) : u.name = o, o = ""), I.next();
        let G = tc(I)[0];
        r.push({ arguments: G });
      } else Xt.white_space(s) ? Xt.white_space(s) && !u.name ? (u.name = o, o = "") : Xt.white_space(s) && o.length && (r.push({ keyword: o }), o = "") : o += s;
      I.next();
    }
    let [d, ...h] = (u.name || "").trim().split(/\s+/);
    return u.name = d, u.addition = h, u.segments = r, u;
  }
  function Ao(I, s) {
    let o, r = zt.pseudo();
    for (; !I.end(); ) {
      if (o = I.curr(), o == "/" && I.curr(1) == "*") mi(I);
      else {
        if (o == "}") break;
        if (Xt.white_space(o)) {
          I.next();
          continue;
        }
        if (r.selector) {
          let u = hi(I, s);
          if (u.property == "@use" ? r.styles = r.styles.concat(u.value) : u.property && r.styles.push(u), I.curr() == "}") break;
        } else r.selector = zd(I);
      }
      I.next();
    }
    return r;
  }
  function hi(I, s) {
    let o, r = zt.rule(), u = I.index();
    for (; !I.end(); ) {
      if (o = I.curr(), o == "/" && I.curr(1) == "*") mi(I);
      else {
        if (o == ";") break;
        if (r.property.length) {
          r.value = nc(I);
          break;
        }
        if (r.property = Sd(I), r.property == "@use") {
          r.value = Dd(I, s);
          break;
        }
      }
      I.next();
    }
    let d = I.index();
    return r.raw = () => I.range(u, d).trim(), r;
  }
  function so(I, s) {
    let o, r = zt.cond();
    for (; !I.end(); ) {
      if (o = I.curr(), o == "/" && I.curr(1) == "*") mi(I);
      else {
        if (o == "}") break;
        if (r.name.length) if (o == ":") {
          let u = Ao(I);
          u.selector && r.styles.push(u);
        } else if (o != "@" || Bd(I, !0).includes(":")) {
          if (!Xt.white_space(o)) {
            let u = hi(I, s);
            if (u.property && r.styles.push(u), I.curr() == "}") break;
          }
        } else r.styles.push(so(I));
        else Object.assign(r, qd(I));
      }
      I.next();
    }
    return r;
  }
  function oo(I, s) {
    let o = "";
    return I && I.get_variable && (o = I.get_variable(s)), o;
  }
  function lo(I, s) {
    I.forEach && I.forEach((o) => {
      if (o.type == "text" && o.value) {
        let r = B(o.value);
        o.value = r.reduce((u, d) => {
          let h, G = "", V = "";
          G = oo(s, d.name), !G && d.fallback && d.fallback.every((Z) => {
            if (V = oo(s, Z.name), V) return G = V, !1;
          });
          try {
            h = Jn(G, s);
          } catch {
          }
          return h && u.push.apply(u, h), u;
        }, []);
      }
      o.type == "func" && o.arguments && o.arguments.forEach((r) => {
        lo(r, s);
      });
    });
  }
  function Dd(I, s) {
    return I.next(), (nc(I) || []).reduce((o, r) => {
      lo(r, s);
      let [u] = r;
      return u.value && u.value.length && o.push(...u.value), o;
    }, []);
  }
  function Jn(I, s) {
    const o = io(I), r = [];
    for (; !o.end(); ) {
      let u = o.curr();
      if (Xt.white_space(u)) o.next();
      else {
        if (u == "/" && o.curr(1) == "*") mi(o);
        else if (u == ":") {
          let d = Ao(o, s);
          d.selector && r.push(d);
        } else if (u == "@" && Io(o, !0) === "@keyframes") {
          let d = Jd(o, s);
          r.push(d);
        } else if (u == "<") Rd(o);
        else if (Xt.selector(o)) {
          let d = so(o, s);
          d.name.length && r.push(d);
        } else if (!Xt.white_space(u)) {
          let d = hi(o, s);
          d.property && r.push(d);
        }
        o.next();
      }
    }
    return r;
  }
  function Rn(I, s = 64) {
    const [o, r, u] = [1, s, s * s];
    let [d, h, G] = (I + "").replace(/\s+/g, "").replace(/[,\uff0cxX]+/g, "x").split("x").map((W) => parseInt(W));
    const V = d == 1 || h == 1 ? u : r, Z = d == 1 && h == 1 ? u : o, X = { x: J(d || o, 1, V), y: J(h || d || o, 1, V), z: J(G || o, 1, Z) };
    return Object.assign({}, X, { count: X.x * X.y * X.z, ratio: X.x / X.y });
  }
  function Ld(I) {
    return /^texture\w*$|^(fragment|vertex)$/.test(I);
  }
  function ro() {
    return new n({ type: "LineBreak", value: `
` });
  }
  function ao(I) {
    let s = I[0], o = I[I.length - 1];
    for (; s && s.isSymbol("(") && o && o.isSymbol(")"); ) s = (I = I.slice(1, I.length - 1))[0], o = I[I.length - 1];
    return I;
  }
  function gc(I) {
    return ao(I).map((s) => s.value).join("");
  }
  var kd = function(I) {
    let s, o, r = g(ao(p(I, { preserveLineBreak: !0, ignoreInlineComment: !0 }))), u = [], d = [], h = { textures: [] };
    for (; r.next(); ) {
      let { curr: G, next: V } = r.get();
      if (G.isSymbol("{")) {
        if (u.length) d.push(G);
        else {
          let Z = gc(d);
          Ld(Z) ? (s = Z, d = []) : d.push(G);
        }
        u.push("{");
      } else if (G.isSymbol("}")) if (u.pop(), !u.length && s) {
        let Z = gc(d);
        s && Z.length && (s.startsWith("texture") ? h.textures.push({ name: s, value: Z }) : h[s] = Z, d = []), s = null;
      } else d.push(G);
      else O(o) || o == G.pos[1] || (d.push(ro()), o = null), s && s.startsWith("texture") || G.isWord() && G.value.startsWith("#") && (d.push(ro()), o = V.pos[1]), d.push(G);
    }
    return O(h.fragment) && (h.fragment = gc(d), h.textures = h.textures || []), h;
  }, pi = function(I) {
    let s = g(p(I)), o = {}, r = { commands: [], valid: !0 };
    for (; s.next(); ) {
      let { curr: u } = s.get();
      if (!u.isSpace() && !u.isSymbol(",")) if (u.isWord()) o.name && (r.commands.push(o), o = {}), o.name = u.value, o.value = [], "MmLlHhVvCcSsQqTtAaZz".includes(u.value) ? "mlhvcsqtaz".includes(u.value) ? o.type = "relative" : o.type = "absolute" : (o.type = "unknown", r.valid = !1);
      else if (o.value) {
        let d = u.value;
        u.isNumber() && (d = Number(u.value)), o.value.push(d);
      } else o.name || (r.valid = !1);
    }
    return o.name && r.commands.push(o), r;
  }, hg = function(I) {
    let s = g(p(I)), o = {}, r = !1;
    for (; s.next(); ) {
      let { prev: u, curr: d, next: h } = s.get(), G = r && (d.isWord() || d.isSymbol()) && u && u.isNumber() && !h;
      if (d.isNumber()) o.value = Number(d.value), r = !0;
      else {
        if (!G) break;
        o.unit = d.value;
      }
    }
    return o;
  }, pg = 'xmlns="http://www.w3.org/2000/svg"', Co = 'xmlns="http://www.w3.org/1999/xhtml"', ic = 'xmlns:xlink="http://www.w3.org/1999/xlink"';
  function Vi(I, s) {
    return `url("data:image/svg+xml;utf8,${encodeURIComponent(I) + (s ? `#${s}` : "")}")`;
  }
  function uo(I) {
    return I.includes("<svg") || (I = `<svg ${pg} ${ic}>${I}</svg>`), I.includes("xmlns") || (I = I.replace(/<svg([\s>])/, `<svg ${pg} ${ic}$1`)), I;
  }
  var Ed = /* @__PURE__ */ function() {
    let I = 0;
    return (s = "") => `${s}-${++I}`;
  }(), Vg = class {
    constructor(I, s = "") {
      if (!I) throw new Error("Tag name is required");
      this.id = Symbol(), this.name = I, this.body = [], this.attrs = {}, this.isTextNode() && (this.body = s);
    }
    isTextNode() {
      return this.name === "text-node";
    }
    find(I) {
      let s = I.attrs.id, o = I.name;
      if (Array.isArray(this.body) && s !== void 0) return this.body.find((r) => r.attrs.id === s && r.name === o);
    }
    findSpareDefs() {
      return this.body.find((I) => I.name === "defs" && !I.attrs.id);
    }
    append(I) {
      Array.isArray(I) || (I = [I]);
      for (let s of I) this.isTextNode() || this.body.push(s);
    }
    merge(I) {
      for (let [s, o] of Object.entries(I.attrs)) this.attrs[s] = o;
      Array.isArray(I.body) && this.body.push(...I.body);
    }
    attr(I, s) {
      if (!this.isTextNode()) return s === void 0 ? this.attrs[I] : this.attrs[I] = s;
    }
    toString() {
      if (this.isTextNode()) return bo(this.body);
      let I = [""], s = [];
      for (let [o, r] of Object.entries(this.attrs)) r = bo(r), I.push(`${o}="${r}"`);
      for (let o of this.body) s.push(o.toString());
      return s.join("").length || /svg/i.test(this.name) ? `<${this.name}${I.join(" ")}>${s.join("")}</${this.name}>` : `<${this.name}${I.join(" ")}/>`;
    }
  };
  function bo(I) {
    let s = (I = String(I)).startsWith('"') && I.endsWith('"'), o = I.startsWith("'") && I.endsWith("'");
    return s || o ? I.substring(1, I.length - 1) : I;
  }
  function Ic(I, s, o, r) {
    let u;
    if (s || (s = new Vg("root")), I.type === "block") if (I.name === "style") {
      let h = new Vg("style");
      h.append(I.value), s.append(h);
    } else {
      let h = new Vg(I.name);
      if (r || (r = h).attr("xmlns", pg.split("=")[1]), I.name === "defs") {
        let W = r.findSpareDefs();
        W && (h = W);
      }
      for (let W of I.value) {
        I.parent = o;
        let S = Ic(W, h, I, r);
        S && (u = S);
      }
      let G = I && I.inline && I.name !== "defs", V = o && o.inline && o.name === "defs", Z = V && o.value.length == 1;
      if (G || V) {
        let W = I.value.find((S) => S.type === "statement" && S.name === "id");
        W ? u = W.value : (Z || G) && (u = Ed(I.name), h.attr("id", u));
      }
      let X = s.find(h);
      if (X) X.merge(h);
      else if (I.name === "defs") {
        let W = r.findSpareDefs();
        W && !h.attrs.id ? h.id !== W.id && W.append(h.body) : r.append(h);
      } else s.append(h);
    }
    if (I.type === "statement" && !I.variable) if (I.name === "content") {
      let h = new Vg("text-node", I.value);
      s.append(h);
    } else if (I.name.startsWith("style ")) {
      let h = (I.name.split("style ")[1] || "").trim();
      if (h.length) {
        let G = s.attr("style") || "";
        s.attr("style", G + function(V, Z) {
          return `${V}:${Z};`;
        }(h, I.value));
      }
    } else {
      let h = I.value;
      if (h && h.type === "block") {
        let G = Ic(I.value, r, I, r);
        H(G) ? h = "" : (h = `url(#${G})`, I.name !== "xlink:href" && I.name !== "href" || (h = `#${G}`));
      }
      if (/viewBox/i.test(I.name)) h = function(G) {
        let V = G.detail.value, Z = G.detail.padding || G.detail.p || G.detail.expand;
        if (!V.length) return "";
        let [X, W, S, F] = V;
        return Z && ([X, W, S, F] = [X - Z, W - Z, S + 2 * Z, F + 2 * Z]), `${X} ${W} ${S} ${F}`;
      }(I), h && s.attr(I.name, h);
      else if (I.name !== "draw" && I.name !== "animate" || (d = o && o.name) !== "path" && d !== "line" && d !== "circle" && d !== "ellipse" && d !== "rect" && d !== "polygon" && d !== "polyline") s.attr(I.name, h);
      else {
        let [G, V] = String(h).split(/\s+/);
        (G === "indefinite" || G === "infinite" || /\d$/.test(G)) && ([G, V] = [V, G]), V === "infinite" && (V = "indefinite"), s.attr("stroke-dasharray", 10), s.attr("pathLength", 10);
        let Z = new Vg("animate");
        Z.attr("attributeName", "stroke-dashoffset"), Z.attr("from", 10), Z.attr("to", 0), Z.attr("dur", G), V && Z.attr("repeatCount", V), s.append(Z);
      }
      I.name.includes("xlink:") && r.attr("xmlns:xlink", ic.split("=")[1]);
    }
    var d;
    return o ? u : r.toString();
  }
  function Zi(I) {
    return Ic(I);
  }
  var jd = ["auto", "reverse"], Md = ["deg", "rad", "grad", "turn"], Ud = function(I) {
    let s = g(p(I)), o = !1, r = "", u = { direction: "", angle: "" };
    for (; s.next(); ) {
      let { prev: d, curr: h, next: G } = s.get();
      if (h.isWord() && jd.includes(h.value)) u.direction = h.value, o = !0;
      else if (h.isNumber()) u.angle = Number(h.value), o = !0;
      else if (h.isWord() && d && d.isNumber() && Md.includes(h.value)) r = h.value;
      else if (h.isSpace() && u.direction !== "" && u.angle !== "") break;
    }
    return o || (u.direction = "auto"), function(d, h) {
      let { angle: G } = d;
      return G === "" && (G = 0), h === "rad" && (G /= Math.PI / 180), h === "grad" && (G *= 0.9), h === "turn" && (G *= 360), Object.assign({}, d, { angle: G });
    }(u, r);
  };
  function Go(I, s, o) {
    return ["fill-rule", "fill"].includes(I) ? s : o ? `-1 * (${s})` : s;
  }
  function cc(I) {
    return I.map((s) => s.value).join("");
  }
  var Td = function(I) {
    let s, o = g(p(I)), r = {}, u = [], d = !1;
    for (; o.next(); ) {
      let { prev: h, curr: G, next: V } = o.get();
      if (G.isSymbol(":") && !s) s = cc(u), u = [];
      else if (G.isSymbol(";") && s) r[s] = Go(s, cc(u), d), u = [], s = null, d = !1;
      else if (!G.isSymbol(";")) {
        let Z = h && h.isSymbol("-"), X = V && V.isSymbol("-"), W = G.isSymbol("-");
        s || u.length || !W || Z || X || V && V.isSymbol(":") ? u.push(G) : d = !0;
      }
    }
    return u.length && s && (r[s] = Go(s, cc(u), d)), r;
  }, fe = new class {
    constructor() {
      this.cache = /* @__PURE__ */ new Map();
    }
    clear() {
      this.cache.clear();
    }
    set(I, s) {
      if (H(I)) return "";
      let o = this.getKey(I);
      return this.cache.set(o, s), s;
    }
    has(I) {
      return this.cache.has(I);
    }
    get(I) {
      let s = this.getKey(I);
      return this.cache.get(s);
    }
    getKey(I) {
      return H(I) ? "" : xe(typeof I == "string" ? I : JSON.stringify(I));
    }
  }();
  function Ac(I, s) {
    return (...o) => {
      let r = I + o.join("-");
      return fe.get(r) || fe.set(r, s(...o));
    };
  }
  var Qd = { π: Math.PI, gcd: (I, s) => {
    for (; s; ) [I, s] = [s, I % s];
    return I;
  } }, sc = { "^": 7, "*": 6, "/": 6, "÷": 6, "%": 6, "&": 5, "|": 5, "+": 4, "-": 4, "<": 3, "<<": 3, ">": 3, ">>": 3, "=": 3, "==": 3, "≤": 3, "<=": 3, "≥": 3, ">=": 3, "≠": 3, "!=": 3, "∧": 2, "&&": 2, "∨": 2, "||": 2, "(": 1, ")": 1 };
  function yi(I, s, o = []) {
    let r = [];
    for (; I.length; ) {
      let { name: u, value: d, type: h } = I.shift();
      if (h === "variable") {
        let G = s[d];
        E(G) && (G = Math[d]), E(G) && (G = mo(d, s, o)), E(G) && /^\-\D/.test(d) && (G = mo("-1" + d.substr(1), s, o)), G === void 0 && (G = 0), typeof G != "number" && (o.push(G), ho(o) ? (G = 0, o = []) : G = yi(Zg(G), s, o)), r.push(G);
      } else if (h === "function") {
        let G = !1;
        /^\-/.test(u) && (G = !0, u = u.substr(1));
        let V, Z = d.map((W) => yi(W, s, o)), X = u.split(".");
        for (; V = X.pop(); ) {
          if (!V) continue;
          let W = s[V] || Math[V];
          Z = typeof W == "function" ? Array.isArray(Z) ? W(...Z) : W(Z) : 0;
        }
        G && (Z *= -1), r.push(Z);
      } else if (/\d+/.test(d)) r.push(d);
      else {
        let G = r.pop(), V = r.pop();
        r.push(Od(d, Number(V), Number(G)));
      }
    }
    return Number(r[0]) || 0;
  }
  function Zg(I) {
    let s = function(u) {
      if (fe.has(u)) return fe.get(u);
      let d = String(u), h = [], G = "";
      for (let V = 0; V < d.length; ++V) {
        let Z = d[V];
        if (sc[Z]) {
          let X = nt(h);
          if (Z == "=" && X && /^[!<>=]$/.test(X.value)) X.value += Z;
          else if (/^[|&<>]$/.test(Z) && X && X.value == Z) X.value += Z;
          else if (Z == "-" && d[V - 1] == "e") G += Z;
          else if (h.length || G.length || !/[+-]/.test(Z)) {
            let { type: W, value: S } = X || {};
            W == "operator" && !G.length && /[^()]/.test(Z) && /[^()]/.test(S) ? G += Z : (G.length && (h.push({ type: "number", value: G }), G = ""), h.push({ type: "operator", value: Z }));
          } else G += Z;
        } else /\S/.test(Z) && (Z == "," ? (h.push({ type: "number", value: G }), G = "", h.push({ type: "comma", value: Z })) : Z == "!" ? (h.push({ type: "number", value: G }), h.push({ type: "operator", value: Z }), G = "") : G += Z);
      }
      return G.length && h.push({ type: "number", value: G }), fe.set(u, h), h;
    }(I);
    const o = [], r = [];
    for (let u = 0; u < s.length; ++u) {
      let { type: d, value: h } = s[u], G = s[u + 1] || {};
      if (d == "number") if (G.value == "(" && /[^\d.\-]/.test(h)) {
        let V = "", Z = [], X = [];
        for (u += 1; s[u++] !== void 0; ) {
          let W = s[u];
          if (W === void 0) break;
          let S = W.value;
          if (S == ")") {
            if (!Z.length) break;
            Z.pop(), V += S;
          } else if (S == "(" && Z.push(S), S != "," || Z.length) V += S;
          else {
            let F = Zg(V);
            F.length && X.push(F), V = "";
          }
        }
        V.length && X.push(Zg(V)), r.push({ type: "function", name: h, value: X });
      } else /[^\d.\-]/.test(h) ? r.push({ type: "variable", value: h }) : r.push({ type: "number", value: h });
      else if (d == "operator") if (h == "(") o.push(h);
      else if (h == ")") {
        for (; o.length && nt(o) != "("; ) r.push({ type: "operator", value: o.pop() });
        o.pop();
      } else {
        for (; o.length && sc[nt(o)] >= sc[h]; ) {
          let V = o.pop();
          /[()]/.test(V) || r.push({ type: "operator", value: V });
        }
        o.push(h);
      }
    }
    for (; o.length; ) r.push({ type: "operator", value: o.pop() });
    return r;
  }
  function Od(I, s, o) {
    switch (I) {
      case "+":
        return s + o;
      case "-":
        return s - o;
      case "*":
        return s * o;
      case "%":
        return s % o;
      case "|":
        return s | o;
      case "&":
        return s & o;
      case "<":
        return s < o;
      case ">":
        return s > o;
      case "^":
        return Math.pow(s, o);
      case "÷":
      case "/":
        return s / o;
      case "=":
      case "==":
        return s == o;
      case "≤":
      case "<=":
        return s <= o;
      case "≥":
      case ">=":
        return s >= o;
      case "≠":
      case "!=":
        return s != o;
      case "∧":
      case "&&":
        return s && o;
      case "∨":
      case "||":
        return s || o;
      case "<<":
        return s << o;
      case ">>":
        return s >> o;
    }
  }
  function mo(I, s, o) {
    let [r, u, d] = I.match(/([\d.\-]+)(.*)/) || [], h = s[d];
    return h === void 0 ? h : typeof h == "number" ? Number(u) * h : (o.push(h), ho(o) ? (o = [], 0) : u * yi(Zg(h), s, o));
  }
  function ho(I) {
    if (I.length > 50) return !0;
    let s = nt(I);
    for (let o = 2; o <= 4; ++o) {
      let r = I[I.length - o];
      if (r === void 0 || s !== r) return !1;
    }
    return !0;
  }
  function Be(I, s) {
    return yi(Zg(I), Object.assign({}, Qd, s));
  }
  var { cos: yg, sin: vg, abs: Pd, atan2: po, PI: oc } = Math, lc = { circle: `
 split:180;scale:.99
 `, triangle: `
 rotate:30;scale:1.1;move:0 .2
 `, pentagon: `
 split:5;rotate:54
 `, hexagon: `
 split:6;rotate:30;scale:.98
 `, octagon: `
 split:8;rotat:22.5;scale:.99
 `, star: `
 split:10;r:cos(5t);rotate:-18;scale:.99
 `, infinity: `
 split:180;scale:.99;x:cos(t)*.99 / (sin(t)^2 + 1);y:x * sin(t)
 `, heart: `
 split:180;rotate:180;a:cos(t)*13/18 - cos(2t)*5/18;b:cos(3t)/18 + cos(4t)/18;x:(.75 * sin(t)^3) * 1.2;y:(a - b + .2) * -1.1
 `, bean: `
 split:180;r:sin(t)^3 + cos(t)^3;move:-.35 .35;`, bicorn: `
 split:180;x:cos(t);y:sin(t)^2 / (2 + sin(t)) - .5
 `, drop: `
 split:180;rotate:90;scale:.95;x:sin(t);y:(1 + sin(t)) * cos(t) / 1.6
 `, fish: `
 split:240;x:cos(t) - sin(t)^2 / sqrt(2) - .04;y:sin(2t)/2
 `, whale: `
 split:240;rotate:180;R:3.4 * (sin(t)^2 - .5) * cos(t);x:cos(t) * R + .75;y:sin(t) * R * 1.2
 `, windmill: `
 split:18;R:seq(.618, 1, 0);T:seq(t-.55, t, t);x:R * cos(T);y:R * sin(T)
 `, vase: `
 split:240;scale:.3;x:sin(4t) + sin(t) * 1.4;y:cos(t) + cos(t) * 4.8 + .3
 `, clover: (I = 3) => ((I = J(I, 3, 5)) == 4 && (I = 2), `
 split:240;r:cos(${I}t);scale:.98
`), hypocycloid: (I = 3) => `
 split:240;scale:${[0.34, 0.25, 0.19][(I = J(I, 3, 5)) - 3]};k:${I};x:(k-1)*cos(t) + cos((k-1)*t);y:(k-1)*sin(t) - sin((k-1)*t)
`, bud: (I = 3) => `
 split:240;scale:.8;r:1 + .2 * cos(${I = J(I, 3, 10)}t)
` }, Vo = class {
    constructor(I, s, o) {
      this.x = I, this.y = s, this.extra = o;
    }
    valueOf() {
      return this.x + " " + this.y;
    }
    toString() {
      return this.valueOf();
    }
  };
  function Kd(I, s) {
    s || (s = (z) => [yg(z), vg(z)]);
    let o, r, u = I.split || 180, d = I.turn || 1, h = I.frame, G = I.fill || I["fill-rule"], V = Ud(I.direction || I.dir || ""), Z = I.unit, X = 2 * oc * d / u, W = [], S = I.scale === void 0 ? 1 : I.scale, F = ([z, q, M = 0, Q = 0]) => {
      if (z == "evenodd" || z == "nonzero") return W.push(new Vo(z, "", ""));
      let [et, lt] = Zo(z, -q, S), [it, P] = Zo(M, -Q, S), ct = function($, bt, ft, mt, Ut) {
        let Tt = 180 * po(bt + mt, $ - ft) / oc;
        return Ut.direction === "reverse" && (Tt -= 180), Ut.direction || (Tt = 90), Ut.angle && (Tt += Ut.angle), Tt;
      }(et, lt, it, P, V);
      Z !== void 0 && Z !== "%" ? Z !== "none" && (et += Z, lt += Z) : (et = 50 * (et + 1) + "%", lt = 50 * (lt + 1) + "%"), W.push(new Vo(et, lt, ct));
    };
    G != "nonzero" && G != "evenodd" || F([G, "", ""]);
    for (let z = 0; z < u; ++z) {
      let q = s(X * z, z);
      z || (o = q), F(q);
    }
    if (h !== void 0) {
      F(o);
      let z = h / 100;
      d > 1 && (z *= 2), z == 0 && (z = 2e-3);
      for (let q = 0; q < u; ++q) {
        let M = -X * q, [Q, et, lt = 0, it = 0] = s(M, q), P = po(et + it, Q - lt), ct = [Q - z * yg(P), et - z * vg(P)];
        q || (r = ct), F(ct);
      }
      F(r), F(o);
    }
    return W;
  }
  function Zo(I, s, o) {
    let [r, u = r] = vt(o).map(Number);
    return [I * r, s * u];
  }
  function _d(I, { min: s, max: o }) {
    let r = J(parseInt(I.vertices || I.points || I.split) || 0, s, o), u = O(I.x) ? "cos(t)" : I.x, d = O(I.y) ? "sin(t)" : I.y, h = O(I.r) ? "" : I.r, G = O(I.t) ? "" : I.t, { unit: V, value: Z } = hg(h);
    return V && !I[V] && V !== "t" && (O(I.unit) && (I.unit = V), h = I.r = Z), I.degree && (I.rotate = I.degree), I.origin && (I.move = I.origin), I.split = r, Kd(I, (X, W) => {
      let S = Object.assign({}, I, { t: G || X, θ: G || X, i: W + 1, seq: (...Q) => Q.length ? Q[W % Q.length] : "", range: (Q, et = 0) => ((Q = Number(Q) || 0) > (et = Number(et) || 0) && ([Q, et] = [et, Q]), Q + Pd(et - Q) / (r - 1) * W) }), F = Be(u, S), z = Be(d, S), q = 0, M = 0;
      if (h) {
        let Q = Be(h, S);
        Q == 0 && (Q = 1e-5), G && (X = Be(G, S)), F = Q * yg(X), z = Q * vg(X);
      }
      return I.rotate && ([F, z] = function(Q, et, lt) {
        let it = -oc / 180 * lt;
        return [Q * yg(it) - et * vg(it), et * yg(it) + Q * vg(it)];
      }(F, z, Number(I.rotate) || 0)), I.move && ([F, z, q, M] = function(Q, et, lt) {
        let [it, P = it] = vt(lt).map(Number);
        return [Q + (it || 0), et - (P || 0), it, P];
      }(F, z, I.move)), [F, z, q, M];
    });
  }
  function Xg(I, s = 3, o = 3600, r) {
    let u = "", [d, ...h] = vt(I), G = !1;
    switch (typeof lc[d]) {
      case "function":
        u = lc[d](...h), G = !0;
        break;
      case "string":
        u = lc[d], G = !0;
        break;
      default:
        u = I;
    }
    let V = Td(u);
    return typeof r == "function" && (V = r(V)), { rules: V, points: _d(V, { min: s, max: o }), preset: G };
  }
  var yo = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180];
  function an(I, s, o) {
    return s + I * (o - s);
  }
  function Me(I, s, o, r) {
    let u = 15 & I, d = u < 8 ? s : o, h = u < 4 ? o : u == 12 || u == 14 ? s : r;
    return (1 & u ? -d : d) + (2 & u ? -h : h);
  }
  var $d = class {
    constructor() {
      this.p = [].concat(yo, yo);
    }
    noise(I, s, o) {
      let { p: r } = this, [u, d, h] = [I, s, o].map((M) => 255 & Math.floor(M));
      [I, s, o] = [I, s, o].map((M) => M - Math.floor(M));
      let [G, V, Z] = [I, s, o].map((M) => M * M * M * (M * (6 * M - 15) + 10)), X = r[u] + d, W = r[X] + h, S = r[X + 1] + h, F = r[u + 1] + d, z = r[F] + h, q = r[F + 1] + h;
      return an(Z, an(V, an(G, Me(r[W], I, s, o), Me(r[z], I - 1, s, o)), an(G, Me(r[S], I, s - 1, o), Me(r[q], I - 1, s - 1, o))), an(V, an(G, Me(r[W + 1], I, s, o - 1), Me(r[z + 1], I - 1, s, o - 1)), an(G, Me(r[S + 1], I, s - 1, o - 1), Me(r[q + 1], I - 1, s - 1, o - 1))));
    }
  };
  function vo(I) {
    let s = 864e5, o = `${I}-animation`;
    return { name: I, ticks: s, "animation-name": o, animation: (r = "0s") => `86400000ms steps(10368000) ${r} infinite ${o}` };
  }
  var Ye = vo("cssd-utime"), Ue = vo("cssd-UTime"), rc = "cssd-umousex", ac = "cssd-umousey", Cc = "cssd-uwidth", uc = "cssd-uheight";
  function Xo(I) {
    return (...s) => {
      let o = [], r = [];
      for (let h of s) {
        let { unit: G, value: V } = hg(h);
        G !== void 0 && o.push(G), V !== void 0 && r.push(V);
      }
      let u = I(...r), d = o.find((h) => h !== void 0);
      return d === void 0 ? u : Array.isArray(u) ? u.map((h) => h + d) : u + d;
    };
  }
  function bc(I) {
    return (...s) => {
      let o = s.map((u) => String(u).charCodeAt(0)), r = I(...o);
      return Array.isArray(r) ? r.map((u) => String.fromCharCode(u)) : String.fromCharCode(r);
    };
  }
  function vi(I, s) {
    return { type: I, value: s };
  }
  function tG(I, s, o) {
    let r = 0, u = I, d = (V) => V > 0 && V < 1 ? 0.1 : 1, h = arguments.length;
    h == 1 && ([I, s] = [d(I), I]), h < 3 && (o = d(I));
    let G = [];
    for (; (o >= 0 && I <= s || o < 0 && I > s) && (G.push(I), I += o, !(r++ >= 65535)); ) ;
    return G.length || G.push(u), G;
  }
  var eG = Ac("build_range", (I) => function(o) {
    let r = String(o), u = [], d = [];
    if (!r.startsWith("[") || !r.endsWith("]")) return u;
    for (let h = 1; h < r.length - 1; ++h) {
      let G = r[h];
      if (G != "-" || r[h - 1] != "-") if (G != "-") if (nt(d) != "-") d.length && u.push(vi("char", d.pop())), d.push(G);
      else {
        d.pop();
        let V = d.pop();
        u.push(V ? vi("range", [V, G]) : vi("char", G));
      }
      else d.push(G);
    }
    return d.length && u.push(vi("char", d.pop())), u;
  }(I).flatMap(({ type: o, value: r }) => {
    if (o == "char") return r;
    let [u, d] = r, h = !1;
    u > d && ([u, d] = [d, u], h = !0);
    let G = bc(tG)(u, d);
    return h && G.reverse(), G;
  }));
  function xg(I) {
    return (...s) => I(...s.flatMap((o) => String(o).startsWith("[") ? eG(o) : o));
  }
  var nG = class {
    constructor(I) {
      this.prev = this.next = null, this.data = I;
    }
  }, gG = class {
    constructor(I = 20) {
      this._limit = I, this._size = 0;
    }
    push(I) {
      this._size >= this._limit && (this.root = this.root.next, this.root.prev = null);
      let s = new nG(I);
      this.root ? (s.prev = this.tail, this.tail.next = s, this.tail = s) : this.root = this.tail = s, this._size++;
    }
    last(I = 1) {
      let s = this.tail;
      for (; --I && s.prev; ) s = s.prev;
      return s.data;
    }
  };
  function xo(I, s) {
    let o = {}, r = !0;
    for (let u = 0; u < I.length; ++u) {
      let d = I[u], h = s[u];
      if (/=/.test(d)) {
        let [G, V] = vt(d, { symbol: "=", noSpace: !0 });
        V !== void 0 ? (s.includes(G) && (o[G] = V), r = !1) : o[h] = d;
      } else r && (o[h] = d);
    }
    return o;
  }
  function dc(I) {
    return j((s, o, ...r) => {
      if (!r || !o) return "";
      let u = D(o()), d = u;
      /\D/.test(u) && !/\d+[x-]\d+/.test(u) && (d = Be(u), d === 0 && (d = u));
      let h = Math.random();
      return function(G, V) {
        let [Z, X = 1] = String(G).split(/[x-]/), [W, S] = [Math.ceil(Z), Math.ceil(X)];
        E(W) && (W = 1), E(S) && (S = 1), Z = J(W, 0, 65536), X = J(S, 0, 65536);
        let F = Z * X, z = [], q = 1;
        if (/x/.test(G)) for (let M = 1; M <= X; ++M) for (let Q = 1; Q <= Z; ++Q) z.push(V(q, Q, M, F, Z, X, q)), q++;
        else if (/-/.test(G)) if (F = Math.abs(Z - X) + 1, Z <= X) for (let M = Z; M <= X; ++M) z.push(V(M, M, 1, F, F, 1, q++));
        else for (let M = Z; M >= X; --M) z.push(V(M, M, 1, F, F, 1, q++));
        else for (let M = 1; M <= Z; ++M) z.push(V(M, M, 1, Z, Z, 1, q++));
        return z;
      }(d, (...G) => r.map((V) => D(V(...G, h))).join(",")).join(I);
    });
  }
  function Cn(I, s, o) {
    return I[s] || (I[s] = new gG(1024)), I[s].push(o), o;
  }
  function Wo(I) {
    return -1 * I;
  }
  function fo(I, s, o) {
    switch (I) {
      case "+":
        return s + o;
      case "-":
        return s - o;
      case "*":
        return s * o;
      case "/":
        return s / o;
      case "%":
        return s % o;
      default:
        return 0;
    }
  }
  function Bo(I, s) {
    return [`calc(${I})`, s];
  }
  function iG(I, s) {
    if (O(s) || O(I)) return [];
    if (/^[\+\*\-\/%][\-\.\d\s]/.test(s)) {
      let o = s[0], { unit: r = "", value: u } = hg(s.substr(1).trim() || 0);
      return /var\(/.test(I) ? Bo(o === "%" ? `mod(${I}, ${u})` : `${I} ${o} ${u}`, r) : [fo(o, Number(I), Number(u)), r];
    }
    if (/[\+\*\-\/%]$/.test(s)) {
      let o = s.substr(-1), { unit: r = "", value: u } = hg(s.substr(0, s.length - 1).trim() || 0);
      return /var\(/.test(I) ? Bo(o === "%" ? `mod(${u}, ${I})` : `${u} ${o} ${I}`, r) : [fo(o, Number(u), Number(I)), r];
    }
    {
      let { unit: o = "", value: r } = hg(s || 0);
      return [Number(I) + Number(r), o];
    }
  }
  function st(I) {
    let s = "";
    return (...o) => {
      for (let r of o) {
        let [u, d] = iG(I, r);
        I = u, !s && d && (s = d);
      }
      return /^calc\(/.test(I) ? `calc(${I} * 1${s})` : I + s;
    };
  }
  var Sn = N({ i: ({ count: I }) => st(I), y: ({ y: I }) => st(I), x: ({ x: I }) => st(I), z: ({ z: I }) => st(I), I: ({ grid: I }) => st(I.count), Y: ({ grid: I }) => st(I.y), X: ({ grid: I }) => st(I.x), Z: ({ grid: I }) => st(I.z), iI: ({ count: I, grid: s }) => st(I / s.count), Ii: ({ count: I, grid: s }) => st((s.count - I + 1) / s.count), xX: ({ x: I, grid: s }) => st(I / s.x), Xx: ({ x: I, grid: s }) => st((s.x - I + 1) / s.x), yY: ({ y: I, grid: s }) => st(I / s.y), Yy: ({ y: I, grid: s }) => st((s.y - I + 1) / s.y), id: ({ x: I, y: s, z: o }) => (r) => U(I, s, o), dx: ({ x: I, grid: s }) => (o) => (o = Number(o) || 0, I - 0.5 - o - s.x / 2), dy: ({ y: I, grid: s }) => (o) => (o = Number(o) || 0, I - 0.5 - o - s.y / 2), n({ extra: I }) {
    let s = nt(I);
    return s ? st(s[0]) : "@n";
  }, nx({ extra: I }) {
    let s = nt(I);
    return s ? st(s[1]) : "@nx";
  }, ny({ extra: I }) {
    let s = nt(I);
    return s ? st(s[2]) : "@ny";
  }, nd({ extra: I }) {
    let s = nt(I);
    if (s) {
      let o = s[0], r = s[3];
      return (u) => (u = Number(u) || 0, o - 0.5 - u - r / 2);
    }
    return "@nd";
  }, N({ extra: I }) {
    let s = nt(I);
    return s ? st(s[3]) : "@N";
  }, nN({ extra: I }) {
    let s = nt(I);
    return s ? st(s[0] / s[3]) : "@nN";
  }, Nn({ extra: I }) {
    let s = nt(I);
    if (s) {
      let o = s[0], r = s[3];
      return st((r - o + 1) / r);
    }
    return "@Nn";
  }, m: dc(","), M: dc(" "), µ: dc(""), p: ({ context: I, pick: s }) => xg((...o) => {
    o.length || (o = I.last_pick_args || []);
    let r = s(o);
    return I.last_pick_args = o, Cn(I, "last_pick", r);
  }), P({ context: I, pick: s, position: o }) {
    let r = "P-counter" + o;
    return xg((...u) => {
      let d = !0;
      u.length || (u = I.last_pick_args || [], d = !1);
      let h = I.last_pick, G = h ? h.last(1) : "";
      if (d && (I[r] || (I[r] = {}), G = I[r].last_pick), u.length > 1) {
        let Z = u.findIndex((X) => X === G);
        Z !== -1 && u.splice(Z, 1);
      }
      let V = s(u);
      return I.last_pick_args = u, d && (I[r].last_pick = V), Cn(I, "last_pick", V);
    });
  }, pl({ context: I, extra: s, upextra: o, position: r }, u) {
    let d = nt(u && o.length ? o : s), h = (u ? "PL-counter" : "pl-counter") + r + (d ? nt(d) : "");
    return xg((...G) => {
      I[h] || (I[h] = 0), I[h] += 1;
      let V = G.length, Z = d && d[6];
      Z ?? (Z = I[h]);
      let X = G[(Z - 1) % V];
      return Cn(I, "last_pick", X);
    });
  }, PL: (I) => Sn.pl(I, !0), pr({ context: I, extra: s, upextra: o, position: r }, u) {
    let d = nt(u && o.length ? o : s), h = (u ? "PR-counter" : "pr-counter") + r + (d ? nt(d) : "");
    return xg((...G) => {
      I[h] || (I[h] = 0), I[h] += 1;
      let V = G.length, Z = d && d[6];
      Z ?? (Z = I[h]);
      let X = G[V - (Z - 1) % V - 1];
      return Cn(I, "last_pick", X);
    });
  }, PR: (I) => Sn.pr(I, !0), pd({ context: I, extra: s, upextra: o, position: r, shuffle: u }, d) {
    let h = nt(d && o.length ? o : s), G = h ? nt(h) : "", V = (d ? "PD-counter" : "pd-counter") + r + G, Z = (d ? "PD-valeus" : "pd-values") + r + G;
    return xg((...X) => {
      I[V] || (I[V] = 0), I[V] += 1, I[Z] || (I[Z] = u(X || []));
      let W = X.length, S = h && h[6];
      S ?? (S = I[V]);
      let F = (S - 1) % W, z = I[Z][F];
      return Cn(I, "last_pick", z);
    });
  }, PD: (I) => Sn.pd(I, !0), lp: ({ context: I }) => (s = 1) => {
    let o = I.last_pick;
    return o ? o.last(s) : "";
  }, r: ({ context: I, rand: s }) => (...o) => {
    let r = (o.length && o.every(R) ? bc : Xo)(s)(...o);
    return Cn(I, "last_rand", r);
  }, rn({ x: I, y: s, context: o, position: r, grid: u, extra: d, random: h }) {
    let G = "noise-2d" + r, V = G + "offset-x", Z = G + "offset-y", [X, W, S, F, z, q] = nt(d) || [], M = X && F;
    return (...Q) => {
      let { from: et = 0, to: lt = et, frequency: it = 1, scale: P = 1, octave: ct = 1 } = xo(Q, ["from", "to", "frequency", "scale", "octave"]);
      it = J(it, 0, 1 / 0), P = J(P, 0, 1 / 0), ct = J(ct, 1, 100), Q.length == 1 && ([et, lt] = [0, et]), o[G] || (o[G] = new $d()), o[V] || (o[V] = h()), o[Z] || (o[Z] = h());
      let $ = R(et) && R(lt) ? bc : Xo, bt = o[G], ft = o[V], mt = o[Z], Ut = (M ? (W - 1) / z : (I - 1) / u.x) + ft, Tt = (M ? (S - 1) / q : (s - 1) / u.y) + mt;
      (z <= 1 || u.x <= 1) && (Ut = 0), (q <= 1 || u.y <= 1) && (Tt = 0), Ut == 0 && Tt == 0 && (Ut = ft, Tt = mt);
      let Po = bt.noise(Ut * it, Tt * it, 0) * P;
      for (let Yg = 1; Yg < ct; ++Yg) {
        let Ng = 2 * Yg;
        Po += bt.noise(Ut * it * Ng, Tt * it * Ng, 0) * (P / Ng);
      }
      let pG = $((Yg, Ng) => function(VG, ZG, yG, vc = 1) {
        let Ko = Math.sqrt(0.5) * vc, [_o, vG] = [-Ko, Ko];
        return We((VG - _o) / (vG - _o), ZG * vc, yG * vc);
      }(Po, Yg, Ng, P));
      return Cn(o, "last_rand", pG(et, lt));
    };
  }, lr: ({ context: I }) => (s = 1) => {
    let o = I.last_rand;
    return o ? o.last(s) : "";
  }, stripe: () => (...I) => {
    let s, o = I.map(D), r = o.length, u = 0, d = [];
    if (!r) return "";
    o.forEach((G) => {
      let [V, Z] = vt(G);
      Z !== void 0 ? d.push(Z) : u += 1;
    });
    let h = d.length ? `(100% - ${d.join(" - ")}) / ${u}` : `100% / ${r}`;
    return o.map((G, V) => {
      if (d.length) {
        let [Z, X] = vt(G);
        return s = (s ? s + " + " : "") + (X !== void 0 ? X : h), `${Z} 0 calc(${s})`;
      }
      return `${G} 0 ${100 / r * (V + 1)}%`;
    }).join(",");
  }, calc: () => (I, s) => Be(D(I), s), hex: () => (I) => parseInt(D(I)).toString(16), svg: j((I, ...s) => {
    let o = s.map((r) => D(r())).join(",");
    return o.startsWith("<") || (o = Zi(mg(o))), Vi(uo(o));
  }), "svg-filter": j((I, ...s) => {
    let o = s.map((d) => D(d())), r = o.join(","), u = Mt("filter-");
    if (o.every((d) => /^[\-\d.]/.test(d) || /^(\w+)/.test(d) && !/[{}<>]/.test(d))) {
      let { frequency: d, scale: h, octave: G, seed: V = I.seed, blur: Z, erode: X, dilate: W } = xo(o, ["frequency", "scale", "octave", "seed", "blur", "erode", "dilate"]);
      if (r = `
 x:-20%;y:-20%;width:140%;height:140%;`, H(W) || (r += `
 feMorphology{operator:dilate;radius:${W};}`), H(X) || (r += `
 feMorphology{operator:erode;radius:${X};}`), H(Z) || (r += `
 feGaussianBlur{stdDeviation:${Z};}`), !H(d)) {
        let [S, F = S] = vt(d);
        G = G ? `numOctaves:${G};` : "", r += `
 feTurbulence{type:fractalNoise;baseFrequency:${S} ${F};seed:${V};${G}}`, h && (r += `
 feDisplacementMap{in:SourceGraphic;scale:${h};}`);
      }
    }
    return r.startsWith("<") || (r = Zi(mg(r, { type: "block", name: "filter" }))), Vi(uo(r).replace(/<filter([\s>])/, `<filter id="${u}"$1`), u);
  }), "svg-pattern": j((I, ...s) => {
    let o = s.map((r) => D(r())).join(",");
    return Vi(Zi(mg(`
 viewBox:0 0 1 1;preserveAspectRatio:xMidYMid slice;rect{width, height:100%;fill:defs pattern{${o}}}`)));
  }), "svg-polygon": j((I, ...s) => {
    let o = s.map((V) => D(V())).join(","), { rules: r, points: u } = Xg(o, 3, 65536, (V) => (delete V.frame, V.unit = "none", V["stroke-width"] ?? (V["stroke-width"] = 0.01), V.stroke ?? (V.stroke = "currentColor"), V.fill ?? (V.fill = "none"), V)), d = `points:${u};`, h = "", G = r.padding ?? Number(r["stroke-width"]) / 2;
    for (let V of Object.keys(r)) /^(stroke|fill|clip|marker|mask|animate|draw)/.test(V) && (h += `${V}:${r[V]};`);
    return Vi(Zi(mg(`
 viewBox:-1 -1 2 2 p ${G};polygon{${h} ${d}}`)));
  }), var: () => (I) => `var(${D(I)})`, ut: () => st(`var(--${Ye.name})`), ts: () => st(`calc(var(--${Ye.name}) / 1000)`), TS: () => st(`calc(var(--${Ue.name}) / 1000)`), UT: () => st(`var(--${Ue.name})`), uw: () => st(`var(--${Cc})`), uh: () => st(`var(--${uc})`), ux: () => st(`var(--${rc})`), uy: () => st(`var(--${ac})`), plot({ count: I, context: s, extra: o, position: r, grid: u }) {
    let d = nt(o);
    return (...h) => {
      let G = h.join(","), [V = I, Z, X, W = u.count] = d || [], { points: S } = Xg(G, 1, 65536, (F) => (delete F.fill, delete F["fill-rule"], delete F.frame, F.points = W, F));
      return S[V - 1];
    };
  }, Plot({ count: I, context: s, extra: o, position: r, grid: u }) {
    let d = nt(o);
    return (...h) => {
      let G = h.join(","), [V = I, Z, X, W = u.count] = d || [], { points: S } = Xg(G, 1, 65536, (F) => (delete F.fill, delete F["fill-rule"], delete F.frame, F.points = W, F.unit = F.unit || "none", F));
      return S[V - 1];
    };
  }, shape: () => Ac("shape-function", (...I) => {
    let s = I.join(","), { points: o } = Xg(s);
    return `polygon(${o.join(",")})`;
  }), doodle: () => (I) => I, shaders: () => (I) => I, pattern: () => (I) => I, invert: () => (I) => {
    let s = pi(I);
    return s.valid ? s.commands.map(({ name: o, value: r }) => {
      switch (o) {
        case "v":
          return "h" + r.join(" ");
        case "V":
          return "H" + r.join(" ");
        case "h":
          return "v" + r.join(" ");
        case "H":
          return "V" + r.join(" ");
        default:
          return o + r.join(" ");
      }
    }).join(" ") : I;
  }, flipH: () => (I) => {
    let s = pi(I);
    return s.valid ? s.commands.map(({ name: o, value: r }) => {
      switch (o) {
        case "h":
        case "H":
          return o + r.map(Wo).join(" ");
        default:
          return o + r.join(" ");
      }
    }).join(" ") : I;
  }, flipV: () => (I) => {
    let s = pi(I);
    return s.valid ? s.commands.map(({ name: o, value: r }) => {
      switch (o) {
        case "v":
        case "V":
          return o + r.map(Wo).join(" ");
        default:
          return o + r.join(" ");
      }
    }).join(" ") : I;
  }, flip(...I) {
    let s = Sn.flipH(...I), o = Sn.flipV(...I);
    return (r) => o(s(r));
  }, reverse: () => (...I) => {
    let s = I.map(D), o = pi(s.join(","));
    if (o.valid) {
      let r = [];
      for (let u = o.commands.length - 1; u >= 0; --u) {
        let { name: d, value: h } = o.commands[u];
        r.push(d + h.join(" "));
      }
      return r.join(" ");
    }
    return s.reverse();
  }, cycle: () => (...I) => {
    let s, o = [];
    (I = I.map((d) => "<" + d + ">")).length == 1 ? (s = " ", o = vt(I[0], { symbol: s })) : (s = ",", o = vt(I.map(D).join(s), { symbol: s })), o = o.map((d) => d.replace(/^\<|>$/g, ""));
    let r = o.length - 1, u = [o.join(s)];
    for (let d = 0; d < r; ++d) {
      let h = o.shift();
      o.push(h), u.push(o.join(s));
    }
    return u;
  }, mirror: () => (...I) => {
    for (let s = I.length - 1; s >= 0; --s) I.push(I[s]);
    return I;
  }, Mirror: () => (...I) => {
    for (let s = I.length - 2; s >= 0; --s) I.push(I[s]);
    return I;
  }, code: () => (...I) => I.map((s) => String.fromCharCode(s)), once: j(({ context: I, extra: s, position: o }, ...r) => {
    let u = "once-counter" + o;
    return I[u] ?? (I[u] = r.map((d) => D(d())).join(","));
  }), raw: ({ rules: I }) => (s = "") => {
    try {
      let o = s.substring(s.indexOf(",") + 1, s.lastIndexOf('")'));
      if (s.startsWith("${doodle") && s.endsWith("}")) {
        let r = s.substring(2, s.length - 1), u = I.doodles;
        if (u && u[r]) return `<css-doodle>${u[r].doodle}</css-doodle>`;
      }
      if (s.startsWith('url("data:image/svg+xml;utf8')) return decodeURIComponent(o);
      if (s.startsWith('url("data:image/svg+xml;base64')) return atob(o);
      if (s.startsWith('url("data:image/png;base64')) return `<img src="${s}" alt="" />`;
    } catch {
    }
    return s;
  } }, { index: "i", col: "x", row: "y", depth: "z", rand: "r", pick: "p", pn: "pl", pnr: "pr", PN: "PL", PNR: "PR", R: "rn", T: "UT", t: "ut", stripes: "stripe", strip: "stripe", patern: "pattern", flipv: "flipV", fliph: "flipH", filter: "svg-filter", "last-rand": "lr", "last-pick": "lp", multiple: "m", multi: "m", rep: "µ", repeat: "µ", ms: "M", s: "I", size: "I", sx: "X", "size-x": "X", "size-col": "X", "max-col": "X", sy: "Y", "size-y": "Y", "size-row": "Y", "max-row": "Y", sz: "Z", "size-z": "Z", "size-depth": "Z", Svg: "svg", "pick-by-turn": "pl", "pick-n": "pl", "pick-d": "pd", offset: "plot", Offset: "Plot", point: "plot", Point: "Plot", unicode: "code" }), Yo = Sn, No = { a0: [841, 1189], a1: [594, 841], a2: [420, 594], a3: [297, 420], a4: [210, 297], a5: [148, 210], a6: [105, 148], b0: [1e3, 1414], b1: [707, 1e3], b2: [500, 707], b3: [353, 500], b4: [250, 353], b5: [176, 250], b6: [125, 176], c0: [917, 1297], c1: [648, 917], c2: [458, 648], c3: [324, 458], c4: [229, 324], c5: [162, 229], d0: [764, 1064], d1: [532, 760], d2: [380, 528], d3: [264, 376], d4: [188, 260], d5: [130, 184], d6: [92, 126], letter: [216, 279], postcard: [100, 148], poster: [390, 540] }, IG = { portrait: "p", pt: "p", p: "p", landscape: "l", ls: "l", l: "l" }, Jo = "--_cell-width", Ro = "--_cell-height", cG = { center: "50%", left: "0%", right: "100%", top: "50%", bottom: "50%" }, AG = { center: "50%", top: "0%", bottom: "100%", left: "50%", right: "50%" }, Xi = N({ size(I, { is_special_selector: s, grid: o }) {
    let [r, u = r, d] = vt(I);
    No[r] && ([r, u] = function(G, V) {
      G = String(G).toLowerCase();
      let [Z, X] = No[G] ?? [];
      return IG[V] == "p" && ([X, Z] = [Z, X]), [X, Z].map((W) => W + "mm");
    }(r, u));
    let h = `width:${r};height:${u};`;
    return r !== "auto" && u !== "auto" || (d && (/^\(.+\)$/.test(d) ? d = d.substring(1, d.length - 1) : /^calc/.test(d) || (d = `calc(${d})`), s || (h += `aspect-ratio:${d};`)), s && (h += `aspect-ratio:${d || o.ratio};`)), s || (h += `${Jo}:${r};${Ro}:${u};`), h;
  }, place(I, { extra: s }) {
    let [o, r = "50%"] = vt(I);
    o = cG[o] || o, r = AG[r] || r;
    let u = `var(${Jo}, 25%)`, d = `var(${Ro}, 25%)`;
    return `
 position:absolute;left:${o};top:${r};width:${u};height:${d};margin-left:calc(${u} / -2);margin-top:calc(${d} / -2);grid-area:unset;--plot-angle:${s || 0};rotate:${s || 0}deg;`;
  }, grid(I, s) {
    let o = { clip: !0, p3d: !1 }, r = [], u = 0;
    for (let h of vt(I, { symbol: " " })) u || o.grid || h !== "|" && h !== "-" ? /border:?/i.test(h) ? o.border = h.split(":")[1] || "" : /^no\-*clip$/i.test(h) ? o.clip = !1 : /^p3d$/i.test(h) ? o.p3d = !0 : r.push(h) : (o.grid = Rn(I, s.max_grid), h === "|" && (o.flexCol = !0), h === "-" && (o.flexRow = !0)), u += 1;
    let d = vt(r.join(" "), { symbol: ["/", "+", "^", "*", "~", "∆", "_"], noSpace: !0, verbose: !0 });
    for (let { group: h, value: G } of d) {
      if (h === "+" && (o.scale = G), h === "^" && (o.enlarge = G), h === "~" && (o.translate = G), h === "∆" && (o.persp = vt(G, { symbol: " " })), h === "_" && (o.gap = G), h === "*") {
        let [V, ...Z] = vt(G, { symbol: " " });
        V == "h" ? o.hueRotate = Z.join(" ") : o.rotate = G;
      }
      h === "/" && (o.size === void 0 ? o.size = this.size(G, s) : o.fill = G), h !== "" || o.grid || (o.grid = Rn(G, s.max_grid));
    }
    return o;
  }, gap: (I) => I, seed: (I) => I, shape: Ac("shape-property", (I) => {
    let { points: s, preset: o } = Xg(I);
    return o ? `clip-path:polygon(${s.join(",")});` : "";
  }), use(I) {
    if (I.length > 2) return I;
  }, content: (I) => I }, { "place-cell": "place", offset: "place", position: "place" });
  function So(I, s) {
    return s === "+" ? I : s === "-" ? -1 * I : I;
  }
  function Fo(I) {
    return I.reduce((s, o) => s + o, 0);
  }
  function Gc(I) {
    return I % 2;
  }
  function Ho(I) {
    return !Gc(I);
  }
  function mc(I) {
    let s = "";
    return s = I == 0 ? "$:hover" : I > 0 ? `$:hover ${"+*".repeat(I)}` : `:has(+ ${"*+".repeat(Math.abs(I + 1))} $:hover)`, s;
  }
  function hc(I, s) {
    if (I === "even") return Ho(s);
    if (I === "odd") return Gc(s);
    if (I == "n") return !0;
    let { a: o, b: r, error: u } = function(d) {
      let h, G, V = g(p(d)), Z = [], X = [];
      for (; V.next(); ) {
        let { prev: W, curr: S, next: F } = V.get(), z = S.value;
        if (S.isSymbol()) {
          if (z !== "+" && z !== "-") {
            G = "Unexpected " + S.value;
            break;
          }
          h = z;
        } else if (S.isNumber()) {
          if ((Z.length || X.length) && !h) {
            G = "Syntax error";
            break;
          }
          if (z = So(Number(z), h), h = null, F && F.value === "n") {
            Z.push(z), V.next();
            continue;
          }
          X.push(z);
        } else if (z === "n") {
          if ((Z.length || X.length) && !h) {
            G = "Syntax error";
            break;
          }
          Z.push(So(1, h)), h = null;
        } else if (!S.isSpace()) {
          G = "Unexpected " + z;
          break;
        }
      }
      return G ? { a: 0, b: 0, error: G } : { a: Fo(Z), b: Fo(X) };
    }(I);
    if (u) return !1;
    if (o === 0) return s === r;
    {
      let d = (s - r) / o;
      return d >= 0 && Number.isInteger(d);
    }
  }
  var wo, sG = N({ at: ({ x: I, y: s }) => (o, r) => I == o && s == r, nth: ({ count: I, grid: s }) => (...o) => {
    for (let r of o) if (hc(r, I)) return !0;
  }, y: ({ y: I, grid: s }) => (...o) => {
    for (let r of o) if (hc(r, I)) return !0;
  }, x: ({ x: I, grid: s }) => (...o) => {
    for (let r of o) if (hc(r, I)) return !0;
  }, even: ({ x: I, y: s }) => (o) => Gc(I + s), odd: ({ x: I, y: s }) => (o) => Ho(I + s), random: ({ random: I, count: s, x: o, y: r, grid: u }) => (d = 0.5) => /\D/.test(d) ? I() < Be("(" + d + ")", { x: o, X: u.x, y: r, Y: u.y, i: s, I: u.count, random: I }) : I() < d, match: ({ count: I, grid: s, x: o, y: r, random: u }) => (d) => !!Be("(" + d + ")", { x: o, X: s.x, y: r, Y: s.y, i: I, I: s.count, random: u }), hover: ({ count: I, x: s, y: o, grid: r, random: u }) => (...d) => {
    let h = [];
    d.length || h.push(mc(0));
    for (let G of d) {
      let [V, Z] = String(G).split(/\s+/);
      if (V = Number(V), Z = Number(Z), Number.isNaN(Z) && !Number.isNaN(V) && h.push(mc(V)), !Number.isNaN(V) && !Number.isNaN(Z)) {
        let X = V + s, W = Z + o;
        if (X >= 1 && X <= r.x && W >= 1 && W <= r.y) {
          let S = Z * r.y + V;
          h.push(mc(S));
        }
      }
    }
    return !!h.length && { selector: h.join(",") };
  } }, { col: "x", row: "y" }), Wg = globalThis, fg = Math, xi = [], Ce = 256, oG = fg.pow(Ce, 6), zo = fg.pow(2, 52), lG = 2 * zo, un = Ce - 1;
  function rG(I) {
    var s, o = I.length, r = this, u = 0, d = r.i = r.j = 0, h = r.S = [];
    for (o || (I = [o++]); u < Ce; ) h[u] = u++;
    for (u = 0; u < Ce; u++) h[u] = h[d = un & d + I[u % o] + (s = h[u])], h[d] = s;
    (r.g = function(G) {
      for (var V, Z = 0, X = r.i, W = r.j, S = r.S; G--; ) V = S[X = un & X + 1], Z = Z * Ce + S[un & (S[X] = S[W = un & W + V]) + (S[W] = V)];
      return r.i = X, r.j = W, Z;
    })(Ce);
  }
  function qo(I, s) {
    return s.i = I.i, s.j = I.j, s.S = I.S.slice(), s;
  }
  function Do(I, s) {
    var o, r = [], u = typeof I;
    if (s && u == "object") for (o in I) try {
      r.push(Do(I[o], s - 1));
    } catch {
    }
    return r.length ? r : u == "string" ? I : I + "\0";
  }
  function pc(I, s) {
    for (var o, r = I + "", u = 0; u < r.length; ) s[un & u] = un & (o ^= 19 * s[un & u]) + r.charCodeAt(u++);
    return Bg(s);
  }
  function Bg(I) {
    return String.fromCharCode.apply(0, I);
  }
  pc(fg.random(), xi);
  var Wi = function(I, s, o) {
    var r = [], u = pc(Do((s = s == 1 ? { entropy: !0 } : s || {}).entropy ? [I, Bg(xi)] : I ?? function() {
      try {
        var G;
        return wo && (G = wo.randomBytes) ? G = G(Ce) : (G = new Uint8Array(Ce), (Wg.crypto || Wg.msCrypto).getRandomValues(G)), Bg(G);
      } catch {
        var V = Wg.navigator, Z = V && V.plugins;
        return [+/* @__PURE__ */ new Date(), Wg, Z, Wg.screen, Bg(xi)];
      }
    }(), 3), r), d = new rG(r), h = function() {
      for (var G = d.g(6), V = oG, Z = 0; G < zo; ) G = (G + Z) * Ce, V *= Ce, Z = d.g(1);
      for (; G >= lG; ) G /= 2, V /= 2, Z >>>= 1;
      return (G + Z) / V;
    };
    return h.int32 = function() {
      return 0 | d.g(4);
    }, h.quick = function() {
      return d.g(4) / 4294967296;
    }, h.double = h, pc(Bg(d.S), xi), (s.pass || o || function(G, V, Z, X) {
      return X && (X.S && qo(X, d), G.state = function() {
        return qo(d, {});
      }), Z ? (fg.random = G, V) : G;
    })(h, u, "global" in s ? s.global : this == fg, s.state);
  }, aG = (/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0) - Date.now();
  function Ne(I) {
    return /^\:(host|doodle)/.test(I);
  }
  function fi(I) {
    return /^\:container/.test(I);
  }
  function Vc(I) {
    return Ne(I) || fi(I);
  }
  var Lo = {};
  for (let I of Object.getOwnPropertyNames(Math)) Lo[I] = () => (...s) => typeof Math[I] == "number" ? Math[I] : (s = s.map((o) => Be(D(o))), Math[I](...s));
  var CG = class {
    constructor(I) {
      this.tokens = I, this.rules = {}, this.props = {}, this.keyframes = {}, this.grid = null, this.seed = null, this.is_grid_set = !1, this.is_gap_set = !1, this.coords = [], this.doodles = {}, this.pattern = {}, this.shaders = {}, this.vars = {}, this.uniforms = {}, this.content = {}, this.reset();
    }
    reset() {
      this.styles = { host: "", container: "", cells: "", keyframes: "" }, this.coords = [], this.doodles = {}, this.pattern = {}, this.shaders = {}, this.content = {};
      for (let I in this.rules) I.startsWith("#c") && delete this.rules[I];
    }
    add_rule(I, s) {
      let o = this.rules[I];
      o || (o = this.rules[I] = []), o.push.apply(o, At(s));
    }
    pick_func(I) {
      return I.startsWith("$") && (I = "calc"), Yo[I] || Lo[I];
    }
    apply_func(I, s, o, r, u = {}) {
      let d = I(...At(s)), h = [];
      if (o.forEach((G) => {
        let V = typeof G.value;
        if (G.cluster || V !== "number" && V !== "string") {
          if (typeof G == "function") h.push(G);
          else if (!H(G.value)) {
            let Z = D(G.value);
            h.push(Z);
          }
        } else h.push(...vt(G.value, { noSpace: !0 }));
      }), h = At(h.filter((G) => !H(G) && String(G).trim().length)), typeof d == "function") {
        if (r.startsWith("$")) {
          let G = Object.assign({}, this.vars.host, this.vars.container, this.vars[s.count], u), V = {}, Z = "";
          for (let [X, W] of Object.entries(G)) V[X.substr(2)] = W;
          return r.length > 1 && (Z = r.split("$")[1] ?? ""), d(h, V) + Z;
        }
        return d(...h);
      }
      return d;
    }
    compose_aname(...I) {
      return I.join("-");
    }
    compose_selector({ x: I, y: s, z: o }, r = "") {
      return `#${U(I, s, o)}${r}`;
    }
    is_composable(I) {
      return ["doodle", "shaders", "pattern"].includes(I);
    }
    read_var(I, s, o) {
      let r = s.count, u = Object.assign({}, this.vars.host, this.vars.container, this.vars[r], o);
      if (u[I] !== void 0) {
        let d = String(u[I]).trim();
        return d[0] == "(" && d[d.length - 1] === ")" && (d = d.substring(1, d.length - 1)), d.replace(/;+$/g, "");
      }
      return I;
    }
    compose_argument(I, s, o = [], r, u) {
      s.extra || (s.extra = []), s.extra.push(o);
      let d = I.map((h) => {
        if (h.type === "text") return /^\-\-\w/.test(h.value) ? r && r.name === "@var" ? h.value : this.read_var(h.value, s, u) : h.value;
        if (h.type === "func") {
          let G = h.name.substr(1), V = this.pick_func(G);
          if (typeof V == "function") {
            if (this.check_uniforms(G), this.is_composable(G)) {
              let X, W = D((h.arguments[0] || [])[0]);
              if (G === "doodle" && /^\d/.test(W) && (X = W, W = D((h.arguments[1] || [])[0])), !H(W)) switch (G) {
                case "doodle":
                  return this.compose_doodle(this.inject_variables(W, s.count), X, structuredClone(s.extra));
                case "shaders":
                  return this.compose_shaders(W, s);
                case "pattern":
                  return this.compose_pattern(W, s);
              }
            }
            s.position = h.position;
            let Z = h.arguments.map((X) => V.lazy ? (...W) => this.compose_argument(X, s, W, h, u) : this.compose_argument(X, s, o, h, u));
            return this.apply_func(V, s, Z, G, u);
          }
          return h.name;
        }
      });
      return s.extra.pop(), { cluster: I.cluster, value: d.length >= 2 ? { value: d.join("") } : d[0] };
    }
    compose_doodle(I, s, o) {
      let r = Mt("doodle");
      return this.doodles[r] = { doodle: I, arg: s, upextra: o }, "${" + r + "}";
    }
    compose_shaders(I, { x: s, y: o, z: r }) {
      let u = Mt("shader");
      return this.shaders[u] = { shader: I, id: "--" + u, cell: U(s, o, r) }, "${" + u + "}";
    }
    compose_pattern(I, { x: s, y: o, z: r }) {
      let u = Mt("pattern");
      return this.pattern[u] = { code: I, id: "--" + u, cell: U(s, o, r) }, "${" + u + "}";
    }
    check_uniforms(I) {
      switch (I) {
        case "ut":
        case "UT":
        case "t":
        case "T":
        case "ts":
        case "TS":
          this.uniforms.time = !0;
          break;
        case "ux":
          this.uniforms.mousex = !0;
          break;
        case "uy":
          this.uniforms.mousey = !0;
          break;
        case "uw":
          this.uniforms.width = !0;
          break;
        case "uh":
          this.uniforms.height = !0;
      }
    }
    inject_variables(I, s) {
      let o = Object.assign({}, this.vars.host, this.vars.container, this.vars[s]), r = [];
      for (let [u, d] of Object.entries(o)) r.push(`${u}:${d};`);
      return r = r.join(""), r.length ? `:doodle{${r}}` + I : I;
    }
    compose_variables(I, s, o = {}) {
      for (let [r, u] of Object.entries(I)) o[r] = this.get_composed_value(u, s, o).value;
      return o;
    }
    compose_value(I, s, o = {}) {
      if (!Array.isArray(I)) return { value: "", extra: "" };
      let r = "";
      return { value: I.reduce((u, d) => {
        switch (d.type) {
          case "text":
            u += d.value;
            break;
          case "func": {
            let h = d.name.substr(1), G = this.pick_func(h);
            if (typeof G == "function") if (this.check_uniforms(h), this.is_composable(h)) {
              let V, Z = D((d.arguments[0] || [])[0]);
              if (h === "doodle" && /^\d/.test(Z) && (V = Z, Z = D((d.arguments[1] || [])[0])), !H(Z)) switch (h) {
                case "doodle":
                  u += this.compose_doodle(this.inject_variables(Z, s.count), V, structuredClone(s.extra));
                  break;
                case "shaders":
                  u += this.compose_shaders(Z, s);
                  break;
                case "pattern":
                  u += this.compose_pattern(Z, s);
              }
            } else {
              s.position = d.position, d.variables && this.compose_variables(d.variables, s, o);
              let V = d.arguments.map((X) => G.lazy ? (...W) => this.compose_argument(X, s, W, d, o) : this.compose_argument(X, s, [], d, o)), Z = this.apply_func(G, s, V, h, o);
              H(Z) || (u += Z, Z.extra && (r = Z.extra));
            }
            else u += d.name;
          }
        }
        return u;
      }, ""), extra: r };
    }
    get_composed_value(I, s, o) {
      let r, u = [];
      return Array.isArray(I) && (u = I.reduce((d, h) => {
        let G = this.compose_value(h, s, o || {});
        return G && (G.value && d.push(G.value), G.extra && (r = G.extra)), d;
      }, [])), { extra: r, group: u, value: u.join(",") };
    }
    add_grid_style({ fill: I, clip: s, rotate: o, hueRotate: r, scale: u, translate: d, enlarge: h, skew: G, persp: V, flexRow: Z, flexCol: X, p3d: W, border: S, gap: F }) {
      if (I && this.add_rule(":host", `background:${I};`), s || this.add_rule(":host", "contain:none;"), o && (/[0-9]$/.test(o) && (o += "deg"), this.add_rule(":container", `rotate:${o};`)), r && (/[0-9]$/.test(r) && (r += "deg"), this.add_rule(":host", `filter:hue-rotate(${r});`)), u && this.add_rule(":container", `scale:${u};`), d && this.add_rule(":container", `translate:${d};`), V) {
        let [z, ...q] = V;
        this.add_rule(":container", `perspective:${z};`), q.length && this.add_rule(":container", `perspective-origin:${q.join(" ")};`);
      }
      if (h && this.add_rule(":container", `
 width:calc(${h} * 100%);height:calc(${h} * 100%);left:50%;top:50%;transform-origin:0 0;transform:translate(-50%, -50%);`), Z && (this.add_rule(":container", "display:flex;"), this.add_rule("cell", "flex:1;")), X && (this.add_rule(":container", "display:flex;flex-direction:column;"), this.add_rule("cell", "flex:1;")), W) {
        let z = "transform-style:preserve-3d;";
        this.add_rule(":host", z), this.add_rule(":container", z);
      }
      S !== void 0 && this.add_rule(":host", `border:1px solid ${S};`), F && this.add_rule(":container", `gap:${F};`);
    }
    compose_rule(I, s, o) {
      let r = Object.assign({}, s), u = I.property;
      if (u === "@seed") return "";
      let d = this.get_composed_value(I.value, r), h = d.extra, G = d.value;
      if (/^animation(\-name)?$/.test(u)) {
        if (this.props.has_animation = !0, Ne(o)) {
          let Z = Ye.n + "," + Ue.n;
          Z && G && (G = Z + "," + G);
        }
        if (r.count > 1) {
          let { count: Z } = r;
          switch (u) {
            case "animation-name":
              G = d.group.map((X) => this.compose_aname(X, Z)).join(",");
              break;
            case "animation":
              G = d.group.map((X) => {
                let W = (X || "").split(/\s+/);
                return W[0] = this.compose_aname(W[0], Z), W.join(" ");
              }).join(",");
          }
        }
      }
      if (u === "content") {
        /["']|^none\s?$|^(var|counter|counters|attr|url)\(/.test(G) || (G = `'${G}'`);
        let Z = /* @__PURE__ */ new Map();
        return G = G.replace(/var\(\-\-cssd\-u(time|mousex|mousey|width|height)\)/gi, (X, W) => (Z.set(W, `${W} calc(${X})`), `counter(${W})`)), `
 ${Z.size ? `counter-reset:${Array.from(Z.values()).join(" ")};` : ""} content:${G};`;
      }
      u === "transition" && (this.props.has_transition = !0);
      let V = `${u}:${G};`;
      if (u !== "width" && u !== "height" || Vc(o) || (V += `--_cell-${u}:${G};`), /^background(\-image)?$/.test(u) && /\$\{(shader|pattern)/.test(G) && (V += "background-size:100% 100%;"), /^\-\-/.test(u) && this.compose_vars(s, o, u, G), /^@/.test(u) && Xi[u.substr(1)]) {
        let Z = u.substr(1), X = Xi[Z](G, { is_special_selector: Vc(o), grid: r.grid, max_grid: r.max_grid, extra: h });
        switch (Z) {
          case "grid":
            Ne(o) ? (V = X.size || "", this.add_grid_style(X)) : (V = "", this.is_grid_set || (X = Xi[Z](G, { is_special_selector: !0, grid: r.grid, max_grid: r.max_grid }), this.add_rule(":host", X.size || ""), this.add_grid_style(X))), this.grid = r.grid, this.is_grid_set = !0;
            break;
          case "gap":
            V = "", this.is_gap_set || (this.add_rule(":container", `gap:${X};`), this.is_gap_set = !0);
            break;
          case "content": {
            V = "";
            let W = this.compose_selector(r);
            X === void 0 || /\:before|\:after/.test(o) || fi(o) || (this.content[W] = function(S) {
              return S.startsWith('"') && S.endsWith('"') || S.startsWith("'") && S.endsWith("'") ? S.substring(1, S.length - 1) : S;
            }(String(X))), this.content[W] = Yo.raw({ rules: { doodles: this.doodles } })(this.content[W] || "");
          }
          case "seed":
            V = "";
            break;
          case "place-cell":
          case "place":
          case "position":
          case "offset":
            Ne(o) || (V = X);
            break;
          case "use":
            I.value.length && this.compose(r, I.value), V = "";
            break;
          default:
            V = X;
        }
      }
      return /^grid/.test(u) && Ne(o) && (this.add_rule(":container", `${u}:${G};`), V = ""), V;
    }
    get_raw_value(I) {
      let s = I.raw() ?? "", [o, ...r] = s.split(I.property);
      return r = r.join(I.property).replace(/^\s*:\s*/, "").replace(/[;}<]$/, "").trim().replace(/[;}<]$/, ""), r;
    }
    compose_vars(I, s, o, r) {
      let u = I.count;
      fi(s) && (u = "container"), Ne(s) && (u = "host"), this.vars[u] || (this.vars[u] = {}), this.vars[u][o] = r;
    }
    pre_compose_rule(I, s, o) {
      let r = Object.assign({}, s), u = I.property, d = Object.assign({}, this.vars.host, this.vars.container, this.vars[r.count]);
      if (/^\-\-/.test(u)) {
        let h = this.get_composed_value(I.value, r, d).value;
        this.compose_vars(s, o, u, h);
      }
      switch (u) {
        case "@grid": {
          let h = this.get_composed_value(I.value, r, d).value, G = u.substr(1), V = Xi[G](h, { max_grid: s.max_grid });
          this.grid = V.grid;
          break;
        }
        case "@use":
          I.value.length && this.pre_compose(r, I.value);
      }
    }
    pre_compose(I, s) {
      H(this.seed) && ((s || this.tokens).forEach((o) => {
        if (o.type === "rule" && o.property === "@seed" && (this.seed = this.get_raw_value(o)), o.type === "pseudo" && Ne(o.selector)) for (let r of At(o.styles)) r.type === "rule" && r.property === "@seed" && (this.seed = this.get_raw_value(r));
      }), H(this.seed) ? I.upextra.length || (this.seed = I.seed_value) : I.update_random(this.seed)), (s || this.tokens).forEach((o) => {
        switch (o.type) {
          case "rule":
            this.pre_compose_rule(o, I);
            break;
          case "pseudo":
            Ne(o.selector) && (o.styles || []).forEach((r) => {
              this.pre_compose_rule(r, I, r.selector);
            });
        }
      });
    }
    compose(I, s, o) {
      this.coords.push(I), (s || this.tokens).forEach((r, u) => {
        if (r.skip || o && this.grid || r.property === "@gap" && this.is_gap_set || r.property === "@grid" && this.is_grid_set) return !1;
        switch (r.type) {
          case "rule":
            this.add_rule(this.compose_selector(I), this.compose_rule(r, I));
            break;
          case "pseudo": {
            r.selector.startsWith(":doodle") && (r.selector = r.selector.replace(/^\:+doodle/, ":host"));
            let d = Vc(r.selector);
            d && (r.skip = !0), vt(r.selector).forEach((h) => {
              let G = r.styles.map((Z) => this.compose_rule(Z, I, h)), V = d ? h : this.compose_selector(I, h);
              this.add_rule(V, G);
            });
            break;
          }
          case "cond": {
            let d = r.name.substr(1), h = sG[d], G = [];
            if (h) {
              let V = r.segments.find((X) => X.arguments);
              V && V.arguments && (G = V.arguments.map((X) => this.compose_argument(X, I)));
              let Z = this.apply_func(h, I, G, d);
              r.segments && r.segments[0] && r.segments[0].keyword === "not" && (Z = !Z), Z && (Z.selector ? r.styles.forEach((X) => {
                X.type === "rule" && this.add_rule(Z.selector.replaceAll("$", this.compose_selector(I)), this.compose_rule(X, I)), X.type === "pseudo" && X.selector.split(",").forEach((W) => {
                  let S = X.styles.map((F) => this.compose_rule(F, I, W));
                  this.add_rule((Z.selector + W).replaceAll("$", this.compose_selector(I)), S);
                });
              }) : this.compose(I, r.styles));
            } else {
              let V = r.name + " " + r.segments.map((X) => X.keyword ? X.keyword : Array.isArray(X.arguments) ? "(" + X.arguments[0][0].value + ")" : "").join(" "), Z = "";
              r.styles.forEach((X) => {
                X.type === "rule" && (Z += `${V}{${this.compose_rule(X, I)}}`), X.type === "pseudo" && X.name.split(",").forEach((W) => {
                  let S = X.styles.map((F) => this.compose_rule(F, I, W));
                  Z += `${(cond.selector + W).replaceAll("$", this.compose_selector(I))}{${S}}`;
                });
              }), this.add_rule(this.compose_selector(I), Z);
            }
            break;
          }
          case "keyframes":
            this.keyframes[r.name] || (this.keyframes[r.name] = (d) => `
 ${Wt(r.steps.map((h) => `
 ${this.get_composed_value(h.name, d).value}{${Wt(h.styles.map((G) => this.compose_rule(G, d)))}}`))}`);
        }
      });
    }
    output() {
      for (let [d, h] of Object.entries(this.rules)) if (fi(d)) {
        let G = d.replace(/^:container\(?/, "grid").replace(/\)?$/, "");
        this.styles.container += `${G}{${Wt(h)}}`;
      } else {
        let G = Ne(d) ? "host" : "cells", V = Wt(h).trim();
        if (V.length) {
          let Z = G === "host" ? `${d},.host` : d;
          this.styles[G] += `${Z}{${V}}`;
        }
      }
      if (this.uniforms.time) {
        let d = "animation-name", h = Ye.ticks, G = Ye.name, V = Ue.name;
        this.styles.container += `
:host,.host{animation:${Ye.animation()},${Ue.animation(aG + "ms")};}`, this.styles.keyframes += `
 @keyframes ${Ye[d]}{from{--${G}:0} to{--${G}:${h}}} @keyframes ${Ue[d]}{from{--${V}:0} to{--${V}:${h}}}`;
      }
      this.coords.forEach((d, h) => {
        for (let [G, V] of Object.entries(this.keyframes)) {
          let Z = this.compose_aname(G, d.count);
          this.styles.keyframes += `
 ${h === 0 ? `@keyframes ${G}{${V(d)}}` : ""} @keyframes ${Z}{${V(d)}}`;
        }
      });
      let { keyframes: I, host: s, container: o, cells: r } = this.styles, u = I + s + o;
      return { props: this.props, styles: { main: u, cells: r, all: u + r }, grid: this.grid, seed: this.seed, random: this.random, doodles: this.doodles, shaders: this.shaders, pattern: this.pattern, uniforms: this.uniforms, content: this.content };
    }
  };
  function ko(I, s, o, r, u, d = []) {
    let h = new CG(I), G = u || Wi(String(o)), V = {};
    function Z(z = 0, q = 1) {
      return arguments.length == 1 && ([z, q] = [0, z]), We(G(), z, q);
    }
    function X(...z) {
      let q = z.reduce((M, Q) => M.concat(Q), []);
      return q[~~(G() * q.length)];
    }
    function W(z) {
      let q = [...z], M = z.length;
      for (; M; ) {
        let Q = ~~(G() * M--), et = q[M];
        q[M] = q[Q], q[Q] = et;
      }
      return q;
    }
    h.pre_compose({ x: 1, y: 1, z: 1, count: 1, context: {}, grid: { x: 1, y: 1, z: 1, count: 1 }, random: G, rand: Z, pick: X, shuffle: W, max_grid: r, update_random: function(z) {
      G = Wi(String(z));
    }, seed_value: o, rules: h, upextra: d });
    let { grid: S, seed: F } = h.output();
    if (S && (s = S), F ? (F = String(F), G = Wi(F)) : F = o, H(F) && (F = Date.now(), G = Wi(F)), F = String(F), h.seed = F, h.random = G, h.reset(), s.z == 1) for (let z = 1, q = 0; z <= s.y; ++z) for (let M = 1; M <= s.x; ++M) h.compose({ x: M, y: z, z: 1, count: ++q, grid: s, context: V, rand: Z, pick: X, shuffle: W, random: G, seed: F, max_grid: r, upextra: d, rules: h });
    else for (let z = 1, q = 0; z <= s.z; ++z) h.compose({ x: 1, y: 1, z, count: ++q, grid: s, context: V, rand: Z, pick: X, shuffle: W, random: G, seed: F, max_grid: r, rules: h, upextra: d });
    return h.output();
  }
  function Eo(I, s, o) {
    let r = I.createShader(s);
    return I.shaderSource(r, o), I.compileShader(r), r;
  }
  function Fn(I, s) {
    return I.includes(s) ? I : s + `
` + I;
  }
  function jo(I, s) {
    let o = fe.get(I);
    if (o) return Promise.resolve(o);
    let r = document.createElement("canvas"), u = devicePixelRatio || 1, d = r.width = I.width * u, h = r.height = I.height * u, G = [], V = r.getContext("webgl2", { preserveDrawingBuffer: !0 });
    if (!V) return Promise.resolve("");
    let Z = Fn(I.fragment || "", "uniform vec2 u_resolution;");
    Z = Fn(Z, "uniform float u_time;"), Z = Fn(Z, "uniform float u_timeDelta;"), Z = Fn(Z, "uniform int u_frameIndex;"), Z = Fn(Z, "uniform vec2 u_seed;"), I.textures.forEach((P) => {
      let ct = `uniform sampler2D ${P.name};`;
      Z = Fn(Z, ct);
    });
    const X = /(^|[^\w\_])void\s+mainImage\(\s*out\s+vec4\s+fragColor,\s*in\s+vec2\s+fragCoord\s*\)/gm.test(Z), W = ["#define iResolution vec3(u_resolution, 0)", "#define iTime u_time", "#define iTimeDelta u_timeDelta", "#define iFrame u_frameIndex", ...I.textures.map((P, ct) => `#define iChannel${ct} ${P.name}`)].join(`
`);
    X && (Z = `
${W}
${Z}
void main(){mainImage(FragColor, gl_FragCoord.xy);}`);
    let S = function(P, ct, $) {
      let bt = Eo(P, P.VERTEX_SHADER, ct), ft = Eo(P, P.FRAGMENT_SHADER, $), mt = P.createProgram();
      return P.attachShader(mt, bt), P.attachShader(mt, ft), P.linkProgram(mt), P.getProgramParameter(mt, P.LINK_STATUS) || (console.warn("Link failed:" + P.getProgramInfoLog(mt)), console.warn("vs info-log:" + P.getShaderInfoLog(bt)), console.warn("fs info-log:" + P.getShaderInfoLog(ft))), mt;
    }(V, I.vertex || `#version 300 es
 in vec4 position;void main(){gl_Position = position;}`, `#version 300 es
 precision highp float;out vec4 FragColor;` + Z), F = V.getAttribLocation(S, "position"), z = V.createBuffer();
    V.bindBuffer(V.ARRAY_BUFFER, z), V.bufferData(V.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, -1, 1, 1, -1, 1, 1, -1]), V.STATIC_DRAW), V.enableVertexAttribArray(F), V.vertexAttribPointer(F, 2, V.FLOAT, !1, 0, 0), V.viewport(0, 0, V.drawingBufferWidth, V.drawingBufferHeight), V.clearColor(0, 0, 0, 0), V.clear(V.COLOR_BUFFER_BIT), V.useProgram(S);
    const q = (P) => V.getUniformLocation(S, P), M = q("u_resolution");
    V.uniform2fv(M, [d, h]), I.textures.forEach((P, ct) => {
      G.push(function($, bt, ft) {
        const mt = $.createTexture();
        return $.activeTexture($["TEXTURE" + ft]), $.pixelStorei($.UNPACK_FLIP_Y_WEBGL, !0), $.bindTexture($.TEXTURE_2D, mt), $.texImage2D($.TEXTURE_2D, 0, $.RGBA, $.RGBA, $.UNSIGNED_BYTE, bt), $.texParameteri($.TEXTURE_2D, $.TEXTURE_WRAP_S, $.REPEAT), $.texParameteri($.TEXTURE_2D, $.TEXTURE_WRAP_T, $.REPEAT), $.texParameteri($.TEXTURE_2D, $.TEXTURE_MIN_FILTER, $.LINEAR), $.texParameteri($.TEXTURE_2D, $.TEXTURE_MAG_FILTER, $.LINEAR), mt;
      }(V, P.value, ct)), V.uniform1i(V.getUniformLocation(S, P.name), ct);
    });
    const Q = q("u_seed");
    Q && V.uniform2f(Q, xe(s) / 1e16, Math.random());
    const et = q("u_time"), lt = q("u_frameIndex"), it = q("u_timeDelta");
    if (et || it || lt) {
      let P = 0, ct = 0;
      return Promise.resolve(fe.set(I, ($, bt, ft, mt) => (V.clear(V.COLOR_BUFFER_BIT), I.width === bt && I.height === ft || (mt.forEach((Ut, Tt) => {
        V.bindTexture(V.TEXTURE_2D, G[Tt]), V.texImage2D(V.TEXTURE_2D, 0, V.RGBA, V.RGBA, V.UNSIGNED_BYTE, Ut.value);
      }), I.width = bt, I.height = ft, r.width = bt * u, r.height = ft * u, V.viewport(0, 0, r.width, r.height), V.uniform2fv(M, [r.width, r.height])), et && V.uniform1f(et, $ / 1e3), lt && V.uniform1i(lt, P++), it && (V.uniform1f(it, (ct - $) / 1e3), ct = $), V.drawArrays(V.TRIANGLES, 0, 6), r.toDataURL())));
    }
    return V.drawArrays(V.TRIANGLES, 0, 6), Promise.resolve(fe.set(I, r.toDataURL()));
  }
  function uG(I, s) {
    let o = [];
    for (; I.next(); ) {
      let { curr: r, next: u } = I.get(), d = !u || r.isSymbol(";") || u.isSymbol("}");
      if (o.push(r), d) break;
    }
    return o.length && (s.value = Zc(o)), s;
  }
  function Mo(I, s) {
    let o = [], r = [], u = s && s.type || "", d = [];
    for (; I.next(); ) {
      let { prev: h, curr: G, next: V } = I.get(), Z = !V || G.isSymbol("}");
      if (u === "block" && Z) {
        V || !o.length || G.isSymbol("}") || (o[o.length - 1].value += ";" + G.value), s.value = o;
        break;
      }
      if (G.isSymbol("{") && r.length && !d.length) {
        let X = bG(r);
        if (!X.length) continue;
        let W = Mo(I, { type: "block", name: "unkown", value: [] });
        X.forEach((S) => {
          let F = Object.assign({}, W, { name: S.name, args: S.args });
          o.push(F);
        }), r = [];
      } else if (G.isSymbol(":") && r.length && !d.length) {
        let X = Zc(r);
        o.push(uG(I, { type: "statement", name: X, value: "" })), u == "block" && (s.value = o), r = [];
      } else G.isSymbol(";") ? o.length && r.length && (o[o.length - 1].value += ";" + Zc(r), r = []) : (G.isSymbol("(") && d.push(G), G.isSymbol(")") && d.pop(), r.push(G));
    }
    return o.length && u == "block" && (s.value = o), u ? s : o;
  }
  function Zc(I) {
    return I.filter((s, o) => !s.isSymbol(";") || o !== I.length - 1).map((s) => s.value).join("");
  }
  function bG(I) {
    let s = g(I), o = [], r = "", u = [], d = [], h = [];
    for (; s.next(); ) {
      let { curr: G, next: V } = s.get();
      !r.length && G.isWord() ? r = G.value : G.isSymbol("(") ? (h.length && d.push(G.value), h.push(G)) : G.isSymbol(")") ? (h.pop(), h.length ? d.push(G.value) : d.length && (u.push(d.join("")), d = [])) : G.isSymbol(",") ? h.length ? (u.push(d.join("")), d = []) : (d.length && (u.push(d.join("")), d = []), r && (o.push({ name: r, args: u }), r = "", u = [], d = [])) : d.push(G.value);
    }
    return r && o.push({ name: r, args: u }), o.filter((G, V, Z) => Z.findIndex((X) => X.name === G.name && G.args.join("") == X.args.join("")) === V);
  }
  var dG = function(I) {
    return Mo(g(p(I)));
  };
  function Uo(I, s) {
    if (I.name === "fill") {
      let { r: o, g: r, b: u, a: d } = s.get_rgba_color(I.value);
      return { type: "statement", value: `
color = vec4(${Bi(o / 255)}, ${Bi(r / 255)}, ${Bi(u / 255)}, ${Bi(d)});` };
    }
    return I.name == "grid" ? { type: "grid", value: I.value } : { type: "statement", value: "" };
  }
  function Bi(I) {
    return String(I).includes(".") ? I : I + ".0";
  }
  function GG(I, s) {
    let o = dG(I), r = [], u = { x: 1, y: 1 };
    return o.forEach((d) => {
      if (d.type === "statement") {
        let h = Uo(d, s);
        h.type == "statement" && r.push(h.value), h.type === "grid" && (u = Rn(h.value, 1 / 0));
      } else d.type === "block" && r.push(function(h, G) {
        if (h.name === "match") {
          let V = h.args[0], Z = [];
          return h.value.forEach((X) => {
            let W = Uo(X, G);
            W.type == "statement" && Z.push(W.value);
          }), `
 if (${V}){${Z.join("")}}`;
        }
        return "";
      }(d, s));
    }), function(d, { x: h, y: G }) {
      return `
 vec3 mapping(vec2 uv, vec2 grid){vec2 _grid = 1.0/grid;float x = ceil(uv.x/_grid.x);float y = ceil(grid.y - uv.y/_grid.y);float i = x + (y - 1.0) * y;return vec3(x, y, i);} vec4 getColor(float x, float y, float i, float I, float X, float Y, float t){vec4 color = vec4(0, 0, 0, 0);${d} return color;} void main(){vec2 uv = gl_FragCoord.xy/u_resolution.xy;vec2 v = vec2(${h}, ${G});vec3 p = mapping(uv, v);FragColor = getColor(p.x, p.y, p.z, v.x * v.y, v.x, v.y, u_time);}`;
    }(r.join(""), u);
  }
  var To = 1e3 / 60;
  function mG(I) {
    if (typeof getComputedStyle > "u") return "";
    let s = {};
    if (I.computedStyleMap) for (let [o, r] of I.computedStyleMap()) o.startsWith("--") && (s[o] = r[0][0]);
    else {
      let o = getComputedStyle(I);
      for (let r of o) r.startsWith("--") && (s[r] = o.getPropertyValue(r));
    }
    return function(o) {
      let r = [];
      for (let [u, d] of Object.entries(o)) r.push(u + ":" + d);
      return r.join(";");
    }(s);
  }
  var yc = { CSSDoodle: class {
  }, define(I, s) {
    typeof customElements > "u" || customElements.get(I) || customElements.define(I, s);
  } };
  function Yi(I) {
    let { x: s, y: o } = I || {};
    return `
 *,*::after,*::before,:host,.host{box-sizing:border-box;}:host,.host{display:block;visibility:visible;width:auto;height:auto;contain:strict;view-transition-name:css-doodle;--${Ye.name}:0;--${Ue.name}:0
}:host([hidden]),[hidden]{display:none
}:host([cssd-paused]),
:host([cssd-paused]) *{animation-play-state:paused !important
} grid, cell{display:grid;position:relative;} grid{gap:inherit;grid-template:repeat(${o},1fr)/repeat(${s},1fr);container-type:size
} cell{place-items:center
} svg{position:absolute;} grid, svg{width:100%;height:100%
}`;
  }
  function Qo(I, s, o, r, u = "") {
    let d = U(I, s, o);
    return `<cell id="${d}">${r["#" + d] ?? ""}${u ?? ""}</cell>`;
  }
  function Oo(I, s) {
    let { x: o, y: r, z: u } = I || {}, d = "";
    if (u == 1) for (let h = 1; h <= r; ++h) for (let G = 1; G <= o; ++G) d += Qo(G, h, 1, s);
    else {
      let h = "";
      for (let G = u; G >= 1; G--)
        h = Qo(1, 1, G, s, h);
      d = h;
    }
    return `<grid>${d}</grid>`;
  }
  typeof HTMLElement < "u" && (yc.CSSDoodle = class extends HTMLElement {
    constructor() {
      super(), this.doodle = this.attachShadow({ mode: "open" }), this.animations = [], this.extra = { get_variable: (I) => function(s, o) {
        return typeof getComputedStyle > "u" ? "" : getComputedStyle(s).getPropertyValue(o).trim().replace(/^\(|\)$/g, "");
      }(this, I), get_rgba_color: (I) => function(s, o) {
        let r = s.querySelector("style");
        return r ? (r.style.color = o, function(u) {
          let [d, h, G, V = 1] = u.replace(/rgba?\((.+)\)/, (Z, X) => X).split(/,\s*/);
          return { r: d, g: h, b: G, a: V };
        }(getComputedStyle(r).color)) : { r: 0, g: 0, b: 0, a: 1 };
      }(this.shadowRoot, I) };
    }
    connectedCallback(I) {
      this.innerHTML ? this.load(I) : setTimeout(() => this.load(I));
    }
    disconnectedCallback() {
      this.cleanup();
    }
    triggerEvent(I, s = {}) {
      return this.dispatchEvent(new CustomEvent(I, { detail: s, bubbles: !0, composed: !0 }));
    }
    _update(I) {
      this.cleanup(), I || (I = rn(this._code)), this._code !== I && (this._code = I), this.grid_size || (this.grid_size = this.get_grid());
      const { x: s, y: o, z: r } = this.grid_size, u = this.get_use();
      let d = "", h = "";
      this.compiled && (d = this.compiled.content, h = this.compiled.styles.all);
      const G = this.generate(Jn(u + I, this.extra));
      let V = G.grid || this.get_grid(), { x: Z, y: X, z: W } = V, S = !this.shadowRoot.innerHTML || this.shadowRoot.querySelector("css-doodle") || s !== Z || o !== X || r !== W || JSON.stringify(d) !== JSON.stringify(G.content);
      if (Object.assign(this.grid_size, V), S) G.grid ? this.build_grid(G, V) : this.build_grid(this.generate(Jn(u + I, this.extra)), V);
      else {
        this.bind_uniforms(G.uniforms);
        let F = this.replace(G);
        G.props.has_animation && (this.set_style(h.replace(/animation/g, "x")), this.reflow()), this.set_style(F(Yi(this.grid_size) + G.styles.all));
      }
      setTimeout(() => {
        this.triggerEvent("render"), this.triggerEvent("afterUpdate"), this.triggerEvent("update");
      });
    }
    update(I, s = {}) {
      if (this.triggerEvent("beforeUpdate"), !document.startViewTransition) return this._update(I);
      arguments.length || (I = ""), typeof I == "object" && (I = "");
      let o = this.viewTransition;
      o === void 0 && (o = this.hasAttribute("view-transition")), o ? document.startViewTransition(() => {
        this._update(I);
      }) : this._update(I);
    }
    pause() {
      this.setAttribute("cssd-paused", !0);
      for (let I of this.animations) I.pause();
    }
    resume() {
      this.removeAttribute("cssd-paused");
      for (let I of this.animations) I.resume();
    }
    export({ scale: I, name: s, download: o, detail: r } = {}) {
      return new Promise((u, d) => {
        let h = mG(this), G = this.doodle.innerHTML, { width: V, height: Z } = this.getBoundingClientRect(), X = V * (I = parseInt(I) || 1), W = Z * I, S = `
<svg ${pg} preserveAspectRatio="none"
 viewBox="0 0 ${V} ${Z}"
 ${xt() ? "" : `width="${X}px" height="${W}px"`}><foreignObject width="100%" height="100%"><div class="host" ${Co} style="width:${V}px;height:${Z}px"><style>.host{${F = h, F.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")}}</style>${G}</div></foreignObject></svg>`;
        var F;
        o || r ? function(z, q, M, Q) {
          return new Promise((et, lt) => {
            let it = `data:image/svg+xml;utf8,${encodeURIComponent(z)}`;
            function P() {
              let ct = new Image();
              ct.crossOrigin = "anonymous", ct.src = it, ct.onload = () => {
                let $ = document.createElement("canvas"), bt = $.getContext("2d"), ft = devicePixelRatio || 1;
                Q != 1 && (ft = 1), $.width = q * ft, $.height = M * ft, bt.drawImage(ct, 0, 0, $.width, $.height);
                try {
                  $.toBlob((mt) => {
                    et({ blob: mt, source: it, url: URL.createObjectURL(mt) });
                  });
                } catch (mt) {
                  lt(mt);
                }
              };
            }
            xt() ? gt(it, P, 200) : P();
          });
        }(S, X, W, I).then(({ source: z, url: q, blob: M }) => {
          if (u({ width: X, height: W, svg: S, blob: M, source: z }), o) {
            let Q = document.createElement("a");
            Q.download = function(et) {
              return (H(et) ? Date.now() : String(et).replace(/\/.png$/g, "")) + ".png";
            }(s), Q.href = q, Q.click();
          }
        }).catch((z) => {
          d(z);
        }) : u({ width: X, height: W, svg: S });
      });
    }
    get grid() {
      return Object.assign({}, this.grid_size);
    }
    set grid(I) {
      this.attr("grid", I), this.connectedCallback(!0);
    }
    get seed() {
      return this._seed_value;
    }
    set seed(I) {
      this.attr("seed", I), this.connectedCallback(!0);
    }
    get use() {
      return this.attr("use");
    }
    set use(I) {
      this.attr("use", I), this.connectedCallback(!0);
    }
    get_max_grid() {
      return this.hasAttribute("experimental") ? 256 : 64;
    }
    get_grid() {
      return Rn(this.attr("grid"), this.get_max_grid());
    }
    get_use() {
      let I = String(this.attr("use") || "").trim();
      return /^var\(/.test(I) && (I = `@use:${I};`), I;
    }
    cleanup() {
      if (fe.clear(), this.compiled) {
        for (let o of this.animations) o.cancel();
        this.animations = [];
        let { pattern: I, shaders: s } = this.compiled;
        if (Object.keys(I).length || Object.keys(s).length) for (let o of this.shadowRoot.querySelectorAll("cell")) o.style.cssText = "";
      }
    }
    attr(I, s) {
      let o = arguments.length;
      return o === 1 ? this.getAttribute(I) : o === 2 ? (this.setAttribute(I, s), s) : void 0;
    }
    generate(I) {
      let s = this.get_grid(), o = this.attr("seed") || this.attr("data-seed");
      H(o) && (o = Date.now());
      let r = this.compiled = ko(I, s, o, this.get_max_grid());
      return this._seed_value = r.seed, this._seed_random = r.random, r;
    }
    doodle_to_image(I, s, o) {
      typeof s == "function" && (o = s, s = null);
      let r = Jn(I = ":doodle{width:100%;height:100%}" + I, this.extra), u = Rn(""), d = ko(r, u, this._seed_value, this.get_max_grid(), this._seed_random, s.upextra), h = d.grid ? d.grid : u, G = "";
      if (s && s.arg) {
        let X = Rn(s.arg, 1 / 0);
        X.x && X.y && (s.width = X.x + "px", s.height = X.y + "px", G = `viewBox="0 0 ${X.x} ${X.y}"`);
      }
      let V = this.replace(d), Z = Oo(h, d.content);
      V(`
<svg ${s && s.width && s.height ? `width="${s.width}" height="${s.height}"` : ""} ${pg} preserveAspectRatio="none" ${G}><foreignObject width="100%" height="100%"><div class="host" width="100%" height="100%" ${Co}><style>${Yi(h)} ${d.styles.all}</style>${Z}</div></foreignObject></svg>`).then((X) => {
        let W = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(X)))}`;
        xt() && gt(W), o(W);
      });
    }
    pattern_to_image({ code: I, cell: s, id: o }, r) {
      let u = GG(I, this.extra);
      this.shader_to_image({ shader: u, cell: s, id: o }, r);
    }
    shader_to_image({ shader: I, cell: s, id: o }, r) {
      const u = this.doodle.getElementById(s);
      if (!u) return !1;
      let { width: d, height: h } = u.getBoundingClientRect(), G = devicePixelRatio || 1, V = this.seed, Z = typeof I == "string" ? kd(I) : I;
      Z.width = d, Z.height = h;
      let X = Z.textures, W = [];
      const S = (q) => {
        u.style.setProperty(o, `url(${q})`);
      }, F = (q) => {
        typeof q == "function" ? this.animations.push(function(M) {
          let Q, et = 0, lt = 0, it = 0, P = !1;
          function ct($) {
            et || (et = $), M(et);
            let bt = $ - lt;
            bt < To && (bt = To), bt > 1e3 && (bt = it || 1e3), lt && (et += bt), it = bt, lt = $, Q = requestAnimationFrame(ct);
          }
          return Q = requestAnimationFrame(ct), { resume() {
            Q && P && (P = !1, Q = requestAnimationFrame(ct));
          }, pause() {
            Q && (cancelAnimationFrame(Q), P = !0);
          }, cancel() {
            Q && (P = !1, cancelAnimationFrame(Q), Q = null);
          } };
        }((M) => {
          S(q(M, d, h, W));
        })) : S(q);
      }, z = (q, M) => {
        Promise.all(q.map(({ name: Q, value: et }) => new Promise((lt) => {
          this.doodle_to_image(et, { width: d, height: h }, (it) => {
            let P = new Image();
            P.width = d * G, P.height = d * G, P.onload = () => lt({ name: Q, value: P }), P.src = it;
          });
        }))).then(M);
      };
      u.observer || (u.observer = new ResizeObserver(() => {
        let q = u.getBoundingClientRect();
        d = q.width, h = q.height, z(X, (M) => W = M);
      }), u.observer.observe(u)), X.length ? z(X, (q) => {
        Z.textures = W = q, Z.width = d, Z.height = h, jo(Z, V).then(F).then(r);
      }) : jo(Z, V).then(F).then(r);
    }
    load(I) {
      this.cleanup();
      let s = this._code || this.innerHTML, o = Jn(this.get_use() + rn(s), this.extra), r = this.generate(o);
      I || this.hasAttribute("click-to-update") && this.addEventListener("click", (u) => this.update()), this.grid_size = r.grid ? r.grid : this.get_grid(), this.build_grid(r, this.grid_size), this._code = s, this.innerHTML = "", setTimeout(() => {
        this.triggerEvent("render");
      });
    }
    replace({ doodles: I, shaders: s, pattern: o }) {
      let r = Object.keys(I), u = Object.keys(s), d = Object.keys(o), h = r.length + u.length + d.length;
      return (G) => {
        if (!h) return Promise.resolve(G);
        let V = [].concat(r.map((Z) => G.includes(Z) ? new Promise((X) => {
          let { arg: W, doodle: S, upextra: F } = I[Z];
          this.doodle_to_image(S, { arg: W, upextra: F }, (z) => X({ id: Z, value: z }));
        }) : Promise.resolve("")), u.map((Z) => G.includes(Z) ? new Promise((X) => {
          this.shader_to_image(s[Z], (W) => X({ id: Z, value: W }));
        }) : Promise.resolve("")), d.map((Z) => G.includes(Z) ? new Promise((X) => {
          this.pattern_to_image(o[Z], (W) => X({ id: Z, value: W }));
        }) : Promise.resolve("")));
        return Promise.all(V).then((Z) => {
          for (let { id: X, value: W } of Z) {
            let S = `url(${W})`;
            /^shader|^pattern/.test(X) && (S = `var(--${X})`), G = G.replaceAll("${" + X + "}", S);
          }
          return G;
        });
      };
    }
    reflow() {
      this.shadowRoot.querySelector("grid").offsetWidth;
    }
    bind_uniforms({ time: I, mousex: s, mousey: o, width: r, height: u }) {
      I && this.reg_utime(), s || o ? this.reg_umouse(s, o) : this.off_umouse(), r || u ? this.reg_usize(r, u) : this.off_usize();
    }
    build_grid(I, s) {
      const { has_transition: o, has_animation: r } = I.props;
      let u = o || r;
      const { uniforms: d, content: h, styles: G } = I;
      this.doodle.innerHTML = `
<style>${Yi(s) + G.main}</style>${Oo(s, h)}`, u && this.reflow();
      let V = this.replace(I);
      this.set_style(V(Yi(s) + G.all)), this.bind_uniforms(d);
    }
    reg_umouse(I, s) {
      if (this.umouse_fn) I || s || this.off_umouse();
      else {
        this.umouse_fn = (r) => {
          let u = r.detail || r;
          (I || s) && (this.style.setProperty("--" + rc, u.offsetX), this.style.setProperty("--" + ac, u.offsetY));
        }, this.addEventListener("pointermove", this.umouse_fn);
        let o = new CustomEvent("pointermove", { detail: { offsetX: 0, offsetY: 0 } });
        this.dispatchEvent(o);
      }
    }
    off_umouse() {
      this.umouse_fn && (this.style.removeProperty("--" + rc), this.style.removeProperty("--" + ac), this.removeEventListener("pointermove", this.umouse_fn), this.umouse_fn = null);
    }
    reg_usize(I, s) {
      this.usize_observer ? I || s || this.off_usize() : (this.usize_observer = new ResizeObserver(() => {
        let o = this.getBoundingClientRect();
        (I || s) && (this.style.setProperty("--" + Cc, o.width), this.style.setProperty("--" + uc, o.height));
      }), this.usize_observer.observe(this));
    }
    off_usize() {
      this.usize_observer && (this.style.removeProperty("--" + Cc), this.style.removeProperty("--" + uc), this.usize_observer.unobserve(this), this.usize_observer = null);
    }
    reg_utime() {
      if (!this.is_utime_set) {
        try {
          CSS.registerProperty({ name: "--" + Ye.name, syntax: "<integer>", initialValue: 0, inherits: !0 }), CSS.registerProperty({ name: "--" + Ue.name, syntax: "<integer>", initialValue: 0, inherits: !0 });
        } catch {
        }
        this.is_utime_set = !0;
      }
    }
    set_style(I) {
      if (I instanceof Promise) I.then((s) => {
        this.set_style(s);
      });
      else {
        const s = this.shadowRoot.querySelector("style");
        s && (s.textContent = I.replace(/\n\s+/g, " "));
      }
    }
  });
  var hG = yc.CSSDoodle;
  (0, yc.define)("css-doodle", hG);
})();
const ry = (t) => {
  const {
    colors: e = [
      // light blues hex
      "#add8e6",
      "#87ceeb",
      "#87cefa",
      "#00bfff"
    ]
  } = t;
  return /* @__PURE__ */ w("css-doodle", {
    /*css*/
    children: `
  --color: ${e.join(", ")};

  @grid: 30x1 / 100vw 100vh / #270f34; 
  
  :container {
    perspective: 30vmin;
    --deg: @p(-180deg, 180deg);
  }
  
  :after, :before {
    // content: '';
    background: @p(--color); 
    @place: @r(100%) @r(100%);
    @size: @r(6px);
    @shape: heart;
  }

  @place: center;
  @size: 18vmin; 

  box-shadow: @m2(0 0 50px @p(--color));
  background: @m100(
    radial-gradient(@p(--color) 50%, transparent 0) 
    @r(-20%, 120%) @r(-20%, 100%) / 1px 1px
    no-repeat
  );

  will-change: transform, opacity;
  animation: scale-up 25s linear infinite;
  animation-delay: calc(-25s / @I * @i);

  @keyframes scale-up {
    0%, 95.01%, 100% {
      transform: translateZ(0) rotate(0);
      opacity: 0;
    }
    10% { 
      opacity: 1; 
    }
    95% {
      transform: 
        translateZ(35vmin) rotateZ(var(--deg));
    }
  }
`
  });
};
var Zn = [], ay = function() {
  return Zn.some(function(t) {
    return t.activeTargets.length > 0;
  });
}, Cy = function() {
  return Zn.some(function(t) {
    return t.skippedTargets.length > 0;
  });
}, Ql = "ResizeObserver loop completed with undelivered notifications.", uy = function() {
  var t;
  typeof ErrorEvent == "function" ? t = new ErrorEvent("error", {
    message: Ql
  }) : (t = document.createEvent("Event"), t.initEvent("error", !1, !1), t.message = Ql), window.dispatchEvent(t);
}, Tg;
(function(t) {
  t.BORDER_BOX = "border-box", t.CONTENT_BOX = "content-box", t.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Tg || (Tg = {}));
var yn = function(t) {
  return Object.freeze(t);
}, by = /* @__PURE__ */ function() {
  function t(e, n) {
    this.inlineSize = e, this.blockSize = n, yn(this);
  }
  return t;
}(), qu = function() {
  function t(e, n, g, i) {
    return this.x = e, this.y = n, this.width = g, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, yn(this);
  }
  return t.prototype.toJSON = function() {
    var e = this, n = e.x, g = e.y, i = e.top, c = e.right, A = e.bottom, l = e.left, a = e.width, C = e.height;
    return { x: n, y: g, top: i, right: c, bottom: A, left: l, width: a, height: C };
  }, t.fromRect = function(e) {
    return new t(e.x, e.y, e.width, e.height);
  }, t;
}(), Xs = function(t) {
  return t instanceof SVGElement && "getBBox" in t;
}, Du = function(t) {
  if (Xs(t)) {
    var e = t.getBBox(), n = e.width, g = e.height;
    return !n && !g;
  }
  var i = t, c = i.offsetWidth, A = i.offsetHeight;
  return !(c || A || t.getClientRects().length);
}, Ol = function(t) {
  var e;
  if (t instanceof Element)
    return !0;
  var n = (e = t == null ? void 0 : t.ownerDocument) === null || e === void 0 ? void 0 : e.defaultView;
  return !!(n && t instanceof n.Element);
}, dy = function(t) {
  switch (t.tagName) {
    case "INPUT":
      if (t.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, wg = typeof window < "u" ? window : {}, zi = /* @__PURE__ */ new WeakMap(), Pl = /auto|scroll/, Gy = /^tb|vertical/, my = /msie|trident/i.test(wg.navigator && wg.navigator.userAgent), ue = function(t) {
  return parseFloat(t || "0");
}, On = function(t, e, n) {
  return t === void 0 && (t = 0), e === void 0 && (e = 0), n === void 0 && (n = !1), new by((n ? e : t) || 0, (n ? t : e) || 0);
}, Kl = yn({
  devicePixelContentBoxSize: On(),
  borderBoxSize: On(),
  contentBoxSize: On(),
  contentRect: new qu(0, 0, 0, 0)
}), Lu = function(t, e) {
  if (e === void 0 && (e = !1), zi.has(t) && !e)
    return zi.get(t);
  if (Du(t))
    return zi.set(t, Kl), Kl;
  var n = getComputedStyle(t), g = Xs(t) && t.ownerSVGElement && t.getBBox(), i = !my && n.boxSizing === "border-box", c = Gy.test(n.writingMode || ""), A = !g && Pl.test(n.overflowY || ""), l = !g && Pl.test(n.overflowX || ""), a = g ? 0 : ue(n.paddingTop), C = g ? 0 : ue(n.paddingRight), b = g ? 0 : ue(n.paddingBottom), m = g ? 0 : ue(n.paddingLeft), p = g ? 0 : ue(n.borderTopWidth), y = g ? 0 : ue(n.borderRightWidth), f = g ? 0 : ue(n.borderBottomWidth), x = g ? 0 : ue(n.borderLeftWidth), Y = m + C, B = a + b, J = x + y, N = p + f, R = l ? t.offsetHeight - N - t.clientHeight : 0, H = A ? t.offsetWidth - J - t.clientWidth : 0, E = i ? Y + J : 0, O = i ? B + N : 0, j = g ? g.width : ue(n.width) - E - H, U = g ? g.height : ue(n.height) - O - R, D = j + Y + H + J, gt = U + B + R + N, xt = yn({
    devicePixelContentBoxSize: On(Math.round(j * devicePixelRatio), Math.round(U * devicePixelRatio), c),
    borderBoxSize: On(D, gt, c),
    contentBoxSize: On(j, U, c),
    contentRect: new qu(m, a, j, U)
  });
  return zi.set(t, xt), xt;
}, ku = function(t, e, n) {
  var g = Lu(t, n), i = g.borderBoxSize, c = g.contentBoxSize, A = g.devicePixelContentBoxSize;
  switch (e) {
    case Tg.DEVICE_PIXEL_CONTENT_BOX:
      return A;
    case Tg.BORDER_BOX:
      return i;
    default:
      return c;
  }
}, hy = /* @__PURE__ */ function() {
  function t(e) {
    var n = Lu(e);
    this.target = e, this.contentRect = n.contentRect, this.borderBoxSize = yn([n.borderBoxSize]), this.contentBoxSize = yn([n.contentBoxSize]), this.devicePixelContentBoxSize = yn([n.devicePixelContentBoxSize]);
  }
  return t;
}(), Eu = function(t) {
  if (Du(t))
    return 1 / 0;
  for (var e = 0, n = t.parentNode; n; )
    e += 1, n = n.parentNode;
  return e;
}, py = function() {
  var t = 1 / 0, e = [];
  Zn.forEach(function(A) {
    if (A.activeTargets.length !== 0) {
      var l = [];
      A.activeTargets.forEach(function(C) {
        var b = new hy(C.target), m = Eu(C.target);
        l.push(b), C.lastReportedSize = ku(C.target, C.observedBox), m < t && (t = m);
      }), e.push(function() {
        A.callback.call(A.observer, l, A.observer);
      }), A.activeTargets.splice(0, A.activeTargets.length);
    }
  });
  for (var n = 0, g = e; n < g.length; n++) {
    var i = g[n];
    i();
  }
  return t;
}, _l = function(t) {
  Zn.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(i) {
      i.isActive() && (Eu(i.target) > t ? n.activeTargets.push(i) : n.skippedTargets.push(i));
    });
  });
}, Vy = function() {
  var t = 0;
  for (_l(t); ay(); )
    t = py(), _l(t);
  return Cy() && uy(), t > 0;
}, Mc, ju = [], Zy = function() {
  return ju.splice(0).forEach(function(t) {
    return t();
  });
}, yy = function(t) {
  if (!Mc) {
    var e = 0, n = document.createTextNode(""), g = { characterData: !0 };
    new MutationObserver(function() {
      return Zy();
    }).observe(n, g), Mc = function() {
      n.textContent = "".concat(e ? e-- : e++);
    };
  }
  ju.push(t), Mc();
}, vy = function(t) {
  yy(function() {
    requestAnimationFrame(t);
  });
}, Oi = 0, Xy = function() {
  return !!Oi;
}, xy = 250, Wy = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, $l = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], tr = function(t) {
  return t === void 0 && (t = 0), Date.now() + t;
}, Uc = !1, fy = function() {
  function t() {
    var e = this;
    this.stopped = !0, this.listener = function() {
      return e.schedule();
    };
  }
  return t.prototype.run = function(e) {
    var n = this;
    if (e === void 0 && (e = xy), !Uc) {
      Uc = !0;
      var g = tr(e);
      vy(function() {
        var i = !1;
        try {
          i = Vy();
        } finally {
          if (Uc = !1, e = g - tr(), !Xy())
            return;
          i ? n.run(1e3) : e > 0 ? n.run(e) : n.start();
        }
      });
    }
  }, t.prototype.schedule = function() {
    this.stop(), this.run();
  }, t.prototype.observe = function() {
    var e = this, n = function() {
      return e.observer && e.observer.observe(document.body, Wy);
    };
    document.body ? n() : wg.addEventListener("DOMContentLoaded", n);
  }, t.prototype.start = function() {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), $l.forEach(function(n) {
      return wg.addEventListener(n, e.listener, !0);
    }));
  }, t.prototype.stop = function() {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), $l.forEach(function(n) {
      return wg.removeEventListener(n, e.listener, !0);
    }), this.stopped = !0);
  }, t;
}(), YA = new fy(), er = function(t) {
  !Oi && t > 0 && YA.start(), Oi += t, !Oi && YA.stop();
}, By = function(t) {
  return !Xs(t) && !dy(t) && getComputedStyle(t).display === "inline";
}, Yy = function() {
  function t(e, n) {
    this.target = e, this.observedBox = n || Tg.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return t.prototype.isActive = function() {
    var e = ku(this.target, this.observedBox, !0);
    return By(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
  }, t;
}(), Ny = /* @__PURE__ */ function() {
  function t(e, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = n;
  }
  return t;
}(), qi = /* @__PURE__ */ new WeakMap(), nr = function(t, e) {
  for (var n = 0; n < t.length; n += 1)
    if (t[n].target === e)
      return n;
  return -1;
}, Di = function() {
  function t() {
  }
  return t.connect = function(e, n) {
    var g = new Ny(e, n);
    qi.set(e, g);
  }, t.observe = function(e, n, g) {
    var i = qi.get(e), c = i.observationTargets.length === 0;
    nr(i.observationTargets, n) < 0 && (c && Zn.push(i), i.observationTargets.push(new Yy(n, g && g.box)), er(1), YA.schedule());
  }, t.unobserve = function(e, n) {
    var g = qi.get(e), i = nr(g.observationTargets, n), c = g.observationTargets.length === 1;
    i >= 0 && (c && Zn.splice(Zn.indexOf(g), 1), g.observationTargets.splice(i, 1), er(-1));
  }, t.disconnect = function(e) {
    var n = this, g = qi.get(e);
    g.observationTargets.slice().forEach(function(i) {
      return n.unobserve(e, i.target);
    }), g.activeTargets.splice(0, g.activeTargets.length);
  }, t;
}(), Jy = function() {
  function t(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof e != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    Di.connect(this, e);
  }
  return t.prototype.observe = function(e, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Ol(e))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Di.observe(this, e, n);
  }, t.prototype.unobserve = function(e) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Ol(e))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Di.unobserve(this, e);
  }, t.prototype.disconnect = function() {
    Di.disconnect(this);
  }, t.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, t;
}();
const Mu = pt[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], Ry = (t) => {
  const e = v.useRef(t);
  return v.useEffect(() => {
    e.current = t;
  }), e;
}, Sy = typeof window < "u" && "ResizeObserver" in window ? (
  // @ts-ignore
  window.ResizeObserver
) : Jy;
function Fy() {
}
function Hy(t, e) {
  const n = zy(), g = Ry(e);
  return Mu(() => {
    let i = !1;
    const c = t && "current" in t ? t.current : t;
    if (!c) return Fy;
    function A(l, a) {
      i || g.current(l, a);
    }
    return n.subscribe(c, A), () => {
      i = !0, n.unsubscribe(c, A);
    };
  }, [t, n, g]), n.observer;
}
function wy() {
  let t = !1, e = [];
  const n = /* @__PURE__ */ new Map(), g = new Sy((i, c) => {
    e = e.concat(i);
    function A() {
      const l = /* @__PURE__ */ new Set();
      for (let a = 0; a < e.length; a++) {
        if (l.has(e[a].target)) continue;
        l.add(e[a].target);
        const C = n.get(e[a].target);
        C == null || C.forEach((b) => b(e[a], c));
      }
      e = [], t = !1;
    }
    t || window.requestAnimationFrame(A), t = !0;
  });
  return {
    observer: g,
    subscribe(i, c) {
      var A;
      g.observe(i);
      const l = (A = n.get(i)) !== null && A !== void 0 ? A : [];
      l.push(c), n.set(i, l);
    },
    unsubscribe(i, c) {
      var A;
      const l = (A = n.get(i)) !== null && A !== void 0 ? A : [];
      if (l.length === 1) {
        g.unobserve(i), n.delete(i);
        return;
      }
      const a = l.indexOf(c);
      a !== -1 && l.splice(a, 1), n.set(i, l);
    }
  };
}
let Tc;
const zy = () => Tc || (Tc = wy()), qy = (t, e) => {
  const [n, g] = v.useState(() => {
    var i, c;
    const A = t && "current" in t ? t.current : t;
    return A ? [A.offsetWidth, A.offsetHeight] : [(i = void 0) !== null && i !== void 0 ? i : 0, (c = void 0) !== null && c !== void 0 ? c : 0];
  });
  return Mu(() => {
    const i = t && "current" in t ? t.current : t;
    i && g([i.offsetWidth, i.offsetHeight]);
  }, [t]), Hy(t, (i) => {
    const c = i.target;
    g([c.offsetWidth, c.offsetHeight]);
  }), n;
}, Li = 30, ki = 30, Dy = (t) => {
  const e = Ke(null), [n, g] = qy(e), i = oe(() => Math.floor(n / (Li + ki) + 1), [n]), c = oe(() => Math.floor(g / (Li + ki) + 1), [g]);
  return /* @__PURE__ */ w(ds, { ref: e, gap: ki, justifyContent: "center", css: [ne, "overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:Dots;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: Array.from({
    length: c
  }).map((A, l) => /* @__PURE__ */ w(Cg, { gap: ki, justifyContent: "center", children: Array.from({
    length: i
  }).map((a, C) => /* @__PURE__ */ w("div", { css: /* @__PURE__ */ Gt({
    width: Li,
    height: Li,
    borderRadius: "50%",
    backgroundColor: K.background,
    // white box shadow highlight
    animation: `${Ly} ${(C + l) % 2 === 0 ? 2.7 : 3}s infinite`,
    animationDelay: `${(C * C / i + 4 * l) * 0.1}s`,
    animationTimingFunction: "ease-in-out"
  }, process.env.NODE_ENV === "production" ? "" : ";label:Dots;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL2JhY2tkcm9wcy9Eb3RzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQ2MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvdWkvdWkvc3JjL2NvbW1vbi9jb21wb25lbnRzL2Jhc2UvYmFja2Ryb3BzL0RvdHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZnVsbFNpemUgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdXRpbHMnO1xuaW1wb3J0IHsgRmxleFJvdywgRmxleENvbHVtbiB9IGZyb20gJy4uL0ZsZXgnO1xuaW1wb3J0IHsga2V5ZnJhbWVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgdXNlTWVtbywgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHVzZVNpemUgZnJvbSAnQHJlYWN0LWhvb2svc2l6ZSc7XG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdGhlbWUnO1xuXG5leHBvcnQgaW50ZXJmYWNlIERvdHNQcm9wcyB7fVxuXG5jb25zdCBkb3RTaXplID0gMzA7XG5jb25zdCBkb3RTcGFjaW5nID0gMzA7XG5cbmV4cG9ydCBjb25zdCBEb3RzID0gKHByb3BzOiBEb3RzUHJvcHMpID0+IHtcbiAgY29uc3Qge30gPSBwcm9wcztcblxuICBjb25zdCByb290UmVmID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50PihudWxsKTtcbiAgY29uc3QgW3dpZHRoLCBoZWlnaHRdID0gdXNlU2l6ZShyb290UmVmKTtcblxuICBjb25zdCBncmlkWCA9IHVzZU1lbW8oKCkgPT4gTWF0aC5mbG9vcih3aWR0aCAvIChkb3RTaXplICsgZG90U3BhY2luZykgKyAxKSwgW3dpZHRoXSk7XG4gIGNvbnN0IGdyaWRZID0gdXNlTWVtbygoKSA9PiBNYXRoLmZsb29yKGhlaWdodCAvIChkb3RTaXplICsgZG90U3BhY2luZykgKyAxKSwgW2hlaWdodF0pO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXhDb2x1bW5cbiAgICAgIHJlZj17cm9vdFJlZn1cbiAgICAgIGdhcD17ZG90U3BhY2luZ31cbiAgICAgIGp1c3RpZnlDb250ZW50PVwiY2VudGVyXCJcbiAgICAgIGNzcz17W2Z1bGxTaXplLCB7IG92ZXJmbG93OiAnaGlkZGVuJyB9XX1cbiAgICA+XG4gICAgICB7QXJyYXkuZnJvbSh7IGxlbmd0aDogZ3JpZFkgfSkubWFwKChfLCB5KSA9PiAoXG4gICAgICAgIDxGbGV4Um93IGdhcD17ZG90U3BhY2luZ30ganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIiBrZXk9e3l9PlxuICAgICAgICAgIHtBcnJheS5mcm9tKHsgbGVuZ3RoOiBncmlkWCB9KS5tYXAoKF8sIHgpID0+IChcbiAgICAgICAgICAgIDxkaXZcbiAgICAgICAgICAgICAga2V5PXt4fVxuICAgICAgICAgICAgICBjc3M9e3tcbiAgICAgICAgICAgICAgICB3aWR0aDogZG90U2l6ZSxcbiAgICAgICAgICAgICAgICBoZWlnaHQ6IGRvdFNpemUsXG4gICAgICAgICAgICAgICAgYm9yZGVyUmFkaXVzOiAnNTAlJyxcbiAgICAgICAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IGNvbG9ycy5iYWNrZ3JvdW5kLFxuICAgICAgICAgICAgICAgIC8vIHdoaXRlIGJveCBzaGFkb3cgaGlnaGxpZ2h0XG4gICAgICAgICAgICAgICAgYW5pbWF0aW9uOiBgJHtkb3RzS2V5ZnJhbWVzfSAkeyh4ICsgeSkgJSAyID09PSAwID8gMi43IDogM31zIGluZmluaXRlYCxcbiAgICAgICAgICAgICAgICBhbmltYXRpb25EZWxheTogYCR7KCh4ICogeCkgLyBncmlkWCArIDQgKiB5KSAqIDAuMX1zYCxcbiAgICAgICAgICAgICAgICBhbmltYXRpb25UaW1pbmdGdW5jdGlvbjogJ2Vhc2UtaW4tb3V0JyxcbiAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgIC8+XG4gICAgICAgICAgKSl9XG4gICAgICAgIDwvRmxleFJvdz5cbiAgICAgICkpfVxuICAgIDwvRmxleENvbHVtbj5cbiAgKTtcbn07XG5cbmV4cG9ydCBjb25zdCBkb3RzS2V5ZnJhbWVzID0ga2V5ZnJhbWVzKHtcbiAgJzAlLCAxMDAlJzoge1xuICAgIHRyYW5zZm9ybTogJ3NjYWxlKDAuNSknLFxuICAgIGJveFNoYWRvdzogJzAgMCAxcHggMXB4ICNmZmZmZmY0ZicsXG4gIH0sXG4gICc1MCUnOiB7XG4gICAgdHJhbnNmb3JtOiAnc2NhbGUoMS41KScsXG4gICAgYm94U2hhZG93OiAnMCAwIDNweCAzcHggI2ZmZmZmZjcwJyxcbiAgfSxcbn0pO1xuIl19 */") }, C)) }, l)) });
}, Ly = Zt({
  "0%, 100%": {
    transform: "scale(0.5)",
    boxShadow: "0 0 1px 1px #ffffff4f"
  },
  "50%": {
    transform: "scale(1.5)",
    boxShadow: "0 0 3px 3px #ffffff70"
  }
}), ky = `
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.out-top {
    animation: rotate 20s linear infinite;
    transform-origin: 13px 25px;
}
.in-top {
    animation: rotate 10s linear infinite;
    transform-origin: 13px 25px;
}
.out-bottom {
    animation: rotate 25s linear infinite;
    transform-origin: 84px 93px;
}
.in-bottom {
    animation: rotate 15s linear infinite;
    transform-origin: 84px 93px;
}
`, Ey = () => /* @__PURE__ */ Vt("svg", { css: [ne, "background-color:#fee440;" + (process.env.NODE_ENV === "production" ? "" : ";label:Blobs;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], preserveAspectRatio: "xMidYMid slice", viewBox: "10 10 80 80", children: [
  /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("style", { children: ky }) }),
  /* @__PURE__ */ w("path", { fill: "#9b5de5", className: "out-top", d: "M37-5C25.1-14.7,5.7-19.1-9.2-10-28.5,1.8-32.7,31.1-19.8,49c15.5,21.5,52.6,22,67.2,2.3C59.4,35,53.7,8.5,37-5Z" }),
  /* @__PURE__ */ w("path", { fill: "#f15bb5", className: "in-top", d: "M20.6,4.1C11.6,1.5-1.9,2.5-8,11.2-16.3,23.1-8.2,45.6,7.4,50S42.1,38.9,41,24.5C40.2,14.1,29.4,6.6,20.6,4.1Z" }),
  /* @__PURE__ */ w("path", { fill: "#00bbf9", className: "out-bottom", d: "M105.9,48.6c-12.4-8.2-29.3-4.8-39.4.8-23.4,12.8-37.7,51.9-19.1,74.1s63.9,15.3,76-5.6c7.6-13.3,1.8-31.1-2.3-43.8C117.6,63.3,114.7,54.3,105.9,48.6Z" }),
  /* @__PURE__ */ w("path", { fill: "#00f5d4", className: "in-bottom", d: "M102,67.1c-9.6-6.1-22-3.1-29.5,2-15.4,10.7-19.6,37.5-7.6,47.8s35.9,3.9,44.5-12.5C115.5,92.6,113.9,74.6,102,67.1Z" })
] });
var jy = /* @__PURE__ */ ((t) => (t[t.Blobs = 0] = "Blobs", t[t.FloatingSquares = 1] = "FloatingSquares", t[t.FallingSpiral = 2] = "FallingSpiral", t[t.Dots = 3] = "Dots", t))(jy || {});
const f2 = (t) => {
  const {
    backdrop: e,
    noAnimation: n,
    ...g
  } = t, i = oe(() => {
    switch (e) {
      case 0:
        return /* @__PURE__ */ w(Ey, {});
      case 1:
        return /* @__PURE__ */ w(Iy, {});
      case 2:
        return /* @__PURE__ */ w(ry, {});
      case 3:
        return /* @__PURE__ */ w(Dy, {});
      default:
        return null;
    }
  }, [n, e]);
  return /* @__PURE__ */ w("div", { css: /* @__PURE__ */ Gt({
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    bottom: 0,
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
    zIndex: -100
  }, process.env.NODE_ENV === "production" ? "" : ";label:BackdropView;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL2JhY2tkcm9wcy9CYWNrZHJvcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0NNIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL2JhY2tkcm9wcy9CYWNrZHJvcC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb21wb25lbnRQcm9wcywgdXNlTWVtbyB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEZsb2F0aW5nU3F1YXJlcyB9IGZyb20gJy4vRmxvYXRpbmdTcXVhcmVzJztcbmltcG9ydCB7IEZhbGxpbmdTcGlyYWwgfSBmcm9tICcuL0ZhbGxpbmdTcGlyYWwnO1xuaW1wb3J0IHsgRG90cyB9IGZyb20gJy4vRG90cyc7XG5pbXBvcnQgeyBCbG9icyB9IGZyb20gJy4vQmxvYnMnO1xuXG5leHBvcnQgZW51bSBCYWNrZHJvcCB7XG4gIEJsb2JzLFxuICBGbG9hdGluZ1NxdWFyZXMsXG4gIEZhbGxpbmdTcGlyYWwsXG4gIERvdHMsXG59XG5cbmV4cG9ydCBpbnRlcmZhY2UgQmFja2Ryb3BQcm9wcyBleHRlbmRzIENvbXBvbmVudFByb3BzPCdkaXYnPiB7XG4gIG5vQW5pbWF0aW9uPzogYm9vbGVhbjtcbiAgYmFja2Ryb3A/OiBCYWNrZHJvcDtcbn1cblxuZXhwb3J0IGNvbnN0IEJhY2tkcm9wVmlldyA9IChwcm9wczogQmFja2Ryb3BQcm9wcykgPT4ge1xuICBjb25zdCB7IGJhY2tkcm9wLCBub0FuaW1hdGlvbiwgLi4ucmVzdCB9ID0gcHJvcHM7XG5cbiAgY29uc3Qgc2VsZWN0ZWRCYWNrZHJvcCA9IHVzZU1lbW8oKCkgPT4ge1xuICAgIHN3aXRjaCAoYmFja2Ryb3ApIHtcbiAgICAgIGNhc2UgQmFja2Ryb3AuQmxvYnM6XG4gICAgICAgIHJldHVybiA8QmxvYnMgLz47XG4gICAgICBjYXNlIEJhY2tkcm9wLkZsb2F0aW5nU3F1YXJlczpcbiAgICAgICAgcmV0dXJuIDxGbG9hdGluZ1NxdWFyZXMgLz47XG4gICAgICBjYXNlIEJhY2tkcm9wLkZhbGxpbmdTcGlyYWw6XG4gICAgICAgIHJldHVybiA8RmFsbGluZ1NwaXJhbCAvPjtcbiAgICAgIGNhc2UgQmFja2Ryb3AuRG90czpcbiAgICAgICAgcmV0dXJuIDxEb3RzIC8+O1xuICAgICAgZGVmYXVsdDpcbiAgICAgICAgcmV0dXJuIG51bGw7XG4gICAgfVxuICB9LCBbbm9BbmltYXRpb24sIGJhY2tkcm9wXSk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e3tcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiAncmdiYSgwLCAwLCAwLCAwLjUpJyxcbiAgICAgICAgYm90dG9tOiAwLFxuICAgICAgICBsZWZ0OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ2ZpeGVkJyxcbiAgICAgICAgcmlnaHQ6IDAsXG4gICAgICAgIHRvcDogMCxcbiAgICAgICAgekluZGV4OiAtMTAwLFxuICAgICAgfX1cbiAgICAgIHsuLi5yZXN0fVxuICAgID5cbiAgICAgIHtzZWxlY3RlZEJhY2tkcm9wfVxuICAgIDwvZGl2PlxuICApO1xufTtcbiJdfQ== */"), ...g, children: i });
}, My = (t) => {
  const {
    active: e
  } = t;
  return /* @__PURE__ */ w("div", { css: [{
    width: 10,
    height: 10,
    borderRadius: 5,
    transition: "0.4s",
    backgroundColor: e ? K.primary : K.border,
    scale: e ? "1.1" : "1"
  }, process.env.NODE_ENV === "production" ? "" : ";label:NavigationIndicator;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL3BhbmVscy9OYXZpZ2F0aW9uSW5kaWNhdG9yLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXTSIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay91aS91aS9zcmMvY29tbW9uL2NvbXBvbmVudHMvYmFzZS9wYW5lbHMvTmF2aWdhdGlvbkluZGljYXRvci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdGhlbWUnO1xuXG5leHBvcnQgaW50ZXJmYWNlIE5hdmlnYXRpb25JbmRpY2F0b3JQcm9wcyB7XG4gIGFjdGl2ZTogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IE5hdmlnYXRpb25JbmRpY2F0b3IgPSAocHJvcHM6IE5hdmlnYXRpb25JbmRpY2F0b3JQcm9wcykgPT4ge1xuICBjb25zdCB7IGFjdGl2ZSB9ID0gcHJvcHM7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e1tcbiAgICAgICAge1xuICAgICAgICAgIHdpZHRoOiAxMCxcbiAgICAgICAgICBoZWlnaHQ6IDEwLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogNSxcbiAgICAgICAgICB0cmFuc2l0aW9uOiAnMC40cycsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiBhY3RpdmUgPyBjb2xvcnMucHJpbWFyeSA6IGNvbG9ycy5ib3JkZXIsXG4gICAgICAgICAgc2NhbGU6IGFjdGl2ZSA/ICcxLjEnIDogJzEnLFxuICAgICAgICB9LFxuICAgICAgXX1cbiAgICAvPlxuICApO1xufTtcbiJdfQ== */"] });
}, Uy = (t) => {
  const {
    count: e,
    activeIndex: n
  } = t;
  return /* @__PURE__ */ w(Cg, { gap: 6, justifyContent: "space-between", children: Array.from({
    length: e
  }).map((g, i) => /* @__PURE__ */ w(My, { active: i === n }, i)) });
}, B2 = (t) => {
  const {
    children: e,
    titleText: n,
    ...g
  } = t;
  return /* @__PURE__ */ Vt(gi, { inset: !0, solid: !0, css: [ne, process.env.NODE_ENV === "production" ? "" : ";label:Panel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL3BhbmVscy9QYW5lbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY3NCIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL3BhbmVscy9QYW5lbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmdWxsU2l6ZSB9IGZyb20gJ0AvY29tbW9uL3N0eWxlcy91dGlscyc7XG5pbXBvcnQgeyBQYW5lbHNDb250ZXh0RGF0YSwgdXNlUGFuZWxzRGF0YSB9IGZyb20gJy4vUGFuZWxzJztcbmltcG9ydCB7IENhcmQgfSBmcm9tICcuLi9DYXJkJztcblxuZXhwb3J0IGludGVyZmFjZSBQYW5lbFByb3BzXG4gIGV4dGVuZHMgT21pdDxSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4sICdjaGlsZHJlbic+IHtcbiAgdGl0bGVUZXh0Pzogc3RyaW5nO1xuICBjaGlsZHJlbjogUmVhY3QuUmVhY3ROb2RlO1xufVxuXG5leHBvcnQgY29uc3QgUGFuZWwgPSAocHJvcHM6IFBhbmVsUHJvcHMpID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgdGl0bGVUZXh0LCAuLi5yZXN0IH0gPSBwcm9wcztcblxuICByZXR1cm4gKFxuICAgIDxDYXJkIGluc2V0IHNvbGlkIGNzcz17W2Z1bGxTaXplXX0gey4uLnJlc3R9PlxuICAgICAge3RpdGxlVGV4dCAmJiA8aDI+e3RpdGxlVGV4dH08L2gyPn1cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0NhcmQ+XG4gICk7XG59O1xuIl19 */"], ...g, children: [
    n && /* @__PURE__ */ w("h2", { children: n }),
    e
  ] });
}, Pi = cn(null), Y2 = () => {
  const t = St(Pi);
  if (!t)
    throw new Error("usePanelsData must be used within a PanelsContext");
  return t;
}, N2 = (t) => {
  const {
    panels: e,
    hidePageIndicators: n,
    hideNavigation: g,
    cycle: i,
    keepRendered: c,
    hasSound: A,
    noAnimation: l
  } = t, [a, C] = ee(null), [b, m] = ee(0), p = pn((B) => {
    C(b), m(B);
  }, [b]), y = !l, f = pn(() => {
    m((B) => (C(B), i ? (B - 1 + e.length) % e.length : Math.max(B - 1, 0)));
  }, [m, e, i]), x = pn(() => {
    m((B) => (C(B), i ? (B + 1) % e.length : Math.min(B + 1, e.length - 1)));
  }, [m, e, i]), Y = oe(() => a === null ? null : a === e.length - 1 && b === 0 ? "left" : a === 0 && b === e.length - 1 ? "right" : a < b ? "left" : "right", [a, b]);
  return /* @__PURE__ */ Vt(ds, { gap: 10, css: [ne, process.env.NODE_ENV === "production" ? "" : ";label:Panels;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
    /* @__PURE__ */ w("div", { css: [ni, _n(), "overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:Panels;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: c ? e.map((B, J) => {
      const N = {
        activePanelIndex: b,
        panelsCount: e.length,
        moveBack: f,
        moveForward: x,
        moveTo: p,
        panelIndex: J
      };
      return /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), ![b, a].includes(J) && {
        display: "none"
      }, y && J === b && Y && Hl(Y, void 0, void 0, "10px"), y && J === a && Y && wl(Y, void 0, void 0, "10px"), process.env.NODE_ENV === "production" ? "" : ";label:Panels;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w(Pi.Provider, { value: N, children: B instanceof Function ? B(N) : B }) }, J);
    }) : /* @__PURE__ */ Vt(XG, { children: [
      a !== null && /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), y && Y && wl(Y, void 0, void 0, "10px"), process.env.NODE_ENV === "production" ? "" : ";label:Panels;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: (() => {
        const B = {
          activePanelIndex: b,
          panelsCount: e.length,
          moveBack: f,
          moveForward: x,
          moveTo: p,
          panelIndex: a
        }, J = e[a];
        return /* @__PURE__ */ w(Pi.Provider, { value: B, children: J instanceof Function ? J(B) : J });
      })() }, a),
      /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), y && Y && Hl(Y, void 0, void 0, "10px"), process.env.NODE_ENV === "production" ? "" : ";label:Panels;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: (() => {
        const B = {
          activePanelIndex: b,
          panelsCount: e.length,
          moveBack: f,
          moveForward: x,
          moveTo: p,
          panelIndex: b
        }, J = e[b];
        return /* @__PURE__ */ w(Pi.Provider, { value: B, children: J instanceof Function ? J(B) : J });
      })() }, b)
    ] }) }),
    (!g || !n) && /* @__PURE__ */ Vt(Cg, { gap: 20, justifyContent: "center", alignItems: "center", children: [
      !g && /* @__PURE__ */ w(oA, { hasSound: A, disabled: !i && b <= 0, onClick: f, children: "⮜" }),
      !n && /* @__PURE__ */ w(Uy, { count: e.length, activeIndex: b }),
      !g && /* @__PURE__ */ w(oA, { hasSound: A, disabled: !i && b >= e.length - 1, onClick: x, children: "⮞" })
    ] })
  ] });
}, J2 = (t) => {
  const {
    children: e,
    titleText: n,
    ...g
  } = t;
  return /* @__PURE__ */ Vt(gi, { shadow: !0, inset: !0, solid: !0, css: [ne, process.env.NODE_ENV === "production" ? "" : ";label:Tab;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3VpL3VpL3NyYy9jb21tb24vY29tcG9uZW50cy9iYXNlL3RhYnMvVGFiLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZNkIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvdWkvdWkvc3JjL2NvbW1vbi9jb21wb25lbnRzL2Jhc2UvdGFicy9UYWIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZnVsbFNpemUgfSBmcm9tICdAL2NvbW1vbi9zdHlsZXMvdXRpbHMnO1xuaW1wb3J0IHsgQ2FyZCB9IGZyb20gJy4uL0NhcmQnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFRhYlByb3BzIGV4dGVuZHMgT21pdDxSZWFjdC5IVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4sICdjaGlsZHJlbic+IHtcbiAgdGl0bGVUZXh0Pzogc3RyaW5nO1xuICBjaGlsZHJlbjogUmVhY3QuUmVhY3ROb2RlO1xufVxuXG5leHBvcnQgY29uc3QgVGFiID0gKHByb3BzOiBUYWJQcm9wcykgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCB0aXRsZVRleHQsIC4uLnJlc3QgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPENhcmQgc2hhZG93IGluc2V0IHNvbGlkIGNzcz17W2Z1bGxTaXplXX0gey4uLnJlc3R9PlxuICAgICAge3RpdGxlVGV4dCAmJiA8aDI+e3RpdGxlVGV4dH08L2gyPn1cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0NhcmQ+XG4gICk7XG59O1xuIl19 */"], ...g, children: [
    n && /* @__PURE__ */ w("h2", { children: n }),
    e
  ] });
}, gr = /* @__PURE__ */ new Set();
function kI(t, e, n) {
  t || gr.has(e) || (console.warn(e), gr.add(e));
}
function Ty(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...g) => (process.env.NODE_ENV !== "production" && kI(!1, "motion() is deprecated. Use motion.create() instead."), t(...g));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (g, i) => i === "create" ? t : (e.has(i) || e.set(i, t(i)), e.get(i))
  });
}
function Qg(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const NA = (t) => Array.isArray(t);
function Uu(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let g = 0; g < n; g++)
    if (e[g] !== t[g])
      return !1;
  return !0;
}
function Og(t) {
  return typeof t == "string" || Array.isArray(t);
}
function ir(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, g) => {
    e[0][g] = n.get(), e[1][g] = n.getVelocity();
  }), e;
}
function xs(t, e, n, g) {
  if (typeof e == "function") {
    const [i, c] = ir(g);
    e = e(n !== void 0 ? n : t.custom, i, c);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, c] = ir(g);
    e = e(n !== void 0 ? n : t.custom, i, c);
  }
  return e;
}
function EI(t, e, n) {
  const g = t.getProps();
  return xs(g, e, n !== void 0 ? n : g.custom, t);
}
const Ws = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], fs = ["initial", ...Ws], ai = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], on = new Set(ai), Ve = (t) => t * 1e3, ze = (t) => t / 1e3, Qy = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Oy = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Py = {
  type: "keyframes",
  duration: 0.8
}, Ky = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, _y = (t, { keyframes: e }) => e.length > 2 ? Py : on.has(t) ? t.startsWith("scale") ? Oy(e[1]) : Qy : Ky;
function Bs(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const $y = {
  skipAnimations: !1,
  useManualTiming: !1
}, tv = (t) => t !== null;
function jI(t, { repeat: e, repeatType: n = "loop" }, g) {
  const i = t.filter(tv), c = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !c || g === void 0 ? i[c] : g;
}
const Jt = (t) => t;
function ev(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), g = !1, i = !1;
  const c = /* @__PURE__ */ new WeakSet();
  let A = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(C) {
    c.has(C) && (a.schedule(C), t()), C(A);
  }
  const a = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (C, b = !1, m = !1) => {
      const y = m && g ? e : n;
      return b && c.add(C), y.has(C) || y.add(C), C;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (C) => {
      n.delete(C), c.delete(C);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (C) => {
      if (A = C, g) {
        i = !0;
        return;
      }
      g = !0, [e, n] = [n, e], n.clear(), e.forEach(l), g = !1, i && (i = !1, a.process(C));
    }
  };
  return a;
}
const Ei = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], nv = 40;
function Tu(t, e) {
  let n = !1, g = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, c = () => n = !0, A = Ei.reduce((B, J) => (B[J] = ev(c), B), {}), { read: l, resolveKeyframes: a, update: C, preRender: b, render: m, postRender: p } = A, y = () => {
    const B = performance.now();
    n = !1, i.delta = g ? 1e3 / 60 : Math.max(Math.min(B - i.timestamp, nv), 1), i.timestamp = B, i.isProcessing = !0, l.process(i), a.process(i), C.process(i), b.process(i), m.process(i), p.process(i), i.isProcessing = !1, n && e && (g = !1, t(y));
  }, f = () => {
    n = !0, g = !0, i.isProcessing || t(y);
  };
  return { schedule: Ei.reduce((B, J) => {
    const N = A[J];
    return B[J] = (R, H = !1, E = !1) => (n || f(), N.schedule(R, H, E)), B;
  }, {}), cancel: (B) => {
    for (let J = 0; J < Ei.length; J++)
      A[Ei[J]].cancel(B);
  }, state: i, steps: A };
}
const { schedule: ot, cancel: en, state: Bt, steps: Qc } = Tu(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Jt, !0), Qu = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, gv = 1e-7, iv = 12;
function Iv(t, e, n, g, i) {
  let c, A, l = 0;
  do
    A = e + (n - e) / 2, c = Qu(A, g, i) - t, c > 0 ? n = A : e = A;
  while (Math.abs(c) > gv && ++l < iv);
  return A;
}
function Ci(t, e, n, g) {
  if (t === e && n === g)
    return Jt;
  const i = (c) => Iv(c, 0, 1, t, n);
  return (c) => c === 0 || c === 1 ? c : Qu(i(c), e, g);
}
const Ou = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Pu = (t) => (e) => 1 - t(1 - e), Ku = /* @__PURE__ */ Ci(0.33, 1.53, 0.69, 0.99), Ys = /* @__PURE__ */ Pu(Ku), _u = /* @__PURE__ */ Ou(Ys), $u = (t) => (t *= 2) < 1 ? 0.5 * Ys(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Ns = (t) => 1 - Math.sin(Math.acos(t)), tb = Pu(Ns), eb = Ou(Ns), nb = (t) => /^0[^.\s]+$/u.test(t);
function cv(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || nb(t) : !0;
}
let bg = Jt, nn = Jt;
process.env.NODE_ENV !== "production" && (bg = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, nn = (t, e) => {
  if (!t)
    throw new Error(e);
});
const gb = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), ib = (t) => (e) => typeof e == "string" && e.startsWith(t), Ib = /* @__PURE__ */ ib("--"), Av = /* @__PURE__ */ ib("var(--"), Js = (t) => Av(t) ? sv.test(t.split("/*")[0].trim()) : !1, sv = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, ov = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function lv(t) {
  const e = ov.exec(t);
  if (!e)
    return [,];
  const [, n, g, i] = e;
  return [`--${n ?? g}`, i];
}
const rv = 4;
function cb(t, e, n = 1) {
  nn(n <= rv, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [g, i] = lv(t);
  if (!g)
    return;
  const c = window.getComputedStyle(e).getPropertyValue(g);
  if (c) {
    const A = c.trim();
    return gb(A) ? parseFloat(A) : A;
  }
  return Js(i) ? cb(i, e, n + 1) : i;
}
const gn = (t, e, n) => n > e ? e : n < t ? t : n, dg = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Pg = {
  ...dg,
  transform: (t) => gn(0, 1, t)
}, ji = {
  ...dg,
  default: 1
}, ui = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Qe = /* @__PURE__ */ ui("deg"), Ze = /* @__PURE__ */ ui("%"), _ = /* @__PURE__ */ ui("px"), av = /* @__PURE__ */ ui("vh"), Cv = /* @__PURE__ */ ui("vw"), Ir = {
  ...Ze,
  parse: (t) => Ze.parse(t) / 100,
  transform: (t) => Ze.transform(t * 100)
}, uv = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), cr = (t) => t === dg || t === _, Ar = (t, e) => parseFloat(t.split(", ")[e]), sr = (t, e) => (n, { transform: g }) => {
  if (g === "none" || !g)
    return 0;
  const i = g.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return Ar(i[1], e);
  {
    const c = g.match(/^matrix\((.+)\)$/u);
    return c ? Ar(c[1], t) : 0;
  }
}, bv = /* @__PURE__ */ new Set(["x", "y", "z"]), dv = ai.filter((t) => !bv.has(t));
function Gv(t) {
  const e = [];
  return dv.forEach((n) => {
    const g = t.getValue(n);
    g !== void 0 && (e.push([n, g.get()]), g.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const cg = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: sr(4, 13),
  y: sr(5, 14)
};
cg.translateX = cg.x;
cg.translateY = cg.y;
const Ab = (t) => (e) => e.test(t), mv = {
  test: (t) => t === "auto",
  parse: (t) => t
}, sb = [dg, _, Ze, Qe, Cv, av, mv], or = (t) => sb.find(Ab(t)), vn = /* @__PURE__ */ new Set();
let JA = !1, RA = !1;
function ob() {
  if (RA) {
    const t = Array.from(vn).filter((g) => g.needsMeasurement), e = new Set(t.map((g) => g.element)), n = /* @__PURE__ */ new Map();
    e.forEach((g) => {
      const i = Gv(g);
      i.length && (n.set(g, i), g.render());
    }), t.forEach((g) => g.measureInitialState()), e.forEach((g) => {
      g.render();
      const i = n.get(g);
      i && i.forEach(([c, A]) => {
        var l;
        (l = g.getValue(c)) === null || l === void 0 || l.set(A);
      });
    }), t.forEach((g) => g.measureEndState()), t.forEach((g) => {
      g.suspendedScrollY !== void 0 && window.scrollTo(0, g.suspendedScrollY);
    });
  }
  RA = !1, JA = !1, vn.forEach((t) => t.complete()), vn.clear();
}
function lb() {
  vn.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (RA = !0);
  });
}
function hv() {
  lb(), ob();
}
class Rs {
  constructor(e, n, g, i, c, A = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = g, this.motionValue = i, this.element = c, this.isAsync = A;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (vn.add(this), JA || (JA = !0, ot.read(lb), ot.resolveKeyframes(ob))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: g, motionValue: i } = this;
    for (let c = 0; c < e.length; c++)
      if (e[c] === null)
        if (c === 0) {
          const A = i == null ? void 0 : i.get(), l = e[e.length - 1];
          if (A !== void 0)
            e[0] = A;
          else if (g && n) {
            const a = g.readValue(n, l);
            a != null && (e[0] = a);
          }
          e[0] === void 0 && (e[0] = l), i && A === void 0 && i.set(e[0]);
        } else
          e[c] = e[c - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), vn.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, vn.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const zg = (t) => Math.round(t * 1e5) / 1e5, Ss = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function pv(t) {
  return t == null;
}
const Vv = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Fs = (t, e) => (n) => !!(typeof n == "string" && Vv.test(n) && n.startsWith(t) || e && !pv(n) && Object.prototype.hasOwnProperty.call(n, e)), rb = (t, e, n) => (g) => {
  if (typeof g != "string")
    return g;
  const [i, c, A, l] = g.match(Ss);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(c),
    [n]: parseFloat(A),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, Zv = (t) => gn(0, 255, t), Oc = {
  ...dg,
  transform: (t) => Math.round(Zv(t))
}, hn = {
  test: /* @__PURE__ */ Fs("rgb", "red"),
  parse: /* @__PURE__ */ rb("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: g = 1 }) => "rgba(" + Oc.transform(t) + ", " + Oc.transform(e) + ", " + Oc.transform(n) + ", " + zg(Pg.transform(g)) + ")"
};
function yv(t) {
  let e = "", n = "", g = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), g = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), g = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, g += g, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(g, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const SA = {
  test: /* @__PURE__ */ Fs("#"),
  parse: yv,
  transform: hn.transform
}, En = {
  test: /* @__PURE__ */ Fs("hsl", "hue"),
  parse: /* @__PURE__ */ rb("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: g = 1 }) => "hsla(" + Math.round(t) + ", " + Ze.transform(zg(e)) + ", " + Ze.transform(zg(n)) + ", " + zg(Pg.transform(g)) + ")"
}, Rt = {
  test: (t) => hn.test(t) || SA.test(t) || En.test(t),
  parse: (t) => hn.test(t) ? hn.parse(t) : En.test(t) ? En.parse(t) : SA.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? hn.transform(t) : En.transform(t)
}, vv = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Xv(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(Ss)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(vv)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const ab = "number", Cb = "color", xv = "var", Wv = "var(", lr = "${}", fv = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Kg(t) {
  const e = t.toString(), n = [], g = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let c = 0;
  const l = e.replace(fv, (a) => (Rt.test(a) ? (g.color.push(c), i.push(Cb), n.push(Rt.parse(a))) : a.startsWith(Wv) ? (g.var.push(c), i.push(xv), n.push(a)) : (g.number.push(c), i.push(ab), n.push(parseFloat(a))), ++c, lr)).split(lr);
  return { values: n, split: l, indexes: g, types: i };
}
function ub(t) {
  return Kg(t).values;
}
function bb(t) {
  const { split: e, types: n } = Kg(t), g = e.length;
  return (i) => {
    let c = "";
    for (let A = 0; A < g; A++)
      if (c += e[A], i[A] !== void 0) {
        const l = n[A];
        l === ab ? c += zg(i[A]) : l === Cb ? c += Rt.transform(i[A]) : c += i[A];
      }
    return c;
  };
}
const Bv = (t) => typeof t == "number" ? 0 : t;
function Yv(t) {
  const e = ub(t);
  return bb(t)(e.map(Bv));
}
const In = {
  test: Xv,
  parse: ub,
  createTransformer: bb,
  getAnimatableNone: Yv
}, Nv = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Jv(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [g] = n.match(Ss) || [];
  if (!g)
    return t;
  const i = n.replace(g, "");
  let c = Nv.has(e) ? 1 : 0;
  return g !== n && (c *= 100), e + "(" + c + i + ")";
}
const Rv = /\b([a-z-]*)\(.*?\)/gu, FA = {
  ...In,
  getAnimatableNone: (t) => {
    const e = t.match(Rv);
    return e ? e.map(Jv).join(" ") : t;
  }
}, Sv = {
  // Border props
  borderWidth: _,
  borderTopWidth: _,
  borderRightWidth: _,
  borderBottomWidth: _,
  borderLeftWidth: _,
  borderRadius: _,
  radius: _,
  borderTopLeftRadius: _,
  borderTopRightRadius: _,
  borderBottomRightRadius: _,
  borderBottomLeftRadius: _,
  // Positioning props
  width: _,
  maxWidth: _,
  height: _,
  maxHeight: _,
  top: _,
  right: _,
  bottom: _,
  left: _,
  // Spacing props
  padding: _,
  paddingTop: _,
  paddingRight: _,
  paddingBottom: _,
  paddingLeft: _,
  margin: _,
  marginTop: _,
  marginRight: _,
  marginBottom: _,
  marginLeft: _,
  // Misc
  backgroundPositionX: _,
  backgroundPositionY: _
}, Fv = {
  rotate: Qe,
  rotateX: Qe,
  rotateY: Qe,
  rotateZ: Qe,
  scale: ji,
  scaleX: ji,
  scaleY: ji,
  scaleZ: ji,
  skew: Qe,
  skewX: Qe,
  skewY: Qe,
  distance: _,
  translateX: _,
  translateY: _,
  translateZ: _,
  x: _,
  y: _,
  z: _,
  perspective: _,
  transformPerspective: _,
  opacity: Pg,
  originX: Ir,
  originY: Ir,
  originZ: _
}, rr = {
  ...dg,
  transform: Math.round
}, Hs = {
  ...Sv,
  ...Fv,
  zIndex: rr,
  size: _,
  // SVG
  fillOpacity: Pg,
  strokeOpacity: Pg,
  numOctaves: rr
}, Hv = {
  ...Hs,
  // Color props
  color: Rt,
  backgroundColor: Rt,
  outlineColor: Rt,
  fill: Rt,
  stroke: Rt,
  // Border props
  borderColor: Rt,
  borderTopColor: Rt,
  borderRightColor: Rt,
  borderBottomColor: Rt,
  borderLeftColor: Rt,
  filter: FA,
  WebkitFilter: FA
}, ws = (t) => Hv[t];
function db(t, e) {
  let n = ws(t);
  return n !== FA && (n = In), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const wv = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function zv(t, e, n) {
  let g = 0, i;
  for (; g < t.length && !i; ) {
    const c = t[g];
    typeof c == "string" && !wv.has(c) && Kg(c).values.length && (i = t[g]), g++;
  }
  if (i && n)
    for (const c of e)
      t[c] = db(n, i);
}
class Gb extends Rs {
  constructor(e, n, g, i, c) {
    super(e, n, g, i, c, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: g } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let a = 0; a < e.length; a++) {
      let C = e[a];
      if (typeof C == "string" && (C = C.trim(), Js(C))) {
        const b = cb(C, n.current);
        b !== void 0 && (e[a] = b), a === e.length - 1 && (this.finalKeyframe = C);
      }
    }
    if (this.resolveNoneKeyframes(), !uv.has(g) || e.length !== 2)
      return;
    const [i, c] = e, A = or(i), l = or(c);
    if (A !== l)
      if (cr(A) && cr(l))
        for (let a = 0; a < e.length; a++) {
          const C = e[a];
          typeof C == "string" && (e[a] = parseFloat(C));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, g = [];
    for (let i = 0; i < e.length; i++)
      cv(e[i]) && g.push(i);
    g.length && zv(e, g, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: g } = this;
    if (!e || !e.current)
      return;
    g === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = cg[g](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(g, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: g, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const c = n.getValue(g);
    c && c.jump(this.measuredOrigin, !1);
    const A = i.length - 1, l = i[A];
    i[A] = cg[g](n.measureViewportBox(), window.getComputedStyle(n.current)), l !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = l), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([a, C]) => {
      n.getValue(a).set(C);
    }), this.resolveNoneKeyframes();
  }
}
function zs(t) {
  return typeof t == "function";
}
let Ki;
function qv() {
  Ki = void 0;
}
const ye = {
  now: () => (Ki === void 0 && ye.set(Bt.isProcessing || $y.useManualTiming ? Bt.timestamp : performance.now()), Ki),
  set: (t) => {
    Ki = t, queueMicrotask(qv);
  }
}, ar = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(In.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function Dv(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function Lv(t, e, n, g) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const c = t[t.length - 1], A = ar(i, e), l = ar(c, e);
  return bg(A === l, `You are trying to animate ${e} from "${i}" to "${c}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${c} via the \`style\` property.`), !A || !l ? !1 : Dv(t) || (n === "spring" || zs(n)) && g;
}
const kv = 40;
class mb {
  constructor({ autoplay: e = !0, delay: n = 0, type: g = "keyframes", repeat: i = 0, repeatDelay: c = 0, repeatType: A = "loop", ...l }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = ye.now(), this.options = {
      autoplay: e,
      delay: n,
      type: g,
      repeat: i,
      repeatDelay: c,
      repeatType: A,
      ...l
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > kv ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && hv(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.resolvedAt = ye.now(), this.hasAttemptedResolve = !0;
    const { name: g, type: i, velocity: c, delay: A, onComplete: l, onUpdate: a, isGenerator: C } = this.options;
    if (!C && !Lv(e, g, i, c))
      if (A)
        this.options.duration = 0;
      else {
        a == null || a(jI(e, this.options, n)), l == null || l(), this.resolveFinishedPromise();
        return;
      }
    const b = this.initPlayback(e, n);
    b !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...b
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
function hb(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Ev = 5;
function pb(t, e, n) {
  const g = Math.max(e - Ev, 0);
  return hb(n - t(g), e - g);
}
const Pc = 1e-3, jv = 0.01, Cr = 10, Mv = 0.05, Uv = 1;
function Tv({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: g = 1 }) {
  let i, c;
  bg(t <= Ve(Cr), "Spring duration must be 10 seconds or less");
  let A = 1 - e;
  A = gn(Mv, Uv, A), t = gn(jv, Cr, ze(t)), A < 1 ? (i = (C) => {
    const b = C * A, m = b * t, p = b - n, y = HA(C, A), f = Math.exp(-m);
    return Pc - p / y * f;
  }, c = (C) => {
    const m = C * A * t, p = m * n + n, y = Math.pow(A, 2) * Math.pow(C, 2) * t, f = Math.exp(-m), x = HA(Math.pow(C, 2), A);
    return (-i(C) + Pc > 0 ? -1 : 1) * ((p - y) * f) / x;
  }) : (i = (C) => {
    const b = Math.exp(-C * t), m = (C - n) * t + 1;
    return -Pc + b * m;
  }, c = (C) => {
    const b = Math.exp(-C * t), m = (n - C) * (t * t);
    return b * m;
  });
  const l = 5 / t, a = Ov(i, c, l);
  if (t = Ve(t), isNaN(a))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const C = Math.pow(a, 2) * g;
    return {
      stiffness: C,
      damping: A * 2 * Math.sqrt(g * C),
      duration: t
    };
  }
}
const Qv = 12;
function Ov(t, e, n) {
  let g = n;
  for (let i = 1; i < Qv; i++)
    g = g - t(g) / e(g);
  return g;
}
function HA(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Pv = ["duration", "bounce"], Kv = ["stiffness", "damping", "mass"];
function ur(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function _v(t) {
  let e = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!ur(t, Kv) && ur(t, Pv)) {
    const n = Tv(t);
    e = {
      ...e,
      ...n,
      mass: 1
    }, e.isResolvedFromDuration = !0;
  }
  return e;
}
function Vb({ keyframes: t, restDelta: e, restSpeed: n, ...g }) {
  const i = t[0], c = t[t.length - 1], A = { done: !1, value: i }, { stiffness: l, damping: a, mass: C, duration: b, velocity: m, isResolvedFromDuration: p } = _v({
    ...g,
    velocity: -ze(g.velocity || 0)
  }), y = m || 0, f = a / (2 * Math.sqrt(l * C)), x = c - i, Y = ze(Math.sqrt(l / C)), B = Math.abs(x) < 5;
  n || (n = B ? 0.01 : 2), e || (e = B ? 5e-3 : 0.5);
  let J;
  if (f < 1) {
    const N = HA(Y, f);
    J = (R) => {
      const H = Math.exp(-f * Y * R);
      return c - H * ((y + f * Y * x) / N * Math.sin(N * R) + x * Math.cos(N * R));
    };
  } else if (f === 1)
    J = (N) => c - Math.exp(-Y * N) * (x + (y + Y * x) * N);
  else {
    const N = Y * Math.sqrt(f * f - 1);
    J = (R) => {
      const H = Math.exp(-f * Y * R), E = Math.min(N * R, 300);
      return c - H * ((y + f * Y * x) * Math.sinh(E) + N * x * Math.cosh(E)) / N;
    };
  }
  return {
    calculatedDuration: p && b || null,
    next: (N) => {
      const R = J(N);
      if (p)
        A.done = N >= b;
      else {
        let H = 0;
        f < 1 && (H = N === 0 ? Ve(y) : pb(J, N, R));
        const E = Math.abs(H) <= n, O = Math.abs(c - R) <= e;
        A.done = E && O;
      }
      return A.value = A.done ? c : R, A;
    }
  };
}
function br({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: g = 325, bounceDamping: i = 10, bounceStiffness: c = 500, modifyTarget: A, min: l, max: a, restDelta: C = 0.5, restSpeed: b }) {
  const m = t[0], p = {
    done: !1,
    value: m
  }, y = (j) => l !== void 0 && j < l || a !== void 0 && j > a, f = (j) => l === void 0 ? a : a === void 0 || Math.abs(l - j) < Math.abs(a - j) ? l : a;
  let x = n * e;
  const Y = m + x, B = A === void 0 ? Y : A(Y);
  B !== Y && (x = B - m);
  const J = (j) => -x * Math.exp(-j / g), N = (j) => B + J(j), R = (j) => {
    const U = J(j), D = N(j);
    p.done = Math.abs(U) <= C, p.value = p.done ? B : D;
  };
  let H, E;
  const O = (j) => {
    y(p.value) && (H = j, E = Vb({
      keyframes: [p.value, f(p.value)],
      velocity: pb(N, j, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: c,
      restDelta: C,
      restSpeed: b
    }));
  };
  return O(0), {
    calculatedDuration: null,
    next: (j) => {
      let U = !1;
      return !E && H === void 0 && (U = !0, R(j), O(j)), H !== void 0 && j >= H ? E.next(j - H) : (!U && R(j), p);
    }
  };
}
const $v = /* @__PURE__ */ Ci(0.42, 0, 1, 1), tX = /* @__PURE__ */ Ci(0, 0, 0.58, 1), Zb = /* @__PURE__ */ Ci(0.42, 0, 0.58, 1), eX = (t) => Array.isArray(t) && typeof t[0] != "number", qs = (t) => Array.isArray(t) && typeof t[0] == "number", dr = {
  linear: Jt,
  easeIn: $v,
  easeInOut: Zb,
  easeOut: tX,
  circIn: Ns,
  circInOut: eb,
  circOut: tb,
  backIn: Ys,
  backInOut: _u,
  backOut: Ku,
  anticipate: $u
}, Gr = (t) => {
  if (qs(t)) {
    nn(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, g, i] = t;
    return Ci(e, n, g, i);
  } else if (typeof t == "string")
    return nn(dr[t] !== void 0, `Invalid easing type '${t}'`), dr[t];
  return t;
}, nX = (t, e) => (n) => e(t(n)), qe = (...t) => t.reduce(nX), Ag = (t, e, n) => {
  const g = e - t;
  return g === 0 ? 1 : (n - t) / g;
}, ut = (t, e, n) => t + (e - t) * n;
function Kc(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function gX({ hue: t, saturation: e, lightness: n, alpha: g }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, c = 0, A = 0;
  if (!e)
    i = c = A = n;
  else {
    const l = n < 0.5 ? n * (1 + e) : n + e - n * e, a = 2 * n - l;
    i = Kc(a, l, t + 1 / 3), c = Kc(a, l, t), A = Kc(a, l, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(c * 255),
    blue: Math.round(A * 255),
    alpha: g
  };
}
function pI(t, e) {
  return (n) => n > 0 ? e : t;
}
const _c = (t, e, n) => {
  const g = t * t, i = n * (e * e - g) + g;
  return i < 0 ? 0 : Math.sqrt(i);
}, iX = [SA, hn, En], IX = (t) => iX.find((e) => e.test(t));
function mr(t) {
  const e = IX(t);
  if (bg(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === En && (n = gX(n)), n;
}
const hr = (t, e) => {
  const n = mr(t), g = mr(e);
  if (!n || !g)
    return pI(t, e);
  const i = { ...n };
  return (c) => (i.red = _c(n.red, g.red, c), i.green = _c(n.green, g.green, c), i.blue = _c(n.blue, g.blue, c), i.alpha = ut(n.alpha, g.alpha, c), hn.transform(i));
}, wA = /* @__PURE__ */ new Set(["none", "hidden"]);
function cX(t, e) {
  return wA.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function AX(t, e) {
  return (n) => ut(t, e, n);
}
function Ds(t) {
  return typeof t == "number" ? AX : typeof t == "string" ? Js(t) ? pI : Rt.test(t) ? hr : lX : Array.isArray(t) ? yb : typeof t == "object" ? Rt.test(t) ? hr : sX : pI;
}
function yb(t, e) {
  const n = [...t], g = n.length, i = t.map((c, A) => Ds(c)(c, e[A]));
  return (c) => {
    for (let A = 0; A < g; A++)
      n[A] = i[A](c);
    return n;
  };
}
function sX(t, e) {
  const n = { ...t, ...e }, g = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (g[i] = Ds(t[i])(t[i], e[i]));
  return (i) => {
    for (const c in g)
      n[c] = g[c](i);
    return n;
  };
}
function oX(t, e) {
  var n;
  const g = [], i = { color: 0, var: 0, number: 0 };
  for (let c = 0; c < e.values.length; c++) {
    const A = e.types[c], l = t.indexes[A][i[A]], a = (n = t.values[l]) !== null && n !== void 0 ? n : 0;
    g[c] = a, i[A]++;
  }
  return g;
}
const lX = (t, e) => {
  const n = In.createTransformer(e), g = Kg(t), i = Kg(e);
  return g.indexes.var.length === i.indexes.var.length && g.indexes.color.length === i.indexes.color.length && g.indexes.number.length >= i.indexes.number.length ? wA.has(t) && !i.values.length || wA.has(e) && !g.values.length ? cX(t, e) : qe(yb(oX(g, i), i.values), n) : (bg(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), pI(t, e));
};
function vb(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? ut(t, e, n) : Ds(t)(t, e);
}
function rX(t, e, n) {
  const g = [], i = n || vb, c = t.length - 1;
  for (let A = 0; A < c; A++) {
    let l = i(t[A], t[A + 1]);
    if (e) {
      const a = Array.isArray(e) ? e[A] || Jt : e;
      l = qe(a, l);
    }
    g.push(l);
  }
  return g;
}
function aX(t, e, { clamp: n = !0, ease: g, mixer: i } = {}) {
  const c = t.length;
  if (nn(c === e.length, "Both input and output ranges must be the same length"), c === 1)
    return () => e[0];
  if (c === 2 && t[0] === t[1])
    return () => e[1];
  t[0] > t[c - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const A = rX(e, g, i), l = A.length, a = (C) => {
    let b = 0;
    if (l > 1)
      for (; b < t.length - 2 && !(C < t[b + 1]); b++)
        ;
    const m = Ag(t[b], t[b + 1], C);
    return A[b](m);
  };
  return n ? (C) => a(gn(t[0], t[c - 1], C)) : a;
}
function CX(t, e) {
  const n = t[t.length - 1];
  for (let g = 1; g <= e; g++) {
    const i = Ag(0, e, g);
    t.push(ut(n, 1, i));
  }
}
function uX(t) {
  const e = [0];
  return CX(e, t.length - 1), e;
}
function bX(t, e) {
  return t.map((n) => n * e);
}
function dX(t, e) {
  return t.map(() => e || Zb).splice(0, t.length - 1);
}
function VI({ duration: t = 300, keyframes: e, times: n, ease: g = "easeInOut" }) {
  const i = eX(g) ? g.map(Gr) : Gr(g), c = {
    done: !1,
    value: e[0]
  }, A = bX(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : uX(e),
    t
  ), l = aX(A, e, {
    ease: Array.isArray(i) ? i : dX(e, i)
  });
  return {
    calculatedDuration: t,
    next: (a) => (c.value = l(a), c.done = a >= t, c)
  };
}
const pr = 2e4;
function GX(t) {
  let e = 0;
  const n = 50;
  let g = t.next(e);
  for (; !g.done && e < pr; )
    e += n, g = t.next(e);
  return e >= pr ? 1 / 0 : e;
}
const mX = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => ot.update(e, !0),
    stop: () => en(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Bt.isProcessing ? Bt.timestamp : ye.now()
  };
}, hX = {
  decay: br,
  inertia: br,
  tween: VI,
  keyframes: VI,
  spring: Vb
}, pX = (t) => t / 100;
class Ls extends mb {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: a } = this.options;
      a && a();
    };
    const { name: n, motionValue: g, element: i, keyframes: c } = this.options, A = (i == null ? void 0 : i.KeyframeResolver) || Rs, l = (a, C) => this.onKeyframesResolved(a, C);
    this.resolver = new A(c, l, n, g, i), this.resolver.scheduleResolve();
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: g = 0, repeatDelay: i = 0, repeatType: c, velocity: A = 0 } = this.options, l = zs(n) ? n : hX[n] || VI;
    let a, C;
    l !== VI && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && nn(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), a = qe(pX, vb(e[0], e[1])), e = [0, 100]);
    const b = l({ ...this.options, keyframes: e });
    c === "mirror" && (C = l({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -A
    })), b.calculatedDuration === null && (b.calculatedDuration = GX(b));
    const { calculatedDuration: m } = b, p = m + i, y = p * (g + 1) - i;
    return {
      generator: b,
      mirroredGenerator: C,
      mapPercentToKeyframes: a,
      calculatedDuration: m,
      resolvedDuration: p,
      totalDuration: y
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: g } = this;
    if (!g) {
      const { keyframes: j } = this.options;
      return { done: !0, value: j[j.length - 1] };
    }
    const { finalKeyframe: i, generator: c, mirroredGenerator: A, mapPercentToKeyframes: l, keyframes: a, calculatedDuration: C, totalDuration: b, resolvedDuration: m } = g;
    if (this.startTime === null)
      return c.next(0);
    const { delay: p, repeat: y, repeatType: f, repeatDelay: x, onUpdate: Y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - b / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const B = this.currentTime - p * (this.speed >= 0 ? 1 : -1), J = this.speed >= 0 ? B < 0 : B > b;
    this.currentTime = Math.max(B, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = b);
    let N = this.currentTime, R = c;
    if (y) {
      const j = Math.min(this.currentTime, b) / m;
      let U = Math.floor(j), D = j % 1;
      !D && j >= 1 && (D = 1), D === 1 && U--, U = Math.min(U, y + 1), !!(U % 2) && (f === "reverse" ? (D = 1 - D, x && (D -= x / m)) : f === "mirror" && (R = A)), N = gn(0, 1, D) * m;
    }
    const H = J ? { done: !1, value: a[0] } : R.next(N);
    l && (H.value = l(H.value));
    let { done: E } = H;
    !J && C !== null && (E = this.speed >= 0 ? this.currentTime >= b : this.currentTime <= 0);
    const O = this.holdTime === null && (this.state === "finished" || this.state === "running" && E);
    return O && i !== void 0 && (H.value = jI(a, this.options, i)), Y && Y(H.value), O && this.finish(), H;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? ze(e.calculatedDuration) : 0;
  }
  get time() {
    return ze(this.currentTime);
  }
  set time(e) {
    e = Ve(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = ze(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = mX, onPlay: n, startTime: g } = this.options;
    this.driver || (this.driver = e((c) => this.tick(c))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = g ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const Xb = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), VX = 10, ZX = (t, e) => {
  let n = "";
  const g = Math.max(Math.round(e / VX), 2);
  for (let i = 0; i < g; i++)
    n += t(Ag(0, g - 1, i)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function ks(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const yX = {
  linearEasing: void 0
};
function vX(t, e) {
  const n = ks(t);
  return () => {
    var g;
    return (g = yX[e]) !== null && g !== void 0 ? g : n();
  };
}
const ZI = /* @__PURE__ */ vX(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function xb(t) {
  return !!(typeof t == "function" && ZI() || !t || typeof t == "string" && (t in zA || ZI()) || qs(t) || Array.isArray(t) && t.every(xb));
}
const Sg = ([t, e, n, g]) => `cubic-bezier(${t}, ${e}, ${n}, ${g})`, zA = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Sg([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Sg([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Sg([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Sg([0.33, 1.53, 0.69, 0.99])
};
function Wb(t, e) {
  if (t)
    return typeof t == "function" && ZI() ? ZX(t, e) : qs(t) ? Sg(t) : Array.isArray(t) ? t.map((n) => Wb(n, e) || zA.easeOut) : zA[t];
}
function XX(t, e, n, { delay: g = 0, duration: i = 300, repeat: c = 0, repeatType: A = "loop", ease: l, times: a } = {}) {
  const C = { [e]: n };
  a && (C.offset = a);
  const b = Wb(l, i);
  return Array.isArray(b) && (C.easing = b), t.animate(C, {
    delay: g,
    duration: i,
    easing: Array.isArray(b) ? "linear" : b,
    fill: "both",
    iterations: c + 1,
    direction: A === "reverse" ? "alternate" : "normal"
  });
}
function Vr(t, e) {
  t.timeline = e, t.onfinish = null;
}
const xX = /* @__PURE__ */ ks(() => Object.hasOwnProperty.call(Element.prototype, "animate")), yI = 10, WX = 2e4;
function fX(t) {
  return zs(t.type) || t.type === "spring" || !xb(t.ease);
}
function BX(t, e) {
  const n = new Ls({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let g = { done: !1, value: t[0] };
  const i = [];
  let c = 0;
  for (; !g.done && c < WX; )
    g = n.sample(c), i.push(g.value), c += yI;
  return {
    times: void 0,
    keyframes: i,
    duration: c - yI,
    ease: "linear"
  };
}
const fb = {
  anticipate: $u,
  backInOut: _u,
  circInOut: eb
};
function YX(t) {
  return t in fb;
}
class Zr extends mb {
  constructor(e) {
    super(e);
    const { name: n, motionValue: g, element: i, keyframes: c } = this.options;
    this.resolver = new Gb(c, (A, l) => this.onKeyframesResolved(A, l), n, g, i), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    var g;
    let { duration: i = 300, times: c, ease: A, type: l, motionValue: a, name: C, startTime: b } = this.options;
    if (!(!((g = a.owner) === null || g === void 0) && g.current))
      return !1;
    if (typeof A == "string" && ZI() && YX(A) && (A = fb[A]), fX(this.options)) {
      const { onComplete: p, onUpdate: y, motionValue: f, element: x, ...Y } = this.options, B = BX(e, Y);
      e = B.keyframes, e.length === 1 && (e[1] = e[0]), i = B.duration, c = B.times, A = B.ease, l = "keyframes";
    }
    const m = XX(a.owner.current, C, e, { ...this.options, duration: i, times: c, ease: A });
    return m.startTime = b ?? this.calcStartTime(), this.pendingTimeline ? (Vr(m, this.pendingTimeline), this.pendingTimeline = void 0) : m.onfinish = () => {
      const { onComplete: p } = this.options;
      a.set(jI(e, this.options, n)), p && p(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: m,
      duration: i,
      times: c,
      type: l,
      ease: A,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return ze(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return ze(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: g } = n;
    g.currentTime = Ve(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: g } = n;
    g.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: n } = e;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return Jt;
      const { animation: g } = n;
      Vr(g, e);
    }
    return Jt;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: g, duration: i, type: c, ease: A, times: l } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: C, onUpdate: b, onComplete: m, element: p, ...y } = this.options, f = new Ls({
        ...y,
        keyframes: g,
        duration: i,
        type: c,
        ease: A,
        times: l,
        isGenerator: !0
      }), x = Ve(this.time);
      C.setWithVelocity(f.sample(x - yI).value, f.sample(x).value, yI);
    }
    const { onStop: a } = this.options;
    a && a(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: g, repeatDelay: i, repeatType: c, damping: A, type: l } = e;
    return xX() && g && Xb.has(g) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !i && c !== "mirror" && A !== 0 && l !== "inertia";
  }
}
const NX = ks(() => window.ScrollTimeline !== void 0);
class JX {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let g = 0; g < this.animations.length; g++)
      this.animations[g][e] = n;
  }
  attachTimeline(e, n) {
    const g = this.animations.map((i) => NX() && i.attachTimeline ? i.attachTimeline(e) : n(i));
    return () => {
      g.forEach((i, c) => {
        i && i(), this.animations[c].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function RX({ when: t, delay: e, delayChildren: n, staggerChildren: g, staggerDirection: i, repeat: c, repeatType: A, repeatDelay: l, from: a, elapsed: C, ...b }) {
  return !!Object.keys(b).length;
}
const Es = (t, e, n, g = {}, i, c) => (A) => {
  const l = Bs(g, t) || {}, a = l.delay || g.delay || 0;
  let { elapsed: C = 0 } = g;
  C = C - Ve(a);
  let b = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...l,
    delay: -C,
    onUpdate: (p) => {
      e.set(p), l.onUpdate && l.onUpdate(p);
    },
    onComplete: () => {
      A(), l.onComplete && l.onComplete();
    },
    name: t,
    motionValue: e,
    element: c ? void 0 : i
  };
  RX(l) || (b = {
    ...b,
    ..._y(t, b)
  }), b.duration && (b.duration = Ve(b.duration)), b.repeatDelay && (b.repeatDelay = Ve(b.repeatDelay)), b.from !== void 0 && (b.keyframes[0] = b.from);
  let m = !1;
  if ((b.type === !1 || b.duration === 0 && !b.repeatDelay) && (b.duration = 0, b.delay === 0 && (m = !0)), m && !c && e.get() !== void 0) {
    const p = jI(b.keyframes, l);
    if (p !== void 0)
      return ot.update(() => {
        b.onUpdate(p), b.onComplete();
      }), new JX([]);
  }
  return !c && Zr.supports(b) ? new Zr(b) : new Ls(b);
}, SX = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), FX = (t) => NA(t) ? t[t.length - 1] || 0 : t;
function js(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ms(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class Us {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return js(this.subscriptions, e), () => Ms(this.subscriptions, e);
  }
  notify(e, n, g) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, g);
      else
        for (let c = 0; c < i; c++) {
          const A = this.subscriptions[c];
          A && A(e, n, g);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const yr = 30, HX = (t) => !isNaN(parseFloat(t));
class wX {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.11.8", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (g, i = !0) => {
      const c = ye.now();
      this.updatedAt !== c && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(g), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = ye.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = HX(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && kI(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Us());
    const g = this.events[e].add(n);
    return e === "change" ? () => {
      g(), ot.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : g;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, g) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - g;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = ye.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > yr)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, yr);
    return hb(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function _g(t, e) {
  return new wX(t, e);
}
function zX(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, _g(n));
}
function qX(t, e) {
  const n = EI(t, e);
  let { transitionEnd: g = {}, transition: i = {}, ...c } = n || {};
  c = { ...c, ...g };
  for (const A in c) {
    const l = FX(c[A]);
    zX(t, A, l);
  }
}
const MI = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), DX = "framerAppearId", Bb = "data-" + MI(DX);
function Yb(t) {
  return t.props[Bb];
}
const Ht = (t) => !!(t && t.getVelocity);
function LX(t) {
  return !!(Ht(t) && t.add);
}
function Nb(t) {
  if (on.has(t))
    return "transform";
  if (Xb.has(t))
    return MI(t);
}
function qA(t, e) {
  var n;
  if (!t.applyWillChange)
    return;
  const g = t.getValue("willChange");
  if (LX(g))
    return g.add(e);
  !(!((n = t.props.style) === null || n === void 0) && n.willChange) && Nb(e) && t.setStaticValue("willChange", "transform");
}
function kX({ protectedKeys: t, needsAnimating: e }, n) {
  const g = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, g;
}
function Jb(t, e, { delay: n = 0, transitionOverride: g, type: i } = {}) {
  var c;
  let { transition: A = t.getDefaultTransition(), transitionEnd: l, ...a } = e;
  g && (A = g);
  const C = [], b = i && t.animationState && t.animationState.getState()[i];
  for (const m in a) {
    const p = t.getValue(m, (c = t.latestValues[m]) !== null && c !== void 0 ? c : null), y = a[m];
    if (y === void 0 || b && kX(b, m))
      continue;
    const f = {
      delay: n,
      ...Bs(A || {}, m)
    };
    let x = !1;
    if (window.MotionHandoffAnimation) {
      const B = Yb(t);
      if (B) {
        const J = window.MotionHandoffAnimation(B, m, ot);
        J !== null && (f.startTime = J, x = !0);
      }
    }
    qA(t, m), p.start(Es(m, p, y, t.shouldReduceMotion && on.has(m) ? { type: !1 } : f, t, x));
    const Y = p.animation;
    Y && C.push(Y);
  }
  return l && Promise.all(C).then(() => {
    ot.update(() => {
      l && qX(t, l);
    });
  }), C;
}
function DA(t, e, n = {}) {
  var g;
  const i = EI(t, e, n.type === "exit" ? (g = t.presenceContext) === null || g === void 0 ? void 0 : g.custom : void 0);
  let { transition: c = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (c = n.transitionOverride);
  const A = i ? () => Promise.all(Jb(t, i, n)) : () => Promise.resolve(), l = t.variantChildren && t.variantChildren.size ? (C = 0) => {
    const { delayChildren: b = 0, staggerChildren: m, staggerDirection: p } = c;
    return EX(t, e, b + C, m, p, n);
  } : () => Promise.resolve(), { when: a } = c;
  if (a) {
    const [C, b] = a === "beforeChildren" ? [A, l] : [l, A];
    return C().then(() => b());
  } else
    return Promise.all([A(), l(n.delay)]);
}
function EX(t, e, n = 0, g = 0, i = 1, c) {
  const A = [], l = (t.variantChildren.size - 1) * g, a = i === 1 ? (C = 0) => C * g : (C = 0) => l - C * g;
  return Array.from(t.variantChildren).sort(jX).forEach((C, b) => {
    C.notify("AnimationStart", e), A.push(DA(C, e, {
      ...c,
      delay: n + a(b)
    }).then(() => C.notify("AnimationComplete", e)));
  }), Promise.all(A);
}
function jX(t, e) {
  return t.sortNodePosition(e);
}
function MX(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let g;
  if (Array.isArray(e)) {
    const i = e.map((c) => DA(t, c, n));
    g = Promise.all(i);
  } else if (typeof e == "string")
    g = DA(t, e, n);
  else {
    const i = typeof e == "function" ? EI(t, e, n.custom) : e;
    g = Promise.all(Jb(t, i, n));
  }
  return g.then(() => {
    t.notify("AnimationComplete", e);
  });
}
const UX = fs.length;
function Rb(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? Rb(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < UX; n++) {
    const g = fs[n], i = t.props[g];
    (Og(i) || i === !1) && (e[g] = i);
  }
  return e;
}
const TX = [...Ws].reverse(), QX = Ws.length;
function OX(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: g }) => MX(t, n, g)));
}
function PX(t) {
  let e = OX(t), n = vr(), g = !0;
  const i = (a) => (C, b) => {
    var m;
    const p = EI(t, b, a === "exit" ? (m = t.presenceContext) === null || m === void 0 ? void 0 : m.custom : void 0);
    if (p) {
      const { transition: y, transitionEnd: f, ...x } = p;
      C = { ...C, ...x, ...f };
    }
    return C;
  };
  function c(a) {
    e = a(t);
  }
  function A(a) {
    const { props: C } = t, b = Rb(t.parent) || {}, m = [], p = /* @__PURE__ */ new Set();
    let y = {}, f = 1 / 0;
    for (let Y = 0; Y < QX; Y++) {
      const B = TX[Y], J = n[B], N = C[B] !== void 0 ? C[B] : b[B], R = Og(N), H = B === a ? J.isActive : null;
      H === !1 && (f = Y);
      let E = N === b[B] && N !== C[B] && R;
      if (E && g && t.manuallyAnimateOnMount && (E = !1), J.protectedKeys = { ...y }, // If it isn't active and hasn't *just* been set as inactive
      !J.isActive && H === null || // If we didn't and don't have any defined prop for this animation type
      !N && !J.prevProp || // Or if the prop doesn't define an animation
      Qg(N) || typeof N == "boolean")
        continue;
      const O = KX(J.prevProp, N);
      let j = O || // If we're making this variant active, we want to always make it active
      B === a && J.isActive && !E && R || // If we removed a higher-priority variant (i is in reverse order)
      Y > f && R, U = !1;
      const D = Array.isArray(N) ? N : [N];
      let gt = D.reduce(i(B), {});
      H === !1 && (gt = {});
      const { prevResolvedValues: xt = {} } = J, rn = {
        ...xt,
        ...gt
      }, xe = (At) => {
        j = !0, p.has(At) && (U = !0, p.delete(At)), J.needsAnimating[At] = !0;
        const Wt = t.getValue(At);
        Wt && (Wt.liveStyle = !1);
      };
      for (const At in rn) {
        const Wt = gt[At], nt = xt[At];
        if (y.hasOwnProperty(At))
          continue;
        let Nn = !1;
        NA(Wt) && NA(nt) ? Nn = !Uu(Wt, nt) : Nn = Wt !== nt, Nn ? Wt != null ? xe(At) : p.add(At) : Wt !== void 0 && p.has(At) ? xe(At) : J.protectedKeys[At] = !0;
      }
      J.prevProp = N, J.prevResolvedValues = gt, J.isActive && (y = { ...y, ...gt }), g && t.blockInitialAnimation && (j = !1), j && (!(E && O) || U) && m.push(...D.map((At) => ({
        animation: At,
        options: { type: B }
      })));
    }
    if (p.size) {
      const Y = {};
      p.forEach((B) => {
        const J = t.getBaseTarget(B), N = t.getValue(B);
        N && (N.liveStyle = !0), Y[B] = J ?? null;
      }), m.push({ animation: Y });
    }
    let x = !!m.length;
    return g && (C.initial === !1 || C.initial === C.animate) && !t.manuallyAnimateOnMount && (x = !1), g = !1, x ? e(m) : Promise.resolve();
  }
  function l(a, C) {
    var b;
    if (n[a].isActive === C)
      return Promise.resolve();
    (b = t.variantChildren) === null || b === void 0 || b.forEach((p) => {
      var y;
      return (y = p.animationState) === null || y === void 0 ? void 0 : y.setActive(a, C);
    }), n[a].isActive = C;
    const m = A(a);
    for (const p in n)
      n[p].protectedKeys = {};
    return m;
  }
  return {
    animateChanges: A,
    setActive: l,
    setAnimateFunction: c,
    getState: () => n,
    reset: () => {
      n = vr(), g = !0;
    }
  };
}
function KX(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Uu(e, t) : !1;
}
function dn(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function vr() {
  return {
    animate: dn(!0),
    whileInView: dn(),
    whileHover: dn(),
    whileTap: dn(),
    whileDrag: dn(),
    whileFocus: dn(),
    exit: dn()
  };
}
class ln {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class _X extends ln {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = PX(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Qg(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let $X = 0;
class tx extends ln {
  constructor() {
    super(...arguments), this.id = $X++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: g } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === g)
      return;
    const i = this.node.animationState.setActive("exit", !e);
    n && !e && i.then(() => n(this.id));
  }
  mount() {
    const { register: e } = this.node.presenceContext || {};
    e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const ex = {
  animation: {
    Feature: _X
  },
  exit: {
    Feature: tx
  }
}, Sb = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function UI(t, e = "page") {
  return {
    point: {
      x: t[`${e}X`],
      y: t[`${e}Y`]
    }
  };
}
const nx = (t) => (e) => Sb(e) && t(e, UI(e));
function He(t, e, n, g = { passive: !0 }) {
  return t.addEventListener(e, n, g), () => t.removeEventListener(e, n);
}
function De(t, e, n, g) {
  return He(t, e, nx(n), g);
}
const Xr = (t, e) => Math.abs(t - e);
function gx(t, e) {
  const n = Xr(t.x, e.x), g = Xr(t.y, e.y);
  return Math.sqrt(n ** 2 + g ** 2);
}
class Fb {
  constructor(e, n, { transformPagePoint: g, contextWindow: i, dragSnapToOrigin: c = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const m = tA(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, y = gx(m.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !y)
        return;
      const { point: f } = m, { timestamp: x } = Bt;
      this.history.push({ ...f, timestamp: x });
      const { onStart: Y, onMove: B } = this.handlers;
      p || (Y && Y(this.lastMoveEvent, m), this.startEvent = this.lastMoveEvent), B && B(this.lastMoveEvent, m);
    }, this.handlePointerMove = (m, p) => {
      this.lastMoveEvent = m, this.lastMoveEventInfo = $c(p, this.transformPagePoint), ot.update(this.updatePoint, !0);
    }, this.handlePointerUp = (m, p) => {
      this.end();
      const { onEnd: y, onSessionEnd: f, resumeAnimation: x } = this.handlers;
      if (this.dragSnapToOrigin && x && x(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const Y = tA(m.type === "pointercancel" ? this.lastMoveEventInfo : $c(p, this.transformPagePoint), this.history);
      this.startEvent && y && y(m, Y), f && f(m, Y);
    }, !Sb(e))
      return;
    this.dragSnapToOrigin = c, this.handlers = n, this.transformPagePoint = g, this.contextWindow = i || window;
    const A = UI(e), l = $c(A, this.transformPagePoint), { point: a } = l, { timestamp: C } = Bt;
    this.history = [{ ...a, timestamp: C }];
    const { onSessionStart: b } = n;
    b && b(e, tA(l, this.history)), this.removeListeners = qe(De(this.contextWindow, "pointermove", this.handlePointerMove), De(this.contextWindow, "pointerup", this.handlePointerUp), De(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), en(this.updatePoint);
  }
}
function $c(t, e) {
  return e ? { point: e(t.point) } : t;
}
function xr(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function tA({ point: t }, e) {
  return {
    point: t,
    delta: xr(t, Hb(e)),
    offset: xr(t, ix(e)),
    velocity: Ix(e, 0.1)
  };
}
function ix(t) {
  return t[0];
}
function Hb(t) {
  return t[t.length - 1];
}
function Ix(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, g = null;
  const i = Hb(t);
  for (; n >= 0 && (g = t[n], !(i.timestamp - g.timestamp > Ve(e))); )
    n--;
  if (!g)
    return { x: 0, y: 0 };
  const c = ze(i.timestamp - g.timestamp);
  if (c === 0)
    return { x: 0, y: 0 };
  const A = {
    x: (i.x - g.x) / c,
    y: (i.y - g.y) / c
  };
  return A.x === 1 / 0 && (A.x = 0), A.y === 1 / 0 && (A.y = 0), A;
}
function wb(t) {
  let e = null;
  return () => {
    const n = () => {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
const Wr = wb("dragHorizontal"), fr = wb("dragVertical");
function zb(t) {
  let e = !1;
  if (t === "y")
    e = fr();
  else if (t === "x")
    e = Wr();
  else {
    const n = Wr(), g = fr();
    n && g ? e = () => {
      n(), g();
    } : (n && n(), g && g());
  }
  return e;
}
function qb() {
  const t = zb(!0);
  return t ? (t(), !1) : !0;
}
function jn(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
const Db = 1e-4, cx = 1 - Db, Ax = 1 + Db, Lb = 0.01, sx = 0 - Lb, ox = 0 + Lb;
function Et(t) {
  return t.max - t.min;
}
function lx(t, e, n) {
  return Math.abs(t - e) <= n;
}
function Br(t, e, n, g = 0.5) {
  t.origin = g, t.originPoint = ut(e.min, e.max, t.origin), t.scale = Et(n) / Et(e), t.translate = ut(n.min, n.max, t.origin) - t.originPoint, (t.scale >= cx && t.scale <= Ax || isNaN(t.scale)) && (t.scale = 1), (t.translate >= sx && t.translate <= ox || isNaN(t.translate)) && (t.translate = 0);
}
function qg(t, e, n, g) {
  Br(t.x, e.x, n.x, g ? g.originX : void 0), Br(t.y, e.y, n.y, g ? g.originY : void 0);
}
function Yr(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + Et(e);
}
function rx(t, e, n) {
  Yr(t.x, e.x, n.x), Yr(t.y, e.y, n.y);
}
function Nr(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + Et(e);
}
function Dg(t, e, n) {
  Nr(t.x, e.x, n.x), Nr(t.y, e.y, n.y);
}
function ax(t, { min: e, max: n }, g) {
  return e !== void 0 && t < e ? t = g ? ut(e, t, g.min) : Math.max(t, e) : n !== void 0 && t > n && (t = g ? ut(n, t, g.max) : Math.min(t, n)), t;
}
function Jr(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function Cx(t, { top: e, left: n, bottom: g, right: i }) {
  return {
    x: Jr(t.x, n, i),
    y: Jr(t.y, e, g)
  };
}
function Rr(t, e) {
  let n = e.min - t.min, g = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, g] = [g, n]), { min: n, max: g };
}
function ux(t, e) {
  return {
    x: Rr(t.x, e.x),
    y: Rr(t.y, e.y)
  };
}
function bx(t, e) {
  let n = 0.5;
  const g = Et(t), i = Et(e);
  return i > g ? n = Ag(e.min, e.max - g, t.min) : g > i && (n = Ag(t.min, t.max - i, e.min)), gn(0, 1, n);
}
function dx(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const LA = 0.35;
function Gx(t = LA) {
  return t === !1 ? t = 0 : t === !0 && (t = LA), {
    x: Sr(t, "left", "right"),
    y: Sr(t, "top", "bottom")
  };
}
function Sr(t, e, n) {
  return {
    min: Fr(t, e),
    max: Fr(t, n)
  };
}
function Fr(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const Hr = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Mn = () => ({
  x: Hr(),
  y: Hr()
}), wr = () => ({ min: 0, max: 0 }), ht = () => ({
  x: wr(),
  y: wr()
});
function Ot(t) {
  return [t("x"), t("y")];
}
function kb({ top: t, left: e, right: n, bottom: g }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: g }
  };
}
function mx({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function hx(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), g = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: g.y,
    right: g.x
  };
}
function eA(t) {
  return t === void 0 || t === 1;
}
function kA({ scale: t, scaleX: e, scaleY: n }) {
  return !eA(t) || !eA(e) || !eA(n);
}
function Gn(t) {
  return kA(t) || Eb(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Eb(t) {
  return zr(t.x) || zr(t.y);
}
function zr(t) {
  return t && t !== "0%";
}
function vI(t, e, n) {
  const g = t - n, i = e * g;
  return n + i;
}
function qr(t, e, n, g, i) {
  return i !== void 0 && (t = vI(t, i, g)), vI(t, n, g) + e;
}
function EA(t, e = 0, n = 1, g, i) {
  t.min = qr(t.min, e, n, g, i), t.max = qr(t.max, e, n, g, i);
}
function jb(t, { x: e, y: n }) {
  EA(t.x, e.translate, e.scale, e.originPoint), EA(t.y, n.translate, n.scale, n.originPoint);
}
const Dr = 0.999999999999, Lr = 1.0000000000001;
function px(t, e, n, g = !1) {
  const i = n.length;
  if (!i)
    return;
  e.x = e.y = 1;
  let c, A;
  for (let l = 0; l < i; l++) {
    c = n[l], A = c.projectionDelta;
    const { visualElement: a } = c.options;
    a && a.props.style && a.props.style.display === "contents" || (g && c.options.layoutScroll && c.scroll && c !== c.root && Tn(t, {
      x: -c.scroll.offset.x,
      y: -c.scroll.offset.y
    }), A && (e.x *= A.x.scale, e.y *= A.y.scale, jb(t, A)), g && Gn(c.latestValues) && Tn(t, c.latestValues));
  }
  e.x < Lr && e.x > Dr && (e.x = 1), e.y < Lr && e.y > Dr && (e.y = 1);
}
function Un(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function kr(t, e, n, g, i = 0.5) {
  const c = ut(t.min, t.max, i);
  EA(t, e, n, c, g);
}
function Tn(t, e) {
  kr(t.x, e.x, e.scaleX, e.scale, e.originX), kr(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function Mb(t, e) {
  return kb(hx(t.getBoundingClientRect(), e));
}
function Vx(t, e, n) {
  const g = Mb(t, n), { scroll: i } = e;
  return i && (Un(g.x, i.offset.x), Un(g.y, i.offset.y)), g;
}
const Ub = ({ current: t }) => t ? t.ownerDocument.defaultView : null, Zx = /* @__PURE__ */ new WeakMap();
class yx {
  constructor(e) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ht(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: g } = this.visualElement;
    if (g && g.isPresent === !1)
      return;
    const i = (b) => {
      const { dragSnapToOrigin: m } = this.getProps();
      m ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(UI(b, "page").point);
    }, c = (b, m) => {
      const { drag: p, dragPropagation: y, onDragStart: f } = this.getProps();
      if (p && !y && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = zb(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ot((Y) => {
        let B = this.getAxisMotionValue(Y).get() || 0;
        if (Ze.test(B)) {
          const { projection: J } = this.visualElement;
          if (J && J.layout) {
            const N = J.layout.layoutBox[Y];
            N && (B = Et(N) * (parseFloat(B) / 100));
          }
        }
        this.originPoint[Y] = B;
      }), f && ot.postRender(() => f(b, m)), qA(this.visualElement, "transform");
      const { animationState: x } = this.visualElement;
      x && x.setActive("whileDrag", !0);
    }, A = (b, m) => {
      const { dragPropagation: p, dragDirectionLock: y, onDirectionLock: f, onDrag: x } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: Y } = m;
      if (y && this.currentDirection === null) {
        this.currentDirection = vx(Y), this.currentDirection !== null && f && f(this.currentDirection);
        return;
      }
      this.updateAxis("x", m.point, Y), this.updateAxis("y", m.point, Y), this.visualElement.render(), x && x(b, m);
    }, l = (b, m) => this.stop(b, m), a = () => Ot((b) => {
      var m;
      return this.getAnimationState(b) === "paused" && ((m = this.getAxisMotionValue(b).animation) === null || m === void 0 ? void 0 : m.play());
    }), { dragSnapToOrigin: C } = this.getProps();
    this.panSession = new Fb(e, {
      onSessionStart: i,
      onStart: c,
      onMove: A,
      onSessionEnd: l,
      resumeAnimation: a
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: C,
      contextWindow: Ub(this.visualElement)
    });
  }
  stop(e, n) {
    const g = this.isDragging;
    if (this.cancel(), !g)
      return;
    const { velocity: i } = n;
    this.startAnimation(i);
    const { onDragEnd: c } = this.getProps();
    c && ot.postRender(() => c(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: g } = this.getProps();
    !g && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, g) {
    const { drag: i } = this.getProps();
    if (!g || !Mi(e, i, this.currentDirection))
      return;
    const c = this.getAxisMotionValue(e);
    let A = this.originPoint[e] + g[e];
    this.constraints && this.constraints[e] && (A = ax(A, this.constraints[e], this.elastic[e])), c.set(A);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: n, dragElastic: g } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, c = this.constraints;
    n && jn(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = Cx(i.layoutBox, n) : this.constraints = !1, this.elastic = Gx(g), c !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Ot((A) => {
      this.constraints !== !1 && this.getAxisMotionValue(A) && (this.constraints[A] = dx(i.layoutBox[A], this.constraints[A]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !jn(e))
      return !1;
    const g = e.current;
    nn(g !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: i } = this.visualElement;
    if (!i || !i.layout)
      return !1;
    const c = Vx(g, i.root, this.visualElement.getTransformPagePoint());
    let A = ux(i.layout.layoutBox, c);
    if (n) {
      const l = n(mx(A));
      this.hasMutatedConstraints = !!l, l && (A = kb(l));
    }
    return A;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: g, dragElastic: i, dragTransition: c, dragSnapToOrigin: A, onDragTransitionEnd: l } = this.getProps(), a = this.constraints || {}, C = Ot((b) => {
      if (!Mi(b, n, this.currentDirection))
        return;
      let m = a && a[b] || {};
      A && (m = { min: 0, max: 0 });
      const p = i ? 200 : 1e6, y = i ? 40 : 1e7, f = {
        type: "inertia",
        velocity: g ? e[b] : 0,
        bounceStiffness: p,
        bounceDamping: y,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...c,
        ...m
      };
      return this.startAxisValueAnimation(b, f);
    });
    return Promise.all(C).then(l);
  }
  startAxisValueAnimation(e, n) {
    const g = this.getAxisMotionValue(e);
    return qA(this.visualElement, e), g.start(Es(e, g, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Ot((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    Ot((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, g = this.visualElement.getProps(), i = g[n];
    return i || this.visualElement.getValue(e, (g.initial ? g.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    Ot((n) => {
      const { drag: g } = this.getProps();
      if (!Mi(n, g, this.currentDirection))
        return;
      const { projection: i } = this.visualElement, c = this.getAxisMotionValue(n);
      if (i && i.layout) {
        const { min: A, max: l } = i.layout.layoutBox[n];
        c.set(e[n] - ut(A, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: g } = this.visualElement;
    if (!jn(n) || !g || !this.constraints)
      return;
    this.stopAnimation();
    const i = { x: 0, y: 0 };
    Ot((A) => {
      const l = this.getAxisMotionValue(A);
      if (l && this.constraints !== !1) {
        const a = l.get();
        i[A] = bx({ min: a, max: a }, this.constraints[A]);
      }
    });
    const { transformTemplate: c } = this.visualElement.getProps();
    this.visualElement.current.style.transform = c ? c({}, "") : "none", g.root && g.root.updateScroll(), g.updateLayout(), this.resolveConstraints(), Ot((A) => {
      if (!Mi(A, e, null))
        return;
      const l = this.getAxisMotionValue(A), { min: a, max: C } = this.constraints[A];
      l.set(ut(a, C, i[A]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Zx.set(this.visualElement, this);
    const e = this.visualElement.current, n = De(e, "pointerdown", (a) => {
      const { drag: C, dragListener: b = !0 } = this.getProps();
      C && b && this.start(a);
    }), g = () => {
      const { dragConstraints: a } = this.getProps();
      jn(a) && a.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: i } = this.visualElement, c = i.addEventListener("measure", g);
    i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), ot.read(g);
    const A = He(window, "resize", () => this.scalePositionWithinConstraints()), l = i.addEventListener("didUpdate", ({ delta: a, hasLayoutChanged: C }) => {
      this.isDragging && C && (Ot((b) => {
        const m = this.getAxisMotionValue(b);
        m && (this.originPoint[b] += a[b].translate, m.set(m.get() + a[b].translate));
      }), this.visualElement.render());
    });
    return () => {
      A(), n(), c(), l && l();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: g = !1, dragPropagation: i = !1, dragConstraints: c = !1, dragElastic: A = LA, dragMomentum: l = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: g,
      dragPropagation: i,
      dragConstraints: c,
      dragElastic: A,
      dragMomentum: l
    };
  }
}
function Mi(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function vx(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class Xx extends ln {
  constructor(e) {
    super(e), this.removeGroupControls = Jt, this.removeListeners = Jt, this.controls = new yx(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Jt;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Er = (t) => (e, n) => {
  t && ot.postRender(() => t(e, n));
};
class xx extends ln {
  constructor() {
    super(...arguments), this.removePointerDownListener = Jt;
  }
  onPointerDown(e) {
    this.session = new Fb(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Ub(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: g, onPanEnd: i } = this.node.getProps();
    return {
      onSessionStart: Er(e),
      onStart: Er(n),
      onMove: g,
      onEnd: (c, A) => {
        delete this.session, i && ot.postRender(() => i(c, A));
      }
    };
  }
  mount() {
    this.removePointerDownListener = De(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Ts = cn(null);
function Wx() {
  const t = St(Ts);
  if (t === null)
    return [!0, null];
  const { isPresent: e, onExitComplete: n, register: g } = t, i = xG();
  Ee(() => g(i), []);
  const c = pn(() => n && n(i), [i, n]);
  return !e && n ? [!1, c] : [!0];
}
const Tb = cn({}), Qb = cn({}), _i = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function jr(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Rg = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (_.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = jr(t, e.target.x), g = jr(t, e.target.y);
    return `${n}% ${g}%`;
  }
}, fx = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const g = t, i = In.parse(t);
    if (i.length > 5)
      return g;
    const c = In.createTransformer(t), A = typeof i[0] != "number" ? 1 : 0, l = n.x.scale * e.x, a = n.y.scale * e.y;
    i[0 + A] /= l, i[1 + A] /= a;
    const C = ut(l, a, 0.5);
    return typeof i[2 + A] == "number" && (i[2 + A] /= C), typeof i[3 + A] == "number" && (i[3 + A] /= C), c(i);
  }
}, XI = {};
function Bx(t) {
  Object.assign(XI, t);
}
const { schedule: Qs, cancel: R2 } = Tu(queueMicrotask, !1);
class Yx extends WG {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: g, layoutId: i } = this.props, { projection: c } = e;
    Bx(Nx), c && (n.group && n.group.add(c), g && g.register && i && g.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), c.setOptions({
      ...c.options,
      onExitComplete: () => this.safeToRemove()
    })), _i.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: g, drag: i, isPresent: c } = this.props, A = g.projection;
    return A && (A.isPresent = c, i || e.layoutDependency !== n || n === void 0 ? A.willUpdate() : this.safeToRemove(), e.isPresent !== c && (c ? A.promote() : A.relegate() || ot.postRender(() => {
      const l = A.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), Qs.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: g } = this.props, { projection: i } = e;
    i && (i.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(i), g && g.deregister && g.deregister(i));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function Ob(t) {
  const [e, n] = Wx(), g = St(Tb);
  return k(Yx, { ...t, layoutGroup: g, switchLayoutGroup: St(Qb), isPresent: e, safeToRemove: n });
}
const Nx = {
  borderRadius: {
    ...Rg,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Rg,
  borderTopRightRadius: Rg,
  borderBottomLeftRadius: Rg,
  borderBottomRightRadius: Rg,
  boxShadow: fx
}, Pb = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Jx = Pb.length, Mr = (t) => typeof t == "string" ? parseFloat(t) : t, Ur = (t) => typeof t == "number" || _.test(t);
function Rx(t, e, n, g, i, c) {
  i ? (t.opacity = ut(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    Sx(g)
  ), t.opacityExit = ut(e.opacity !== void 0 ? e.opacity : 1, 0, Fx(g))) : c && (t.opacity = ut(e.opacity !== void 0 ? e.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, g));
  for (let A = 0; A < Jx; A++) {
    const l = `border${Pb[A]}Radius`;
    let a = Tr(e, l), C = Tr(n, l);
    if (a === void 0 && C === void 0)
      continue;
    a || (a = 0), C || (C = 0), a === 0 || C === 0 || Ur(a) === Ur(C) ? (t[l] = Math.max(ut(Mr(a), Mr(C), g), 0), (Ze.test(C) || Ze.test(a)) && (t[l] += "%")) : t[l] = C;
  }
  (e.rotate || n.rotate) && (t.rotate = ut(e.rotate || 0, n.rotate || 0, g));
}
function Tr(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const Sx = /* @__PURE__ */ Kb(0, 0.5, tb), Fx = /* @__PURE__ */ Kb(0.5, 0.95, Jt);
function Kb(t, e, n) {
  return (g) => g < t ? 0 : g > e ? 1 : n(Ag(t, e, g));
}
function Qr(t, e) {
  t.min = e.min, t.max = e.max;
}
function Qt(t, e) {
  Qr(t.x, e.x), Qr(t.y, e.y);
}
function Or(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function Pr(t, e, n, g, i) {
  return t -= e, t = vI(t, 1 / n, g), i !== void 0 && (t = vI(t, 1 / i, g)), t;
}
function Hx(t, e = 0, n = 1, g = 0.5, i, c = t, A = t) {
  if (Ze.test(e) && (e = parseFloat(e), e = ut(A.min, A.max, e / 100) - A.min), typeof e != "number")
    return;
  let l = ut(c.min, c.max, g);
  t === c && (l -= e), t.min = Pr(t.min, e, n, l, i), t.max = Pr(t.max, e, n, l, i);
}
function Kr(t, e, [n, g, i], c, A) {
  Hx(t, e[n], e[g], e[i], e.scale, c, A);
}
const wx = ["x", "scaleX", "originX"], zx = ["y", "scaleY", "originY"];
function _r(t, e, n, g) {
  Kr(t.x, e, wx, n ? n.x : void 0, g ? g.x : void 0), Kr(t.y, e, zx, n ? n.y : void 0, g ? g.y : void 0);
}
function $r(t) {
  return t.translate === 0 && t.scale === 1;
}
function _b(t) {
  return $r(t.x) && $r(t.y);
}
function ta(t, e) {
  return t.min === e.min && t.max === e.max;
}
function qx(t, e) {
  return ta(t.x, e.x) && ta(t.y, e.y);
}
function ea(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function $b(t, e) {
  return ea(t.x, e.x) && ea(t.y, e.y);
}
function na(t) {
  return Et(t.x) / Et(t.y);
}
function ga(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class Dx {
  constructor() {
    this.members = [];
  }
  add(e) {
    js(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Ms(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((i) => e === i);
    if (n === 0)
      return !1;
    let g;
    for (let i = n; i >= 0; i--) {
      const c = this.members[i];
      if (c.isPresent !== !1) {
        g = c;
        break;
      }
    }
    return g ? (this.promote(g), !0) : !1;
  }
  promote(e, n) {
    const g = this.lead;
    if (e !== g && (this.prevLead = g, this.lead = e, e.show(), g)) {
      g.instance && g.scheduleRender(), e.scheduleRender(), e.resumeFrom = g, n && (e.resumeFrom.preserveOpacity = !0), g.snapshot && (e.snapshot = g.snapshot, e.snapshot.latestValues = g.animationValues || g.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: i } = e.options;
      i === !1 && g.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: g } = e;
      n.onExitComplete && n.onExitComplete(), g && g.options.onExitComplete && g.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function Lx(t, e, n) {
  let g = "";
  const i = t.x.translate / e.x, c = t.y.translate / e.y, A = (n == null ? void 0 : n.z) || 0;
  if ((i || c || A) && (g = `translate3d(${i}px, ${c}px, ${A}px) `), (e.x !== 1 || e.y !== 1) && (g += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: C, rotate: b, rotateX: m, rotateY: p, skewX: y, skewY: f } = n;
    C && (g = `perspective(${C}px) ${g}`), b && (g += `rotate(${b}deg) `), m && (g += `rotateX(${m}deg) `), p && (g += `rotateY(${p}deg) `), y && (g += `skewX(${y}deg) `), f && (g += `skewY(${f}deg) `);
  }
  const l = t.x.scale * e.x, a = t.y.scale * e.y;
  return (l !== 1 || a !== 1) && (g += `scale(${l}, ${a})`), g || "none";
}
const kx = (t, e) => t.depth - e.depth;
class Ex {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    js(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Ms(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(kx), this.isDirty = !1, this.children.forEach(e);
  }
}
function $i(t) {
  const e = Ht(t) ? t.get() : t;
  return SX(e) ? e.toValue() : e;
}
function jx(t, e) {
  const n = ye.now(), g = ({ timestamp: i }) => {
    const c = i - n;
    c >= e && (en(g), t(c - e));
  };
  return ot.read(g, !0), () => en(g);
}
function Mx(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
function Ux(t, e, n) {
  const g = Ht(t) ? t : _g(t);
  return g.start(Es("", g, e, n)), g.animation;
}
const mn = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Fg = typeof window < "u" && window.MotionDebug !== void 0, nA = ["", "X", "Y", "Z"], Tx = { visibility: "hidden" }, ia = 1e3;
let Qx = 0;
function gA(t, e, n, g) {
  const { latestValues: i } = e;
  i[t] && (n[t] = i[t], e.setStaticValue(t, 0), g && (g[t] = 0));
}
function td(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = Yb(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: i, layoutId: c } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ot, !(i || c));
  }
  const { parent: g } = t;
  g && !g.hasCheckedOptimisedAppear && td(g);
}
function ed({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: g, resetTransform: i }) {
  return class {
    constructor(A = {}, l = e == null ? void 0 : e()) {
      this.id = Qx++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Fg && (mn.totalNodes = mn.resolvedTargetDeltas = mn.recalculatedProjection = 0), this.nodes.forEach(Kx), this.nodes.forEach(nW), this.nodes.forEach(gW), this.nodes.forEach(_x), Fg && window.MotionDebug.record(mn);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = A, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let a = 0; a < this.path.length; a++)
        this.path[a].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Ex());
    }
    addEventListener(A, l) {
      return this.eventHandlers.has(A) || this.eventHandlers.set(A, new Us()), this.eventHandlers.get(A).add(l);
    }
    notifyListeners(A, ...l) {
      const a = this.eventHandlers.get(A);
      a && a.notify(...l);
    }
    hasListeners(A) {
      return this.eventHandlers.has(A);
    }
    /**
     * Lifecycles
     */
    mount(A, l = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = Mx(A), this.instance = A;
      const { layoutId: a, layout: C, visualElement: b } = this.options;
      if (b && !b.current && b.mount(A), this.root.nodes.add(this), this.parent && this.parent.children.add(this), l && (C || a) && (this.isLayoutDirty = !0), t) {
        let m;
        const p = () => this.root.updateBlockedByResize = !1;
        t(A, () => {
          this.root.updateBlockedByResize = !0, m && m(), m = jx(p, 250), _i.hasAnimatedSinceResize && (_i.hasAnimatedSinceResize = !1, this.nodes.forEach(ca));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && b && (a || C) && this.addEventListener("didUpdate", ({ delta: m, hasLayoutChanged: p, hasRelativeTargetChanged: y, layout: f }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const x = this.options.transition || b.getDefaultTransition() || sW, { onLayoutAnimationStart: Y, onLayoutAnimationComplete: B } = b.getProps(), J = !this.targetLayout || !$b(this.targetLayout, f) || y, N = !p && y;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || N || p && (J || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(m, N);
          const R = {
            ...Bs(x, "layout"),
            onPlay: Y,
            onComplete: B
          };
          (b.shouldReduceMotion || this.options.layoutRoot) && (R.delay = 0, R.type = !1), this.startAnimation(R);
        } else
          p || ca(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = f;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const A = this.getStack();
      A && A.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, en(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(iW), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: A } = this.options;
      return A && A.getProps().transformTemplate;
    }
    willUpdate(A = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && td(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let b = 0; b < this.path.length; b++) {
        const m = this.path[b];
        m.shouldResetTransform = !0, m.updateScroll("snapshot"), m.options.layoutRoot && m.willUpdate(!1);
      }
      const { layoutId: l, layout: a } = this.options;
      if (l === void 0 && !a)
        return;
      const C = this.getTransformTemplate();
      this.prevTransformTemplateValue = C ? C(this.latestValues, "") : void 0, this.updateSnapshot(), A && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Ia);
        return;
      }
      this.isUpdating || this.nodes.forEach(tW), this.isUpdating = !1, this.nodes.forEach(eW), this.nodes.forEach(Ox), this.nodes.forEach(Px), this.clearAllSnapshots();
      const l = ye.now();
      Bt.delta = gn(0, 1e3 / 60, l - Bt.timestamp), Bt.timestamp = l, Bt.isProcessing = !0, Qc.update.process(Bt), Qc.preRender.process(Bt), Qc.render.process(Bt), Bt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Qs.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach($x), this.sharedNodes.forEach(IW);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ot.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ot.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let a = 0; a < this.path.length; a++)
          this.path[a].updateScroll();
      const A = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ht(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, A ? A.layoutBox : void 0);
    }
    updateScroll(A = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === A && (l = !1), l) {
        const a = g(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: A,
          isRoot: a,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : a
        };
      }
    }
    resetTransform() {
      if (!i)
        return;
      const A = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, l = this.projectionDelta && !_b(this.projectionDelta), a = this.getTransformTemplate(), C = a ? a(this.latestValues, "") : void 0, b = C !== this.prevTransformTemplateValue;
      A && (l || Gn(this.latestValues) || b) && (i(this.instance, C), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(A = !0) {
      const l = this.measurePageBox();
      let a = this.removeElementScroll(l);
      return A && (a = this.removeTransform(a)), oW(a), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: a,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var A;
      const { visualElement: l } = this.options;
      if (!l)
        return ht();
      const a = l.measureViewportBox();
      if (!(((A = this.scroll) === null || A === void 0 ? void 0 : A.wasRoot) || this.path.some(lW))) {
        const { scroll: b } = this.root;
        b && (Un(a.x, b.offset.x), Un(a.y, b.offset.y));
      }
      return a;
    }
    removeElementScroll(A) {
      var l;
      const a = ht();
      if (Qt(a, A), !((l = this.scroll) === null || l === void 0) && l.wasRoot)
        return a;
      for (let C = 0; C < this.path.length; C++) {
        const b = this.path[C], { scroll: m, options: p } = b;
        b !== this.root && m && p.layoutScroll && (m.wasRoot && Qt(a, A), Un(a.x, m.offset.x), Un(a.y, m.offset.y));
      }
      return a;
    }
    applyTransform(A, l = !1) {
      const a = ht();
      Qt(a, A);
      for (let C = 0; C < this.path.length; C++) {
        const b = this.path[C];
        !l && b.options.layoutScroll && b.scroll && b !== b.root && Tn(a, {
          x: -b.scroll.offset.x,
          y: -b.scroll.offset.y
        }), Gn(b.latestValues) && Tn(a, b.latestValues);
      }
      return Gn(this.latestValues) && Tn(a, this.latestValues), a;
    }
    removeTransform(A) {
      const l = ht();
      Qt(l, A);
      for (let a = 0; a < this.path.length; a++) {
        const C = this.path[a];
        if (!C.instance || !Gn(C.latestValues))
          continue;
        kA(C.latestValues) && C.updateSnapshot();
        const b = ht(), m = C.measurePageBox();
        Qt(b, m), _r(l, C.latestValues, C.snapshot ? C.snapshot.layoutBox : void 0, b);
      }
      return Gn(this.latestValues) && _r(l, this.latestValues), l;
    }
    setTargetDelta(A) {
      this.targetDelta = A, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(A) {
      this.options = {
        ...this.options,
        ...A,
        crossfade: A.crossfade !== void 0 ? A.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Bt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(A = !1) {
      var l;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const C = !!this.resumingFrom || this !== a;
      if (!(A || C && this.isSharedProjectionDirty || this.isProjectionDirty || !((l = this.parent) === null || l === void 0) && l.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: m, layoutId: p } = this.options;
      if (!(!this.layout || !(m || p))) {
        if (this.resolvedRelativeTargetAt = Bt.timestamp, !this.targetDelta && !this.relativeTarget) {
          const y = this.getClosestProjectingParent();
          y && y.layout && this.animationProgress !== 1 ? (this.relativeParent = y, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ht(), this.relativeTargetOrigin = ht(), Dg(this.relativeTargetOrigin, this.layout.layoutBox, y.layout.layoutBox), Qt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ht(), this.targetWithTransforms = ht()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), rx(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Qt(this.target, this.layout.layoutBox), jb(this.target, this.targetDelta)) : Qt(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const y = this.getClosestProjectingParent();
            y && !!y.resumingFrom == !!this.resumingFrom && !y.options.layoutScroll && y.target && this.animationProgress !== 1 ? (this.relativeParent = y, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ht(), this.relativeTargetOrigin = ht(), Dg(this.relativeTargetOrigin, this.target, y.target), Qt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Fg && mn.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || kA(this.parent.latestValues) || Eb(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var A;
      const l = this.getLead(), a = !!this.resumingFrom || this !== l;
      let C = !0;
      if ((this.isProjectionDirty || !((A = this.parent) === null || A === void 0) && A.isProjectionDirty) && (C = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (C = !1), this.resolvedRelativeTargetAt === Bt.timestamp && (C = !1), C)
        return;
      const { layout: b, layoutId: m } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(b || m))
        return;
      Qt(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, y = this.treeScale.y;
      px(this.layoutCorrected, this.treeScale, this.path, a), l.layout && !l.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (l.target = l.layout.layoutBox, l.targetWithTransforms = ht());
      const { target: f } = l;
      if (!f) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Or(this.prevProjectionDelta.x, this.projectionDelta.x), Or(this.prevProjectionDelta.y, this.projectionDelta.y)), qg(this.projectionDelta, this.layoutCorrected, f, this.latestValues), (this.treeScale.x !== p || this.treeScale.y !== y || !ga(this.projectionDelta.x, this.prevProjectionDelta.x) || !ga(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", f)), Fg && mn.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(A = !0) {
      var l;
      if ((l = this.options.visualElement) === null || l === void 0 || l.scheduleRender(), A) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Mn(), this.projectionDelta = Mn(), this.projectionDeltaWithTransform = Mn();
    }
    setAnimationOrigin(A, l = !1) {
      const a = this.snapshot, C = a ? a.latestValues : {}, b = { ...this.latestValues }, m = Mn();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const p = ht(), y = a ? a.source : void 0, f = this.layout ? this.layout.source : void 0, x = y !== f, Y = this.getStack(), B = !Y || Y.members.length <= 1, J = !!(x && !B && this.options.crossfade === !0 && !this.path.some(AW));
      this.animationProgress = 0;
      let N;
      this.mixTargetDelta = (R) => {
        const H = R / 1e3;
        Aa(m.x, A.x, H), Aa(m.y, A.y, H), this.setTargetDelta(m), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Dg(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), cW(this.relativeTarget, this.relativeTargetOrigin, p, H), N && qx(this.relativeTarget, N) && (this.isProjectionDirty = !1), N || (N = ht()), Qt(N, this.relativeTarget)), x && (this.animationValues = b, Rx(b, C, this.latestValues, H, J, B)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = H;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(A) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (en(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ot.update(() => {
        _i.hasAnimatedSinceResize = !0, this.currentAnimation = Ux(0, ia, {
          ...A,
          onUpdate: (l) => {
            this.mixTargetDelta(l), A.onUpdate && A.onUpdate(l);
          },
          onComplete: () => {
            A.onComplete && A.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const A = this.getStack();
      A && A.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(ia), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const A = this.getLead();
      let { targetWithTransforms: l, target: a, layout: C, latestValues: b } = A;
      if (!(!l || !a || !C)) {
        if (this !== A && this.layout && C && nd(this.options.animationType, this.layout.layoutBox, C.layoutBox)) {
          a = this.target || ht();
          const m = Et(this.layout.layoutBox.x);
          a.x.min = A.target.x.min, a.x.max = a.x.min + m;
          const p = Et(this.layout.layoutBox.y);
          a.y.min = A.target.y.min, a.y.max = a.y.min + p;
        }
        Qt(l, a), Tn(l, b), qg(this.projectionDeltaWithTransform, this.layoutCorrected, l, b);
      }
    }
    registerSharedNode(A, l) {
      this.sharedNodes.has(A) || this.sharedNodes.set(A, new Dx()), this.sharedNodes.get(A).add(l);
      const C = l.options.initialPromotionConfig;
      l.promote({
        transition: C ? C.transition : void 0,
        preserveFollowOpacity: C && C.shouldPreserveFollowOpacity ? C.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const A = this.getStack();
      return A ? A.lead === this : !0;
    }
    getLead() {
      var A;
      const { layoutId: l } = this.options;
      return l ? ((A = this.getStack()) === null || A === void 0 ? void 0 : A.lead) || this : this;
    }
    getPrevLead() {
      var A;
      const { layoutId: l } = this.options;
      return l ? (A = this.getStack()) === null || A === void 0 ? void 0 : A.prevLead : void 0;
    }
    getStack() {
      const { layoutId: A } = this.options;
      if (A)
        return this.root.sharedNodes.get(A);
    }
    promote({ needsReset: A, transition: l, preserveFollowOpacity: a } = {}) {
      const C = this.getStack();
      C && C.promote(this, a), A && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const A = this.getStack();
      return A ? A.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: A } = this.options;
      if (!A)
        return;
      let l = !1;
      const { latestValues: a } = A;
      if ((a.z || a.rotate || a.rotateX || a.rotateY || a.rotateZ || a.skewX || a.skewY) && (l = !0), !l)
        return;
      const C = {};
      a.z && gA("z", A, C, this.animationValues);
      for (let b = 0; b < nA.length; b++)
        gA(`rotate${nA[b]}`, A, C, this.animationValues), gA(`skew${nA[b]}`, A, C, this.animationValues);
      A.render();
      for (const b in C)
        A.setStaticValue(b, C[b]), this.animationValues && (this.animationValues[b] = C[b]);
      A.scheduleRender();
    }
    getProjectionStyles(A) {
      var l, a;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return Tx;
      const C = {
        visibility: ""
      }, b = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, C.opacity = "", C.pointerEvents = $i(A == null ? void 0 : A.pointerEvents) || "", C.transform = b ? b(this.latestValues, "") : "none", C;
      const m = this.getLead();
      if (!this.projectionDelta || !this.layout || !m.target) {
        const x = {};
        return this.options.layoutId && (x.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, x.pointerEvents = $i(A == null ? void 0 : A.pointerEvents) || ""), this.hasProjected && !Gn(this.latestValues) && (x.transform = b ? b({}, "") : "none", this.hasProjected = !1), x;
      }
      const p = m.animationValues || m.latestValues;
      this.applyTransformsToTarget(), C.transform = Lx(this.projectionDeltaWithTransform, this.treeScale, p), b && (C.transform = b(p, C.transform));
      const { x: y, y: f } = this.projectionDelta;
      C.transformOrigin = `${y.origin * 100}% ${f.origin * 100}% 0`, m.animationValues ? C.opacity = m === this ? (a = (l = p.opacity) !== null && l !== void 0 ? l : this.latestValues.opacity) !== null && a !== void 0 ? a : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : C.opacity = m === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const x in XI) {
        if (p[x] === void 0)
          continue;
        const { correct: Y, applyTo: B } = XI[x], J = C.transform === "none" ? p[x] : Y(p[x], m);
        if (B) {
          const N = B.length;
          for (let R = 0; R < N; R++)
            C[B[R]] = J;
        } else
          C[x] = J;
      }
      return this.options.layoutId && (C.pointerEvents = m === this ? $i(A == null ? void 0 : A.pointerEvents) || "" : "none"), C;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((A) => {
        var l;
        return (l = A.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
      }), this.root.nodes.forEach(Ia), this.root.sharedNodes.clear();
    }
  };
}
function Ox(t) {
  t.updateLayout();
}
function Px(t) {
  var e;
  const n = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && n && t.hasListeners("didUpdate")) {
    const { layoutBox: g, measuredBox: i } = t.layout, { animationType: c } = t.options, A = n.source !== t.layout.source;
    c === "size" ? Ot((m) => {
      const p = A ? n.measuredBox[m] : n.layoutBox[m], y = Et(p);
      p.min = g[m].min, p.max = p.min + y;
    }) : nd(c, n.layoutBox, g) && Ot((m) => {
      const p = A ? n.measuredBox[m] : n.layoutBox[m], y = Et(g[m]);
      p.max = p.min + y, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[m].max = t.relativeTarget[m].min + y);
    });
    const l = Mn();
    qg(l, g, n.layoutBox);
    const a = Mn();
    A ? qg(a, t.applyTransform(i, !0), n.measuredBox) : qg(a, g, n.layoutBox);
    const C = !_b(l);
    let b = !1;
    if (!t.resumeFrom) {
      const m = t.getClosestProjectingParent();
      if (m && !m.resumeFrom) {
        const { snapshot: p, layout: y } = m;
        if (p && y) {
          const f = ht();
          Dg(f, n.layoutBox, p.layoutBox);
          const x = ht();
          Dg(x, g, y.layoutBox), $b(f, x) || (b = !0), m.options.layoutRoot && (t.relativeTarget = x, t.relativeTargetOrigin = f, t.relativeParent = m);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: g,
      snapshot: n,
      delta: a,
      layoutDelta: l,
      hasLayoutChanged: C,
      hasRelativeTargetChanged: b
    });
  } else if (t.isLead()) {
    const { onExitComplete: g } = t.options;
    g && g();
  }
  t.options.transition = void 0;
}
function Kx(t) {
  Fg && mn.totalNodes++, t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function _x(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function $x(t) {
  t.clearSnapshot();
}
function Ia(t) {
  t.clearMeasurements();
}
function tW(t) {
  t.isLayoutDirty = !1;
}
function eW(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function ca(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function nW(t) {
  t.resolveTargetDelta();
}
function gW(t) {
  t.calcProjection();
}
function iW(t) {
  t.resetSkewAndRotation();
}
function IW(t) {
  t.removeLeadSnapshot();
}
function Aa(t, e, n) {
  t.translate = ut(e.translate, 0, n), t.scale = ut(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function sa(t, e, n, g) {
  t.min = ut(e.min, n.min, g), t.max = ut(e.max, n.max, g);
}
function cW(t, e, n, g) {
  sa(t.x, e.x, n.x, g), sa(t.y, e.y, n.y, g);
}
function AW(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const sW = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, oa = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), la = oa("applewebkit/") && !oa("chrome/") ? Math.round : Jt;
function ra(t) {
  t.min = la(t.min), t.max = la(t.max);
}
function oW(t) {
  ra(t.x), ra(t.y);
}
function nd(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !lx(na(e), na(n), 0.2);
}
function lW(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const rW = ed({
  attachResizeListener: (t, e) => He(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), iA = {
  current: void 0
}, gd = ed({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!iA.current) {
      const t = new rW({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), iA.current = t;
    }
    return iA.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), aW = {
  pan: {
    Feature: xx
  },
  drag: {
    Feature: Xx,
    ProjectionNode: gd,
    MeasureLayout: Ob
  }
};
function aa(t, e) {
  const n = e ? "pointerenter" : "pointerleave", g = e ? "onHoverStart" : "onHoverEnd", i = (c, A) => {
    if (c.pointerType === "touch" || qb())
      return;
    const l = t.getProps();
    t.animationState && l.whileHover && t.animationState.setActive("whileHover", e);
    const a = l[g];
    a && ot.postRender(() => a(c, A));
  };
  return De(t.current, n, i, {
    passive: !t.getProps()[g]
  });
}
class CW extends ln {
  mount() {
    this.unmount = qe(aa(this.node, !0), aa(this.node, !1));
  }
  unmount() {
  }
}
class uW extends ln {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = qe(He(this.node.current, "focus", () => this.onFocus()), He(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const id = (t, e) => e ? t === e ? !0 : id(t, e.parentElement) : !1;
function IA(t, e) {
  if (!e)
    return;
  const n = new PointerEvent("pointer" + t);
  e(n, UI(n));
}
class bW extends ln {
  constructor() {
    super(...arguments), this.removeStartListeners = Jt, this.removeEndListeners = Jt, this.removeAccessibleListeners = Jt, this.startPointerPress = (e, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const g = this.node.getProps(), c = De(window, "pointerup", (l, a) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: C, onTapCancel: b, globalTapTarget: m } = this.node.getProps(), p = !m && !id(this.node.current, l.target) ? b : C;
        p && ot.update(() => p(l, a));
      }, {
        passive: !(g.onTap || g.onPointerUp)
      }), A = De(window, "pointercancel", (l, a) => this.cancelPress(l, a), {
        passive: !(g.onTapCancel || g.onPointerCancel)
      });
      this.removeEndListeners = qe(c, A), this.startPress(e, n);
    }, this.startAccessiblePress = () => {
      const e = (c) => {
        if (c.key !== "Enter" || this.isPressing)
          return;
        const A = (l) => {
          l.key !== "Enter" || !this.checkPressEnd() || IA("up", (a, C) => {
            const { onTap: b } = this.node.getProps();
            b && ot.postRender(() => b(a, C));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = He(this.node.current, "keyup", A), IA("down", (l, a) => {
          this.startPress(l, a);
        });
      }, n = He(this.node.current, "keydown", e), g = () => {
        this.isPressing && IA("cancel", (c, A) => this.cancelPress(c, A));
      }, i = He(this.node.current, "blur", g);
      this.removeAccessibleListeners = qe(n, i);
    };
  }
  startPress(e, n) {
    this.isPressing = !0;
    const { onTapStart: g, whileTap: i } = this.node.getProps();
    i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), g && ot.postRender(() => g(e, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !qb();
  }
  cancelPress(e, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: g } = this.node.getProps();
    g && ot.postRender(() => g(e, n));
  }
  mount() {
    const e = this.node.getProps(), n = De(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(e.onTapStart || e.onPointerStart)
    }), g = He(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = qe(n, g);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const jA = /* @__PURE__ */ new WeakMap(), cA = /* @__PURE__ */ new WeakMap(), dW = (t) => {
  const e = jA.get(t.target);
  e && e(t);
}, GW = (t) => {
  t.forEach(dW);
};
function mW({ root: t, ...e }) {
  const n = t || document;
  cA.has(n) || cA.set(n, {});
  const g = cA.get(n), i = JSON.stringify(e);
  return g[i] || (g[i] = new IntersectionObserver(GW, { root: t, ...e })), g[i];
}
function hW(t, e, n) {
  const g = mW(e);
  return jA.set(t, n), g.observe(t), () => {
    jA.delete(t), g.unobserve(t);
  };
}
const pW = {
  some: 0,
  all: 1
};
class VW extends ln {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: g, amount: i = "some", once: c } = e, A = {
      root: n ? n.current : void 0,
      rootMargin: g,
      threshold: typeof i == "number" ? i : pW[i]
    }, l = (a) => {
      const { isIntersecting: C } = a;
      if (this.isInView === C || (this.isInView = C, c && !C && this.hasEnteredView))
        return;
      C && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", C);
      const { onViewportEnter: b, onViewportLeave: m } = this.node.getProps(), p = C ? b : m;
      p && p(a);
    };
    return hW(this.node.current, A, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(ZW(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function ZW({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const yW = {
  inView: {
    Feature: VW
  },
  tap: {
    Feature: bW
  },
  focus: {
    Feature: uW
  },
  hover: {
    Feature: CW
  }
}, vW = {
  layout: {
    ProjectionNode: gd,
    MeasureLayout: Ob
  }
}, Id = cn({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
}), TI = cn({}), Os = typeof window < "u", XW = Os ? fG : Ee, cd = cn({ strict: !1 });
function xW(t, e, n, g, i) {
  var c, A;
  const { visualElement: l } = St(TI), a = St(cd), C = St(Ts), b = St(Id).reducedMotion, m = Ke();
  g = g || a.renderer, !m.current && g && (m.current = g(t, {
    visualState: e,
    parent: l,
    props: n,
    presenceContext: C,
    blockInitialAnimation: C ? C.initial === !1 : !1,
    reducedMotionConfig: b
  }));
  const p = m.current, y = St(Qb);
  p && !p.projection && i && (p.type === "html" || p.type === "svg") && WW(m.current, n, i, y), BG(() => {
    p && p.update(n, C);
  });
  const f = n[Bb], x = Ke(!!f && !(!((c = window.MotionHandoffIsComplete) === null || c === void 0) && c.call(window, f)) && ((A = window.MotionHasOptimisedAnimation) === null || A === void 0 ? void 0 : A.call(window, f)));
  return XW(() => {
    p && (window.MotionIsMounted = !0, p.updateFeatures(), Qs.render(p.render), x.current && p.animationState && p.animationState.animateChanges());
  }), Ee(() => {
    p && (!x.current && p.animationState && p.animationState.animateChanges(), x.current && (queueMicrotask(() => {
      var Y;
      (Y = window.MotionHandoffMarkAsComplete) === null || Y === void 0 || Y.call(window, f);
    }), x.current = !1));
  }), p;
}
function WW(t, e, n, g) {
  const { layoutId: i, layout: c, drag: A, dragConstraints: l, layoutScroll: a, layoutRoot: C } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : Ad(t.parent)), t.projection.setOptions({
    layoutId: i,
    layout: c,
    alwaysMeasureLayout: !!A || l && jn(l),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof c == "string" ? c : "both",
    initialPromotionConfig: g,
    layoutScroll: a,
    layoutRoot: C
  });
}
function Ad(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : Ad(t.parent);
}
function fW(t, e, n) {
  return pn(
    (g) => {
      g && t.mount && t.mount(g), e && (g ? e.mount(g) : e.unmount()), n && (typeof n == "function" ? n(g) : jn(n) && (n.current = g));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function QI(t) {
  return Qg(t.animate) || fs.some((e) => Og(t[e]));
}
function sd(t) {
  return !!(QI(t) || t.variants);
}
function BW(t, e) {
  if (QI(t)) {
    const { initial: n, animate: g } = t;
    return {
      initial: n === !1 || Og(n) ? n : void 0,
      animate: Og(g) ? g : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function YW(t) {
  const { initial: e, animate: n } = BW(t, St(TI));
  return oe(() => ({ initial: e, animate: n }), [Ca(e), Ca(n)]);
}
function Ca(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const ua = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, sg = {};
for (const t in ua)
  sg[t] = {
    isEnabled: (e) => ua[t].some((n) => !!e[n])
  };
function NW(t) {
  for (const e in t)
    sg[e] = {
      ...sg[e],
      ...t[e]
    };
}
const JW = Symbol.for("motionComponentSymbol");
function RW({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: g, Component: i }) {
  t && NW(t);
  function c(l, a) {
    let C;
    const b = {
      ...St(Id),
      ...l,
      layoutId: SW(l)
    }, { isStatic: m } = b, p = YW(l), y = g(l, m);
    if (!m && Os) {
      FW(b, t);
      const f = HW(b);
      C = f.MeasureLayout, p.visualElement = xW(i, y, b, e, f.ProjectionNode);
    }
    return Pn(TI.Provider, { value: p, children: [C && p.visualElement ? k(C, { visualElement: p.visualElement, ...b }) : null, n(i, l, fW(y, p.visualElement, a), y, m, p.visualElement)] });
  }
  const A = Le(c);
  return A[JW] = i, A;
}
function SW({ layoutId: t }) {
  const e = St(Tb).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function FW(t, e) {
  const n = St(cd).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const g = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? bg(!1, g) : nn(!1, g);
  }
}
function HW(t) {
  const { drag: e, layout: n } = sg;
  if (!e && !n)
    return {};
  const g = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? g.MeasureLayout : void 0,
    ProjectionNode: g.ProjectionNode
  };
}
const wW = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ps(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(wW.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function od(t, { style: e, vars: n }, g, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(g));
  for (const c in n)
    t.style.setProperty(c, n[c]);
}
const ld = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function rd(t, e, n, g) {
  od(t, e, void 0, g);
  for (const i in e.attrs)
    t.setAttribute(ld.has(i) ? i : MI(i), e.attrs[i]);
}
function ad(t, { layout: e, layoutId: n }) {
  return on.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!XI[t] || t === "opacity");
}
function Ks(t, e, n) {
  var g;
  const { style: i } = t, c = {};
  for (const A in i)
    (Ht(i[A]) || e.style && Ht(e.style[A]) || ad(A, t) || ((g = n == null ? void 0 : n.getValue(A)) === null || g === void 0 ? void 0 : g.liveStyle) !== void 0) && (c[A] = i[A]);
  return n && i && typeof i.willChange == "string" && (n.applyWillChange = !1), c;
}
function Cd(t, e, n) {
  const g = Ks(t, e, n);
  for (const i in t)
    if (Ht(t[i]) || Ht(e[i])) {
      const c = ai.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      g[c] = t[i];
    }
  return g;
}
function zW(t) {
  const e = Ke(null);
  return e.current === null && (e.current = t()), e.current;
}
function qW({ applyWillChange: t = !1, scrapeMotionValuesFromProps: e, createRenderState: n, onMount: g }, i, c, A, l) {
  const a = {
    latestValues: DW(i, c, A, l ? !1 : t, e),
    renderState: n()
  };
  return g && (a.mount = (C) => g(i, C, a)), a;
}
const ud = (t) => (e, n) => {
  const g = St(TI), i = St(Ts), c = () => qW(t, e, g, i, n);
  return n ? c() : zW(c);
};
function ba(t, e, n) {
  const g = Array.isArray(e) ? e : [e];
  for (let i = 0; i < g.length; i++) {
    const c = xs(t, g[i]);
    if (c) {
      const { transitionEnd: A, transition: l, ...a } = c;
      n(a, A);
    }
  }
}
function DW(t, e, n, g, i) {
  var c;
  const A = {};
  let l = g && ((c = t.style) === null || c === void 0 ? void 0 : c.willChange) === void 0;
  const a = i(t, {});
  for (const x in a)
    A[x] = $i(a[x]);
  let { initial: C, animate: b } = t;
  const m = QI(t), p = sd(t);
  e && p && !m && t.inherit !== !1 && (C === void 0 && (C = e.initial), b === void 0 && (b = e.animate));
  let y = n ? n.initial === !1 : !1;
  y = y || C === !1;
  const f = y ? b : C;
  return f && typeof f != "boolean" && !Qg(f) && ba(t, f, (x, Y) => {
    for (const B in x) {
      let J = x[B];
      if (Array.isArray(J)) {
        const N = y ? J.length - 1 : 0;
        J = J[N];
      }
      J !== null && (A[B] = J);
    }
    for (const B in Y)
      A[B] = Y[B];
  }), l && b && C !== !1 && !Qg(b) && ba(t, b, (x) => {
    for (const Y in x)
      if (Nb(Y)) {
        A.willChange = "transform";
        return;
      }
  }), A;
}
const _s = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), bd = () => ({
  ..._s(),
  attrs: {}
}), dd = (t, e) => e && typeof t == "number" ? e.transform(t) : t, LW = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, kW = ai.length;
function EW(t, e, n) {
  let g = "", i = !0;
  for (let c = 0; c < kW; c++) {
    const A = ai[c], l = t[A];
    if (l === void 0)
      continue;
    let a = !0;
    if (typeof l == "number" ? a = l === (A.startsWith("scale") ? 1 : 0) : a = parseFloat(l) === 0, !a || n) {
      const C = dd(l, Hs[A]);
      if (!a) {
        i = !1;
        const b = LW[A] || A;
        g += `${b}(${C}) `;
      }
      n && (e[A] = C);
    }
  }
  return g = g.trim(), n ? g = n(e, i ? "" : g) : i && (g = "none"), g;
}
function $s(t, e, n) {
  const { style: g, vars: i, transformOrigin: c } = t;
  let A = !1, l = !1;
  for (const a in e) {
    const C = e[a];
    if (on.has(a)) {
      A = !0;
      continue;
    } else if (Ib(a)) {
      i[a] = C;
      continue;
    } else {
      const b = dd(C, Hs[a]);
      a.startsWith("origin") ? (l = !0, c[a] = b) : g[a] = b;
    }
  }
  if (e.transform || (A || n ? g.transform = EW(e, t.transform, n) : g.transform && (g.transform = "none")), l) {
    const { originX: a = "50%", originY: C = "50%", originZ: b = 0 } = c;
    g.transformOrigin = `${a} ${C} ${b}`;
  }
}
function da(t, e, n) {
  return typeof t == "string" ? t : _.transform(e + n * t);
}
function jW(t, e, n) {
  const g = da(e, t.x, t.width), i = da(n, t.y, t.height);
  return `${g} ${i}`;
}
const MW = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, UW = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function TW(t, e, n = 1, g = 0, i = !0) {
  t.pathLength = 1;
  const c = i ? MW : UW;
  t[c.offset] = _.transform(-g);
  const A = _.transform(e), l = _.transform(n);
  t[c.array] = `${A} ${l}`;
}
function to(t, {
  attrX: e,
  attrY: n,
  attrScale: g,
  originX: i,
  originY: c,
  pathLength: A,
  pathSpacing: l = 1,
  pathOffset: a = 0,
  // This is object creation, which we try to avoid per-frame.
  ...C
}, b, m) {
  if ($s(t, C, m), b) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: p, style: y, dimensions: f } = t;
  p.transform && (f && (y.transform = p.transform), delete p.transform), f && (i !== void 0 || c !== void 0 || y.transform) && (y.transformOrigin = jW(f, i !== void 0 ? i : 0.5, c !== void 0 ? c : 0.5)), e !== void 0 && (p.x = e), n !== void 0 && (p.y = n), g !== void 0 && (p.scale = g), A !== void 0 && TW(p, A, l, a, !1);
}
const eo = (t) => typeof t == "string" && t.toLowerCase() === "svg", QW = {
  useVisualState: ud({
    scrapeMotionValuesFromProps: Cd,
    createRenderState: bd,
    onMount: (t, e, { renderState: n, latestValues: g }) => {
      ot.read(() => {
        try {
          n.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), ot.render(() => {
        to(n, g, eo(e.tagName), t.transformTemplate), rd(e, n);
      });
    }
  })
}, OW = {
  useVisualState: ud({
    applyWillChange: !0,
    scrapeMotionValuesFromProps: Ks,
    createRenderState: _s
  })
};
function Gd(t, e, n) {
  for (const g in e)
    !Ht(e[g]) && !ad(g, n) && (t[g] = e[g]);
}
function PW({ transformTemplate: t }, e) {
  return oe(() => {
    const n = _s();
    return $s(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function KW(t, e) {
  const n = t.style || {}, g = {};
  return Gd(g, n, t), Object.assign(g, PW(t, e)), g;
}
function _W(t, e) {
  const n = {}, g = KW(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, g.userSelect = g.WebkitUserSelect = g.WebkitTouchCallout = "none", g.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = g, n;
}
const $W = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function xI(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || $W.has(t);
}
let md = (t) => !xI(t);
function tf(t) {
  t && (md = (e) => e.startsWith("on") ? !xI(e) : t(e));
}
try {
  tf(require("@emotion/is-prop-valid").default);
} catch {
}
function ef(t, e, n) {
  const g = {};
  for (const i in t)
    i === "values" && typeof t.values == "object" || (md(i) || n === !0 && xI(i) || !e && !xI(i) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && i.startsWith("onDrag")) && (g[i] = t[i]);
  return g;
}
function nf(t, e, n, g) {
  const i = oe(() => {
    const c = bd();
    return to(c, e, eo(g), t.transformTemplate), {
      ...c.attrs,
      style: { ...c.style }
    };
  }, [e]);
  if (t.style) {
    const c = {};
    Gd(c, t.style, t), i.style = { ...c, ...i.style };
  }
  return i;
}
function gf(t = !1) {
  return (n, g, i, { latestValues: c }, A) => {
    const a = (Ps(n) ? nf : _W)(g, c, A, n), C = ef(g, typeof n == "string", t), b = n !== ha ? { ...C, ...a, ref: i } : {}, { children: m } = g, p = oe(() => Ht(m) ? m.get() : m, [m]);
    return eI(n, {
      ...b,
      children: p
    });
  };
}
function If(t, e) {
  return function(g, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const A = {
      ...Ps(g) ? QW : OW,
      preloadedFeatures: t,
      useRender: gf(i),
      createVisualElement: e,
      Component: g
    };
    return RW(A);
  };
}
const MA = { current: null }, hd = { current: !1 };
function cf() {
  if (hd.current = !0, !!Os)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => MA.current = t.matches;
      t.addListener(e), e();
    } else
      MA.current = !1;
}
function Af(t, e, n) {
  for (const g in e) {
    const i = e[g], c = n[g];
    if (Ht(i))
      t.addValue(g, i), process.env.NODE_ENV === "development" && kI(i.version === "11.11.8", `Attempting to mix Framer Motion versions ${i.version} with 11.11.8 may not work as expected.`);
    else if (Ht(c))
      t.addValue(g, _g(i, { owner: t }));
    else if (c !== i)
      if (t.hasValue(g)) {
        const A = t.getValue(g);
        A.liveStyle === !0 ? A.jump(i) : A.hasAnimated || A.set(i);
      } else {
        const A = t.getStaticValue(g);
        t.addValue(g, _g(A !== void 0 ? A : i, { owner: t }));
      }
  }
  for (const g in n)
    e[g] === void 0 && t.removeValue(g);
  return e;
}
const Ga = /* @__PURE__ */ new WeakMap(), sf = [...sb, Rt, In], of = (t) => sf.find(Ab(t)), ma = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class lf {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, g) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: g, reducedMotionConfig: i, blockInitialAnimation: c, visualState: A }, l = {}) {
    this.applyWillChange = !1, this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Rs, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = ye.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, ot.render(this.render, !1, !0));
    };
    const { latestValues: a, renderState: C } = A;
    this.latestValues = a, this.baseTarget = { ...a }, this.initialValues = n.initial ? { ...a } : {}, this.renderState = C, this.parent = e, this.props = n, this.presenceContext = g, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = l, this.blockInitialAnimation = !!c, this.isControllingVariants = QI(n), this.isVariantNode = sd(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: b, ...m } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in m) {
      const y = m[p];
      a[p] !== void 0 && Ht(y) && y.set(a[p], !1);
    }
  }
  mount(e) {
    this.current = e, Ga.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, g) => this.bindToMotionValue(g, n)), hd.current || cf(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : MA.current, process.env.NODE_ENV !== "production" && kI(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Ga.delete(this.current), this.projection && this.projection.unmount(), en(this.notifyUpdate), en(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const g = on.has(e), i = n.on("change", (l) => {
      this.latestValues[e] = l, this.props.onUpdate && ot.preRender(this.notifyUpdate), g && this.projection && (this.projection.isTransformDirty = !0);
    }), c = n.on("renderRequest", this.scheduleRender);
    let A;
    window.MotionCheckAppearSync && (A = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), c(), A && A(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in sg) {
      const n = sg[e];
      if (!n)
        continue;
      const { isEnabled: g, Feature: i } = n;
      if (!this.features[e] && i && g(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const c = this.features[e];
        c.isMounted ? c.update() : (c.mount(), c.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ht();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let g = 0; g < ma.length; g++) {
      const i = ma[g];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const c = "on" + i, A = e[c];
      A && (this.propEventSubscriptions[i] = this.on(i, A));
    }
    this.prevMotionValues = Af(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const g = this.values.get(e);
    n !== g && (g && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let g = this.values.get(e);
    return g === void 0 && n !== void 0 && (g = _g(n === null ? void 0 : n, { owner: this }), this.addValue(e, g)), g;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var g;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (g = this.getBaseTargetFromProps(this.props, e)) !== null && g !== void 0 ? g : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (gb(i) || nb(i)) ? i = parseFloat(i) : !of(i) && In.test(n) && (i = db(e, n)), this.setBaseTarget(e, Ht(i) ? i.get() : i)), Ht(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: g } = this.props;
    let i;
    if (typeof g == "string" || typeof g == "object") {
      const A = xs(this.props, g, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      A && (i = A[e]);
    }
    if (g && i !== void 0)
      return i;
    const c = this.getBaseTargetFromProps(this.props, e);
    return c !== void 0 && !Ht(c) ? c : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Us()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class pd extends lf {
  constructor() {
    super(...arguments), this.KeyframeResolver = Gb;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: g }) {
    delete n[e], delete g[e];
  }
}
function rf(t) {
  return window.getComputedStyle(t);
}
class af extends pd {
  constructor() {
    super(...arguments), this.type = "html", this.applyWillChange = !0, this.renderInstance = od;
  }
  readValueFromInstance(e, n) {
    if (on.has(n)) {
      const g = ws(n);
      return g && g.default || 0;
    } else {
      const g = rf(e), i = (Ib(n) ? g.getPropertyValue(n) : g[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Mb(e, n);
  }
  build(e, n, g) {
    $s(e, n, g.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, g) {
    return Ks(e, n, g);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Ht(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Cf extends pd {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ht;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (on.has(n)) {
      const g = ws(n);
      return g && g.default || 0;
    }
    return n = ld.has(n) ? n : MI(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, g) {
    return Cd(e, n, g);
  }
  build(e, n, g) {
    to(e, n, this.isSVGTag, g.transformTemplate);
  }
  renderInstance(e, n, g, i) {
    rd(e, n, g, i);
  }
  mount(e) {
    this.isSVGTag = eo(e.tagName), super.mount(e);
  }
}
const uf = (t, e) => Ps(t) ? new Cf(e) : new af(e, {
  allowProjection: t !== ha
}), bf = /* @__PURE__ */ If({
  ...ex,
  ...yW,
  ...aW,
  ...vW
}, uf), df = /* @__PURE__ */ Ty(bf), tI = cn(null), F2 = () => {
  const t = St(tI);
  if (!t)
    throw new Error("useTabsData must be used within a TabsContext");
  return t;
}, H2 = (t) => {
  const {
    tabs: e,
    keepRendered: n,
    noAnimation: g,
    hasSound: i,
    tabSelectorAlignment: c = "center",
    className: A,
    tabBodyClassName: l,
    ...a
  } = t, [C, b] = ee(null), [m, p] = ee(0), y = pn((Y) => {
    b(m), p(Y);
  }, [m]), f = !g, x = oe(() => {
    switch (c) {
      case "left":
        return "flex-start";
      case "center":
        return "center";
      case "right":
        return "flex-end";
    }
  }, [c]);
  return /* @__PURE__ */ Vt(ds, { gap: 10, css: [ne, process.env.NODE_ENV === "production" ? "" : ";label:Tabs;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], className: A, ...a, children: [
    /* @__PURE__ */ w(Cg, { justifyContent: x, gap: 6, children: e.map((Y, B) => /* @__PURE__ */ Vt(Wm, { css: [_n(), "z-index:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:Tabs;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], hideBackgroundOnHover: !0, hideBackgroundOnActive: !0, onClick: () => y(B), value: B === m, children: [
      B === m && /* @__PURE__ */ w(df.div, { layoutId: "tab-active-indicator", css: [Ft(0, 0, 0, 0), ne, {
        zIndex: -1,
        background: K.transparent
      }, process.env.NODE_ENV === "production" ? "" : ";label:Tabs;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], style: {
        borderRadius: 9999
      }, transition: {
        type: "spring",
        bounce: 0.2,
        duration: 0.6
      } }),
      Y.title
    ] }, `chip-${Y.id}`)) }),
    /* @__PURE__ */ Vt("div", { className: l, css: [ni, _n(), "overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:Tabs;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: [
      n && e.filter((Y, B) => ![m, C].includes(B)).map((Y, B) => {
        const J = {
          activeTabIndex: m,
          tabsCount: e.length,
          moveTo: y,
          tabIndex: B
        }, {
          display: N
        } = Y;
        return /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), {
          zIndex: -2,
          display: "none"
        }, process.env.NODE_ENV === "production" ? "" : ";label:Tabs;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w(tI.Provider, { value: J, children: N instanceof Function ? N(J) : N }) }, `tab-${Y.id}`);
      }),
      C !== null && (() => {
        const Y = {
          activeTabIndex: m,
          tabsCount: e.length,
          moveTo: y,
          tabIndex: C
        }, B = e[C], {
          display: J
        } = B;
        return /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), "z-index:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:Tabs;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w(tI.Provider, { value: Y, children: J instanceof Function ? J(Y) : J }) }, `tab-${B.id}`);
      })(),
      (() => {
        const Y = {
          activeTabIndex: m,
          tabsCount: e.length,
          moveTo: y,
          tabIndex: m
        }, B = e[m], {
          display: J
        } = B;
        return /* @__PURE__ */ w("div", { css: [Ft(0, 0, 0, 0), f && dI("0.4s"), "z-index:1;" + (process.env.NODE_ENV === "production" ? "" : ";label:Tabs;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], children: /* @__PURE__ */ w(tI.Provider, { value: Y, children: J instanceof Function ? J(Y) : J }) }, `tab-${B.id}`);
      })()
    ] })
  ] });
};
export {
  jy as Backdrop,
  f2 as BackdropView,
  Ey as Blobs,
  oA as Button,
  gi as Card,
  t2 as CardBody,
  $f as CardHeader,
  n2 as Checkbox,
  Wm as Chip,
  Je as ColorType,
  g2 as Cube,
  b2 as Dialog,
  d2 as DialogTrigger,
  Dy as Dots,
  ry as FallingSpiral,
  eu as Flex,
  ds as FlexColumn,
  Cg as FlexRow,
  cy as FloatingSquare,
  Iy as FloatingSquares,
  m2 as IconButton,
  c2 as Input,
  UA as Intent,
  $g as IntentColors,
  My as NavigationIndicator,
  Uy as NavigationIndicators,
  B2 as Panel,
  N2 as Panels,
  Pi as PanelsContext,
  BZ as PlayerIcon,
  r2 as PlayerSlot,
  p2 as ProgressBar,
  a2 as Reaction,
  Z2 as ScrollArea,
  v2 as Slider,
  C2 as Spacing,
  u2 as Splash,
  T0 as StrokeText,
  x2 as Switch,
  J2 as Tab,
  H2 as Tabs,
  tI as TabsContext,
  G2 as Text,
  W2 as TitledCard,
  Ft as absolute,
  Xf as absoluteFromDirections,
  QA as border,
  ti as borderRadius,
  Wf as bottomBorder,
  Mf as center,
  Uf as centerHorizontal,
  Tf as centerVertical,
  Of as clearTextStyle,
  rZ as colorPulse,
  K as colors,
  Ug as combineAnimations,
  TA as createStandardSizing,
  QG as darkenColor,
  _C as displayFixer,
  Ly as dotsKeyframes,
  me as dropShadow,
  l2 as errorBorder,
  o2 as errorShake,
  dI as fadeIn,
  A2 as fadeInDisplay,
  XA as fadeOut,
  s2 as fadeOutDisplay,
  Za as flex,
  ni as flex1,
  Nf as flex2,
  Jf as flex3,
  Rf as flex4,
  Sf as flex5,
  zf as flexAround,
  wf as flexBetween,
  $n as flexCenter,
  Hf as flexCenterHorizontal,
  Ff as flexCenterVertical,
  Df as flexColumn,
  qf as flexEvenly,
  ei as flexValue,
  fn as font,
  ke as fontFamilies,
  pa as fontSizes,
  yf as fontStyles,
  Lf as fullHeight,
  ne as fullSize,
  ya as fullWidth,
  _e as getStandardSizes,
  vf as gradients,
  lZ as growShrink,
  Xa as hexToRGBValues,
  Ef as imageContain,
  kf as imageCover,
  PZ as indicatorStyles,
  UG as interpolateRGB,
  TG as interpolateRGBA,
  _f as lightenColor,
  ff as margin,
  LG as marginHorizontal,
  Bf as marginHorizontalCenter,
  Yf as marginVertical,
  va as noSelect,
  WI as padding,
  OA as paddingHorizontal,
  Va as paddingVertical,
  Kf as progressGradient,
  Pf as property,
  _n as relative,
  xf as relativeFromDirections,
  OZ as rootStyles,
  aZ as scalePop,
  xA as scaleTransition,
  Hl as slideIn,
  pZ as slideInDownKeyFrames,
  GZ as slideInLeftKeyFrames,
  mZ as slideInRightKeyFrames,
  hZ as slideInUpKeyFrames,
  wl as slideOut,
  vZ as slideOutDownKeyFrames,
  VZ as slideOutLeftKeyFrames,
  ZZ as slideOutRightKeyFrames,
  yZ as slideOutUpKeyFrames,
  sA as standardShadows,
  Kn as standardSizes,
  jf as textShadow,
  DG as textStroke,
  Qf as transition,
  qG as transitionTimes,
  Y2 as usePanelsData,
  F2 as useTabsData,
  dZ as waveMovement
};
